import type { ProviderIconCatalog } from './types';

const PROVIDER_ICON_CATALOG_DATA: unknown = {
  "generatedAt": "2026-06-24T21:47:56.339Z",
  "sources": [
    {
      "provider": "aws",
      "label": "AWS Architecture Icons",
      "docsUrl": "https://aws.amazon.com/architecture/icons/",
      "packageUrl": "https://d1.awsstatic.com/onedam/marketing-channels/website/aws/en_US/architecture/approved/architecture-icons/Icon-package_04302026.4705b90f5aa45b019271a2699e9ce9b97b941ee1.zip",
      "packageLabel": "Icon-package_04302026",
      "lastVerified": "2026-06-24"
    },
    {
      "provider": "azure",
      "label": "Azure Public Service Icons",
      "docsUrl": "https://learn.microsoft.com/en-us/azure/architecture/icons/",
      "packageUrl": "https://arch-center.azureedge.net/icons/Azure_Public_Service_Icons_V23.zip",
      "packageLabel": "Azure_Public_Service_Icons_V23",
      "lastVerified": "2026-06-24"
    },
    {
      "provider": "gcp",
      "label": "Google Cloud Product Icons",
      "docsUrl": "https://cloud.google.com/icons",
      "packageUrl": "https://services.google.com/fh/files/misc/core-products-icons.zip",
      "packageLabel": "core-products-icons",
      "lastVerified": "2026-06-24"
    },
    {
      "provider": "gcp",
      "label": "Google Cloud Category Icons",
      "docsUrl": "https://cloud.google.com/icons",
      "packageUrl": "https://services.google.com/fh/files/misc/category-icons.zip",
      "packageLabel": "category-icons",
      "lastVerified": "2026-06-24"
    },
    {
      "provider": "gcp",
      "label": "Google Cloud Legacy Console Icons",
      "docsUrl": "https://cloud.google.com/icons",
      "packageUrl": "https://services.google.com/fh/files/misc/google-cloud-legacy-icons.zip",
      "packageLabel": "google-cloud-legacy-icons",
      "lastVerified": "2026-06-24"
    },
    {
      "provider": "kubernetes",
      "label": "Kubernetes Community Icons",
      "docsUrl": "https://github.com/kubernetes/community/blob/main/icons/README.md",
      "packageUrl": "https://github.com/kubernetes/community/archive/refs/heads/main.zip",
      "packageLabel": "kubernetes-community-main",
      "lastVerified": "2026-06-24"
    }
  ],
  "icons": [
    {
      "provider": "aws",
      "label": "Amazon API Gateway",
      "category": "Arch Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_Amazon-API-Gateway_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_Amazon-API-Gateway_64.svg",
      "tokens": [
        "Amazon API Gateway",
        "Arch Networking Content Delivery",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Networking",
        "Content",
        "Delivery",
        "64",
        "Amazon",
        "API",
        "Gateway",
        "svg",
        "amazonapigateway",
        "archnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon App Flow",
      "category": "Arch Application Integration",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Application-Integration/64/Arch_Amazon-AppFlow_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Application-Integration/64/Arch_Amazon-AppFlow_64.svg",
      "tokens": [
        "Amazon App Flow",
        "Arch Application Integration",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Application",
        "Integration",
        "64",
        "Amazon",
        "AppFlow",
        "svg",
        "amazonappflow",
        "archapplicationintegration"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Application Recovery Controller",
      "category": "Arch Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_Amazon-Application-Recovery-Controller_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_Amazon-Application-Recovery-Controller_64.svg",
      "tokens": [
        "Amazon Application Recovery Controller",
        "Arch Networking Content Delivery",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Networking",
        "Content",
        "Delivery",
        "64",
        "Amazon",
        "Application",
        "Recovery",
        "Controller",
        "svg",
        "amazonapplicationrecoverycontroller",
        "archnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Athena",
      "category": "Arch Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-Athena_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-Athena_64.svg",
      "tokens": [
        "Amazon Athena",
        "Arch Analytics",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Analytics",
        "64",
        "Amazon",
        "Athena",
        "svg",
        "amazonathena",
        "archanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Augmented AI A2 I",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Augmented-AI-A2I_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Augmented-AI-A2I_64.svg",
      "tokens": [
        "Amazon Augmented AI A2 I",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "Augmented",
        "AI",
        "A2I",
        "svg",
        "amazonaugmentedaia2i",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Aurora",
      "category": "Arch Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Databases/64/Arch_Amazon-Aurora_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Databases/64/Arch_Amazon-Aurora_64.svg",
      "tokens": [
        "Amazon Aurora",
        "Arch Databases",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Databases",
        "64",
        "Amazon",
        "Aurora",
        "svg",
        "amazonaurora",
        "archdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Bedrock Agent Core",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Bedrock-AgentCore_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Bedrock-AgentCore_64.svg",
      "tokens": [
        "Amazon Bedrock Agent Core",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "Bedrock",
        "AgentCore",
        "svg",
        "amazonbedrockagentcore",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Bedrock",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Bedrock_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Bedrock_64.svg",
      "tokens": [
        "Amazon Bedrock",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "Bedrock",
        "svg",
        "amazonbedrock",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Braket",
      "category": "Arch Quantum Technologies",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Quantum-Technologies/64/Arch_Amazon-Braket_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Quantum-Technologies/64/Arch_Amazon-Braket_64.svg",
      "tokens": [
        "Amazon Braket",
        "Arch Quantum Technologies",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Quantum",
        "Technologies",
        "64",
        "Amazon",
        "Braket",
        "svg",
        "amazonbraket",
        "archquantumtechnologies"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Chime SDK",
      "category": "Arch Business Applications",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_Amazon-Chime-SDK_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_Amazon-Chime-SDK_64.svg",
      "tokens": [
        "Amazon Chime SDK",
        "Arch Business Applications",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Business",
        "Applications",
        "64",
        "Amazon",
        "Chime",
        "SDK",
        "svg",
        "amazonchimesdk",
        "archbusinessapplications"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Chime",
      "category": "Arch Business Applications",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_Amazon-Chime_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_Amazon-Chime_64.svg",
      "tokens": [
        "Amazon Chime",
        "Arch Business Applications",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Business",
        "Applications",
        "64",
        "Amazon",
        "Chime",
        "svg",
        "amazonchime",
        "archbusinessapplications"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Cloud Directory",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_Amazon-Cloud-Directory_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_Amazon-Cloud-Directory_64.svg",
      "tokens": [
        "Amazon Cloud Directory",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "Amazon",
        "Cloud",
        "Directory",
        "svg",
        "amazonclouddirectory",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Cloud Front",
      "category": "Arch Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_Amazon-CloudFront_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_Amazon-CloudFront_64.svg",
      "tokens": [
        "Amazon Cloud Front",
        "Arch Networking Content Delivery",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Networking",
        "Content",
        "Delivery",
        "64",
        "Amazon",
        "CloudFront",
        "svg",
        "amazoncloudfront",
        "archnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Cloud Search",
      "category": "Arch Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-CloudSearch_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-CloudSearch_64.svg",
      "tokens": [
        "Amazon Cloud Search",
        "Arch Analytics",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Analytics",
        "64",
        "Amazon",
        "CloudSearch",
        "svg",
        "amazoncloudsearch",
        "archanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Cloud Watch",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_Amazon-CloudWatch_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_Amazon-CloudWatch_64.svg",
      "tokens": [
        "Amazon Cloud Watch",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "Amazon",
        "CloudWatch",
        "svg",
        "amazoncloudwatch",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Code Catalyst",
      "category": "Arch Developer Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_Amazon-CodeCatalyst_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_Amazon-CodeCatalyst_64.svg",
      "tokens": [
        "Amazon Code Catalyst",
        "Arch Developer Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Developer",
        "Tools",
        "64",
        "Amazon",
        "CodeCatalyst",
        "svg",
        "amazoncodecatalyst",
        "archdevelopertools"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Code Guru",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-CodeGuru_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-CodeGuru_64.svg",
      "tokens": [
        "Amazon Code Guru",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "CodeGuru",
        "svg",
        "amazoncodeguru",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Code Whisperer",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-CodeWhisperer_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-CodeWhisperer_64.svg",
      "tokens": [
        "Amazon Code Whisperer",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "CodeWhisperer",
        "svg",
        "amazoncodewhisperer",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Cognito",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_Amazon-Cognito_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_Amazon-Cognito_64.svg",
      "tokens": [
        "Amazon Cognito",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "Amazon",
        "Cognito",
        "svg",
        "amazoncognito",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Comprehend Medical",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Comprehend-Medical_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Comprehend-Medical_64.svg",
      "tokens": [
        "Amazon Comprehend Medical",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "Comprehend",
        "Medical",
        "svg",
        "amazoncomprehendmedical",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Comprehend",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Comprehend_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Comprehend_64.svg",
      "tokens": [
        "Amazon Comprehend",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "Comprehend",
        "svg",
        "amazoncomprehend",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Connect",
      "category": "Arch Business Applications",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_Amazon-Connect_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_Amazon-Connect_64.svg",
      "tokens": [
        "Amazon Connect",
        "Arch Business Applications",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Business",
        "Applications",
        "64",
        "Amazon",
        "Connect",
        "svg",
        "amazonconnect",
        "archbusinessapplications"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Corretto",
      "category": "Arch Developer Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_Amazon-Corretto_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_Amazon-Corretto_64.svg",
      "tokens": [
        "Amazon Corretto",
        "Arch Developer Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Developer",
        "Tools",
        "64",
        "Amazon",
        "Corretto",
        "svg",
        "amazoncorretto",
        "archdevelopertools"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Data Firehose",
      "category": "Arch Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-Data-Firehose_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-Data-Firehose_64.svg",
      "tokens": [
        "Amazon Data Firehose",
        "Arch Analytics",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Analytics",
        "64",
        "Amazon",
        "Data",
        "Firehose",
        "svg",
        "amazondatafirehose",
        "archanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Data Zone",
      "category": "Arch Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-DataZone_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-DataZone_64.svg",
      "tokens": [
        "Amazon Data Zone",
        "Arch Analytics",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Analytics",
        "64",
        "Amazon",
        "DataZone",
        "svg",
        "amazondatazone",
        "archanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon DCV",
      "category": "Arch Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_Amazon-DCV_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_Amazon-DCV_64.svg",
      "tokens": [
        "Amazon DCV",
        "Arch Compute",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Compute",
        "64",
        "Amazon",
        "DCV",
        "svg",
        "amazondcv",
        "archcompute"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Detective",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_Amazon-Detective_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_Amazon-Detective_64.svg",
      "tokens": [
        "Amazon Detective",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "Amazon",
        "Detective",
        "svg",
        "amazondetective",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Dev Ops Guru",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-DevOps-Guru_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-DevOps-Guru_64.svg",
      "tokens": [
        "Amazon Dev Ops Guru",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "DevOps",
        "Guru",
        "svg",
        "amazondevopsguru",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Document DB",
      "category": "Arch Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Databases/64/Arch_Amazon-DocumentDB_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Databases/64/Arch_Amazon-DocumentDB_64.svg",
      "tokens": [
        "Amazon Document DB",
        "Arch Databases",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Databases",
        "64",
        "Amazon",
        "DocumentDB",
        "svg",
        "amazondocumentdb",
        "archdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Dynamo DB",
      "category": "Arch Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Databases/64/Arch_Amazon-DynamoDB_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Databases/64/Arch_Amazon-DynamoDB_64.svg",
      "tokens": [
        "Amazon Dynamo DB",
        "Arch Databases",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Databases",
        "64",
        "Amazon",
        "DynamoDB",
        "svg",
        "amazondynamodb",
        "archdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon EC2 Auto Scaling",
      "category": "Arch Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_Amazon-EC2-Auto-Scaling_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_Amazon-EC2-Auto-Scaling_64.svg",
      "tokens": [
        "Amazon EC2 Auto Scaling",
        "Arch Compute",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Compute",
        "64",
        "Amazon",
        "EC2",
        "Auto",
        "Scaling",
        "svg",
        "amazonec2autoscaling",
        "archcompute"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon EC2 Image Builder",
      "category": "Arch Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_Amazon-EC2-Image-Builder_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_Amazon-EC2-Image-Builder_64.svg",
      "tokens": [
        "Amazon EC2 Image Builder",
        "Arch Compute",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Compute",
        "64",
        "Amazon",
        "EC2",
        "Image",
        "Builder",
        "svg",
        "amazonec2imagebuilder",
        "archcompute"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon EC2",
      "category": "Arch Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_Amazon-EC2_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_Amazon-EC2_64.svg",
      "tokens": [
        "Amazon EC2",
        "Arch Compute",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Compute",
        "64",
        "Amazon",
        "EC2",
        "svg",
        "amazonec2",
        "archcompute"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon ECS Anywhere",
      "category": "Arch Containers",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Containers/64/Arch_Amazon-ECS-Anywhere_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Containers/64/Arch_Amazon-ECS-Anywhere_64.svg",
      "tokens": [
        "Amazon ECS Anywhere",
        "Arch Containers",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Containers",
        "64",
        "Amazon",
        "ECS",
        "Anywhere",
        "svg",
        "amazonecsanywhere",
        "archcontainers"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon EFS",
      "category": "Arch Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_Amazon-EFS_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_Amazon-EFS_64.svg",
      "tokens": [
        "Amazon EFS",
        "Arch Storage",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Storage",
        "64",
        "Amazon",
        "EFS",
        "svg",
        "amazonefs",
        "archstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon EKS Anywhere",
      "category": "Arch Containers",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Containers/64/Arch_Amazon-EKS-Anywhere_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Containers/64/Arch_Amazon-EKS-Anywhere_64.svg",
      "tokens": [
        "Amazon EKS Anywhere",
        "Arch Containers",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Containers",
        "64",
        "Amazon",
        "EKS",
        "Anywhere",
        "svg",
        "amazoneksanywhere",
        "archcontainers"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon EKS Distro",
      "category": "Arch Containers",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Containers/64/Arch_Amazon-EKS-Distro_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Containers/64/Arch_Amazon-EKS-Distro_64.svg",
      "tokens": [
        "Amazon EKS Distro",
        "Arch Containers",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Containers",
        "64",
        "Amazon",
        "EKS",
        "Distro",
        "svg",
        "amazoneksdistro",
        "archcontainers"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Elasti Cache",
      "category": "Arch Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Databases/64/Arch_Amazon-ElastiCache_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Databases/64/Arch_Amazon-ElastiCache_64.svg",
      "tokens": [
        "Amazon Elasti Cache",
        "Arch Databases",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Databases",
        "64",
        "Amazon",
        "ElastiCache",
        "svg",
        "amazonelasticache",
        "archdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Elastic Block Store",
      "category": "Arch Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_Amazon-Elastic-Block-Store_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_Amazon-Elastic-Block-Store_64.svg",
      "tokens": [
        "Amazon Elastic Block Store",
        "Arch Storage",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Storage",
        "64",
        "Amazon",
        "Elastic",
        "Block",
        "Store",
        "svg",
        "amazonelasticblockstore",
        "archstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Elastic Container Registry",
      "category": "Arch Containers",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Containers/64/Arch_Amazon-Elastic-Container-Registry_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Containers/64/Arch_Amazon-Elastic-Container-Registry_64.svg",
      "tokens": [
        "Amazon Elastic Container Registry",
        "Arch Containers",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Containers",
        "64",
        "Amazon",
        "Elastic",
        "Container",
        "Registry",
        "svg",
        "amazonelasticcontainerregistry",
        "archcontainers"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Elastic Container Service",
      "category": "Arch Containers",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Containers/64/Arch_Amazon-Elastic-Container-Service_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Containers/64/Arch_Amazon-Elastic-Container-Service_64.svg",
      "tokens": [
        "Amazon Elastic Container Service",
        "Arch Containers",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Containers",
        "64",
        "Amazon",
        "Elastic",
        "Container",
        "svg",
        "amazonelasticcontainerservice",
        "archcontainers"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Elastic Inference",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Elastic-Inference_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Elastic-Inference_64.svg",
      "tokens": [
        "Amazon Elastic Inference",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "Elastic",
        "Inference",
        "svg",
        "amazonelasticinference",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Elastic Kubernetes Service",
      "category": "Arch Containers",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Containers/64/Arch_Amazon-Elastic-Kubernetes-Service_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Containers/64/Arch_Amazon-Elastic-Kubernetes-Service_64.svg",
      "tokens": [
        "Amazon Elastic Kubernetes Service",
        "Arch Containers",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Containers",
        "64",
        "Amazon",
        "Elastic",
        "Kubernetes",
        "svg",
        "amazonelastickubernetesservice",
        "archcontainers"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Elastic V Mware Service",
      "category": "Arch Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_Amazon-Elastic-VMware-Service_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_Amazon-Elastic-VMware-Service_64.svg",
      "tokens": [
        "Amazon Elastic V Mware Service",
        "Arch Compute",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Compute",
        "64",
        "Amazon",
        "Elastic",
        "VMware",
        "svg",
        "amazonelasticvmwareservice",
        "archcompute"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon EMR",
      "category": "Arch Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-EMR_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-EMR_64.svg",
      "tokens": [
        "Amazon EMR",
        "Arch Analytics",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Analytics",
        "64",
        "Amazon",
        "EMR",
        "svg",
        "amazonemr",
        "archanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Event Bridge",
      "category": "Arch Application Integration",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Application-Integration/64/Arch_Amazon-EventBridge_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Application-Integration/64/Arch_Amazon-EventBridge_64.svg",
      "tokens": [
        "Amazon Event Bridge",
        "Arch Application Integration",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Application",
        "Integration",
        "64",
        "Amazon",
        "EventBridge",
        "svg",
        "amazoneventbridge",
        "archapplicationintegration"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon F Sx For Lustre",
      "category": "Arch Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_Amazon-FSx-for-Lustre_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_Amazon-FSx-for-Lustre_64.svg",
      "tokens": [
        "Amazon F Sx For Lustre",
        "Arch Storage",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Storage",
        "64",
        "Amazon",
        "FSx",
        "for",
        "Lustre",
        "svg",
        "amazonfsxforlustre",
        "archstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon F Sx For Net App ONTAP",
      "category": "Arch Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_Amazon-FSx-for-NetApp-ONTAP_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_Amazon-FSx-for-NetApp-ONTAP_64.svg",
      "tokens": [
        "Amazon F Sx For Net App ONTAP",
        "Arch Storage",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Storage",
        "64",
        "Amazon",
        "FSx",
        "for",
        "NetApp",
        "ONTAP",
        "svg",
        "amazonfsxfornetappontap",
        "archstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon F Sx For Open ZFS",
      "category": "Arch Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_Amazon-FSx-for-OpenZFS_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_Amazon-FSx-for-OpenZFS_64.svg",
      "tokens": [
        "Amazon F Sx For Open ZFS",
        "Arch Storage",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Storage",
        "64",
        "Amazon",
        "FSx",
        "for",
        "OpenZFS",
        "svg",
        "amazonfsxforopenzfs",
        "archstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon F Sx For WFS",
      "category": "Arch Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_Amazon-FSx-for-WFS_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_Amazon-FSx-for-WFS_64.svg",
      "tokens": [
        "Amazon F Sx For WFS",
        "Arch Storage",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Storage",
        "64",
        "Amazon",
        "FSx",
        "for",
        "WFS",
        "svg",
        "amazonfsxforwfs",
        "archstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon F Sx",
      "category": "Arch Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_Amazon-FSx_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_Amazon-FSx_64.svg",
      "tokens": [
        "Amazon F Sx",
        "Arch Storage",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Storage",
        "64",
        "Amazon",
        "FSx",
        "svg",
        "amazonfsx",
        "archstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon File Cache",
      "category": "Arch Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_Amazon-File-Cache_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_Amazon-File-Cache_64.svg",
      "tokens": [
        "Amazon File Cache",
        "Arch Storage",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Storage",
        "64",
        "Amazon",
        "File",
        "Cache",
        "svg",
        "amazonfilecache",
        "archstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Fin Space",
      "category": "Arch Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-FinSpace_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-FinSpace_64.svg",
      "tokens": [
        "Amazon Fin Space",
        "Arch Analytics",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Analytics",
        "64",
        "Amazon",
        "FinSpace",
        "svg",
        "amazonfinspace",
        "archanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Forecast",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Forecast_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Forecast_64.svg",
      "tokens": [
        "Amazon Forecast",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "Forecast",
        "svg",
        "amazonforecast",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Fraud Detector",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Fraud-Detector_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Fraud-Detector_64.svg",
      "tokens": [
        "Amazon Fraud Detector",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "Fraud",
        "Detector",
        "svg",
        "amazonfrauddetector",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Game Lift Servers",
      "category": "Arch Games",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Games/64/Arch_Amazon-GameLift-Servers_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Games/64/Arch_Amazon-GameLift-Servers_64.svg",
      "tokens": [
        "Amazon Game Lift Servers",
        "Arch Games",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Games",
        "64",
        "Amazon",
        "GameLift",
        "Servers",
        "svg",
        "amazongameliftservers",
        "archgames"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Game Lift Streams",
      "category": "Arch Games",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Games/64/Arch_Amazon-GameLift-Streams_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Games/64/Arch_Amazon-GameLift-Streams_64.svg",
      "tokens": [
        "Amazon Game Lift Streams",
        "Arch Games",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Games",
        "64",
        "Amazon",
        "GameLift",
        "Streams",
        "svg",
        "amazongameliftstreams",
        "archgames"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Guard Duty",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_Amazon-GuardDuty_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_Amazon-GuardDuty_64.svg",
      "tokens": [
        "Amazon Guard Duty",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "Amazon",
        "GuardDuty",
        "svg",
        "amazonguardduty",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Inspector",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_Amazon-Inspector_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_Amazon-Inspector_64.svg",
      "tokens": [
        "Amazon Inspector",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "Amazon",
        "Inspector",
        "svg",
        "amazoninspector",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Interactive Video Service",
      "category": "Arch Media Services",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_Amazon-Interactive-Video-Service_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_Amazon-Interactive-Video-Service_64.svg",
      "tokens": [
        "Amazon Interactive Video Service",
        "Arch Media Services",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Media",
        "Services",
        "64",
        "Amazon",
        "Interactive",
        "Video",
        "svg",
        "amazoninteractivevideoservice",
        "archmediaservices"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Kendra",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Kendra_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Kendra_64.svg",
      "tokens": [
        "Amazon Kendra",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "Kendra",
        "svg",
        "amazonkendra",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Keyspaces",
      "category": "Arch Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Databases/64/Arch_Amazon-Keyspaces_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Databases/64/Arch_Amazon-Keyspaces_64.svg",
      "tokens": [
        "Amazon Keyspaces",
        "Arch Databases",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Databases",
        "64",
        "Amazon",
        "Keyspaces",
        "svg",
        "amazonkeyspaces",
        "archdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Kinesis Data Streams",
      "category": "Arch Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-Kinesis-Data-Streams_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-Kinesis-Data-Streams_64.svg",
      "tokens": [
        "Amazon Kinesis Data Streams",
        "Arch Analytics",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Analytics",
        "64",
        "Amazon",
        "Kinesis",
        "Data",
        "Streams",
        "svg",
        "amazonkinesisdatastreams",
        "archanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Kinesis Video Streams",
      "category": "Arch Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-Kinesis-Video-Streams_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-Kinesis-Video-Streams_64.svg",
      "tokens": [
        "Amazon Kinesis Video Streams",
        "Arch Analytics",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Analytics",
        "64",
        "Amazon",
        "Kinesis",
        "Video",
        "Streams",
        "svg",
        "amazonkinesisvideostreams",
        "archanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Kinesis Video Streams",
      "category": "Arch Media Services",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_Amazon-Kinesis-Video-Streams_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_Amazon-Kinesis-Video-Streams_64.svg",
      "tokens": [
        "Amazon Kinesis Video Streams",
        "Arch Media Services",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Media",
        "Services",
        "64",
        "Amazon",
        "Kinesis",
        "Video",
        "Streams",
        "svg",
        "amazonkinesisvideostreams",
        "archmediaservices"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Kinesis",
      "category": "Arch Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-Kinesis_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-Kinesis_64.svg",
      "tokens": [
        "Amazon Kinesis",
        "Arch Analytics",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Analytics",
        "64",
        "Amazon",
        "Kinesis",
        "svg",
        "amazonkinesis",
        "archanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Lex",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Lex_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Lex_64.svg",
      "tokens": [
        "Amazon Lex",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "Lex",
        "svg",
        "amazonlex",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Lightsail For Research",
      "category": "Arch Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_Amazon-Lightsail-for-Research_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_Amazon-Lightsail-for-Research_64.svg",
      "tokens": [
        "Amazon Lightsail For Research",
        "Arch Compute",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Compute",
        "64",
        "Amazon",
        "Lightsail",
        "for",
        "Research",
        "svg",
        "amazonlightsailforresearch",
        "archcompute"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Lightsail",
      "category": "Arch Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_Amazon-Lightsail_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_Amazon-Lightsail_64.svg",
      "tokens": [
        "Amazon Lightsail",
        "Arch Compute",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Compute",
        "64",
        "Amazon",
        "Lightsail",
        "svg",
        "amazonlightsail",
        "archcompute"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Location Service",
      "category": "Arch Front End Web Mobile",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Front-End-Web-Mobile/64/Arch_Amazon-Location-Service_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Front-End-Web-Mobile/64/Arch_Amazon-Location-Service_64.svg",
      "tokens": [
        "Amazon Location Service",
        "Arch Front End Web Mobile",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Front",
        "End",
        "Web",
        "Mobile",
        "64",
        "Amazon",
        "Location",
        "svg",
        "amazonlocationservice",
        "archfrontendwebmobile"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Lookout For Equipment",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Lookout-for-Equipment_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Lookout-for-Equipment_64.svg",
      "tokens": [
        "Amazon Lookout For Equipment",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "Lookout",
        "for",
        "Equipment",
        "svg",
        "amazonlookoutforequipment",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Lookout For Vision",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Lookout-for-Vision_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Lookout-for-Vision_64.svg",
      "tokens": [
        "Amazon Lookout For Vision",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "Lookout",
        "for",
        "Vision",
        "svg",
        "amazonlookoutforvision",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Macie",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_Amazon-Macie_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_Amazon-Macie_64.svg",
      "tokens": [
        "Amazon Macie",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "Amazon",
        "Macie",
        "svg",
        "amazonmacie",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Managed Blockchain",
      "category": "Arch Blockchain",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Blockchain/64/Arch_Amazon-Managed-Blockchain_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Blockchain/64/Arch_Amazon-Managed-Blockchain_64.svg",
      "tokens": [
        "Amazon Managed Blockchain",
        "Arch Blockchain",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Blockchain",
        "64",
        "Amazon",
        "Managed",
        "svg",
        "amazonmanagedblockchain",
        "archblockchain"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Managed Grafana",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_Amazon-Managed-Grafana_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_Amazon-Managed-Grafana_64.svg",
      "tokens": [
        "Amazon Managed Grafana",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "Amazon",
        "Managed",
        "Grafana",
        "svg",
        "amazonmanagedgrafana",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Managed Service For Apache Flink",
      "category": "Arch Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-Managed-Service-for-Apache-Flink_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-Managed-Service-for-Apache-Flink_64.svg",
      "tokens": [
        "Amazon Managed Service For Apache Flink",
        "Arch Analytics",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Analytics",
        "64",
        "Amazon",
        "Managed",
        "for",
        "Apache",
        "Flink",
        "svg",
        "amazonmanagedserviceforapacheflink",
        "archanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Managed Service For Prometheus",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_Amazon-Managed-Service-for-Prometheus_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_Amazon-Managed-Service-for-Prometheus_64.svg",
      "tokens": [
        "Amazon Managed Service For Prometheus",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "Amazon",
        "Managed",
        "for",
        "Prometheus",
        "svg",
        "amazonmanagedserviceforprometheus",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Managed Streaming For Apache Kafka",
      "category": "Arch Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-Managed-Streaming-for-Apache-Kafka_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-Managed-Streaming-for-Apache-Kafka_64.svg",
      "tokens": [
        "Amazon Managed Streaming For Apache Kafka",
        "Arch Analytics",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Analytics",
        "64",
        "Amazon",
        "Managed",
        "Streaming",
        "for",
        "Apache",
        "Kafka",
        "svg",
        "amazonmanagedstreamingforapachekafka",
        "archanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Managed Workflows For Apache Airflow",
      "category": "Arch Application Integration",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Application-Integration/64/Arch_Amazon-Managed-Workflows-for-Apache-Airflow_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Application-Integration/64/Arch_Amazon-Managed-Workflows-for-Apache-Airflow_64.svg",
      "tokens": [
        "Amazon Managed Workflows For Apache Airflow",
        "Arch Application Integration",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Application",
        "Integration",
        "64",
        "Amazon",
        "Managed",
        "Workflows",
        "for",
        "Apache",
        "Airflow",
        "svg",
        "amazonmanagedworkflowsforapacheairflow",
        "archapplicationintegration"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Memory DB",
      "category": "Arch Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Databases/64/Arch_Amazon-MemoryDB_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Databases/64/Arch_Amazon-MemoryDB_64.svg",
      "tokens": [
        "Amazon Memory DB",
        "Arch Databases",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Databases",
        "64",
        "Amazon",
        "MemoryDB",
        "svg",
        "amazonmemorydb",
        "archdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Monitron",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Monitron_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Monitron_64.svg",
      "tokens": [
        "Amazon Monitron",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "Monitron",
        "svg",
        "amazonmonitron",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon MQ",
      "category": "Arch Application Integration",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Application-Integration/64/Arch_Amazon-MQ_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Application-Integration/64/Arch_Amazon-MQ_64.svg",
      "tokens": [
        "Amazon MQ",
        "Arch Application Integration",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Application",
        "Integration",
        "64",
        "Amazon",
        "MQ",
        "svg",
        "amazonmq",
        "archapplicationintegration"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Neptune",
      "category": "Arch Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Databases/64/Arch_Amazon-Neptune_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Databases/64/Arch_Amazon-Neptune_64.svg",
      "tokens": [
        "Amazon Neptune",
        "Arch Databases",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Databases",
        "64",
        "Amazon",
        "Neptune",
        "svg",
        "amazonneptune",
        "archdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Nova",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Nova_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Nova_64.svg",
      "tokens": [
        "Amazon Nova",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "Nova",
        "svg",
        "amazonnova",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Open Search Service",
      "category": "Arch Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-OpenSearch-Service_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-OpenSearch-Service_64.svg",
      "tokens": [
        "Amazon Open Search Service",
        "Arch Analytics",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Analytics",
        "64",
        "Amazon",
        "OpenSearch",
        "svg",
        "amazonopensearchservice",
        "archanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Personalize",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Personalize_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Personalize_64.svg",
      "tokens": [
        "Amazon Personalize",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "Personalize",
        "svg",
        "amazonpersonalize",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Pinpoint AP Is",
      "category": "Arch Business Applications",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_Amazon-Pinpoint-APIs_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_Amazon-Pinpoint-APIs_64.svg",
      "tokens": [
        "Amazon Pinpoint AP Is",
        "Arch Business Applications",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Business",
        "Applications",
        "64",
        "Amazon",
        "Pinpoint",
        "APIs",
        "svg",
        "amazonpinpointapis",
        "archbusinessapplications"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Pinpoint",
      "category": "Arch Business Applications",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_Amazon-Pinpoint_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_Amazon-Pinpoint_64.svg",
      "tokens": [
        "Amazon Pinpoint",
        "Arch Business Applications",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Business",
        "Applications",
        "64",
        "Amazon",
        "Pinpoint",
        "svg",
        "amazonpinpoint",
        "archbusinessapplications"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Polly",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Polly_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Polly_64.svg",
      "tokens": [
        "Amazon Polly",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "Polly",
        "svg",
        "amazonpolly",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Q",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Q_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Q_64.svg",
      "tokens": [
        "Amazon Q",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "Q",
        "svg",
        "amazonq",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Quick",
      "category": "Arch Business Applications",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_Amazon-Quick_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_Amazon-Quick_64.svg",
      "tokens": [
        "Amazon Quick",
        "Arch Business Applications",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Business",
        "Applications",
        "64",
        "Amazon",
        "Quick",
        "svg",
        "amazonquick",
        "archbusinessapplications"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon RDS",
      "category": "Arch Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Databases/64/Arch_Amazon-RDS_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Databases/64/Arch_Amazon-RDS_64.svg",
      "tokens": [
        "Amazon RDS",
        "Arch Databases",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Databases",
        "64",
        "Amazon",
        "RDS",
        "svg",
        "amazonrds",
        "archdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Redshift",
      "category": "Arch Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-Redshift_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-Redshift_64.svg",
      "tokens": [
        "Amazon Redshift",
        "Arch Analytics",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Analytics",
        "64",
        "Amazon",
        "Redshift",
        "svg",
        "amazonredshift",
        "archanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Rekognition",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Rekognition_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Rekognition_64.svg",
      "tokens": [
        "Amazon Rekognition",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "Rekognition",
        "svg",
        "amazonrekognition",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Route 53",
      "category": "Arch Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_Amazon-Route-53_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_Amazon-Route-53_64.svg",
      "tokens": [
        "Amazon Route 53",
        "Arch Networking Content Delivery",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Networking",
        "Content",
        "Delivery",
        "64",
        "Amazon",
        "Route",
        "53",
        "svg",
        "amazonroute53",
        "archnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon S3 On Outposts",
      "category": "Arch Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_Amazon-S3-on-Outposts_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_Amazon-S3-on-Outposts_64.svg",
      "tokens": [
        "Amazon S3 On Outposts",
        "Arch Storage",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Storage",
        "64",
        "Amazon",
        "S3",
        "on",
        "Outposts",
        "svg",
        "amazons3onoutposts",
        "archstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Sage Maker AI",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-SageMaker-AI_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-SageMaker-AI_64.svg",
      "tokens": [
        "Amazon Sage Maker AI",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "SageMaker",
        "AI",
        "svg",
        "amazonsagemakerai",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Sage Maker Ground Truth",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-SageMaker-Ground-Truth_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-SageMaker-Ground-Truth_64.svg",
      "tokens": [
        "Amazon Sage Maker Ground Truth",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "SageMaker",
        "Ground",
        "Truth",
        "svg",
        "amazonsagemakergroundtruth",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Sage Maker Studio Lab",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-SageMaker-Studio-Lab_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-SageMaker-Studio-Lab_64.svg",
      "tokens": [
        "Amazon Sage Maker Studio Lab",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "SageMaker",
        "Studio",
        "Lab",
        "svg",
        "amazonsagemakerstudiolab",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Sage Maker",
      "category": "Arch Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-SageMaker_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_Amazon-SageMaker_64.svg",
      "tokens": [
        "Amazon Sage Maker",
        "Arch Analytics",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Analytics",
        "64",
        "Amazon",
        "SageMaker",
        "svg",
        "amazonsagemaker",
        "archanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Security Lake",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_Amazon-Security-Lake_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_Amazon-Security-Lake_64.svg",
      "tokens": [
        "Amazon Security Lake",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "Amazon",
        "Lake",
        "svg",
        "amazonsecuritylake",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Simple Email Service",
      "category": "Arch Business Applications",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_Amazon-Simple-Email-Service_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_Amazon-Simple-Email-Service_64.svg",
      "tokens": [
        "Amazon Simple Email Service",
        "Arch Business Applications",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Business",
        "Applications",
        "64",
        "Amazon",
        "Simple",
        "Email",
        "svg",
        "amazonsimpleemailservice",
        "archbusinessapplications"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Simple Notification Service",
      "category": "Arch Application Integration",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Application-Integration/64/Arch_Amazon-Simple-Notification-Service_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Application-Integration/64/Arch_Amazon-Simple-Notification-Service_64.svg",
      "tokens": [
        "Amazon Simple Notification Service",
        "Arch Application Integration",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Application",
        "Integration",
        "64",
        "Amazon",
        "Simple",
        "Notification",
        "svg",
        "amazonsimplenotificationservice",
        "archapplicationintegration"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Simple Queue Service",
      "category": "Arch Application Integration",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Application-Integration/64/Arch_Amazon-Simple-Queue-Service_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Application-Integration/64/Arch_Amazon-Simple-Queue-Service_64.svg",
      "tokens": [
        "Amazon Simple Queue Service",
        "Arch Application Integration",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Application",
        "Integration",
        "64",
        "Amazon",
        "Simple",
        "Queue",
        "svg",
        "amazonsimplequeueservice",
        "archapplicationintegration"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Simple Storage Service Glacier",
      "category": "Arch Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_Amazon-Simple-Storage-Service-Glacier_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_Amazon-Simple-Storage-Service-Glacier_64.svg",
      "tokens": [
        "Amazon Simple Storage Service Glacier",
        "Arch Storage",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Storage",
        "64",
        "Amazon",
        "Simple",
        "Glacier",
        "svg",
        "amazonsimplestorageserviceglacier",
        "archstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Simple Storage Service",
      "category": "Arch Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_Amazon-Simple-Storage-Service_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_Amazon-Simple-Storage-Service_64.svg",
      "tokens": [
        "Amazon Simple Storage Service",
        "Arch Storage",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Storage",
        "64",
        "Amazon",
        "Simple",
        "svg",
        "amazonsimplestorageservice",
        "archstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Textract",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Textract_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Textract_64.svg",
      "tokens": [
        "Amazon Textract",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "Textract",
        "svg",
        "amazontextract",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Timestream",
      "category": "Arch Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Databases/64/Arch_Amazon-Timestream_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Databases/64/Arch_Amazon-Timestream_64.svg",
      "tokens": [
        "Amazon Timestream",
        "Arch Databases",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Databases",
        "64",
        "Amazon",
        "Timestream",
        "svg",
        "amazontimestream",
        "archdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Transcribe",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Transcribe_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Transcribe_64.svg",
      "tokens": [
        "Amazon Transcribe",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "Transcribe",
        "svg",
        "amazontranscribe",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Translate",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Translate_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Amazon-Translate_64.svg",
      "tokens": [
        "Amazon Translate",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Amazon",
        "Translate",
        "svg",
        "amazontranslate",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Verified Permissions",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_Amazon-Verified-Permissions_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_Amazon-Verified-Permissions_64.svg",
      "tokens": [
        "Amazon Verified Permissions",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "Amazon",
        "Verified",
        "Permissions",
        "svg",
        "amazonverifiedpermissions",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Virtual Private Cloud",
      "category": "Arch Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_Amazon-Virtual-Private-Cloud_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_Amazon-Virtual-Private-Cloud_64.svg",
      "tokens": [
        "Amazon Virtual Private Cloud",
        "Arch Networking Content Delivery",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Networking",
        "Content",
        "Delivery",
        "64",
        "Amazon",
        "Virtual",
        "Private",
        "Cloud",
        "svg",
        "amazonvirtualprivatecloud",
        "archnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon VPC Lattice",
      "category": "Arch Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_Amazon-VPC-Lattice_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_Amazon-VPC-Lattice_64.svg",
      "tokens": [
        "Amazon VPC Lattice",
        "Arch Networking Content Delivery",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Networking",
        "Content",
        "Delivery",
        "64",
        "Amazon",
        "VPC",
        "Lattice",
        "svg",
        "amazonvpclattice",
        "archnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Work Docs SDK",
      "category": "Arch Business Applications",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_Amazon-WorkDocs-SDK_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_Amazon-WorkDocs-SDK_64.svg",
      "tokens": [
        "Amazon Work Docs SDK",
        "Arch Business Applications",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Business",
        "Applications",
        "64",
        "Amazon",
        "WorkDocs",
        "SDK",
        "svg",
        "amazonworkdocssdk",
        "archbusinessapplications"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Work Docs",
      "category": "Arch Business Applications",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_Amazon-WorkDocs_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_Amazon-WorkDocs_64.svg",
      "tokens": [
        "Amazon Work Docs",
        "Arch Business Applications",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Business",
        "Applications",
        "64",
        "Amazon",
        "WorkDocs",
        "svg",
        "amazonworkdocs",
        "archbusinessapplications"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Work Mail",
      "category": "Arch Business Applications",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_Amazon-WorkMail_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_Amazon-WorkMail_64.svg",
      "tokens": [
        "Amazon Work Mail",
        "Arch Business Applications",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Business",
        "Applications",
        "64",
        "Amazon",
        "WorkMail",
        "svg",
        "amazonworkmail",
        "archbusinessapplications"
      ]
    },
    {
      "provider": "aws",
      "label": "Amazon Work Spaces",
      "category": "Arch End User Computing",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_End-User-Computing/64/Arch_Amazon-WorkSpaces_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_End-User-Computing/64/Arch_Amazon-WorkSpaces_64.svg",
      "tokens": [
        "Amazon Work Spaces",
        "Arch End User Computing",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "End",
        "User",
        "Computing",
        "64",
        "Amazon",
        "WorkSpaces",
        "svg",
        "amazonworkspaces",
        "archendusercomputing"
      ]
    },
    {
      "provider": "aws",
      "label": "Apache MX Net On AWS",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Apache-MXNet-on-AWS_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_Apache-MXNet-on-AWS_64.svg",
      "tokens": [
        "Apache MX Net On AWS",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "Apache",
        "MXNet",
        "on",
        "AWS",
        "svg",
        "apachemxnetonaws",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Auto Scaling Group",
      "category": "Architecture Group Icons 04302026",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Group-Icons_04302026/Auto-Scaling-group_32.svg",
      "sourcePath": "Architecture-Group-Icons_04302026/Auto-Scaling-group_32.svg",
      "tokens": [
        "Auto Scaling Group",
        "Architecture Group Icons 04302026",
        "Architecture",
        "Group",
        "Icons",
        "04302026",
        "Auto",
        "Scaling",
        "group",
        "32",
        "svg",
        "autoscalinggroup",
        "architecturegroupicons04302026"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Account",
      "category": "Architecture Group Icons 04302026",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Group-Icons_04302026/AWS-Account_32.svg",
      "sourcePath": "Architecture-Group-Icons_04302026/AWS-Account_32.svg",
      "tokens": [
        "AWS Account",
        "Architecture Group Icons 04302026",
        "Architecture",
        "Group",
        "Icons",
        "04302026",
        "AWS",
        "Account",
        "32",
        "svg",
        "awsaccount",
        "architecturegroupicons04302026"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Activate",
      "category": "Arch Customer Enablement",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Customer-Enablement/64/Arch_AWS-Activate_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Customer-Enablement/64/Arch_AWS-Activate_64.svg",
      "tokens": [
        "AWS Activate",
        "Arch Customer Enablement",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Customer",
        "Enablement",
        "64",
        "AWS",
        "Activate",
        "svg",
        "awsactivate",
        "archcustomerenablement"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Amplify",
      "category": "Arch Front End Web Mobile",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Front-End-Web-Mobile/64/Arch_AWS-Amplify_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Front-End-Web-Mobile/64/Arch_AWS-Amplify_64.svg",
      "tokens": [
        "AWS Amplify",
        "Arch Front End Web Mobile",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Front",
        "End",
        "Web",
        "Mobile",
        "64",
        "AWS",
        "Amplify",
        "svg",
        "awsamplify",
        "archfrontendwebmobile"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS App Config",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-AppConfig_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-AppConfig_64.svg",
      "tokens": [
        "AWS App Config",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "AppConfig",
        "svg",
        "awsappconfig",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS App Fabric",
      "category": "Arch Business Applications",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_AWS-AppFabric_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_AWS-AppFabric_64.svg",
      "tokens": [
        "AWS App Fabric",
        "Arch Business Applications",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Business",
        "Applications",
        "64",
        "AWS",
        "AppFabric",
        "svg",
        "awsappfabric",
        "archbusinessapplications"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS App Mesh",
      "category": "Arch Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_AWS-App-Mesh_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_AWS-App-Mesh_64.svg",
      "tokens": [
        "AWS App Mesh",
        "Arch Networking Content Delivery",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Networking",
        "Content",
        "Delivery",
        "64",
        "AWS",
        "App",
        "Mesh",
        "svg",
        "awsappmesh",
        "archnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS App Runner",
      "category": "Arch Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-App-Runner_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-App-Runner_64.svg",
      "tokens": [
        "AWS App Runner",
        "Arch Compute",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Compute",
        "64",
        "AWS",
        "App",
        "Runner",
        "svg",
        "awsapprunner",
        "archcompute"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS App Studio",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_AWS-App-Studio_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_AWS-App-Studio_64.svg",
      "tokens": [
        "AWS App Studio",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "AWS",
        "App",
        "Studio",
        "svg",
        "awsappstudio",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS App Sync",
      "category": "Arch Application Integration",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Application-Integration/64/Arch_AWS-AppSync_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Application-Integration/64/Arch_AWS-AppSync_64.svg",
      "tokens": [
        "AWS App Sync",
        "Arch Application Integration",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Application",
        "Integration",
        "64",
        "AWS",
        "AppSync",
        "svg",
        "awsappsync",
        "archapplicationintegration"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Application Auto Scaling",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Application-Auto-Scaling_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Application-Auto-Scaling_64.svg",
      "tokens": [
        "AWS Application Auto Scaling",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "Application",
        "Auto",
        "Scaling",
        "svg",
        "awsapplicationautoscaling",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Application Discovery Service",
      "category": "Arch Migration Modernization",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Migration-Modernization/64/Arch_AWS-Application-Discovery-Service_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Migration-Modernization/64/Arch_AWS-Application-Discovery-Service_64.svg",
      "tokens": [
        "AWS Application Discovery Service",
        "Arch Migration Modernization",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Migration",
        "Modernization",
        "64",
        "AWS",
        "Application",
        "Discovery",
        "svg",
        "awsapplicationdiscoveryservice",
        "archmigrationmodernization"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Application Migration Service",
      "category": "Arch Migration Modernization",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Migration-Modernization/64/Arch_AWS-Application-Migration-Service_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Migration-Modernization/64/Arch_AWS-Application-Migration-Service_64.svg",
      "tokens": [
        "AWS Application Migration Service",
        "Arch Migration Modernization",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Migration",
        "Modernization",
        "64",
        "AWS",
        "Application",
        "svg",
        "awsapplicationmigrationservice",
        "archmigrationmodernization"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Artifact",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Artifact_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Artifact_64.svg",
      "tokens": [
        "AWS Artifact",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "AWS",
        "Artifact",
        "svg",
        "awsartifact",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Audit Manager",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Audit-Manager_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Audit-Manager_64.svg",
      "tokens": [
        "AWS Audit Manager",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "AWS",
        "Audit",
        "Manager",
        "svg",
        "awsauditmanager",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Auto Scaling",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Auto-Scaling_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Auto-Scaling_64.svg",
      "tokens": [
        "AWS Auto Scaling",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "Auto",
        "Scaling",
        "svg",
        "awsautoscaling",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS B2 B Data Interchange",
      "category": "Arch Application Integration",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Application-Integration/64/Arch_AWS-B2B-Data-Interchange_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Application-Integration/64/Arch_AWS-B2B-Data-Interchange_64.svg",
      "tokens": [
        "AWS B2 B Data Interchange",
        "Arch Application Integration",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Application",
        "Integration",
        "64",
        "AWS",
        "B2B",
        "Data",
        "Interchange",
        "svg",
        "awsb2bdatainterchange",
        "archapplicationintegration"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Backint Agent",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Backint-Agent_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Backint-Agent_64.svg",
      "tokens": [
        "AWS Backint Agent",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "Backint",
        "Agent",
        "svg",
        "awsbackintagent",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Backup",
      "category": "Arch Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_AWS-Backup_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_AWS-Backup_64.svg",
      "tokens": [
        "AWS Backup",
        "Arch Storage",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Storage",
        "64",
        "AWS",
        "Backup",
        "svg",
        "awsbackup",
        "archstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Batch",
      "category": "Arch Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-Batch_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-Batch_64.svg",
      "tokens": [
        "AWS Batch",
        "Arch Compute",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Compute",
        "64",
        "AWS",
        "Batch",
        "svg",
        "awsbatch",
        "archcompute"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Billing Conductor",
      "category": "Arch Cloud Financial Management",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Cloud-Financial-Management/64/Arch_AWS-Billing-Conductor_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Cloud-Financial-Management/64/Arch_AWS-Billing-Conductor_64.svg",
      "tokens": [
        "AWS Billing Conductor",
        "Arch Cloud Financial Management",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Cloud",
        "Financial",
        "Management",
        "64",
        "AWS",
        "Billing",
        "Conductor",
        "svg",
        "awsbillingconductor",
        "archcloudfinancialmanagement"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Budgets",
      "category": "Arch Cloud Financial Management",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Cloud-Financial-Management/64/Arch_AWS-Budgets_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Cloud-Financial-Management/64/Arch_AWS-Budgets_64.svg",
      "tokens": [
        "AWS Budgets",
        "Arch Cloud Financial Management",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Cloud",
        "Financial",
        "Management",
        "64",
        "AWS",
        "Budgets",
        "svg",
        "awsbudgets",
        "archcloudfinancialmanagement"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Certificate Manager",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Certificate-Manager_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Certificate-Manager_64.svg",
      "tokens": [
        "AWS Certificate Manager",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "AWS",
        "Certificate",
        "Manager",
        "svg",
        "awscertificatemanager",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Chatbot",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Chatbot_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Chatbot_64.svg",
      "tokens": [
        "AWS Chatbot",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "Chatbot",
        "svg",
        "awschatbot",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Clean Rooms",
      "category": "Arch Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_AWS-Clean-Rooms_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_AWS-Clean-Rooms_64.svg",
      "tokens": [
        "AWS Clean Rooms",
        "Arch Analytics",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Analytics",
        "64",
        "AWS",
        "Clean",
        "Rooms",
        "svg",
        "awscleanrooms",
        "archanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Client VPN",
      "category": "Arch Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_AWS-Client-VPN_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_AWS-Client-VPN_64.svg",
      "tokens": [
        "AWS Client VPN",
        "Arch Networking Content Delivery",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Networking",
        "Content",
        "Delivery",
        "64",
        "AWS",
        "Client",
        "VPN",
        "svg",
        "awsclientvpn",
        "archnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Cloud 32 Dark",
      "category": "Architecture Group Icons 04302026",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Group-Icons_04302026/AWS-Cloud_32_Dark.svg",
      "sourcePath": "Architecture-Group-Icons_04302026/AWS-Cloud_32_Dark.svg",
      "tokens": [
        "AWS Cloud 32 Dark",
        "Architecture Group Icons 04302026",
        "Architecture",
        "Group",
        "Icons",
        "04302026",
        "AWS",
        "Cloud",
        "32",
        "Dark",
        "svg",
        "awscloud32dark",
        "architecturegroupicons04302026"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Cloud Control API",
      "category": "Arch Developer Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-Cloud-Control-API_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-Cloud-Control-API_64.svg",
      "tokens": [
        "AWS Cloud Control API",
        "Arch Developer Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Developer",
        "Tools",
        "64",
        "AWS",
        "Cloud",
        "Control",
        "API",
        "svg",
        "awscloudcontrolapi",
        "archdevelopertools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Cloud Development Kit",
      "category": "Arch Developer Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-Cloud-Development-Kit_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-Cloud-Development-Kit_64.svg",
      "tokens": [
        "AWS Cloud Development Kit",
        "Arch Developer Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Developer",
        "Tools",
        "64",
        "AWS",
        "Cloud",
        "Development",
        "Kit",
        "svg",
        "awsclouddevelopmentkit",
        "archdevelopertools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Cloud Formation",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-CloudFormation_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-CloudFormation_64.svg",
      "tokens": [
        "AWS Cloud Formation",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "CloudFormation",
        "svg",
        "awscloudformation",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Cloud HSM",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-CloudHSM_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-CloudHSM_64.svg",
      "tokens": [
        "AWS Cloud HSM",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "AWS",
        "CloudHSM",
        "svg",
        "awscloudhsm",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Cloud Logo 32 Dark",
      "category": "Architecture Group Icons 04302026",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Group-Icons_04302026/AWS-Cloud-logo_32_Dark.svg",
      "sourcePath": "Architecture-Group-Icons_04302026/AWS-Cloud-logo_32_Dark.svg",
      "tokens": [
        "AWS Cloud Logo 32 Dark",
        "Architecture Group Icons 04302026",
        "Architecture",
        "Group",
        "Icons",
        "04302026",
        "AWS",
        "Cloud",
        "logo",
        "32",
        "Dark",
        "svg",
        "awscloudlogo32dark",
        "architecturegroupicons04302026"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Cloud Logo",
      "category": "Architecture Group Icons 04302026",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Group-Icons_04302026/AWS-Cloud-logo_32.svg",
      "sourcePath": "Architecture-Group-Icons_04302026/AWS-Cloud-logo_32.svg",
      "tokens": [
        "AWS Cloud Logo",
        "Architecture Group Icons 04302026",
        "Architecture",
        "Group",
        "Icons",
        "04302026",
        "AWS",
        "Cloud",
        "logo",
        "32",
        "svg",
        "awscloudlogo",
        "architecturegroupicons04302026"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Cloud Map",
      "category": "Arch Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_AWS-Cloud-Map_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_AWS-Cloud-Map_64.svg",
      "tokens": [
        "AWS Cloud Map",
        "Arch Networking Content Delivery",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Networking",
        "Content",
        "Delivery",
        "64",
        "AWS",
        "Cloud",
        "Map",
        "svg",
        "awscloudmap",
        "archnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Cloud Shell",
      "category": "Arch Developer Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-CloudShell_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-CloudShell_64.svg",
      "tokens": [
        "AWS Cloud Shell",
        "Arch Developer Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Developer",
        "Tools",
        "64",
        "AWS",
        "CloudShell",
        "svg",
        "awscloudshell",
        "archdevelopertools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Cloud Trail",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-CloudTrail_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-CloudTrail_64.svg",
      "tokens": [
        "AWS Cloud Trail",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "CloudTrail",
        "svg",
        "awscloudtrail",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Cloud WAN",
      "category": "Arch Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_AWS-Cloud-WAN_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_AWS-Cloud-WAN_64.svg",
      "tokens": [
        "AWS Cloud WAN",
        "Arch Networking Content Delivery",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Networking",
        "Content",
        "Delivery",
        "64",
        "AWS",
        "Cloud",
        "WAN",
        "svg",
        "awscloudwan",
        "archnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Cloud",
      "category": "Architecture Group Icons 04302026",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Group-Icons_04302026/AWS-Cloud_32.svg",
      "sourcePath": "Architecture-Group-Icons_04302026/AWS-Cloud_32.svg",
      "tokens": [
        "AWS Cloud",
        "Architecture Group Icons 04302026",
        "Architecture",
        "Group",
        "Icons",
        "04302026",
        "AWS",
        "Cloud",
        "32",
        "svg",
        "awscloud",
        "architecturegroupicons04302026"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Cloud9",
      "category": "Arch Developer Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-Cloud9_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-Cloud9_64.svg",
      "tokens": [
        "AWS Cloud9",
        "Arch Developer Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Developer",
        "Tools",
        "64",
        "AWS",
        "Cloud9",
        "svg",
        "awscloud9",
        "archdevelopertools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Code Artifact",
      "category": "Arch Developer Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-CodeArtifact_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-CodeArtifact_64.svg",
      "tokens": [
        "AWS Code Artifact",
        "Arch Developer Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Developer",
        "Tools",
        "64",
        "AWS",
        "CodeArtifact",
        "svg",
        "awscodeartifact",
        "archdevelopertools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Code Build",
      "category": "Arch Developer Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-CodeBuild_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-CodeBuild_64.svg",
      "tokens": [
        "AWS Code Build",
        "Arch Developer Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Developer",
        "Tools",
        "64",
        "AWS",
        "CodeBuild",
        "svg",
        "awscodebuild",
        "archdevelopertools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Code Commit",
      "category": "Arch Developer Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-CodeCommit_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-CodeCommit_64.svg",
      "tokens": [
        "AWS Code Commit",
        "Arch Developer Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Developer",
        "Tools",
        "64",
        "AWS",
        "CodeCommit",
        "svg",
        "awscodecommit",
        "archdevelopertools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Code Deploy",
      "category": "Arch Developer Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-CodeDeploy_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-CodeDeploy_64.svg",
      "tokens": [
        "AWS Code Deploy",
        "Arch Developer Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Developer",
        "Tools",
        "64",
        "AWS",
        "CodeDeploy",
        "svg",
        "awscodedeploy",
        "archdevelopertools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Code Pipeline",
      "category": "Arch Developer Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-CodePipeline_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-CodePipeline_64.svg",
      "tokens": [
        "AWS Code Pipeline",
        "Arch Developer Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Developer",
        "Tools",
        "64",
        "AWS",
        "CodePipeline",
        "svg",
        "awscodepipeline",
        "archdevelopertools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Command Line Interface",
      "category": "Arch Developer Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-Command-Line-Interface_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-Command-Line-Interface_64.svg",
      "tokens": [
        "AWS Command Line Interface",
        "Arch Developer Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Developer",
        "Tools",
        "64",
        "AWS",
        "Command",
        "Line",
        "Interface",
        "svg",
        "awscommandlineinterface",
        "archdevelopertools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Compute Optimizer",
      "category": "Arch Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-Compute-Optimizer_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-Compute-Optimizer_64.svg",
      "tokens": [
        "AWS Compute Optimizer",
        "Arch Compute",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Compute",
        "64",
        "AWS",
        "Optimizer",
        "svg",
        "awscomputeoptimizer",
        "archcompute"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Compute Optimizer",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Compute-Optimizer_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Compute-Optimizer_64.svg",
      "tokens": [
        "AWS Compute Optimizer",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "Compute",
        "Optimizer",
        "svg",
        "awscomputeoptimizer",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Config",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Config_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Config_64.svg",
      "tokens": [
        "AWS Config",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "Config",
        "svg",
        "awsconfig",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Console Mobile Application",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Console-Mobile-Application_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Console-Mobile-Application_64.svg",
      "tokens": [
        "AWS Console Mobile Application",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "Console",
        "Mobile",
        "Application",
        "svg",
        "awsconsolemobileapplication",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Control Tower",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Control-Tower_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Control-Tower_64.svg",
      "tokens": [
        "AWS Control Tower",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "Control",
        "Tower",
        "svg",
        "awscontroltower",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Cost And Usage Report",
      "category": "Arch Cloud Financial Management",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Cloud-Financial-Management/64/Arch_AWS-Cost-and-Usage-Report_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Cloud-Financial-Management/64/Arch_AWS-Cost-and-Usage-Report_64.svg",
      "tokens": [
        "AWS Cost And Usage Report",
        "Arch Cloud Financial Management",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Cloud",
        "Financial",
        "Management",
        "64",
        "AWS",
        "Cost",
        "and",
        "Usage",
        "Report",
        "svg",
        "awscostandusagereport",
        "archcloudfinancialmanagement"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Cost Explorer",
      "category": "Arch Cloud Financial Management",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Cloud-Financial-Management/64/Arch_AWS-Cost-Explorer_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Cloud-Financial-Management/64/Arch_AWS-Cost-Explorer_64.svg",
      "tokens": [
        "AWS Cost Explorer",
        "Arch Cloud Financial Management",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Cloud",
        "Financial",
        "Management",
        "64",
        "AWS",
        "Cost",
        "Explorer",
        "svg",
        "awscostexplorer",
        "archcloudfinancialmanagement"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Data Exchange",
      "category": "Arch Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_AWS-Data-Exchange_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_AWS-Data-Exchange_64.svg",
      "tokens": [
        "AWS Data Exchange",
        "Arch Analytics",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Analytics",
        "64",
        "AWS",
        "Data",
        "Exchange",
        "svg",
        "awsdataexchange",
        "archanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Data Sync",
      "category": "Arch Migration Modernization",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Migration-Modernization/64/Arch_AWS-DataSync_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Migration-Modernization/64/Arch_AWS-DataSync_64.svg",
      "tokens": [
        "AWS Data Sync",
        "Arch Migration Modernization",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Migration",
        "Modernization",
        "64",
        "AWS",
        "DataSync",
        "svg",
        "awsdatasync",
        "archmigrationmodernization"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Data Transfer Terminal",
      "category": "Arch Migration Modernization",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Migration-Modernization/64/Arch_AWS-Data-Transfer-Terminal_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Migration-Modernization/64/Arch_AWS-Data-Transfer-Terminal_64.svg",
      "tokens": [
        "AWS Data Transfer Terminal",
        "Arch Migration Modernization",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Migration",
        "Modernization",
        "64",
        "AWS",
        "Data",
        "Transfer",
        "Terminal",
        "svg",
        "awsdatatransferterminal",
        "archmigrationmodernization"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Database Migration Service",
      "category": "Arch Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Databases/64/Arch_AWS-Database-Migration-Service_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Databases/64/Arch_AWS-Database-Migration-Service_64.svg",
      "tokens": [
        "AWS Database Migration Service",
        "Arch Databases",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Databases",
        "64",
        "AWS",
        "Database",
        "Migration",
        "svg",
        "awsdatabasemigrationservice",
        "archdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Deadline Cloud",
      "category": "Arch Media Services",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Deadline-Cloud_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Deadline-Cloud_64.svg",
      "tokens": [
        "AWS Deadline Cloud",
        "Arch Media Services",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Media",
        "Services",
        "64",
        "AWS",
        "Deadline",
        "Cloud",
        "svg",
        "awsdeadlinecloud",
        "archmediaservices"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Deep Learning AM Is",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_AWS-Deep-Learning-AMIs_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_AWS-Deep-Learning-AMIs_64.svg",
      "tokens": [
        "AWS Deep Learning AM Is",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "AWS",
        "Deep",
        "Learning",
        "AMIs",
        "svg",
        "awsdeeplearningamis",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Deep Learning Containers",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_AWS-Deep-Learning-Containers_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_AWS-Deep-Learning-Containers_64.svg",
      "tokens": [
        "AWS Deep Learning Containers",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "AWS",
        "Deep",
        "Learning",
        "Containers",
        "svg",
        "awsdeeplearningcontainers",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Deep Racer",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_AWS-DeepRacer_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_AWS-DeepRacer_64.svg",
      "tokens": [
        "AWS Deep Racer",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "AWS",
        "DeepRacer",
        "svg",
        "awsdeepracer",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Dev Ops Agent",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-DevOps-Agent_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-DevOps-Agent_64.svg",
      "tokens": [
        "AWS Dev Ops Agent",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "DevOps",
        "Agent",
        "svg",
        "awsdevopsagent",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Device Farm",
      "category": "Arch Front End Web Mobile",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Front-End-Web-Mobile/64/Arch_AWS-Device-Farm_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Front-End-Web-Mobile/64/Arch_AWS-Device-Farm_64.svg",
      "tokens": [
        "AWS Device Farm",
        "Arch Front End Web Mobile",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Front",
        "End",
        "Web",
        "Mobile",
        "64",
        "AWS",
        "Device",
        "Farm",
        "svg",
        "awsdevicefarm",
        "archfrontendwebmobile"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Direct Connect",
      "category": "Arch Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_AWS-Direct-Connect_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_AWS-Direct-Connect_64.svg",
      "tokens": [
        "AWS Direct Connect",
        "Arch Networking Content Delivery",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Networking",
        "Content",
        "Delivery",
        "64",
        "AWS",
        "Direct",
        "Connect",
        "svg",
        "awsdirectconnect",
        "archnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Directory Service",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Directory-Service_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Directory-Service_64.svg",
      "tokens": [
        "AWS Directory Service",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "AWS",
        "Directory",
        "svg",
        "awsdirectoryservice",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Distro For Open Telemetry",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Distro-for-OpenTelemetry_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Distro-for-OpenTelemetry_64.svg",
      "tokens": [
        "AWS Distro For Open Telemetry",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "Distro",
        "for",
        "OpenTelemetry",
        "svg",
        "awsdistroforopentelemetry",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Elastic Beanstalk",
      "category": "Arch Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-Elastic-Beanstalk_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-Elastic-Beanstalk_64.svg",
      "tokens": [
        "AWS Elastic Beanstalk",
        "Arch Compute",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Compute",
        "64",
        "AWS",
        "Elastic",
        "Beanstalk",
        "svg",
        "awselasticbeanstalk",
        "archcompute"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Elastic Disaster Recovery",
      "category": "Arch Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_AWS-Elastic-Disaster-Recovery_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_AWS-Elastic-Disaster-Recovery_64.svg",
      "tokens": [
        "AWS Elastic Disaster Recovery",
        "Arch Storage",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Storage",
        "64",
        "AWS",
        "Elastic",
        "Disaster",
        "Recovery",
        "svg",
        "awselasticdisasterrecovery",
        "archstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Elemental Appliances & Software",
      "category": "Arch Media Services",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Elemental-Appliances---Software_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Elemental-Appliances-&-Software_64.svg",
      "tokens": [
        "AWS Elemental Appliances & Software",
        "Arch Media Services",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Media",
        "Services",
        "64",
        "AWS",
        "Elemental",
        "Appliances",
        "&",
        "Software",
        "svg",
        "awselementalappliancesandsoftware",
        "archmediaservices"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Elemental Conductor",
      "category": "Arch Media Services",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Elemental-Conductor_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Elemental-Conductor_64.svg",
      "tokens": [
        "AWS Elemental Conductor",
        "Arch Media Services",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Media",
        "Services",
        "64",
        "AWS",
        "Elemental",
        "Conductor",
        "svg",
        "awselementalconductor",
        "archmediaservices"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Elemental Delta",
      "category": "Arch Media Services",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Elemental-Delta_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Elemental-Delta_64.svg",
      "tokens": [
        "AWS Elemental Delta",
        "Arch Media Services",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Media",
        "Services",
        "64",
        "AWS",
        "Elemental",
        "Delta",
        "svg",
        "awselementaldelta",
        "archmediaservices"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Elemental Inference",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_AWS-Elemental-Inference_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_AWS-Elemental-Inference_64.svg",
      "tokens": [
        "AWS Elemental Inference",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "AWS",
        "Elemental",
        "Inference",
        "svg",
        "awselementalinference",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Elemental Link",
      "category": "Arch Media Services",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Elemental-Link_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Elemental-Link_64.svg",
      "tokens": [
        "AWS Elemental Link",
        "Arch Media Services",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Media",
        "Services",
        "64",
        "AWS",
        "Elemental",
        "Link",
        "svg",
        "awselementallink",
        "archmediaservices"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Elemental Live",
      "category": "Arch Media Services",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Elemental-Live_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Elemental-Live_64.svg",
      "tokens": [
        "AWS Elemental Live",
        "Arch Media Services",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Media",
        "Services",
        "64",
        "AWS",
        "Elemental",
        "Live",
        "svg",
        "awselementallive",
        "archmediaservices"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Elemental Media Connect",
      "category": "Arch Media Services",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Elemental-MediaConnect_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Elemental-MediaConnect_64.svg",
      "tokens": [
        "AWS Elemental Media Connect",
        "Arch Media Services",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Media",
        "Services",
        "64",
        "AWS",
        "Elemental",
        "MediaConnect",
        "svg",
        "awselementalmediaconnect",
        "archmediaservices"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Elemental Media Convert",
      "category": "Arch Media Services",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Elemental-MediaConvert_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Elemental-MediaConvert_64.svg",
      "tokens": [
        "AWS Elemental Media Convert",
        "Arch Media Services",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Media",
        "Services",
        "64",
        "AWS",
        "Elemental",
        "MediaConvert",
        "svg",
        "awselementalmediaconvert",
        "archmediaservices"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Elemental Media Live",
      "category": "Arch Media Services",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Elemental-MediaLive_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Elemental-MediaLive_64.svg",
      "tokens": [
        "AWS Elemental Media Live",
        "Arch Media Services",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Media",
        "Services",
        "64",
        "AWS",
        "Elemental",
        "MediaLive",
        "svg",
        "awselementalmedialive",
        "archmediaservices"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Elemental Media Package",
      "category": "Arch Media Services",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Elemental-MediaPackage_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Elemental-MediaPackage_64.svg",
      "tokens": [
        "AWS Elemental Media Package",
        "Arch Media Services",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Media",
        "Services",
        "64",
        "AWS",
        "Elemental",
        "MediaPackage",
        "svg",
        "awselementalmediapackage",
        "archmediaservices"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Elemental Media Store",
      "category": "Arch Media Services",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Elemental-MediaStore_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Elemental-MediaStore_64.svg",
      "tokens": [
        "AWS Elemental Media Store",
        "Arch Media Services",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Media",
        "Services",
        "64",
        "AWS",
        "Elemental",
        "MediaStore",
        "svg",
        "awselementalmediastore",
        "archmediaservices"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Elemental Media Tailor",
      "category": "Arch Media Services",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Elemental-MediaTailor_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Elemental-MediaTailor_64.svg",
      "tokens": [
        "AWS Elemental Media Tailor",
        "Arch Media Services",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Media",
        "Services",
        "64",
        "AWS",
        "Elemental",
        "MediaTailor",
        "svg",
        "awselementalmediatailor",
        "archmediaservices"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Elemental Server",
      "category": "Arch Media Services",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Elemental-Server_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Elemental-Server_64.svg",
      "tokens": [
        "AWS Elemental Server",
        "Arch Media Services",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Media",
        "Services",
        "64",
        "AWS",
        "Elemental",
        "Server",
        "svg",
        "awselementalserver",
        "archmediaservices"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS End User Messaging",
      "category": "Arch Business Applications",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_AWS-End-User-Messaging_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_AWS-End-User-Messaging_64.svg",
      "tokens": [
        "AWS End User Messaging",
        "Arch Business Applications",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Business",
        "Applications",
        "64",
        "AWS",
        "End",
        "User",
        "Messaging",
        "svg",
        "awsendusermessaging",
        "archbusinessapplications"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Entity Resolution",
      "category": "Arch Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_AWS-Entity-Resolution_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_AWS-Entity-Resolution_64.svg",
      "tokens": [
        "AWS Entity Resolution",
        "Arch Analytics",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Analytics",
        "64",
        "AWS",
        "Entity",
        "Resolution",
        "svg",
        "awsentityresolution",
        "archanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Express Workflows",
      "category": "Arch Application Integration",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Application-Integration/64/Arch_AWS-Express-Workflows_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Application-Integration/64/Arch_AWS-Express-Workflows_64.svg",
      "tokens": [
        "AWS Express Workflows",
        "Arch Application Integration",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Application",
        "Integration",
        "64",
        "AWS",
        "Express",
        "Workflows",
        "svg",
        "awsexpressworkflows",
        "archapplicationintegration"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Fargate",
      "category": "Arch Containers",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Containers/64/Arch_AWS-Fargate_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Containers/64/Arch_AWS-Fargate_64.svg",
      "tokens": [
        "AWS Fargate",
        "Arch Containers",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Containers",
        "64",
        "AWS",
        "Fargate",
        "svg",
        "awsfargate",
        "archcontainers"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Fault Injection Service",
      "category": "Arch Developer Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-Fault-Injection-Service_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-Fault-Injection-Service_64.svg",
      "tokens": [
        "AWS Fault Injection Service",
        "Arch Developer Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Developer",
        "Tools",
        "64",
        "AWS",
        "Fault",
        "Injection",
        "svg",
        "awsfaultinjectionservice",
        "archdevelopertools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Firewall Manager",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Firewall-Manager_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Firewall-Manager_64.svg",
      "tokens": [
        "AWS Firewall Manager",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "AWS",
        "Firewall",
        "Manager",
        "svg",
        "awsfirewallmanager",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Global Accelerator",
      "category": "Arch Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_AWS-Global-Accelerator_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_AWS-Global-Accelerator_64.svg",
      "tokens": [
        "AWS Global Accelerator",
        "Arch Networking Content Delivery",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Networking",
        "Content",
        "Delivery",
        "64",
        "AWS",
        "Global",
        "Accelerator",
        "svg",
        "awsglobalaccelerator",
        "archnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Glue Data Brew",
      "category": "Arch Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_AWS-Glue-DataBrew_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_AWS-Glue-DataBrew_64.svg",
      "tokens": [
        "AWS Glue Data Brew",
        "Arch Analytics",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Analytics",
        "64",
        "AWS",
        "Glue",
        "DataBrew",
        "svg",
        "awsgluedatabrew",
        "archanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Glue",
      "category": "Arch Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_AWS-Glue_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_AWS-Glue_64.svg",
      "tokens": [
        "AWS Glue",
        "Arch Analytics",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Analytics",
        "64",
        "AWS",
        "Glue",
        "svg",
        "awsglue",
        "archanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Ground Station",
      "category": "Arch Satellite",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Satellite/64/Arch_AWS-Ground-Station_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Satellite/64/Arch_AWS-Ground-Station_64.svg",
      "tokens": [
        "AWS Ground Station",
        "Arch Satellite",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Satellite",
        "64",
        "AWS",
        "Ground",
        "Station",
        "svg",
        "awsgroundstation",
        "archsatellite"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Health Dashboard",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Health-Dashboard_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Health-Dashboard_64.svg",
      "tokens": [
        "AWS Health Dashboard",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "Health",
        "Dashboard",
        "svg",
        "awshealthdashboard",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Health Imaging",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_AWS-HealthImaging_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_AWS-HealthImaging_64.svg",
      "tokens": [
        "AWS Health Imaging",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "AWS",
        "HealthImaging",
        "svg",
        "awshealthimaging",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Health Lake",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_AWS-HealthLake_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_AWS-HealthLake_64.svg",
      "tokens": [
        "AWS Health Lake",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "AWS",
        "HealthLake",
        "svg",
        "awshealthlake",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Health Omics",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_AWS-HealthOmics_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_AWS-HealthOmics_64.svg",
      "tokens": [
        "AWS Health Omics",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "AWS",
        "HealthOmics",
        "svg",
        "awshealthomics",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Health Scribe",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_AWS-HealthScribe_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_AWS-HealthScribe_64.svg",
      "tokens": [
        "AWS Health Scribe",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "AWS",
        "HealthScribe",
        "svg",
        "awshealthscribe",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS IAM Identity Center",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-IAM-Identity-Center_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-IAM-Identity-Center_64.svg",
      "tokens": [
        "AWS IAM Identity Center",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "AWS",
        "IAM",
        "Center",
        "svg",
        "awsiamidentitycenter",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Identity And Access Management",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Identity-and-Access-Management_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Identity-and-Access-Management_64.svg",
      "tokens": [
        "AWS Identity And Access Management",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "AWS",
        "and",
        "Access",
        "Management",
        "svg",
        "awsidentityandaccessmanagement",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Infrastructure Composer",
      "category": "Arch Developer Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-Infrastructure-Composer_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-Infrastructure-Composer_64.svg",
      "tokens": [
        "AWS Infrastructure Composer",
        "Arch Developer Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Developer",
        "Tools",
        "64",
        "AWS",
        "Infrastructure",
        "Composer",
        "svg",
        "awsinfrastructurecomposer",
        "archdevelopertools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Interconnect",
      "category": "Arch Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_AWS-Interconnect_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_AWS-Interconnect_64.svg",
      "tokens": [
        "AWS Interconnect",
        "Arch Networking Content Delivery",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Networking",
        "Content",
        "Delivery",
        "64",
        "AWS",
        "Interconnect",
        "svg",
        "awsinterconnect",
        "archnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Io T Core",
      "category": "Arch Internet Of Things",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Internet-of-Things/64/Arch_AWS-IoT-Core_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Internet-of-Things/64/Arch_AWS-IoT-Core_64.svg",
      "tokens": [
        "AWS Io T Core",
        "Arch Internet Of Things",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Internet",
        "of",
        "Things",
        "64",
        "AWS",
        "IoT",
        "Core",
        "svg",
        "awsiotcore",
        "archinternetofthings"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Io T Device Defender",
      "category": "Arch Internet Of Things",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Internet-of-Things/64/Arch_AWS-IoT-Device-Defender_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Internet-of-Things/64/Arch_AWS-IoT-Device-Defender_64.svg",
      "tokens": [
        "AWS Io T Device Defender",
        "Arch Internet Of Things",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Internet",
        "of",
        "Things",
        "64",
        "AWS",
        "IoT",
        "Device",
        "Defender",
        "svg",
        "awsiotdevicedefender",
        "archinternetofthings"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Io T Device Management",
      "category": "Arch Internet Of Things",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Internet-of-Things/64/Arch_AWS-IoT-Device-Management_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Internet-of-Things/64/Arch_AWS-IoT-Device-Management_64.svg",
      "tokens": [
        "AWS Io T Device Management",
        "Arch Internet Of Things",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Internet",
        "of",
        "Things",
        "64",
        "AWS",
        "IoT",
        "Device",
        "Management",
        "svg",
        "awsiotdevicemanagement",
        "archinternetofthings"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Io T Events",
      "category": "Arch Internet Of Things",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Internet-of-Things/64/Arch_AWS-IoT-Events_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Internet-of-Things/64/Arch_AWS-IoT-Events_64.svg",
      "tokens": [
        "AWS Io T Events",
        "Arch Internet Of Things",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Internet",
        "of",
        "Things",
        "64",
        "AWS",
        "IoT",
        "Events",
        "svg",
        "awsiotevents",
        "archinternetofthings"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Io T Express Link",
      "category": "Arch Internet Of Things",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Internet-of-Things/64/Arch_AWS-IoT-ExpressLink_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Internet-of-Things/64/Arch_AWS-IoT-ExpressLink_64.svg",
      "tokens": [
        "AWS Io T Express Link",
        "Arch Internet Of Things",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Internet",
        "of",
        "Things",
        "64",
        "AWS",
        "IoT",
        "ExpressLink",
        "svg",
        "awsiotexpresslink",
        "archinternetofthings"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Io T Fleet Wise",
      "category": "Arch Internet Of Things",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Internet-of-Things/64/Arch_AWS-IoT-FleetWise_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Internet-of-Things/64/Arch_AWS-IoT-FleetWise_64.svg",
      "tokens": [
        "AWS Io T Fleet Wise",
        "Arch Internet Of Things",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Internet",
        "of",
        "Things",
        "64",
        "AWS",
        "IoT",
        "FleetWise",
        "svg",
        "awsiotfleetwise",
        "archinternetofthings"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Io T Greengrass Deployment",
      "category": "Architecture Group Icons 04302026",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Group-Icons_04302026/AWS-IoT-Greengrass-Deployment_32.svg",
      "sourcePath": "Architecture-Group-Icons_04302026/AWS-IoT-Greengrass-Deployment_32.svg",
      "tokens": [
        "AWS Io T Greengrass Deployment",
        "Architecture Group Icons 04302026",
        "Architecture",
        "Group",
        "Icons",
        "04302026",
        "AWS",
        "IoT",
        "Greengrass",
        "Deployment",
        "32",
        "svg",
        "awsiotgreengrassdeployment",
        "architecturegroupicons04302026"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Io T Greengrass",
      "category": "Arch Internet Of Things",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Internet-of-Things/64/Arch_AWS-IoT-Greengrass_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Internet-of-Things/64/Arch_AWS-IoT-Greengrass_64.svg",
      "tokens": [
        "AWS Io T Greengrass",
        "Arch Internet Of Things",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Internet",
        "of",
        "Things",
        "64",
        "AWS",
        "IoT",
        "Greengrass",
        "svg",
        "awsiotgreengrass",
        "archinternetofthings"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Io T Site Wise",
      "category": "Arch Internet Of Things",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Internet-of-Things/64/Arch_AWS-IoT-SiteWise_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Internet-of-Things/64/Arch_AWS-IoT-SiteWise_64.svg",
      "tokens": [
        "AWS Io T Site Wise",
        "Arch Internet Of Things",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Internet",
        "of",
        "Things",
        "64",
        "AWS",
        "IoT",
        "SiteWise",
        "svg",
        "awsiotsitewise",
        "archinternetofthings"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Io T Twin Maker",
      "category": "Arch Internet Of Things",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Internet-of-Things/64/Arch_AWS-IoT-TwinMaker_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Internet-of-Things/64/Arch_AWS-IoT-TwinMaker_64.svg",
      "tokens": [
        "AWS Io T Twin Maker",
        "Arch Internet Of Things",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Internet",
        "of",
        "Things",
        "64",
        "AWS",
        "IoT",
        "TwinMaker",
        "svg",
        "awsiottwinmaker",
        "archinternetofthings"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS IQ",
      "category": "Arch Customer Enablement",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Customer-Enablement/64/Arch_AWS-IQ_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Customer-Enablement/64/Arch_AWS-IQ_64.svg",
      "tokens": [
        "AWS IQ",
        "Arch Customer Enablement",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Customer",
        "Enablement",
        "64",
        "AWS",
        "IQ",
        "svg",
        "awsiq",
        "archcustomerenablement"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Key Management Service",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Key-Management-Service_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Key-Management-Service_64.svg",
      "tokens": [
        "AWS Key Management Service",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "AWS",
        "Key",
        "Management",
        "svg",
        "awskeymanagementservice",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Lake Formation",
      "category": "Arch Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_AWS-Lake-Formation_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Analytics/64/Arch_AWS-Lake-Formation_64.svg",
      "tokens": [
        "AWS Lake Formation",
        "Arch Analytics",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Analytics",
        "64",
        "AWS",
        "Lake",
        "Formation",
        "svg",
        "awslakeformation",
        "archanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Lambda",
      "category": "Arch Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-Lambda_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-Lambda_64.svg",
      "tokens": [
        "AWS Lambda",
        "Arch Compute",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Compute",
        "64",
        "AWS",
        "Lambda",
        "svg",
        "awslambda",
        "archcompute"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Launch Wizard",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Launch-Wizard_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Launch-Wizard_64.svg",
      "tokens": [
        "AWS Launch Wizard",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "Launch",
        "Wizard",
        "svg",
        "awslaunchwizard",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS License Manager",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-License-Manager_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-License-Manager_64.svg",
      "tokens": [
        "AWS License Manager",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "License",
        "Manager",
        "svg",
        "awslicensemanager",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Local Zones",
      "category": "Arch Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-Local-Zones_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-Local-Zones_64.svg",
      "tokens": [
        "AWS Local Zones",
        "Arch Compute",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Compute",
        "64",
        "AWS",
        "Local",
        "Zones",
        "svg",
        "awslocalzones",
        "archcompute"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Mainframe Modernization",
      "category": "Arch Migration Modernization",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Migration-Modernization/64/Arch_AWS-Mainframe-Modernization_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Migration-Modernization/64/Arch_AWS-Mainframe-Modernization_64.svg",
      "tokens": [
        "AWS Mainframe Modernization",
        "Arch Migration Modernization",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Migration",
        "Modernization",
        "64",
        "AWS",
        "Mainframe",
        "svg",
        "awsmainframemodernization",
        "archmigrationmodernization"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Managed Services",
      "category": "Arch Customer Enablement",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Customer-Enablement/64/Arch_AWS-Managed-Services_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Customer-Enablement/64/Arch_AWS-Managed-Services_64.svg",
      "tokens": [
        "AWS Managed Services",
        "Arch Customer Enablement",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Customer",
        "Enablement",
        "64",
        "AWS",
        "Managed",
        "Services",
        "svg",
        "awsmanagedservices",
        "archcustomerenablement"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Management Console",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Management-Console_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Management-Console_64.svg",
      "tokens": [
        "AWS Management Console",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "Console",
        "svg",
        "awsmanagementconsole",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Marketplace Dark",
      "category": "Arch General Icons",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_General-Icons/64/Arch_AWS-Marketplace_Dark_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_General-Icons/64/Arch_AWS-Marketplace_Dark_64.svg",
      "tokens": [
        "AWS Marketplace Dark",
        "Arch General Icons",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "General",
        "64",
        "AWS",
        "Marketplace",
        "Dark",
        "svg",
        "awsmarketplacedark",
        "archgeneralicons"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Marketplace Light",
      "category": "Arch General Icons",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_General-Icons/64/Arch_AWS-Marketplace_Light_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_General-Icons/64/Arch_AWS-Marketplace_Light_64.svg",
      "tokens": [
        "AWS Marketplace Light",
        "Arch General Icons",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "General",
        "64",
        "AWS",
        "Marketplace",
        "Light",
        "svg",
        "awsmarketplacelight",
        "archgeneralicons"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Migration Evaluator",
      "category": "Arch Migration Modernization",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Migration-Modernization/64/Arch_AWS-Migration-Evaluator_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Migration-Modernization/64/Arch_AWS-Migration-Evaluator_64.svg",
      "tokens": [
        "AWS Migration Evaluator",
        "Arch Migration Modernization",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Migration",
        "Modernization",
        "64",
        "AWS",
        "Evaluator",
        "svg",
        "awsmigrationevaluator",
        "archmigrationmodernization"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Migration Hub",
      "category": "Arch Migration Modernization",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Migration-Modernization/64/Arch_AWS-Migration-Hub_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Migration-Modernization/64/Arch_AWS-Migration-Hub_64.svg",
      "tokens": [
        "AWS Migration Hub",
        "Arch Migration Modernization",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Migration",
        "Modernization",
        "64",
        "AWS",
        "Hub",
        "svg",
        "awsmigrationhub",
        "archmigrationmodernization"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Network Firewall",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Network-Firewall_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Network-Firewall_64.svg",
      "tokens": [
        "AWS Network Firewall",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "AWS",
        "Network",
        "Firewall",
        "svg",
        "awsnetworkfirewall",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Neuron",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_AWS-Neuron_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_AWS-Neuron_64.svg",
      "tokens": [
        "AWS Neuron",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "AWS",
        "Neuron",
        "svg",
        "awsneuron",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Nitro Enclaves",
      "category": "Arch Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-Nitro-Enclaves_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-Nitro-Enclaves_64.svg",
      "tokens": [
        "AWS Nitro Enclaves",
        "Arch Compute",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Compute",
        "64",
        "AWS",
        "Nitro",
        "Enclaves",
        "svg",
        "awsnitroenclaves",
        "archcompute"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Organizations",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Organizations_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Organizations_64.svg",
      "tokens": [
        "AWS Organizations",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "Organizations",
        "svg",
        "awsorganizations",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Outposts Family",
      "category": "Arch Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-Outposts-family_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-Outposts-family_64.svg",
      "tokens": [
        "AWS Outposts Family",
        "Arch Compute",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Compute",
        "64",
        "AWS",
        "Outposts",
        "family",
        "svg",
        "awsoutpostsfamily",
        "archcompute"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Outposts Rack",
      "category": "Arch Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-Outposts-rack_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-Outposts-rack_64.svg",
      "tokens": [
        "AWS Outposts Rack",
        "Arch Compute",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Compute",
        "64",
        "AWS",
        "Outposts",
        "rack",
        "svg",
        "awsoutpostsrack",
        "archcompute"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Outposts Servers",
      "category": "Arch Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-Outposts-servers_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-Outposts-servers_64.svg",
      "tokens": [
        "AWS Outposts Servers",
        "Arch Compute",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Compute",
        "64",
        "AWS",
        "Outposts",
        "servers",
        "svg",
        "awsoutpostsservers",
        "archcompute"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Panorama",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_AWS-Panorama_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_AWS-Panorama_64.svg",
      "tokens": [
        "AWS Panorama",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "AWS",
        "Panorama",
        "svg",
        "awspanorama",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Parallel Cluster",
      "category": "Arch Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-Parallel-Cluster_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-Parallel-Cluster_64.svg",
      "tokens": [
        "AWS Parallel Cluster",
        "Arch Compute",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Compute",
        "64",
        "AWS",
        "Parallel",
        "Cluster",
        "svg",
        "awsparallelcluster",
        "archcompute"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Parallel Computing Service",
      "category": "Arch Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-Parallel-Computing-Service_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-Parallel-Computing-Service_64.svg",
      "tokens": [
        "AWS Parallel Computing Service",
        "Arch Compute",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Compute",
        "64",
        "AWS",
        "Parallel",
        "Computing",
        "svg",
        "awsparallelcomputingservice",
        "archcompute"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Partner Central",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Partner-Central_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Partner-Central_64.svg",
      "tokens": [
        "AWS Partner Central",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "Partner",
        "Central",
        "svg",
        "awspartnercentral",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Payment Cryptography",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Payment-Cryptography_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Payment-Cryptography_64.svg",
      "tokens": [
        "AWS Payment Cryptography",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "AWS",
        "Payment",
        "Cryptography",
        "svg",
        "awspaymentcryptography",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Private Certificate Authority",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Private-Certificate-Authority_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Private-Certificate-Authority_64.svg",
      "tokens": [
        "AWS Private Certificate Authority",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "AWS",
        "Private",
        "Certificate",
        "Authority",
        "svg",
        "awsprivatecertificateauthority",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Private Link",
      "category": "Arch Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_AWS-PrivateLink_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_AWS-PrivateLink_64.svg",
      "tokens": [
        "AWS Private Link",
        "Arch Networking Content Delivery",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Networking",
        "Content",
        "Delivery",
        "64",
        "AWS",
        "PrivateLink",
        "svg",
        "awsprivatelink",
        "archnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Professional Services",
      "category": "Arch Customer Enablement",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Customer-Enablement/64/Arch_AWS-Professional-Services_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Customer-Enablement/64/Arch_AWS-Professional-Services_64.svg",
      "tokens": [
        "AWS Professional Services",
        "Arch Customer Enablement",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Customer",
        "Enablement",
        "64",
        "AWS",
        "Professional",
        "Services",
        "svg",
        "awsprofessionalservices",
        "archcustomerenablement"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Proton",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Proton_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Proton_64.svg",
      "tokens": [
        "AWS Proton",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "Proton",
        "svg",
        "awsproton",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Re Post Private",
      "category": "Arch Customer Enablement",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Customer-Enablement/64/Arch_AWS-rePost-Private_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Customer-Enablement/64/Arch_AWS-rePost-Private_64.svg",
      "tokens": [
        "AWS Re Post Private",
        "Arch Customer Enablement",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Customer",
        "Enablement",
        "64",
        "AWS",
        "rePost",
        "Private",
        "svg",
        "awsrepostprivate",
        "archcustomerenablement"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Re Post",
      "category": "Arch Customer Enablement",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Customer-Enablement/64/Arch_AWS-rePost_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Customer-Enablement/64/Arch_AWS-rePost_64.svg",
      "tokens": [
        "AWS Re Post",
        "Arch Customer Enablement",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Customer",
        "Enablement",
        "64",
        "AWS",
        "rePost",
        "svg",
        "awsrepost",
        "archcustomerenablement"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Resilience Hub",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Resilience-Hub_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Resilience-Hub_64.svg",
      "tokens": [
        "AWS Resilience Hub",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "Resilience",
        "Hub",
        "svg",
        "awsresiliencehub",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Resource Access Manager",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Resource-Access-Manager_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Resource-Access-Manager_64.svg",
      "tokens": [
        "AWS Resource Access Manager",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "AWS",
        "Resource",
        "Access",
        "Manager",
        "svg",
        "awsresourceaccessmanager",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Resource Explorer",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Resource-Explorer_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Resource-Explorer_64.svg",
      "tokens": [
        "AWS Resource Explorer",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "Resource",
        "Explorer",
        "svg",
        "awsresourceexplorer",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS RTB Fabric",
      "category": "Arch Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_AWS-RTB-Fabric_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_AWS-RTB-Fabric_64.svg",
      "tokens": [
        "AWS RTB Fabric",
        "Arch Networking Content Delivery",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Networking",
        "Content",
        "Delivery",
        "64",
        "AWS",
        "RTB",
        "Fabric",
        "svg",
        "awsrtbfabric",
        "archnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Secrets Manager",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Secrets-Manager_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Secrets-Manager_64.svg",
      "tokens": [
        "AWS Secrets Manager",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "AWS",
        "Secrets",
        "Manager",
        "svg",
        "awssecretsmanager",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Security Agent",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Security-Agent_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Security-Agent_64.svg",
      "tokens": [
        "AWS Security Agent",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "AWS",
        "Agent",
        "svg",
        "awssecurityagent",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Security Hub",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Security-Hub_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Security-Hub_64.svg",
      "tokens": [
        "AWS Security Hub",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "AWS",
        "Hub",
        "svg",
        "awssecurityhub",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Security Incident Response",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Security-Incident-Response_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Security-Incident-Response_64.svg",
      "tokens": [
        "AWS Security Incident Response",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "AWS",
        "Incident",
        "Response",
        "svg",
        "awssecurityincidentresponse",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Serverless Application Repository",
      "category": "Arch Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-Serverless-Application-Repository_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-Serverless-Application-Repository_64.svg",
      "tokens": [
        "AWS Serverless Application Repository",
        "Arch Compute",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Compute",
        "64",
        "AWS",
        "Serverless",
        "Application",
        "Repository",
        "svg",
        "awsserverlessapplicationrepository",
        "archcompute"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Service Catalog",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Service-Catalog_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Service-Catalog_64.svg",
      "tokens": [
        "AWS Service Catalog",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "Catalog",
        "svg",
        "awsservicecatalog",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Service Management Connector",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Service-Management-Connector_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Service-Management-Connector_64.svg",
      "tokens": [
        "AWS Service Management Connector",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "Connector",
        "svg",
        "awsservicemanagementconnector",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Shield",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Shield_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Shield_64.svg",
      "tokens": [
        "AWS Shield",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "AWS",
        "Shield",
        "svg",
        "awsshield",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Signer",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Signer_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-Signer_64.svg",
      "tokens": [
        "AWS Signer",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "AWS",
        "Signer",
        "svg",
        "awssigner",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Sim Space Weaver",
      "category": "Arch Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-SimSpace-Weaver_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-SimSpace-Weaver_64.svg",
      "tokens": [
        "AWS Sim Space Weaver",
        "Arch Compute",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Compute",
        "64",
        "AWS",
        "SimSpace",
        "Weaver",
        "svg",
        "awssimspaceweaver",
        "archcompute"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Site To Site VPN",
      "category": "Arch Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_AWS-Site-to-Site-VPN_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_AWS-Site-to-Site-VPN_64.svg",
      "tokens": [
        "AWS Site To Site VPN",
        "Arch Networking Content Delivery",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Networking",
        "Content",
        "Delivery",
        "64",
        "AWS",
        "Site",
        "to",
        "VPN",
        "svg",
        "awssitetositevpn",
        "archnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Snowball Edge",
      "category": "Arch Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_AWS-Snowball-Edge_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_AWS-Snowball-Edge_64.svg",
      "tokens": [
        "AWS Snowball Edge",
        "Arch Storage",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Storage",
        "64",
        "AWS",
        "Snowball",
        "Edge",
        "svg",
        "awssnowballedge",
        "archstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Snowball",
      "category": "Arch Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_AWS-Snowball_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_AWS-Snowball_64.svg",
      "tokens": [
        "AWS Snowball",
        "Arch Storage",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Storage",
        "64",
        "AWS",
        "Snowball",
        "svg",
        "awssnowball",
        "archstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Step Functions",
      "category": "Arch Application Integration",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Application-Integration/64/Arch_AWS-Step-Functions_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Application-Integration/64/Arch_AWS-Step-Functions_64.svg",
      "tokens": [
        "AWS Step Functions",
        "Arch Application Integration",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Application",
        "Integration",
        "64",
        "AWS",
        "Step",
        "Functions",
        "svg",
        "awsstepfunctions",
        "archapplicationintegration"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Storage Gateway",
      "category": "Arch Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_AWS-Storage-Gateway_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Storage/64/Arch_AWS-Storage-Gateway_64.svg",
      "tokens": [
        "AWS Storage Gateway",
        "Arch Storage",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Storage",
        "64",
        "AWS",
        "Gateway",
        "svg",
        "awsstoragegateway",
        "archstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Supply Chain",
      "category": "Arch Business Applications",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_AWS-Supply-Chain_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_AWS-Supply-Chain_64.svg",
      "tokens": [
        "AWS Supply Chain",
        "Arch Business Applications",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Business",
        "Applications",
        "64",
        "AWS",
        "Supply",
        "Chain",
        "svg",
        "awssupplychain",
        "archbusinessapplications"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Support",
      "category": "Arch Customer Enablement",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Customer-Enablement/64/Arch_AWS-Support_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Customer-Enablement/64/Arch_AWS-Support_64.svg",
      "tokens": [
        "AWS Support",
        "Arch Customer Enablement",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Customer",
        "Enablement",
        "64",
        "AWS",
        "Support",
        "svg",
        "awssupport",
        "archcustomerenablement"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Sustainability",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Sustainability_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Sustainability_64.svg",
      "tokens": [
        "AWS Sustainability",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "Sustainability",
        "svg",
        "awssustainability",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Systems Manager",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Systems-Manager_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Systems-Manager_64.svg",
      "tokens": [
        "AWS Systems Manager",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "Systems",
        "Manager",
        "svg",
        "awssystemsmanager",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Telco Network Builder",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Telco-Network-Builder_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Telco-Network-Builder_64.svg",
      "tokens": [
        "AWS Telco Network Builder",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "Telco",
        "Network",
        "Builder",
        "svg",
        "awstelconetworkbuilder",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Thinkbox Deadline",
      "category": "Arch Media Services",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Thinkbox-Deadline_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Thinkbox-Deadline_64.svg",
      "tokens": [
        "AWS Thinkbox Deadline",
        "Arch Media Services",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Media",
        "Services",
        "64",
        "AWS",
        "Thinkbox",
        "Deadline",
        "svg",
        "awsthinkboxdeadline",
        "archmediaservices"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Thinkbox Frost",
      "category": "Arch Media Services",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Thinkbox-Frost_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Thinkbox-Frost_64.svg",
      "tokens": [
        "AWS Thinkbox Frost",
        "Arch Media Services",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Media",
        "Services",
        "64",
        "AWS",
        "Thinkbox",
        "Frost",
        "svg",
        "awsthinkboxfrost",
        "archmediaservices"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Thinkbox Krakatoa",
      "category": "Arch Media Services",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Thinkbox-Krakatoa_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Thinkbox-Krakatoa_64.svg",
      "tokens": [
        "AWS Thinkbox Krakatoa",
        "Arch Media Services",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Media",
        "Services",
        "64",
        "AWS",
        "Thinkbox",
        "Krakatoa",
        "svg",
        "awsthinkboxkrakatoa",
        "archmediaservices"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Thinkbox Stoke",
      "category": "Arch Media Services",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Thinkbox-Stoke_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Thinkbox-Stoke_64.svg",
      "tokens": [
        "AWS Thinkbox Stoke",
        "Arch Media Services",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Media",
        "Services",
        "64",
        "AWS",
        "Thinkbox",
        "Stoke",
        "svg",
        "awsthinkboxstoke",
        "archmediaservices"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Thinkbox X Mesh",
      "category": "Arch Media Services",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Thinkbox-XMesh_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Media-Services/64/Arch_AWS-Thinkbox-XMesh_64.svg",
      "tokens": [
        "AWS Thinkbox X Mesh",
        "Arch Media Services",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Media",
        "Services",
        "64",
        "AWS",
        "Thinkbox",
        "XMesh",
        "svg",
        "awsthinkboxxmesh",
        "archmediaservices"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Tools And SD Ks",
      "category": "Arch Developer Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-Tools-and-SDKs_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-Tools-and-SDKs_64.svg",
      "tokens": [
        "AWS Tools And SD Ks",
        "Arch Developer Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Developer",
        "Tools",
        "64",
        "AWS",
        "and",
        "SDKs",
        "svg",
        "awstoolsandsdks",
        "archdevelopertools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Training Certification",
      "category": "Arch Customer Enablement",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Customer-Enablement/64/Arch_AWS-Training-Certification_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Customer-Enablement/64/Arch_AWS-Training-Certification_64.svg",
      "tokens": [
        "AWS Training Certification",
        "Arch Customer Enablement",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Customer",
        "Enablement",
        "64",
        "AWS",
        "Training",
        "Certification",
        "svg",
        "awstrainingcertification",
        "archcustomerenablement"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Transfer Family",
      "category": "Arch Migration Modernization",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Migration-Modernization/64/Arch_AWS-Transfer-Family_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Migration-Modernization/64/Arch_AWS-Transfer-Family_64.svg",
      "tokens": [
        "AWS Transfer Family",
        "Arch Migration Modernization",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Migration",
        "Modernization",
        "64",
        "AWS",
        "Transfer",
        "Family",
        "svg",
        "awstransferfamily",
        "archmigrationmodernization"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Transform",
      "category": "Arch Migration Modernization",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Migration-Modernization/64/Arch_AWS-Transform_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Migration-Modernization/64/Arch_AWS-Transform_64.svg",
      "tokens": [
        "AWS Transform",
        "Arch Migration Modernization",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Migration",
        "Modernization",
        "64",
        "AWS",
        "Transform",
        "svg",
        "awstransform",
        "archmigrationmodernization"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Transit Gateway",
      "category": "Arch Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_AWS-Transit-Gateway_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_AWS-Transit-Gateway_64.svg",
      "tokens": [
        "AWS Transit Gateway",
        "Arch Networking Content Delivery",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Networking",
        "Content",
        "Delivery",
        "64",
        "AWS",
        "Transit",
        "Gateway",
        "svg",
        "awstransitgateway",
        "archnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Trusted Advisor",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Trusted-Advisor_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Trusted-Advisor_64.svg",
      "tokens": [
        "AWS Trusted Advisor",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "Trusted",
        "Advisor",
        "svg",
        "awstrustedadvisor",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS User Notifications",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-User-Notifications_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-User-Notifications_64.svg",
      "tokens": [
        "AWS User Notifications",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "User",
        "Notifications",
        "svg",
        "awsusernotifications",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Verified Access",
      "category": "Arch Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_AWS-Verified-Access_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_AWS-Verified-Access_64.svg",
      "tokens": [
        "AWS Verified Access",
        "Arch Networking Content Delivery",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Networking",
        "Content",
        "Delivery",
        "64",
        "AWS",
        "Verified",
        "Access",
        "svg",
        "awsverifiedaccess",
        "archnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS WAF",
      "category": "Arch Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-WAF_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Security-Identity/64/Arch_AWS-WAF_64.svg",
      "tokens": [
        "AWS WAF",
        "Arch Security Identity",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Security",
        "Identity",
        "64",
        "AWS",
        "WAF",
        "svg",
        "awswaf",
        "archsecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Wavelength",
      "category": "Arch Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-Wavelength_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_AWS-Wavelength_64.svg",
      "tokens": [
        "AWS Wavelength",
        "Arch Compute",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Compute",
        "64",
        "AWS",
        "Wavelength",
        "svg",
        "awswavelength",
        "archcompute"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Well Architected Tool",
      "category": "Arch Management Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Well-Architected-Tool_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Management-Tools/64/Arch_AWS-Well-Architected-Tool_64.svg",
      "tokens": [
        "AWS Well Architected Tool",
        "Arch Management Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Management",
        "Tools",
        "64",
        "AWS",
        "Well",
        "Architected",
        "Tool",
        "svg",
        "awswellarchitectedtool",
        "archmanagementtools"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS Wickr",
      "category": "Arch Business Applications",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_AWS-Wickr_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Business-Applications/64/Arch_AWS-Wickr_64.svg",
      "tokens": [
        "AWS Wickr",
        "Arch Business Applications",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Business",
        "Applications",
        "64",
        "AWS",
        "Wickr",
        "svg",
        "awswickr",
        "archbusinessapplications"
      ]
    },
    {
      "provider": "aws",
      "label": "AWS X Ray",
      "category": "Arch Developer Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-X-Ray_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Developer-Tools/64/Arch_AWS-X-Ray_64.svg",
      "tokens": [
        "AWS X Ray",
        "Arch Developer Tools",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Developer",
        "Tools",
        "64",
        "AWS",
        "X",
        "Ray",
        "svg",
        "awsxray",
        "archdevelopertools"
      ]
    },
    {
      "provider": "aws",
      "label": "Bottlerocket",
      "category": "Arch Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_Bottlerocket_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_Bottlerocket_64.svg",
      "tokens": [
        "Bottlerocket",
        "Arch Compute",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Compute",
        "64",
        "svg",
        "bottlerocket",
        "archcompute"
      ]
    },
    {
      "provider": "aws",
      "label": "Corporate Data Center",
      "category": "Architecture Group Icons 04302026",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Group-Icons_04302026/Corporate-data-center_32.svg",
      "sourcePath": "Architecture-Group-Icons_04302026/Corporate-data-center_32.svg",
      "tokens": [
        "Corporate Data Center",
        "Architecture Group Icons 04302026",
        "Architecture",
        "Group",
        "Icons",
        "04302026",
        "Corporate",
        "data",
        "center",
        "32",
        "svg",
        "corporatedatacenter",
        "architecturegroupicons04302026"
      ]
    },
    {
      "provider": "aws",
      "label": "EC2 Instance Contents",
      "category": "Architecture Group Icons 04302026",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Group-Icons_04302026/EC2-instance-contents_32.svg",
      "sourcePath": "Architecture-Group-Icons_04302026/EC2-instance-contents_32.svg",
      "tokens": [
        "EC2 Instance Contents",
        "Architecture Group Icons 04302026",
        "Architecture",
        "Group",
        "Icons",
        "04302026",
        "EC2",
        "instance",
        "contents",
        "32",
        "svg",
        "ec2instancecontents",
        "architecturegroupicons04302026"
      ]
    },
    {
      "provider": "aws",
      "label": "Elastic Fabric Adapter",
      "category": "Arch Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_Elastic-Fabric-Adapter_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Compute/64/Arch_Elastic-Fabric-Adapter_64.svg",
      "tokens": [
        "Elastic Fabric Adapter",
        "Arch Compute",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Compute",
        "64",
        "Elastic",
        "Fabric",
        "Adapter",
        "svg",
        "elasticfabricadapter",
        "archcompute"
      ]
    },
    {
      "provider": "aws",
      "label": "Elastic Load Balancing",
      "category": "Arch Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_Elastic-Load-Balancing_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Networking-Content-Delivery/64/Arch_Elastic-Load-Balancing_64.svg",
      "tokens": [
        "Elastic Load Balancing",
        "Arch Networking Content Delivery",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Networking",
        "Content",
        "Delivery",
        "64",
        "Elastic",
        "Load",
        "Balancing",
        "svg",
        "elasticloadbalancing",
        "archnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Free RTOS",
      "category": "Arch Internet Of Things",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Internet-of-Things/64/Arch_FreeRTOS_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Internet-of-Things/64/Arch_FreeRTOS_64.svg",
      "tokens": [
        "Free RTOS",
        "Arch Internet Of Things",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Internet",
        "of",
        "Things",
        "64",
        "FreeRTOS",
        "svg",
        "freertos",
        "archinternetofthings"
      ]
    },
    {
      "provider": "aws",
      "label": "Open 3 D Engine",
      "category": "Arch Games",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Games/64/Arch_Open-3D-Engine_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Games/64/Arch_Open-3D-Engine_64.svg",
      "tokens": [
        "Open 3 D Engine",
        "Arch Games",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Games",
        "64",
        "Open",
        "3D",
        "Engine",
        "svg",
        "open3dengine",
        "archgames"
      ]
    },
    {
      "provider": "aws",
      "label": "Oracle Database At AWS",
      "category": "Arch Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Databases/64/Arch_Oracle-Database-at-AWS_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Databases/64/Arch_Oracle-Database-at-AWS_64.svg",
      "tokens": [
        "Oracle Database At AWS",
        "Arch Databases",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Databases",
        "64",
        "Oracle",
        "Database",
        "at",
        "AWS",
        "svg",
        "oracledatabaseataws",
        "archdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Private Subnet",
      "category": "Architecture Group Icons 04302026",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Group-Icons_04302026/Private-subnet_32.svg",
      "sourcePath": "Architecture-Group-Icons_04302026/Private-subnet_32.svg",
      "tokens": [
        "Private Subnet",
        "Architecture Group Icons 04302026",
        "Architecture",
        "Group",
        "Icons",
        "04302026",
        "Private",
        "subnet",
        "32",
        "svg",
        "privatesubnet",
        "architecturegroupicons04302026"
      ]
    },
    {
      "provider": "aws",
      "label": "Public Subnet",
      "category": "Architecture Group Icons 04302026",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Group-Icons_04302026/Public-subnet_32.svg",
      "sourcePath": "Architecture-Group-Icons_04302026/Public-subnet_32.svg",
      "tokens": [
        "Public Subnet",
        "Architecture Group Icons 04302026",
        "Architecture",
        "Group",
        "Icons",
        "04302026",
        "Public",
        "subnet",
        "32",
        "svg",
        "publicsubnet",
        "architecturegroupicons04302026"
      ]
    },
    {
      "provider": "aws",
      "label": "Py Torch On AWS",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_PyTorch-on-AWS_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_PyTorch-on-AWS_64.svg",
      "tokens": [
        "Py Torch On AWS",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "PyTorch",
        "on",
        "AWS",
        "svg",
        "pytorchonaws",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Red Hat Open Shift Service On AWS",
      "category": "Arch Containers",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Containers/64/Arch_Red-Hat-OpenShift-Service-on-AWS_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Containers/64/Arch_Red-Hat-OpenShift-Service-on-AWS_64.svg",
      "tokens": [
        "Red Hat Open Shift Service On AWS",
        "Arch Containers",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Containers",
        "64",
        "Red",
        "Hat",
        "OpenShift",
        "on",
        "AWS",
        "svg",
        "redhatopenshiftserviceonaws",
        "archcontainers"
      ]
    },
    {
      "provider": "aws",
      "label": "Region",
      "category": "Architecture Group Icons 04302026",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Group-Icons_04302026/Region_32.svg",
      "sourcePath": "Architecture-Group-Icons_04302026/Region_32.svg",
      "tokens": [
        "Region",
        "Architecture Group Icons 04302026",
        "Architecture",
        "Group",
        "Icons",
        "04302026",
        "32",
        "svg",
        "region",
        "architecturegroupicons04302026"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Alert 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Alert_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Alert_48_Dark.svg",
      "tokens": [
        "Res Alert 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Alert",
        "svg",
        "resalert48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Alert 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Alert_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Alert_48_Light.svg",
      "tokens": [
        "Res Alert 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Alert",
        "svg",
        "resalert48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon API Gateway Endpoint",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-API-Gateway_Endpoint_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-API-Gateway_Endpoint_48.svg",
      "tokens": [
        "Res Amazon API Gateway Endpoint",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "API",
        "Gateway",
        "Endpoint",
        "48",
        "svg",
        "resamazonapigatewayendpoint",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Athena Data Source Connectors",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_Amazon-Athena_Data-Source-Connectors_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_Amazon-Athena_Data-Source-Connectors_48.svg",
      "tokens": [
        "Res Amazon Athena Data Source Connectors",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "Amazon",
        "Athena",
        "Data",
        "Source",
        "Connectors",
        "48",
        "svg",
        "resamazonathenadatasourceconnectors",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Aurora Amazon Aurora Instance Alternate",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora_Amazon-Aurora-Instance-alternate_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora_Amazon-Aurora-Instance-alternate_48.svg",
      "tokens": [
        "Res Amazon Aurora Amazon Aurora Instance Alternate",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "Aurora",
        "Instance",
        "alternate",
        "48",
        "svg",
        "resamazonauroraamazonaurorainstancealternate",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Aurora Amazon RDS Instance Aternate",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora_Amazon-RDS-Instance-Aternate_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora_Amazon-RDS-Instance-Aternate_48.svg",
      "tokens": [
        "Res Amazon Aurora Amazon RDS Instance Aternate",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "Aurora",
        "RDS",
        "Instance",
        "Aternate",
        "48",
        "svg",
        "resamazonauroraamazonrdsinstanceaternate",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Aurora Amazon RDS Instance",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora_Amazon-RDS-Instance_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora_Amazon-RDS-Instance_48.svg",
      "tokens": [
        "Res Amazon Aurora Amazon RDS Instance",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "Aurora",
        "RDS",
        "Instance",
        "48",
        "svg",
        "resamazonauroraamazonrdsinstance",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Aurora Instance",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora-Instance_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora-Instance_48.svg",
      "tokens": [
        "Res Amazon Aurora Instance",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "Aurora",
        "Instance",
        "48",
        "svg",
        "resamazonaurorainstance",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Aurora Maria DB Instance Alternate",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora-MariaDB-Instance-Alternate_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora-MariaDB-Instance-Alternate_48.svg",
      "tokens": [
        "Res Amazon Aurora Maria DB Instance Alternate",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "Aurora",
        "MariaDB",
        "Instance",
        "Alternate",
        "48",
        "svg",
        "resamazonauroramariadbinstancealternate",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Aurora Maria DB Instance",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora-MariaDB-Instance_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora-MariaDB-Instance_48.svg",
      "tokens": [
        "Res Amazon Aurora Maria DB Instance",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "Aurora",
        "MariaDB",
        "Instance",
        "48",
        "svg",
        "resamazonauroramariadbinstance",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Aurora My SQL Instance Alternate",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora-MySQL-Instance-Alternate_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora-MySQL-Instance-Alternate_48.svg",
      "tokens": [
        "Res Amazon Aurora My SQL Instance Alternate",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "Aurora",
        "MySQL",
        "Instance",
        "Alternate",
        "48",
        "svg",
        "resamazonauroramysqlinstancealternate",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Aurora My SQL Instance",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora-MySQL-Instance_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora-MySQL-Instance_48.svg",
      "tokens": [
        "Res Amazon Aurora My SQL Instance",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "Aurora",
        "MySQL",
        "Instance",
        "48",
        "svg",
        "resamazonauroramysqlinstance",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Aurora Oracle Instance Alternate",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora-Oracle-Instance-Alternate_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora-Oracle-Instance-Alternate_48.svg",
      "tokens": [
        "Res Amazon Aurora Oracle Instance Alternate",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "Aurora",
        "Oracle",
        "Instance",
        "Alternate",
        "48",
        "svg",
        "resamazonauroraoracleinstancealternate",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Aurora Oracle Instance",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora-Oracle-Instance_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora-Oracle-Instance_48.svg",
      "tokens": [
        "Res Amazon Aurora Oracle Instance",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "Aurora",
        "Oracle",
        "Instance",
        "48",
        "svg",
        "resamazonauroraoracleinstance",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Aurora PIOPS Instance",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora-PIOPS-Instance_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora-PIOPS-Instance_48.svg",
      "tokens": [
        "Res Amazon Aurora PIOPS Instance",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "Aurora",
        "PIOPS",
        "Instance",
        "48",
        "svg",
        "resamazonaurorapiopsinstance",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Aurora Postgre SQL Instance Alternate",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora-PostgreSQL-Instance-Alternate_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora-PostgreSQL-Instance-Alternate_48.svg",
      "tokens": [
        "Res Amazon Aurora Postgre SQL Instance Alternate",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "Aurora",
        "PostgreSQL",
        "Instance",
        "Alternate",
        "48",
        "svg",
        "resamazonaurorapostgresqlinstancealternate",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Aurora Postgre SQL Instance",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora-PostgreSQL-Instance_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora-PostgreSQL-Instance_48.svg",
      "tokens": [
        "Res Amazon Aurora Postgre SQL Instance",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "Aurora",
        "PostgreSQL",
        "Instance",
        "48",
        "svg",
        "resamazonaurorapostgresqlinstance",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Aurora SQL Server Instance Alternate",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora-SQL-Server-Instance-Alternate_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora-SQL-Server-Instance-Alternate_48.svg",
      "tokens": [
        "Res Amazon Aurora SQL Server Instance Alternate",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "Aurora",
        "SQL",
        "Server",
        "Instance",
        "Alternate",
        "48",
        "svg",
        "resamazonaurorasqlserverinstancealternate",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Aurora SQL Server Instance",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora-SQL-Server-Instance_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora-SQL-Server-Instance_48.svg",
      "tokens": [
        "Res Amazon Aurora SQL Server Instance",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "Aurora",
        "SQL",
        "Server",
        "Instance",
        "48",
        "svg",
        "resamazonaurorasqlserverinstance",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Aurora Trusted Language Extensions For Postgre SQL",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora_Trusted-Language-Extensions-for-PostgreSQL_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-Aurora_Trusted-Language-Extensions-for-PostgreSQL_48.svg",
      "tokens": [
        "Res Amazon Aurora Trusted Language Extensions For Postgre SQL",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "Aurora",
        "Trusted",
        "Language",
        "Extensions",
        "for",
        "PostgreSQL",
        "48",
        "svg",
        "resamazonauroratrustedlanguageextensionsforpostgresql",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Braket Chandelier",
      "category": "Res Quantum Technologies",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Quantum-Technologies/Res_Amazon-Braket_Chandelier_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Quantum-Technologies/Res_Amazon-Braket_Chandelier_48.svg",
      "tokens": [
        "Res Amazon Braket Chandelier",
        "Res Quantum Technologies",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Quantum",
        "Technologies",
        "Amazon",
        "Braket",
        "Chandelier",
        "48",
        "svg",
        "resamazonbraketchandelier",
        "resquantumtechnologies"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Braket Chip",
      "category": "Res Quantum Technologies",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Quantum-Technologies/Res_Amazon-Braket_Chip_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Quantum-Technologies/Res_Amazon-Braket_Chip_48.svg",
      "tokens": [
        "Res Amazon Braket Chip",
        "Res Quantum Technologies",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Quantum",
        "Technologies",
        "Amazon",
        "Braket",
        "Chip",
        "48",
        "svg",
        "resamazonbraketchip",
        "resquantumtechnologies"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Braket Embedded Simulator",
      "category": "Res Quantum Technologies",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Quantum-Technologies/Res_Amazon-Braket_Embedded-Simulator_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Quantum-Technologies/Res_Amazon-Braket_Embedded-Simulator_48.svg",
      "tokens": [
        "Res Amazon Braket Embedded Simulator",
        "Res Quantum Technologies",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Quantum",
        "Technologies",
        "Amazon",
        "Braket",
        "Embedded",
        "Simulator",
        "48",
        "svg",
        "resamazonbraketembeddedsimulator",
        "resquantumtechnologies"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Braket Managed Simulator",
      "category": "Res Quantum Technologies",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Quantum-Technologies/Res_Amazon-Braket_Managed-Simulator_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Quantum-Technologies/Res_Amazon-Braket_Managed-Simulator_48.svg",
      "tokens": [
        "Res Amazon Braket Managed Simulator",
        "Res Quantum Technologies",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Quantum",
        "Technologies",
        "Amazon",
        "Braket",
        "Managed",
        "Simulator",
        "48",
        "svg",
        "resamazonbraketmanagedsimulator",
        "resquantumtechnologies"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Braket Noise Simulator",
      "category": "Res Quantum Technologies",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Quantum-Technologies/Res_Amazon-Braket_Noise-Simulator_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Quantum-Technologies/Res_Amazon-Braket_Noise-Simulator_48.svg",
      "tokens": [
        "Res Amazon Braket Noise Simulator",
        "Res Quantum Technologies",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Quantum",
        "Technologies",
        "Amazon",
        "Braket",
        "Noise",
        "Simulator",
        "48",
        "svg",
        "resamazonbraketnoisesimulator",
        "resquantumtechnologies"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Braket QPU",
      "category": "Res Quantum Technologies",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Quantum-Technologies/Res_Amazon-Braket_QPU_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Quantum-Technologies/Res_Amazon-Braket_QPU_48.svg",
      "tokens": [
        "Res Amazon Braket QPU",
        "Res Quantum Technologies",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Quantum",
        "Technologies",
        "Amazon",
        "Braket",
        "QPU",
        "48",
        "svg",
        "resamazonbraketqpu",
        "resquantumtechnologies"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Braket Simulator 1",
      "category": "Res Quantum Technologies",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Quantum-Technologies/Res_Amazon-Braket_Simulator-1_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Quantum-Technologies/Res_Amazon-Braket_Simulator-1_48.svg",
      "tokens": [
        "Res Amazon Braket Simulator 1",
        "Res Quantum Technologies",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Quantum",
        "Technologies",
        "Amazon",
        "Braket",
        "Simulator",
        "1",
        "48",
        "svg",
        "resamazonbraketsimulator1",
        "resquantumtechnologies"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Braket Simulator 2",
      "category": "Res Quantum Technologies",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Quantum-Technologies/Res_Amazon-Braket_Simulator-2_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Quantum-Technologies/Res_Amazon-Braket_Simulator-2_48.svg",
      "tokens": [
        "Res Amazon Braket Simulator 2",
        "Res Quantum Technologies",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Quantum",
        "Technologies",
        "Amazon",
        "Braket",
        "Simulator",
        "2",
        "48",
        "svg",
        "resamazonbraketsimulator2",
        "resquantumtechnologies"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Braket Simulator 3",
      "category": "Res Quantum Technologies",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Quantum-Technologies/Res_Amazon-Braket_Simulator-3_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Quantum-Technologies/Res_Amazon-Braket_Simulator-3_48.svg",
      "tokens": [
        "Res Amazon Braket Simulator 3",
        "Res Quantum Technologies",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Quantum",
        "Technologies",
        "Amazon",
        "Braket",
        "Simulator",
        "3",
        "48",
        "svg",
        "resamazonbraketsimulator3",
        "resquantumtechnologies"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Braket Simulator 4",
      "category": "Res Quantum Technologies",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Quantum-Technologies/Res_Amazon-Braket_Simulator-4_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Quantum-Technologies/Res_Amazon-Braket_Simulator-4_48.svg",
      "tokens": [
        "Res Amazon Braket Simulator 4",
        "Res Quantum Technologies",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Quantum",
        "Technologies",
        "Amazon",
        "Braket",
        "Simulator",
        "4",
        "48",
        "svg",
        "resamazonbraketsimulator4",
        "resquantumtechnologies"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Braket Simulator",
      "category": "Res Quantum Technologies",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Quantum-Technologies/Res_Amazon-Braket_Simulator_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Quantum-Technologies/Res_Amazon-Braket_Simulator_48.svg",
      "tokens": [
        "Res Amazon Braket Simulator",
        "Res Quantum Technologies",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Quantum",
        "Technologies",
        "Amazon",
        "Braket",
        "Simulator",
        "48",
        "svg",
        "resamazonbraketsimulator",
        "resquantumtechnologies"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Braket State Vector",
      "category": "Res Quantum Technologies",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Quantum-Technologies/Res_Amazon-Braket_State-Vector_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Quantum-Technologies/Res_Amazon-Braket_State-Vector_48.svg",
      "tokens": [
        "Res Amazon Braket State Vector",
        "Res Quantum Technologies",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Quantum",
        "Technologies",
        "Amazon",
        "Braket",
        "State",
        "Vector",
        "48",
        "svg",
        "resamazonbraketstatevector",
        "resquantumtechnologies"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Braket Tensor Network",
      "category": "Res Quantum Technologies",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Quantum-Technologies/Res_Amazon-Braket_Tensor-Network_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Quantum-Technologies/Res_Amazon-Braket_Tensor-Network_48.svg",
      "tokens": [
        "Res Amazon Braket Tensor Network",
        "Res Quantum Technologies",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Quantum",
        "Technologies",
        "Amazon",
        "Braket",
        "Tensor",
        "Network",
        "48",
        "svg",
        "resamazonbrakettensornetwork",
        "resquantumtechnologies"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Cloud Front Download Distribution",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-CloudFront_Download-Distribution_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-CloudFront_Download-Distribution_48.svg",
      "tokens": [
        "Res Amazon Cloud Front Download Distribution",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "CloudFront",
        "Download",
        "Distribution",
        "48",
        "svg",
        "resamazoncloudfrontdownloaddistribution",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Cloud Front Edge Location",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-CloudFront_Edge-Location_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-CloudFront_Edge-Location_48.svg",
      "tokens": [
        "Res Amazon Cloud Front Edge Location",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "CloudFront",
        "Edge",
        "Location",
        "48",
        "svg",
        "resamazoncloudfrontedgelocation",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Cloud Front Functions",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-CloudFront_Functions_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-CloudFront_Functions_48.svg",
      "tokens": [
        "Res Amazon Cloud Front Functions",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "CloudFront",
        "Functions",
        "48",
        "svg",
        "resamazoncloudfrontfunctions",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Cloud Front Streaming Distribution",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-CloudFront_Streaming-Distribution_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-CloudFront_Streaming-Distribution_48.svg",
      "tokens": [
        "Res Amazon Cloud Front Streaming Distribution",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "CloudFront",
        "Streaming",
        "Distribution",
        "48",
        "svg",
        "resamazoncloudfrontstreamingdistribution",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Cloud Search Search Documents",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_Amazon-CloudSearch_Search-Documents_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_Amazon-CloudSearch_Search-Documents_48.svg",
      "tokens": [
        "Res Amazon Cloud Search Search Documents",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "Amazon",
        "CloudSearch",
        "Search",
        "Documents",
        "48",
        "svg",
        "resamazoncloudsearchsearchdocuments",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Cloud Watch Alarm",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_Amazon-CloudWatch_Alarm_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_Amazon-CloudWatch_Alarm_48.svg",
      "tokens": [
        "Res Amazon Cloud Watch Alarm",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "Amazon",
        "CloudWatch",
        "Alarm",
        "48",
        "svg",
        "resamazoncloudwatchalarm",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Cloud Watch Cross Account Observability",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_Amazon-CloudWatch_Cross-account-Observability_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_Amazon-CloudWatch_Cross-account-Observability_48.svg",
      "tokens": [
        "Res Amazon Cloud Watch Cross Account Observability",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "Amazon",
        "CloudWatch",
        "Cross",
        "account",
        "Observability",
        "48",
        "svg",
        "resamazoncloudwatchcrossaccountobservability",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Cloud Watch Data Protection",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_Amazon-CloudWatch_Data-Protection_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_Amazon-CloudWatch_Data-Protection_48.svg",
      "tokens": [
        "Res Amazon Cloud Watch Data Protection",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "Amazon",
        "CloudWatch",
        "Data",
        "Protection",
        "48",
        "svg",
        "resamazoncloudwatchdataprotection",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Cloud Watch Event Event Based",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_Amazon-CloudWatch_Event-Event-Based_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_Amazon-CloudWatch_Event-Event-Based_48.svg",
      "tokens": [
        "Res Amazon Cloud Watch Event Event Based",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "Amazon",
        "CloudWatch",
        "Event",
        "Based",
        "48",
        "svg",
        "resamazoncloudwatcheventeventbased",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Cloud Watch Event Time Based",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_Amazon-CloudWatch_Event-Time-Based_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_Amazon-CloudWatch_Event-Time-Based_48.svg",
      "tokens": [
        "Res Amazon Cloud Watch Event Time Based",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "Amazon",
        "CloudWatch",
        "Event",
        "Time",
        "Based",
        "48",
        "svg",
        "resamazoncloudwatcheventtimebased",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Cloud Watch Evidently",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_Amazon-CloudWatch_Evidently_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_Amazon-CloudWatch_Evidently_48.svg",
      "tokens": [
        "Res Amazon Cloud Watch Evidently",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "Amazon",
        "CloudWatch",
        "Evidently",
        "48",
        "svg",
        "resamazoncloudwatchevidently",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Cloud Watch Logs",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_Amazon-CloudWatch_Logs_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_Amazon-CloudWatch_Logs_48.svg",
      "tokens": [
        "Res Amazon Cloud Watch Logs",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "Amazon",
        "CloudWatch",
        "Logs",
        "48",
        "svg",
        "resamazoncloudwatchlogs",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Cloud Watch Metrics Insights",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_Amazon-CloudWatch_Metrics-Insights_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_Amazon-CloudWatch_Metrics-Insights_48.svg",
      "tokens": [
        "Res Amazon Cloud Watch Metrics Insights",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "Amazon",
        "CloudWatch",
        "Metrics",
        "Insights",
        "48",
        "svg",
        "resamazoncloudwatchmetricsinsights",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Cloud Watch Rule",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_Amazon-CloudWatch_Rule_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_Amazon-CloudWatch_Rule_48.svg",
      "tokens": [
        "Res Amazon Cloud Watch Rule",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "Amazon",
        "CloudWatch",
        "Rule",
        "48",
        "svg",
        "resamazoncloudwatchrule",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Cloud Watch RUM",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_Amazon-CloudWatch_RUM_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_Amazon-CloudWatch_RUM_48.svg",
      "tokens": [
        "Res Amazon Cloud Watch RUM",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "Amazon",
        "CloudWatch",
        "RUM",
        "48",
        "svg",
        "resamazoncloudwatchrum",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Cloud Watch Synthetics",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_Amazon-CloudWatch_Synthetics_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_Amazon-CloudWatch_Synthetics_48.svg",
      "tokens": [
        "Res Amazon Cloud Watch Synthetics",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "Amazon",
        "CloudWatch",
        "Synthetics",
        "48",
        "svg",
        "resamazoncloudwatchsynthetics",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Data Zone Business Data Catalog",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_Amazon-DataZone_Business-Data-Catalog_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_Amazon-DataZone_Business-Data-Catalog_48.svg",
      "tokens": [
        "Res Amazon Data Zone Business Data Catalog",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "Amazon",
        "DataZone",
        "Business",
        "Data",
        "Catalog",
        "48",
        "svg",
        "resamazondatazonebusinessdatacatalog",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Data Zone Data Portal",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_Amazon-DataZone_Data-Portal_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_Amazon-DataZone_Data-Portal_48.svg",
      "tokens": [
        "Res Amazon Data Zone Data Portal",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "Amazon",
        "DataZone",
        "Data",
        "Portal",
        "48",
        "svg",
        "resamazondatazonedataportal",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Data Zone Data Projects",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_Amazon-DataZone_Data-Projects_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_Amazon-DataZone_Data-Projects_48.svg",
      "tokens": [
        "Res Amazon Data Zone Data Projects",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "Amazon",
        "DataZone",
        "Data",
        "Projects",
        "48",
        "svg",
        "resamazondatazonedataprojects",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Dev Ops Guru Insights",
      "category": "Res Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Artificial-Intelligence/Res_Amazon-DevOps-Guru_Insights_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Artificial-Intelligence/Res_Amazon-DevOps-Guru_Insights_48.svg",
      "tokens": [
        "Res Amazon Dev Ops Guru Insights",
        "Res Artificial Intelligence",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Artificial",
        "Intelligence",
        "Amazon",
        "DevOps",
        "Guru",
        "Insights",
        "48",
        "svg",
        "resamazondevopsguruinsights",
        "resartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Document DB Elastic Clusters",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-DocumentDB_Elastic-Clusters_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-DocumentDB_Elastic-Clusters_48.svg",
      "tokens": [
        "Res Amazon Document DB Elastic Clusters",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "DocumentDB",
        "Elastic",
        "Clusters",
        "48",
        "svg",
        "resamazondocumentdbelasticclusters",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Dynamo DB Amazon Dynamo DB Accelerator",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-DynamoDB_Amazon-DynamoDB-Accelerator_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-DynamoDB_Amazon-DynamoDB-Accelerator_48.svg",
      "tokens": [
        "Res Amazon Dynamo DB Amazon Dynamo DB Accelerator",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "DynamoDB",
        "Accelerator",
        "48",
        "svg",
        "resamazondynamodbamazondynamodbaccelerator",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Dynamo DB Attribute",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-DynamoDB_Attribute_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-DynamoDB_Attribute_48.svg",
      "tokens": [
        "Res Amazon Dynamo DB Attribute",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "DynamoDB",
        "Attribute",
        "48",
        "svg",
        "resamazondynamodbattribute",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Dynamo DB Attributes",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-DynamoDB_Attributes_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-DynamoDB_Attributes_48.svg",
      "tokens": [
        "Res Amazon Dynamo DB Attributes",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "DynamoDB",
        "Attributes",
        "48",
        "svg",
        "resamazondynamodbattributes",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Dynamo DB Global Secondary Index",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-DynamoDB_Global-secondary-index_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-DynamoDB_Global-secondary-index_48.svg",
      "tokens": [
        "Res Amazon Dynamo DB Global Secondary Index",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "DynamoDB",
        "Global",
        "secondary",
        "index",
        "48",
        "svg",
        "resamazondynamodbglobalsecondaryindex",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Dynamo DB Item",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-DynamoDB_Item_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-DynamoDB_Item_48.svg",
      "tokens": [
        "Res Amazon Dynamo DB Item",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "DynamoDB",
        "Item",
        "48",
        "svg",
        "resamazondynamodbitem",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Dynamo DB Items",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-DynamoDB_Items_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-DynamoDB_Items_48.svg",
      "tokens": [
        "Res Amazon Dynamo DB Items",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "DynamoDB",
        "Items",
        "48",
        "svg",
        "resamazondynamodbitems",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Dynamo DB Standard Access Table Class",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-DynamoDB_Standard-Access-Table-Class_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-DynamoDB_Standard-Access-Table-Class_48.svg",
      "tokens": [
        "Res Amazon Dynamo DB Standard Access Table Class",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "DynamoDB",
        "Standard",
        "Access",
        "Table",
        "Class",
        "48",
        "svg",
        "resamazondynamodbstandardaccesstableclass",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Dynamo DB Standard Infrequent Access Table Class",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-DynamoDB_Standard-Infrequent-Access-Table-Class_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-DynamoDB_Standard-Infrequent-Access-Table-Class_48.svg",
      "tokens": [
        "Res Amazon Dynamo DB Standard Infrequent Access Table Class",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "DynamoDB",
        "Standard",
        "Infrequent",
        "Access",
        "Table",
        "Class",
        "48",
        "svg",
        "resamazondynamodbstandardinfrequentaccesstableclass",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Dynamo DB Stream",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-DynamoDB_Stream_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-DynamoDB_Stream_48.svg",
      "tokens": [
        "Res Amazon Dynamo DB Stream",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "DynamoDB",
        "Stream",
        "48",
        "svg",
        "resamazondynamodbstream",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Dynamo DB Table",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-DynamoDB_Table_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-DynamoDB_Table_48.svg",
      "tokens": [
        "Res Amazon Dynamo DB Table",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "DynamoDB",
        "Table",
        "48",
        "svg",
        "resamazondynamodbtable",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon EC2 AMI",
      "category": "Res Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Compute/Res_Amazon-EC2_AMI_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Compute/Res_Amazon-EC2_AMI_48.svg",
      "tokens": [
        "Res Amazon EC2 AMI",
        "Res Compute",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Compute",
        "Amazon",
        "EC2",
        "AMI",
        "48",
        "svg",
        "resamazonec2ami",
        "rescompute"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon EC2 Auto Scaling",
      "category": "Res Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Compute/Res_Amazon-EC2_Auto-Scaling_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Compute/Res_Amazon-EC2_Auto-Scaling_48.svg",
      "tokens": [
        "Res Amazon EC2 Auto Scaling",
        "Res Compute",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Compute",
        "Amazon",
        "EC2",
        "Auto",
        "Scaling",
        "48",
        "svg",
        "resamazonec2autoscaling",
        "rescompute"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon EC2 AWS Microservice Extractor For .NET",
      "category": "Res Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Compute/Res_Amazon-EC2_AWS-Microservice-Extractor-for-.NET_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Compute/Res_Amazon-EC2_AWS-Microservice-Extractor-for-.NET_48.svg",
      "tokens": [
        "Res Amazon EC2 AWS Microservice Extractor For .NET",
        "Res Compute",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Compute",
        "Amazon",
        "EC2",
        "AWS",
        "Microservice",
        "Extractor",
        "for",
        "NET",
        "48",
        "svg",
        "resamazonec2awsmicroserviceextractorfornet",
        "rescompute"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon EC2 DB Instance",
      "category": "Res Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Compute/Res_Amazon-EC2_DB-Instance_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Compute/Res_Amazon-EC2_DB-Instance_48.svg",
      "tokens": [
        "Res Amazon EC2 DB Instance",
        "Res Compute",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Compute",
        "Amazon",
        "EC2",
        "DB",
        "Instance",
        "48",
        "svg",
        "resamazonec2dbinstance",
        "rescompute"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon EC2 Elastic IP Address",
      "category": "Res Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Compute/Res_Amazon-EC2_Elastic-IP-Address_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Compute/Res_Amazon-EC2_Elastic-IP-Address_48.svg",
      "tokens": [
        "Res Amazon EC2 Elastic IP Address",
        "Res Compute",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Compute",
        "Amazon",
        "EC2",
        "Elastic",
        "IP",
        "Address",
        "48",
        "svg",
        "resamazonec2elasticipaddress",
        "rescompute"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon EC2 Instance With Cloud Watch",
      "category": "Res Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Compute/Res_Amazon-EC2_Instance-with-CloudWatch_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Compute/Res_Amazon-EC2_Instance-with-CloudWatch_48.svg",
      "tokens": [
        "Res Amazon EC2 Instance With Cloud Watch",
        "Res Compute",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Compute",
        "Amazon",
        "EC2",
        "Instance",
        "with",
        "CloudWatch",
        "48",
        "svg",
        "resamazonec2instancewithcloudwatch",
        "rescompute"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon EC2 Instance",
      "category": "Res Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Compute/Res_Amazon-EC2_Instance_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Compute/Res_Amazon-EC2_Instance_48.svg",
      "tokens": [
        "Res Amazon EC2 Instance",
        "Res Compute",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Compute",
        "Amazon",
        "EC2",
        "Instance",
        "48",
        "svg",
        "resamazonec2instance",
        "rescompute"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon EC2 Instances",
      "category": "Res Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Compute/Res_Amazon-EC2_Instances_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Compute/Res_Amazon-EC2_Instances_48.svg",
      "tokens": [
        "Res Amazon EC2 Instances",
        "Res Compute",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Compute",
        "Amazon",
        "EC2",
        "Instances",
        "48",
        "svg",
        "resamazonec2instances",
        "rescompute"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon EC2 Rescue",
      "category": "Res Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Compute/Res_Amazon-EC2_Rescue_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Compute/Res_Amazon-EC2_Rescue_48.svg",
      "tokens": [
        "Res Amazon EC2 Rescue",
        "Res Compute",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Compute",
        "Amazon",
        "EC2",
        "Rescue",
        "48",
        "svg",
        "resamazonec2rescue",
        "rescompute"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon EC2 Spot Instance",
      "category": "Res Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Compute/Res_Amazon-EC2_Spot-Instance_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Compute/Res_Amazon-EC2_Spot-Instance_48.svg",
      "tokens": [
        "Res Amazon EC2 Spot Instance",
        "Res Compute",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Compute",
        "Amazon",
        "EC2",
        "Spot",
        "Instance",
        "48",
        "svg",
        "resamazonec2spotinstance",
        "rescompute"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Elasti Cache Cache Node",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-ElastiCache_Cache-Node_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-ElastiCache_Cache-Node_48.svg",
      "tokens": [
        "Res Amazon Elasti Cache Cache Node",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "ElastiCache",
        "Cache",
        "Node",
        "48",
        "svg",
        "resamazonelasticachecachenode",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Elasti Cache Elasti Cache For Memcached",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-ElastiCache_ElastiCache-for-Memcached_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-ElastiCache_ElastiCache-for-Memcached_48.svg",
      "tokens": [
        "Res Amazon Elasti Cache Elasti Cache For Memcached",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "ElastiCache",
        "for",
        "Memcached",
        "48",
        "svg",
        "resamazonelasticacheelasticacheformemcached",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Elasti Cache Elasti Cache For Redis",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-ElastiCache_ElastiCache-for-Redis_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-ElastiCache_ElastiCache-for-Redis_48.svg",
      "tokens": [
        "Res Amazon Elasti Cache Elasti Cache For Redis",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "ElastiCache",
        "for",
        "Redis",
        "48",
        "svg",
        "resamazonelasticacheelasticacheforredis",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Elasti Cache Elasti Cache For Valkey",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-ElastiCache_ElastiCache-for-Valkey_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-ElastiCache_ElastiCache-for-Valkey_48.svg",
      "tokens": [
        "Res Amazon Elasti Cache Elasti Cache For Valkey",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "ElastiCache",
        "for",
        "Valkey",
        "48",
        "svg",
        "resamazonelasticacheelasticacheforvalkey",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Elastic Block Store Amazon Data Lifecycle Manager",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Elastic-Block-Store_Amazon-Data-Lifecycle-Manager_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Elastic-Block-Store_Amazon-Data-Lifecycle-Manager_48.svg",
      "tokens": [
        "Res Amazon Elastic Block Store Amazon Data Lifecycle Manager",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Elastic",
        "Block",
        "Store",
        "Data",
        "Lifecycle",
        "Manager",
        "48",
        "svg",
        "resamazonelasticblockstoreamazondatalifecyclemanager",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Elastic Block Store Multiple Volumes",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Elastic-Block-Store_Multiple-Volumes_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Elastic-Block-Store_Multiple-Volumes_48.svg",
      "tokens": [
        "Res Amazon Elastic Block Store Multiple Volumes",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Elastic",
        "Block",
        "Store",
        "Multiple",
        "Volumes",
        "48",
        "svg",
        "resamazonelasticblockstoremultiplevolumes",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Elastic Block Store Snapshot",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Elastic-Block-Store_Snapshot_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Elastic-Block-Store_Snapshot_48.svg",
      "tokens": [
        "Res Amazon Elastic Block Store Snapshot",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Elastic",
        "Block",
        "Store",
        "Snapshot",
        "48",
        "svg",
        "resamazonelasticblockstoresnapshot",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Elastic Block Store Volume Gp3",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Elastic-Block-Store_Volume-gp3_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Elastic-Block-Store_Volume-gp3_48.svg",
      "tokens": [
        "Res Amazon Elastic Block Store Volume Gp3",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Elastic",
        "Block",
        "Store",
        "Volume",
        "gp3",
        "48",
        "svg",
        "resamazonelasticblockstorevolumegp3",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Elastic Block Store Volume",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Elastic-Block-Store_Volume_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Elastic-Block-Store_Volume_48.svg",
      "tokens": [
        "Res Amazon Elastic Block Store Volume",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Elastic",
        "Block",
        "Store",
        "Volume",
        "48",
        "svg",
        "resamazonelasticblockstorevolume",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Elastic Container Registry Image",
      "category": "Res Containers",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Containers/Res_Amazon-Elastic-Container-Registry_Image_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Containers/Res_Amazon-Elastic-Container-Registry_Image_48.svg",
      "tokens": [
        "Res Amazon Elastic Container Registry Image",
        "Res Containers",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Containers",
        "Amazon",
        "Elastic",
        "Container",
        "Registry",
        "Image",
        "48",
        "svg",
        "resamazonelasticcontainerregistryimage",
        "rescontainers"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Elastic Container Registry Registry",
      "category": "Res Containers",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Containers/Res_Amazon-Elastic-Container-Registry_Registry_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Containers/Res_Amazon-Elastic-Container-Registry_Registry_48.svg",
      "tokens": [
        "Res Amazon Elastic Container Registry Registry",
        "Res Containers",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Containers",
        "Amazon",
        "Elastic",
        "Container",
        "Registry",
        "48",
        "svg",
        "resamazonelasticcontainerregistryregistry",
        "rescontainers"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Elastic Container Service Container 1",
      "category": "Res Containers",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Containers/Res_Amazon-Elastic-Container-Service_Container-1_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Containers/Res_Amazon-Elastic-Container-Service_Container-1_48.svg",
      "tokens": [
        "Res Amazon Elastic Container Service Container 1",
        "Res Containers",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Containers",
        "Amazon",
        "Elastic",
        "Container",
        "Service",
        "1",
        "48",
        "svg",
        "resamazonelasticcontainerservicecontainer1",
        "rescontainers"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Elastic Container Service Container 2",
      "category": "Res Containers",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Containers/Res_Amazon-Elastic-Container-Service_Container-2_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Containers/Res_Amazon-Elastic-Container-Service_Container-2_48.svg",
      "tokens": [
        "Res Amazon Elastic Container Service Container 2",
        "Res Containers",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Containers",
        "Amazon",
        "Elastic",
        "Container",
        "Service",
        "2",
        "48",
        "svg",
        "resamazonelasticcontainerservicecontainer2",
        "rescontainers"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Elastic Container Service Container 3",
      "category": "Res Containers",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Containers/Res_Amazon-Elastic-Container-Service_Container-3_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Containers/Res_Amazon-Elastic-Container-Service_Container-3_48.svg",
      "tokens": [
        "Res Amazon Elastic Container Service Container 3",
        "Res Containers",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Containers",
        "Amazon",
        "Elastic",
        "Container",
        "Service",
        "3",
        "48",
        "svg",
        "resamazonelasticcontainerservicecontainer3",
        "rescontainers"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Elastic Container Service Copi Io T CLI",
      "category": "Res Containers",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Containers/Res_Amazon-Elastic-Container-Service_CopiIoT-CLI_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Containers/Res_Amazon-Elastic-Container-Service_CopiIoT-CLI_48.svg",
      "tokens": [
        "Res Amazon Elastic Container Service Copi Io T CLI",
        "Res Containers",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Containers",
        "Amazon",
        "Elastic",
        "Container",
        "Service",
        "CopiIoT",
        "CLI",
        "48",
        "svg",
        "resamazonelasticcontainerservicecopiiotcli",
        "rescontainers"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Elastic Container Service ECS Service Connect",
      "category": "Res Containers",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Containers/Res_Amazon-Elastic-Container-Service_ECS-Service-Connect_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Containers/Res_Amazon-Elastic-Container-Service_ECS-Service-Connect_48.svg",
      "tokens": [
        "Res Amazon Elastic Container Service ECS Service Connect",
        "Res Containers",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Containers",
        "Amazon",
        "Elastic",
        "Container",
        "Service",
        "ECS",
        "Connect",
        "48",
        "svg",
        "resamazonelasticcontainerserviceecsserviceconnect",
        "rescontainers"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Elastic Container Service Service",
      "category": "Res Containers",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Containers/Res_Amazon-Elastic-Container-Service_Service_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Containers/Res_Amazon-Elastic-Container-Service_Service_48.svg",
      "tokens": [
        "Res Amazon Elastic Container Service Service",
        "Res Containers",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Containers",
        "Amazon",
        "Elastic",
        "Container",
        "Service",
        "48",
        "svg",
        "resamazonelasticcontainerserviceservice",
        "rescontainers"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Elastic Container Service Task",
      "category": "Res Containers",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Containers/Res_Amazon-Elastic-Container-Service_Task_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Containers/Res_Amazon-Elastic-Container-Service_Task_48.svg",
      "tokens": [
        "Res Amazon Elastic Container Service Task",
        "Res Containers",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Containers",
        "Amazon",
        "Elastic",
        "Container",
        "Service",
        "Task",
        "48",
        "svg",
        "resamazonelasticcontainerservicetask",
        "rescontainers"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Elastic File System EFS Intelligent Tiering",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Elastic-File-System_EFS-Intelligent-Tiering_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Elastic-File-System_EFS-Intelligent-Tiering_48.svg",
      "tokens": [
        "Res Amazon Elastic File System EFS Intelligent Tiering",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Elastic",
        "File",
        "System",
        "EFS",
        "Intelligent",
        "Tiering",
        "48",
        "svg",
        "resamazonelasticfilesystemefsintelligenttiering",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Elastic File System EFS One Zone Infrequent Access",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Elastic-File-System_EFS-One-Zone-Infrequent-Access_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Elastic-File-System_EFS-One-Zone-Infrequent-Access_48.svg",
      "tokens": [
        "Res Amazon Elastic File System EFS One Zone Infrequent Access",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Elastic",
        "File",
        "System",
        "EFS",
        "One",
        "Zone",
        "Infrequent",
        "Access",
        "48",
        "svg",
        "resamazonelasticfilesystemefsonezoneinfrequentaccess",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Elastic File System EFS One Zone",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Elastic-File-System_EFS-One-Zone_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Elastic-File-System_EFS-One-Zone_48.svg",
      "tokens": [
        "Res Amazon Elastic File System EFS One Zone",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Elastic",
        "File",
        "System",
        "EFS",
        "One",
        "Zone",
        "48",
        "svg",
        "resamazonelasticfilesystemefsonezone",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Elastic File System EFS Standard Infrequent Access",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Elastic-File-System_EFS-Standard-Infrequent-Access_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Elastic-File-System_EFS-Standard-Infrequent-Access_48.svg",
      "tokens": [
        "Res Amazon Elastic File System EFS Standard Infrequent Access",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Elastic",
        "File",
        "System",
        "EFS",
        "Standard",
        "Infrequent",
        "Access",
        "48",
        "svg",
        "resamazonelasticfilesystemefsstandardinfrequentaccess",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Elastic File System EFS Standard",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Elastic-File-System_EFS-Standard_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Elastic-File-System_EFS-Standard_48.svg",
      "tokens": [
        "Res Amazon Elastic File System EFS Standard",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Elastic",
        "File",
        "System",
        "EFS",
        "Standard",
        "48",
        "svg",
        "resamazonelasticfilesystemefsstandard",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Elastic File System Elastic Throughput",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Elastic-File-System_Elastic-Throughput_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Elastic-File-System_Elastic-Throughput_48.svg",
      "tokens": [
        "Res Amazon Elastic File System Elastic Throughput",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Elastic",
        "File",
        "System",
        "Throughput",
        "48",
        "svg",
        "resamazonelasticfilesystemelasticthroughput",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Elastic File System File System",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Elastic-File-System_File-System_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Elastic-File-System_File-System_48.svg",
      "tokens": [
        "Res Amazon Elastic File System File System",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Elastic",
        "File",
        "System",
        "48",
        "svg",
        "resamazonelasticfilesystemfilesystem",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Elastic Kubernetes Service EKS On Outposts",
      "category": "Res Containers",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Containers/Res_Amazon-Elastic-Kubernetes-Service_EKS-on-Outposts_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Containers/Res_Amazon-Elastic-Kubernetes-Service_EKS-on-Outposts_48.svg",
      "tokens": [
        "Res Amazon Elastic Kubernetes Service EKS On Outposts",
        "Res Containers",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Containers",
        "Amazon",
        "Elastic",
        "Kubernetes",
        "Service",
        "EKS",
        "on",
        "Outposts",
        "48",
        "svg",
        "resamazonelastickubernetesserviceeksonoutposts",
        "rescontainers"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon EMR Cluster",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_Amazon-EMR_Cluster_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_Amazon-EMR_Cluster_48.svg",
      "tokens": [
        "Res Amazon EMR Cluster",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "Amazon",
        "EMR",
        "Cluster",
        "48",
        "svg",
        "resamazonemrcluster",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon EMR EMR Engine",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_Amazon-EMR_EMR-Engine_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_Amazon-EMR_EMR-Engine_48.svg",
      "tokens": [
        "Res Amazon EMR EMR Engine",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "Amazon",
        "EMR",
        "Engine",
        "48",
        "svg",
        "resamazonemremrengine",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon EMR HDFS Cluster",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_Amazon-EMR_HDFS-Cluster_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_Amazon-EMR_HDFS-Cluster_48.svg",
      "tokens": [
        "Res Amazon EMR HDFS Cluster",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "Amazon",
        "EMR",
        "HDFS",
        "Cluster",
        "48",
        "svg",
        "resamazonemrhdfscluster",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Event Bridge Custom Event Bus",
      "category": "Res Application Integration",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-EventBridge_Custom-Event-Bus_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-EventBridge_Custom-Event-Bus_48.svg",
      "tokens": [
        "Res Amazon Event Bridge Custom Event Bus",
        "Res Application Integration",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Application",
        "Integration",
        "Amazon",
        "EventBridge",
        "Custom",
        "Event",
        "Bus",
        "48",
        "svg",
        "resamazoneventbridgecustomeventbus",
        "resapplicationintegration"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Event Bridge Default Event Bus",
      "category": "Res Application Integration",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-EventBridge_Default-Event-Bus_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-EventBridge_Default-Event-Bus_48.svg",
      "tokens": [
        "Res Amazon Event Bridge Default Event Bus",
        "Res Application Integration",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Application",
        "Integration",
        "Amazon",
        "EventBridge",
        "Default",
        "Event",
        "Bus",
        "48",
        "svg",
        "resamazoneventbridgedefaulteventbus",
        "resapplicationintegration"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Event Bridge Event",
      "category": "Res Application Integration",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-EventBridge-Event_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-EventBridge-Event_48.svg",
      "tokens": [
        "Res Amazon Event Bridge Event",
        "Res Application Integration",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Application",
        "Integration",
        "Amazon",
        "EventBridge",
        "Event",
        "48",
        "svg",
        "resamazoneventbridgeevent",
        "resapplicationintegration"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Event Bridge Pipes",
      "category": "Res Application Integration",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-EventBridge_Pipes_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-EventBridge_Pipes_48.svg",
      "tokens": [
        "Res Amazon Event Bridge Pipes",
        "Res Application Integration",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Application",
        "Integration",
        "Amazon",
        "EventBridge",
        "Pipes",
        "48",
        "svg",
        "resamazoneventbridgepipes",
        "resapplicationintegration"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Event Bridge Rule",
      "category": "Res Application Integration",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-EventBridge_Rule_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-EventBridge_Rule_48.svg",
      "tokens": [
        "Res Amazon Event Bridge Rule",
        "Res Application Integration",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Application",
        "Integration",
        "Amazon",
        "EventBridge",
        "Rule",
        "48",
        "svg",
        "resamazoneventbridgerule",
        "resapplicationintegration"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Event Bridge Saas Partner Event",
      "category": "Res Application Integration",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-EventBridge_Saas-Partner-Event_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-EventBridge_Saas-Partner-Event_48.svg",
      "tokens": [
        "Res Amazon Event Bridge Saas Partner Event",
        "Res Application Integration",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Application",
        "Integration",
        "Amazon",
        "EventBridge",
        "Saas",
        "Partner",
        "Event",
        "48",
        "svg",
        "resamazoneventbridgesaaspartnerevent",
        "resapplicationintegration"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Event Bridge Scheduler",
      "category": "Res Application Integration",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-EventBridge_Scheduler_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-EventBridge_Scheduler_48.svg",
      "tokens": [
        "Res Amazon Event Bridge Scheduler",
        "Res Application Integration",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Application",
        "Integration",
        "Amazon",
        "EventBridge",
        "Scheduler",
        "48",
        "svg",
        "resamazoneventbridgescheduler",
        "resapplicationintegration"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Event Bridge Schema Registry",
      "category": "Res Application Integration",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-EventBridge_Schema-Registry_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-EventBridge_Schema-Registry_48.svg",
      "tokens": [
        "Res Amazon Event Bridge Schema Registry",
        "Res Application Integration",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Application",
        "Integration",
        "Amazon",
        "EventBridge",
        "Schema",
        "Registry",
        "48",
        "svg",
        "resamazoneventbridgeschemaregistry",
        "resapplicationintegration"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Event Bridge Schema",
      "category": "Res Application Integration",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-EventBridge_Schema_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-EventBridge_Schema_48.svg",
      "tokens": [
        "Res Amazon Event Bridge Schema",
        "Res Application Integration",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Application",
        "Integration",
        "Amazon",
        "EventBridge",
        "Schema",
        "48",
        "svg",
        "resamazoneventbridgeschema",
        "resapplicationintegration"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon File Cache Hybrid NFS Linked Datasets",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-File-Cache_Hybrid-NFS-linked-datasets_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-File-Cache_Hybrid-NFS-linked-datasets_48.svg",
      "tokens": [
        "Res Amazon File Cache Hybrid NFS Linked Datasets",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "File",
        "Cache",
        "Hybrid",
        "NFS",
        "linked",
        "datasets",
        "48",
        "svg",
        "resamazonfilecachehybridnfslinkeddatasets",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon File Cache On Premises NFS Linked Datasets",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-File-Cache_On-premises-NFS-linked-datasets_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-File-Cache_On-premises-NFS-linked-datasets_48.svg",
      "tokens": [
        "Res Amazon File Cache On Premises NFS Linked Datasets",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "File",
        "Cache",
        "On",
        "premises",
        "NFS",
        "linked",
        "datasets",
        "48",
        "svg",
        "resamazonfilecacheonpremisesnfslinkeddatasets",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon File Cache S3 Linked Datasets",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-File-Cache_S3-linked-datasets_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-File-Cache_S3-linked-datasets_48.svg",
      "tokens": [
        "Res Amazon File Cache S3 Linked Datasets",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "File",
        "Cache",
        "S3",
        "linked",
        "datasets",
        "48",
        "svg",
        "resamazonfilecaches3linkeddatasets",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Inspector Agent",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_Amazon-Inspector_Agent_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_Amazon-Inspector_Agent_48.svg",
      "tokens": [
        "Res Amazon Inspector Agent",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "Amazon",
        "Inspector",
        "Agent",
        "48",
        "svg",
        "resamazoninspectoragent",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Location Service Geofence",
      "category": "Res Front End Web Mobile",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Front-End-Web-Mobile/Res_Amazon-Location-Service_Geofence_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Front-End-Web-Mobile/Res_Amazon-Location-Service_Geofence_48.svg",
      "tokens": [
        "Res Amazon Location Service Geofence",
        "Res Front End Web Mobile",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Front",
        "End",
        "Web",
        "Mobile",
        "Amazon",
        "Location",
        "Service",
        "Geofence",
        "48",
        "svg",
        "resamazonlocationservicegeofence",
        "resfrontendwebmobile"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Location Service Map",
      "category": "Res Front End Web Mobile",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Front-End-Web-Mobile/Res_Amazon-Location-Service_Map-_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Front-End-Web-Mobile/Res_Amazon-Location-Service_Map _48.svg",
      "tokens": [
        "Res Amazon Location Service Map",
        "Res Front End Web Mobile",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Front",
        "End",
        "Web",
        "Mobile",
        "Amazon",
        "Location",
        "Service",
        "Map",
        "48",
        "svg",
        "resamazonlocationservicemap",
        "resfrontendwebmobile"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Location Service Place",
      "category": "Res Front End Web Mobile",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Front-End-Web-Mobile/Res_Amazon-Location-Service_Place_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Front-End-Web-Mobile/Res_Amazon-Location-Service_Place_48.svg",
      "tokens": [
        "Res Amazon Location Service Place",
        "Res Front End Web Mobile",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Front",
        "End",
        "Web",
        "Mobile",
        "Amazon",
        "Location",
        "Service",
        "Place",
        "48",
        "svg",
        "resamazonlocationserviceplace",
        "resfrontendwebmobile"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Location Service Routes",
      "category": "Res Front End Web Mobile",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Front-End-Web-Mobile/Res_Amazon-Location-Service_Routes_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Front-End-Web-Mobile/Res_Amazon-Location-Service_Routes_48.svg",
      "tokens": [
        "Res Amazon Location Service Routes",
        "Res Front End Web Mobile",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Front",
        "End",
        "Web",
        "Mobile",
        "Amazon",
        "Location",
        "Service",
        "Routes",
        "48",
        "svg",
        "resamazonlocationserviceroutes",
        "resfrontendwebmobile"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Location Service Track",
      "category": "Res Front End Web Mobile",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Front-End-Web-Mobile/Res_Amazon-Location-Service_Track-_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Front-End-Web-Mobile/Res_Amazon-Location-Service_Track _48.svg",
      "tokens": [
        "Res Amazon Location Service Track",
        "Res Front End Web Mobile",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Front",
        "End",
        "Web",
        "Mobile",
        "Amazon",
        "Location",
        "Service",
        "Track",
        "48",
        "svg",
        "resamazonlocationservicetrack",
        "resfrontendwebmobile"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Managed Blockchain Blockchain",
      "category": "Res Blockchain",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Blockchain/Res_Amazon-Managed-Blockchain_Blockchain_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Blockchain/Res_Amazon-Managed-Blockchain_Blockchain_48.svg",
      "tokens": [
        "Res Amazon Managed Blockchain Blockchain",
        "Res Blockchain",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Blockchain",
        "Amazon",
        "Managed",
        "48",
        "svg",
        "resamazonmanagedblockchainblockchain",
        "resblockchain"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon MQ Broker",
      "category": "Res Application Integration",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-MQ_Broker_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-MQ_Broker_48.svg",
      "tokens": [
        "Res Amazon MQ Broker",
        "Res Application Integration",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Application",
        "Integration",
        "Amazon",
        "MQ",
        "Broker",
        "48",
        "svg",
        "resamazonmqbroker",
        "resapplicationintegration"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon MSK Amazon MSK Connect",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_Amazon-MSK_Amazon-MSK-Connect_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_Amazon-MSK_Amazon-MSK-Connect_48.svg",
      "tokens": [
        "Res Amazon MSK Amazon MSK Connect",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "Amazon",
        "MSK",
        "Connect",
        "48",
        "svg",
        "resamazonmskamazonmskconnect",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Open Search Service Cluster Administrator Node",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_Amazon-OpenSearch-Service_Cluster-Administrator-Node_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_Amazon-OpenSearch-Service_Cluster-Administrator-Node_48.svg",
      "tokens": [
        "Res Amazon Open Search Service Cluster Administrator Node",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "Amazon",
        "OpenSearch",
        "Service",
        "Cluster",
        "Administrator",
        "Node",
        "48",
        "svg",
        "resamazonopensearchserviceclusteradministratornode",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Open Search Service Data Node",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_Amazon-OpenSearch-Service_Data-Node_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_Amazon-OpenSearch-Service_Data-Node_48.svg",
      "tokens": [
        "Res Amazon Open Search Service Data Node",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "Amazon",
        "OpenSearch",
        "Service",
        "Data",
        "Node",
        "48",
        "svg",
        "resamazonopensearchservicedatanode",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Open Search Service Index",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_Amazon-OpenSearch-Service_Index_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_Amazon-OpenSearch-Service_Index_48.svg",
      "tokens": [
        "Res Amazon Open Search Service Index",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "Amazon",
        "OpenSearch",
        "Service",
        "Index",
        "48",
        "svg",
        "resamazonopensearchserviceindex",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Open Search Service Observability",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_Amazon-OpenSearch-Service_Observability_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_Amazon-OpenSearch-Service_Observability_48.svg",
      "tokens": [
        "Res Amazon Open Search Service Observability",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "Amazon",
        "OpenSearch",
        "Service",
        "Observability",
        "48",
        "svg",
        "resamazonopensearchserviceobservability",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Open Search Service Open Search Dashboards",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_Amazon-OpenSearch-Service_OpenSearch-Dashboards_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_Amazon-OpenSearch-Service_OpenSearch-Dashboards_48.svg",
      "tokens": [
        "Res Amazon Open Search Service Open Search Dashboards",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "Amazon",
        "OpenSearch",
        "Service",
        "Dashboards",
        "48",
        "svg",
        "resamazonopensearchserviceopensearchdashboards",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Open Search Service Open Search Ingestion",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_Amazon-OpenSearch-Service_OpenSearch-Ingestion_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_Amazon-OpenSearch-Service_OpenSearch-Ingestion_48.svg",
      "tokens": [
        "Res Amazon Open Search Service Open Search Ingestion",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "Amazon",
        "OpenSearch",
        "Service",
        "Ingestion",
        "48",
        "svg",
        "resamazonopensearchserviceopensearchingestion",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Open Search Service Traces",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_Amazon-OpenSearch-Service_Traces_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_Amazon-OpenSearch-Service_Traces_48.svg",
      "tokens": [
        "Res Amazon Open Search Service Traces",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "Amazon",
        "OpenSearch",
        "Service",
        "Traces",
        "48",
        "svg",
        "resamazonopensearchservicetraces",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Open Search Service Ultra Warm Node",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_Amazon-OpenSearch-Service_UltraWarm-Node_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_Amazon-OpenSearch-Service_UltraWarm-Node_48.svg",
      "tokens": [
        "Res Amazon Open Search Service Ultra Warm Node",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "Amazon",
        "OpenSearch",
        "Service",
        "UltraWarm",
        "Node",
        "48",
        "svg",
        "resamazonopensearchserviceultrawarmnode",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Pinpoint Journey",
      "category": "Res Business Applications",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Business-Applications/Res_Amazon-Pinpoint_Journey_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Business-Applications/Res_Amazon-Pinpoint_Journey_48.svg",
      "tokens": [
        "Res Amazon Pinpoint Journey",
        "Res Business Applications",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Business",
        "Applications",
        "Amazon",
        "Pinpoint",
        "Journey",
        "48",
        "svg",
        "resamazonpinpointjourney",
        "resbusinessapplications"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon RDS Blue Green Deployments",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-RDS_Blue-Green-Deployments_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-RDS_Blue-Green-Deployments_48.svg",
      "tokens": [
        "Res Amazon RDS Blue Green Deployments",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "RDS",
        "Blue",
        "Green",
        "Deployments",
        "48",
        "svg",
        "resamazonrdsbluegreendeployments",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon RDS Multi AZ DB Cluster",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-RDS_Multi-AZ-DB-Cluster_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-RDS_Multi-AZ-DB-Cluster_48.svg",
      "tokens": [
        "Res Amazon RDS Multi AZ DB Cluster",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "RDS",
        "Multi",
        "AZ",
        "DB",
        "Cluster",
        "48",
        "svg",
        "resamazonrdsmultiazdbcluster",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon RDS Multi AZ",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-RDS_Multi-AZ_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-RDS_Multi-AZ_48.svg",
      "tokens": [
        "Res Amazon RDS Multi AZ",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "RDS",
        "Multi",
        "AZ",
        "48",
        "svg",
        "resamazonrdsmultiaz",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon RDS Optimized Writes",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-RDS_Optimized-Writes_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-RDS_Optimized-Writes_48.svg",
      "tokens": [
        "Res Amazon RDS Optimized Writes",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "RDS",
        "Optimized",
        "Writes",
        "48",
        "svg",
        "resamazonrdsoptimizedwrites",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon RDS Proxy Instance Alternate",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-RDS-Proxy-Instance-Alternate_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-RDS-Proxy-Instance-Alternate_48.svg",
      "tokens": [
        "Res Amazon RDS Proxy Instance Alternate",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "RDS",
        "Proxy",
        "Instance",
        "Alternate",
        "48",
        "svg",
        "resamazonrdsproxyinstancealternate",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon RDS Proxy Instance",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-RDS-Proxy-Instance_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-RDS-Proxy-Instance_48.svg",
      "tokens": [
        "Res Amazon RDS Proxy Instance",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "RDS",
        "Proxy",
        "Instance",
        "48",
        "svg",
        "resamazonrdsproxyinstance",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon RDS Trusted Language Extensions For Postgre SQL",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_Amazon-RDS_Trusted-Language-Extensions-for-PostgreSQL_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_Amazon-RDS_Trusted-Language-Extensions-for-PostgreSQL_48.svg",
      "tokens": [
        "Res Amazon RDS Trusted Language Extensions For Postgre SQL",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "Amazon",
        "RDS",
        "Trusted",
        "Language",
        "Extensions",
        "for",
        "PostgreSQL",
        "48",
        "svg",
        "resamazonrdstrustedlanguageextensionsforpostgresql",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Redshift Auto Copy",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_Amazon-Redshift_Auto-copy_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_Amazon-Redshift_Auto-copy_48.svg",
      "tokens": [
        "Res Amazon Redshift Auto Copy",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "Amazon",
        "Redshift",
        "Auto",
        "copy",
        "48",
        "svg",
        "resamazonredshiftautocopy",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Redshift Data Sharing Governance",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_Amazon-Redshift_Data-Sharing-Governance_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_Amazon-Redshift_Data-Sharing-Governance_48.svg",
      "tokens": [
        "Res Amazon Redshift Data Sharing Governance",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "Amazon",
        "Redshift",
        "Data",
        "Sharing",
        "Governance",
        "48",
        "svg",
        "resamazonredshiftdatasharinggovernance",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Redshift Dense Compute Node",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_Amazon-Redshift_Dense-Compute-Node_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_Amazon-Redshift_Dense-Compute-Node_48.svg",
      "tokens": [
        "Res Amazon Redshift Dense Compute Node",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "Amazon",
        "Redshift",
        "Dense",
        "Compute",
        "Node",
        "48",
        "svg",
        "resamazonredshiftdensecomputenode",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Redshift Dense Storage Node",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_Amazon-Redshift_Dense-Storage-Node_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_Amazon-Redshift_Dense-Storage-Node_48.svg",
      "tokens": [
        "Res Amazon Redshift Dense Storage Node",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "Amazon",
        "Redshift",
        "Dense",
        "Storage",
        "Node",
        "48",
        "svg",
        "resamazonredshiftdensestoragenode",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Redshift ML",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_Amazon-Redshift_ML_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_Amazon-Redshift_ML_48.svg",
      "tokens": [
        "Res Amazon Redshift ML",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "Amazon",
        "Redshift",
        "ML",
        "48",
        "svg",
        "resamazonredshiftml",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Redshift Query Editor V2.0",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_Amazon-Redshift_Query-Editor-v2.0_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_Amazon-Redshift_Query-Editor-v2.0_48.svg",
      "tokens": [
        "Res Amazon Redshift Query Editor V2.0",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "Amazon",
        "Redshift",
        "Query",
        "Editor",
        "v2",
        "0",
        "48",
        "svg",
        "resamazonredshiftqueryeditorv20",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Redshift RA3",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_Amazon-Redshift_RA3_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_Amazon-Redshift_RA3_48.svg",
      "tokens": [
        "Res Amazon Redshift RA3",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "Amazon",
        "Redshift",
        "RA3",
        "48",
        "svg",
        "resamazonredshiftra3",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Redshift Streaming Ingestion",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_Amazon-Redshift_Streaming-Ingestion_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_Amazon-Redshift_Streaming-Ingestion_48.svg",
      "tokens": [
        "Res Amazon Redshift Streaming Ingestion",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "Amazon",
        "Redshift",
        "Streaming",
        "Ingestion",
        "48",
        "svg",
        "resamazonredshiftstreamingingestion",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Rekognition Image",
      "category": "Res Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Artificial-Intelligence/Res_Amazon-Rekognition_Image_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Artificial-Intelligence/Res_Amazon-Rekognition_Image_48.svg",
      "tokens": [
        "Res Amazon Rekognition Image",
        "Res Artificial Intelligence",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Artificial",
        "Intelligence",
        "Amazon",
        "Rekognition",
        "Image",
        "48",
        "svg",
        "resamazonrekognitionimage",
        "resartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Rekognition Video",
      "category": "Res Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Artificial-Intelligence/Res_Amazon-Rekognition_Video_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Artificial-Intelligence/Res_Amazon-Rekognition_Video_48.svg",
      "tokens": [
        "Res Amazon Rekognition Video",
        "Res Artificial Intelligence",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Artificial",
        "Intelligence",
        "Amazon",
        "Rekognition",
        "Video",
        "48",
        "svg",
        "resamazonrekognitionvideo",
        "resartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Route 53 Hosted Zone",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-Route-53-Hosted-Zone_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-Route-53-Hosted-Zone_48.svg",
      "tokens": [
        "Res Amazon Route 53 Hosted Zone",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "Route",
        "53",
        "Hosted",
        "Zone",
        "48",
        "svg",
        "resamazonroute53hostedzone",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Route 53 Readiness Checks",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-Route-53_Readiness-Checks_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-Route-53_Readiness-Checks_48.svg",
      "tokens": [
        "Res Amazon Route 53 Readiness Checks",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "Route",
        "53",
        "Readiness",
        "Checks",
        "48",
        "svg",
        "resamazonroute53readinesschecks",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Route 53 Resolver DNS Firewall",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-Route-53_Resolver-DNS-Firewall_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-Route-53_Resolver-DNS-Firewall_48.svg",
      "tokens": [
        "Res Amazon Route 53 Resolver DNS Firewall",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "Route",
        "53",
        "Resolver",
        "DNS",
        "Firewall",
        "48",
        "svg",
        "resamazonroute53resolverdnsfirewall",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Route 53 Resolver Query Logging",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-Route-53_Resolver-Query-Logging_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-Route-53_Resolver-Query-Logging_48.svg",
      "tokens": [
        "Res Amazon Route 53 Resolver Query Logging",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "Route",
        "53",
        "Resolver",
        "Query",
        "Logging",
        "48",
        "svg",
        "resamazonroute53resolverquerylogging",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Route 53 Resolver",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-Route-53_Resolver_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-Route-53_Resolver_48.svg",
      "tokens": [
        "Res Amazon Route 53 Resolver",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "Route",
        "53",
        "Resolver",
        "48",
        "svg",
        "resamazonroute53resolver",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Route 53 Route Table",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-Route-53_Route-Table_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-Route-53_Route-Table_48.svg",
      "tokens": [
        "Res Amazon Route 53 Route Table",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "Route",
        "53",
        "Table",
        "48",
        "svg",
        "resamazonroute53routetable",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Route 53 Routing Controls",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-Route-53_Routing-Controls_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-Route-53_Routing-Controls_48.svg",
      "tokens": [
        "Res Amazon Route 53 Routing Controls",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "Route",
        "53",
        "Routing",
        "Controls",
        "48",
        "svg",
        "resamazonroute53routingcontrols",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Sage Maker AI Canvas",
      "category": "Res Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Artificial-Intelligence/Res_Amazon-SageMaker-AI_Canvas_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Artificial-Intelligence/Res_Amazon-SageMaker-AI_Canvas_48.svg",
      "tokens": [
        "Res Amazon Sage Maker AI Canvas",
        "Res Artificial Intelligence",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Artificial",
        "Intelligence",
        "Amazon",
        "SageMaker",
        "AI",
        "Canvas",
        "48",
        "svg",
        "resamazonsagemakeraicanvas",
        "resartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Sage Maker AI Geospatial ML",
      "category": "Res Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Artificial-Intelligence/Res_Amazon-SageMaker-AI_Geospatial-ML_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Artificial-Intelligence/Res_Amazon-SageMaker-AI_Geospatial-ML_48.svg",
      "tokens": [
        "Res Amazon Sage Maker AI Geospatial ML",
        "Res Artificial Intelligence",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Artificial",
        "Intelligence",
        "Amazon",
        "SageMaker",
        "AI",
        "Geospatial",
        "ML",
        "48",
        "svg",
        "resamazonsagemakeraigeospatialml",
        "resartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Sage Maker AI Model",
      "category": "Res Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Artificial-Intelligence/Res_Amazon-SageMaker-AI_Model_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Artificial-Intelligence/Res_Amazon-SageMaker-AI_Model_48.svg",
      "tokens": [
        "Res Amazon Sage Maker AI Model",
        "Res Artificial Intelligence",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Artificial",
        "Intelligence",
        "Amazon",
        "SageMaker",
        "AI",
        "Model",
        "48",
        "svg",
        "resamazonsagemakeraimodel",
        "resartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Sage Maker AI Notebook",
      "category": "Res Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Artificial-Intelligence/Res_Amazon-SageMaker-AI_Notebook_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Artificial-Intelligence/Res_Amazon-SageMaker-AI_Notebook_48.svg",
      "tokens": [
        "Res Amazon Sage Maker AI Notebook",
        "Res Artificial Intelligence",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Artificial",
        "Intelligence",
        "Amazon",
        "SageMaker",
        "AI",
        "Notebook",
        "48",
        "svg",
        "resamazonsagemakerainotebook",
        "resartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Sage Maker AI Shadow Testing",
      "category": "Res Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Artificial-Intelligence/Res_Amazon-SageMaker-AI_Shadow-Testing_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Artificial-Intelligence/Res_Amazon-SageMaker-AI_Shadow-Testing_48.svg",
      "tokens": [
        "Res Amazon Sage Maker AI Shadow Testing",
        "Res Artificial Intelligence",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Artificial",
        "Intelligence",
        "Amazon",
        "SageMaker",
        "AI",
        "Shadow",
        "Testing",
        "48",
        "svg",
        "resamazonsagemakeraishadowtesting",
        "resartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Sage Maker AI Train",
      "category": "Res Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Artificial-Intelligence/Res_Amazon-SageMaker-AI_Train_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Artificial-Intelligence/Res_Amazon-SageMaker-AI_Train_48.svg",
      "tokens": [
        "Res Amazon Sage Maker AI Train",
        "Res Artificial Intelligence",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Artificial",
        "Intelligence",
        "Amazon",
        "SageMaker",
        "AI",
        "Train",
        "48",
        "svg",
        "resamazonsagemakeraitrain",
        "resartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Email Service Email",
      "category": "Res Business Applications",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Business-Applications/Res_Amazon-Simple-Email-Service_Email_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Business-Applications/Res_Amazon-Simple-Email-Service_Email_48.svg",
      "tokens": [
        "Res Amazon Simple Email Service Email",
        "Res Business Applications",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Business",
        "Applications",
        "Amazon",
        "Simple",
        "Email",
        "Service",
        "48",
        "svg",
        "resamazonsimpleemailserviceemail",
        "resbusinessapplications"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Notification Service Email Notification",
      "category": "Res Application Integration",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-Simple-Notification-Service_Email-Notification_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-Simple-Notification-Service_Email-Notification_48.svg",
      "tokens": [
        "Res Amazon Simple Notification Service Email Notification",
        "Res Application Integration",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Application",
        "Integration",
        "Amazon",
        "Simple",
        "Notification",
        "Service",
        "Email",
        "48",
        "svg",
        "resamazonsimplenotificationserviceemailnotification",
        "resapplicationintegration"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Notification Service HTTP Notification",
      "category": "Res Application Integration",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-Simple-Notification-Service_HTTP-Notification_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-Simple-Notification-Service_HTTP-Notification_48.svg",
      "tokens": [
        "Res Amazon Simple Notification Service HTTP Notification",
        "Res Application Integration",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Application",
        "Integration",
        "Amazon",
        "Simple",
        "Notification",
        "Service",
        "HTTP",
        "48",
        "svg",
        "resamazonsimplenotificationservicehttpnotification",
        "resapplicationintegration"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Notification Service Topic",
      "category": "Res Application Integration",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-Simple-Notification-Service_Topic_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-Simple-Notification-Service_Topic_48.svg",
      "tokens": [
        "Res Amazon Simple Notification Service Topic",
        "Res Application Integration",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Application",
        "Integration",
        "Amazon",
        "Simple",
        "Notification",
        "Service",
        "Topic",
        "48",
        "svg",
        "resamazonsimplenotificationservicetopic",
        "resapplicationintegration"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Queue Service Message",
      "category": "Res Application Integration",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-Simple-Queue-Service_Message_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-Simple-Queue-Service_Message_48.svg",
      "tokens": [
        "Res Amazon Simple Queue Service Message",
        "Res Application Integration",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Application",
        "Integration",
        "Amazon",
        "Simple",
        "Queue",
        "Service",
        "Message",
        "48",
        "svg",
        "resamazonsimplequeueservicemessage",
        "resapplicationintegration"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Queue Service Queue",
      "category": "Res Application Integration",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-Simple-Queue-Service_Queue_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Application-Integration/Res_Amazon-Simple-Queue-Service_Queue_48.svg",
      "tokens": [
        "Res Amazon Simple Queue Service Queue",
        "Res Application Integration",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Application",
        "Integration",
        "Amazon",
        "Simple",
        "Queue",
        "Service",
        "48",
        "svg",
        "resamazonsimplequeueservicequeue",
        "resapplicationintegration"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service Bucket With Objects",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_Bucket-With-Objects_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_Bucket-With-Objects_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service Bucket With Objects",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "Bucket",
        "With",
        "Objects",
        "48",
        "svg",
        "resamazonsimplestorageservicebucketwithobjects",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service Bucket",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_Bucket_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_Bucket_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service Bucket",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "Bucket",
        "48",
        "svg",
        "resamazonsimplestorageservicebucket",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service Directory Bucket",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_Directory-bucket_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_Directory-bucket_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service Directory Bucket",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "Directory",
        "bucket",
        "48",
        "svg",
        "resamazonsimplestorageservicedirectorybucket",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service General Access Points",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_General-Access-Points_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_General-Access-Points_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service General Access Points",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "General",
        "Access",
        "Points",
        "48",
        "svg",
        "resamazonsimplestorageservicegeneralaccesspoints",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service Glacier Archive",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service-Glacier_Archive_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service-Glacier_Archive_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service Glacier Archive",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "Glacier",
        "Archive",
        "48",
        "svg",
        "resamazonsimplestorageserviceglacierarchive",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service Glacier Vault",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service-Glacier_Vault_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service-Glacier_Vault_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service Glacier Vault",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "Glacier",
        "Vault",
        "48",
        "svg",
        "resamazonsimplestorageserviceglaciervault",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service Object",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_Object_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_Object_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service Object",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "Object",
        "48",
        "svg",
        "resamazonsimplestorageserviceobject",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service S3 Batch Operations",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Batch-Operations_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Batch-Operations_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service S3 Batch Operations",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "S3",
        "Batch",
        "Operations",
        "48",
        "svg",
        "resamazonsimplestorageservices3batchoperations",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service S3 Express One Zone",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Express-One-Zone_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Express-One-Zone_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service S3 Express One Zone",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "S3",
        "Express",
        "One",
        "Zone",
        "48",
        "svg",
        "resamazonsimplestorageservices3expressonezone",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service S3 Files",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Files_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Files_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service S3 Files",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "S3",
        "Files",
        "48",
        "svg",
        "resamazonsimplestorageservices3files",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service S3 Glacier Deep Archive",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Glacier-Deep-Archive_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Glacier-Deep-Archive_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service S3 Glacier Deep Archive",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "S3",
        "Glacier",
        "Deep",
        "Archive",
        "48",
        "svg",
        "resamazonsimplestorageservices3glacierdeeparchive",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service S3 Glacier Flexible Retrieval",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Glacier-Flexible-Retrieval_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Glacier-Flexible-Retrieval_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service S3 Glacier Flexible Retrieval",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "S3",
        "Glacier",
        "Flexible",
        "Retrieval",
        "48",
        "svg",
        "resamazonsimplestorageservices3glacierflexibleretrieval",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service S3 Glacier Instant Retrieval",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Glacier-Instant-Retrieval_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Glacier-Instant-Retrieval_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service S3 Glacier Instant Retrieval",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "S3",
        "Glacier",
        "Instant",
        "Retrieval",
        "48",
        "svg",
        "resamazonsimplestorageservices3glacierinstantretrieval",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service S3 Intelligent Tiering",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Intelligent-Tiering_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Intelligent-Tiering_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service S3 Intelligent Tiering",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "S3",
        "Intelligent",
        "Tiering",
        "48",
        "svg",
        "resamazonsimplestorageservices3intelligenttiering",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service S3 Multi Region Access Points",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Multi-Region-Access-Points_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Multi-Region-Access-Points_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service S3 Multi Region Access Points",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "S3",
        "Multi",
        "Region",
        "Access",
        "Points",
        "48",
        "svg",
        "resamazonsimplestorageservices3multiregionaccesspoints",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service S3 Object Lambda Access Points",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Object-Lambda-Access-Points_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Object-Lambda-Access-Points_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service S3 Object Lambda Access Points",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "S3",
        "Object",
        "Lambda",
        "Access",
        "Points",
        "48",
        "svg",
        "resamazonsimplestorageservices3objectlambdaaccesspoints",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service S3 Object Lambda",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Object-Lambda_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Object-Lambda_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service S3 Object Lambda",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "S3",
        "Object",
        "Lambda",
        "48",
        "svg",
        "resamazonsimplestorageservices3objectlambda",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service S3 Object Lock",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Object-Lock_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Object-Lock_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service S3 Object Lock",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "S3",
        "Object",
        "Lock",
        "48",
        "svg",
        "resamazonsimplestorageservices3objectlock",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service S3 On Outposts",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-On-Outposts_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-On-Outposts_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service S3 On Outposts",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "S3",
        "On",
        "Outposts",
        "48",
        "svg",
        "resamazonsimplestorageservices3onoutposts",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service S3 One Zone IA",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-One-Zone-IA_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-One-Zone-IA_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service S3 One Zone IA",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "S3",
        "One",
        "Zone",
        "IA",
        "48",
        "svg",
        "resamazonsimplestorageservices3onezoneia",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service S3 Replication Time Control",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Replication-Time-Control_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Replication-Time-Control_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service S3 Replication Time Control",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "S3",
        "Replication",
        "Time",
        "Control",
        "48",
        "svg",
        "resamazonsimplestorageservices3replicationtimecontrol",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service S3 Replication",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Replication_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Replication_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service S3 Replication",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "S3",
        "Replication",
        "48",
        "svg",
        "resamazonsimplestorageservices3replication",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service S3 Select",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Select_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Select_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service S3 Select",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "S3",
        "Select",
        "48",
        "svg",
        "resamazonsimplestorageservices3select",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service S3 Standard IA",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Standard-IA_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Standard-IA_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service S3 Standard IA",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "S3",
        "Standard",
        "IA",
        "48",
        "svg",
        "resamazonsimplestorageservices3standardia",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service S3 Standard",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Standard_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Standard_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service S3 Standard",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "S3",
        "Standard",
        "48",
        "svg",
        "resamazonsimplestorageservices3standard",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service S3 Storage Lens",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Storage-Lens_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Storage-Lens_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service S3 Storage Lens",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "S3",
        "Lens",
        "48",
        "svg",
        "resamazonsimplestorageservices3storagelens",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service S3 Tables",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Tables_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Tables_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service S3 Tables",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "S3",
        "Tables",
        "48",
        "svg",
        "resamazonsimplestorageservices3tables",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service S3 Vectors",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Vectors_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_S3-Vectors_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service S3 Vectors",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "S3",
        "Vectors",
        "48",
        "svg",
        "resamazonsimplestorageservices3vectors",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Simple Storage Service VPC Access Points",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_VPC-Access-Points_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_Amazon-Simple-Storage-Service_VPC-Access-Points_48.svg",
      "tokens": [
        "Res Amazon Simple Storage Service VPC Access Points",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "Amazon",
        "Simple",
        "Service",
        "VPC",
        "Access",
        "Points",
        "48",
        "svg",
        "resamazonsimplestorageservicevpcaccesspoints",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon Textract Analyze Lending",
      "category": "Res Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Artificial-Intelligence/Res_Amazon-Textract_Analyze-Lending_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Artificial-Intelligence/Res_Amazon-Textract_Analyze-Lending_48.svg",
      "tokens": [
        "Res Amazon Textract Analyze Lending",
        "Res Artificial Intelligence",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Artificial",
        "Intelligence",
        "Amazon",
        "Textract",
        "Analyze",
        "Lending",
        "48",
        "svg",
        "resamazontextractanalyzelending",
        "resartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon VPC Carrier Gateway",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Carrier-Gateway_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Carrier-Gateway_48.svg",
      "tokens": [
        "Res Amazon VPC Carrier Gateway",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "VPC",
        "Carrier",
        "Gateway",
        "48",
        "svg",
        "resamazonvpccarriergateway",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon VPC Customer Gateway",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Customer-Gateway_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Customer-Gateway_48.svg",
      "tokens": [
        "Res Amazon VPC Customer Gateway",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "VPC",
        "Customer",
        "Gateway",
        "48",
        "svg",
        "resamazonvpccustomergateway",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon VPC Elastic Network Adapter",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Elastic-Network-Adapter_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Elastic-Network-Adapter_48.svg",
      "tokens": [
        "Res Amazon VPC Elastic Network Adapter",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "VPC",
        "Elastic",
        "Network",
        "Adapter",
        "48",
        "svg",
        "resamazonvpcelasticnetworkadapter",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon VPC Elastic Network Interface",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Elastic-Network-Interface_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Elastic-Network-Interface_48.svg",
      "tokens": [
        "Res Amazon VPC Elastic Network Interface",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "VPC",
        "Elastic",
        "Network",
        "Interface",
        "48",
        "svg",
        "resamazonvpcelasticnetworkinterface",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon VPC Endpoints",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Endpoints_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Endpoints_48.svg",
      "tokens": [
        "Res Amazon VPC Endpoints",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "VPC",
        "Endpoints",
        "48",
        "svg",
        "resamazonvpcendpoints",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon VPC Flow Logs",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Flow-Logs_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Flow-Logs_48.svg",
      "tokens": [
        "Res Amazon VPC Flow Logs",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "VPC",
        "Flow",
        "Logs",
        "48",
        "svg",
        "resamazonvpcflowlogs",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon VPC Internet Gateway",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Internet-Gateway_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Internet-Gateway_48.svg",
      "tokens": [
        "Res Amazon VPC Internet Gateway",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "VPC",
        "Internet",
        "Gateway",
        "48",
        "svg",
        "resamazonvpcinternetgateway",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon VPC NAT Gateway",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_NAT-Gateway_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_NAT-Gateway_48.svg",
      "tokens": [
        "Res Amazon VPC NAT Gateway",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "VPC",
        "NAT",
        "Gateway",
        "48",
        "svg",
        "resamazonvpcnatgateway",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon VPC Network Access Analyzer",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Network-Access-Analyzer_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Network-Access-Analyzer_48.svg",
      "tokens": [
        "Res Amazon VPC Network Access Analyzer",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "VPC",
        "Network",
        "Access",
        "Analyzer",
        "48",
        "svg",
        "resamazonvpcnetworkaccessanalyzer",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon VPC Network Access Control List",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Network-Access-Control-List_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Network-Access-Control-List_48.svg",
      "tokens": [
        "Res Amazon VPC Network Access Control List",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "VPC",
        "Network",
        "Access",
        "Control",
        "List",
        "48",
        "svg",
        "resamazonvpcnetworkaccesscontrollist",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon VPC Peering Connection",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Peering-Connection_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Peering-Connection_48.svg",
      "tokens": [
        "Res Amazon VPC Peering Connection",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "VPC",
        "Peering",
        "Connection",
        "48",
        "svg",
        "resamazonvpcpeeringconnection",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon VPC Reachability Analyzer",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Reachability-Analyzer_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Reachability-Analyzer_48.svg",
      "tokens": [
        "Res Amazon VPC Reachability Analyzer",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "VPC",
        "Reachability",
        "Analyzer",
        "48",
        "svg",
        "resamazonvpcreachabilityanalyzer",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon VPC Router",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Router_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Router_48.svg",
      "tokens": [
        "Res Amazon VPC Router",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "VPC",
        "Router",
        "48",
        "svg",
        "resamazonvpcrouter",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon VPC Traffic Mirroring",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Traffic-Mirroring_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Traffic-Mirroring_48.svg",
      "tokens": [
        "Res Amazon VPC Traffic Mirroring",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "VPC",
        "Traffic",
        "Mirroring",
        "48",
        "svg",
        "resamazonvpctrafficmirroring",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon VPC Virtual Private Cloud VPC",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Virtual-private-cloud-VPC_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_Virtual-private-cloud-VPC_48.svg",
      "tokens": [
        "Res Amazon VPC Virtual Private Cloud VPC",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "VPC",
        "Virtual",
        "private",
        "cloud",
        "48",
        "svg",
        "resamazonvpcvirtualprivatecloudvpc",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon VPC VPN Connection",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_VPN-Connection_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_VPN-Connection_48.svg",
      "tokens": [
        "Res Amazon VPC VPN Connection",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "VPC",
        "VPN",
        "Connection",
        "48",
        "svg",
        "resamazonvpcvpnconnection",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Amazon VPC VPN Gateway",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_VPN-Gateway_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Amazon-VPC_VPN-Gateway_48.svg",
      "tokens": [
        "Res Amazon VPC VPN Gateway",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Amazon",
        "VPC",
        "VPN",
        "Gateway",
        "48",
        "svg",
        "resamazonvpcvpngateway",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Authenticated User 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Authenticated-User_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Authenticated-User_48_Dark.svg",
      "tokens": [
        "Res Authenticated User 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Authenticated",
        "User",
        "svg",
        "resauthenticateduser48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Authenticated User 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Authenticated-User_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Authenticated-User_48_Light.svg",
      "tokens": [
        "Res Authenticated User 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Authenticated",
        "User",
        "svg",
        "resauthenticateduser48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Amplify AWS Amplify Studio",
      "category": "Res Front End Web Mobile",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Front-End-Web-Mobile/Res_AWS-Amplify_AWS-Amplify-Studio_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Front-End-Web-Mobile/Res_AWS-Amplify_AWS-Amplify-Studio_48.svg",
      "tokens": [
        "Res AWS Amplify AWS Amplify Studio",
        "Res Front End Web Mobile",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Front",
        "End",
        "Web",
        "Mobile",
        "AWS",
        "Amplify",
        "Studio",
        "48",
        "svg",
        "resawsamplifyawsamplifystudio",
        "resfrontendwebmobile"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS App Mesh Mesh",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_AWS-App-Mesh_Mesh_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_AWS-App-Mesh_Mesh_48.svg",
      "tokens": [
        "Res AWS App Mesh Mesh",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "AWS",
        "App",
        "Mesh",
        "48",
        "svg",
        "resawsappmeshmesh",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS App Mesh Virtual Gateway",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_AWS-App-Mesh_Virtual-Gateway_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_AWS-App-Mesh_Virtual-Gateway_48.svg",
      "tokens": [
        "Res AWS App Mesh Virtual Gateway",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "AWS",
        "App",
        "Mesh",
        "Virtual",
        "Gateway",
        "48",
        "svg",
        "resawsappmeshvirtualgateway",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS App Mesh Virtual Node",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_AWS-App-Mesh_Virtual-Node_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_AWS-App-Mesh_Virtual-Node_48.svg",
      "tokens": [
        "Res AWS App Mesh Virtual Node",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "AWS",
        "App",
        "Mesh",
        "Virtual",
        "Node",
        "48",
        "svg",
        "resawsappmeshvirtualnode",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS App Mesh Virtual Router",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_AWS-App-Mesh_Virtual-Router_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_AWS-App-Mesh_Virtual-Router_48.svg",
      "tokens": [
        "Res AWS App Mesh Virtual Router",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "AWS",
        "App",
        "Mesh",
        "Virtual",
        "Router",
        "48",
        "svg",
        "resawsappmeshvirtualrouter",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS App Mesh Virtual Service",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_AWS-App-Mesh_Virtual-Service_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_AWS-App-Mesh_Virtual-Service_48.svg",
      "tokens": [
        "Res AWS App Mesh Virtual Service",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "AWS",
        "App",
        "Mesh",
        "Virtual",
        "Service",
        "48",
        "svg",
        "resawsappmeshvirtualservice",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Application Discovery Service AWS Agentless Collector",
      "category": "Res Migration Modernization",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Application-Discovery-Service_AWS-Agentless-Collector_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Application-Discovery-Service_AWS-Agentless-Collector_48.svg",
      "tokens": [
        "Res AWS Application Discovery Service AWS Agentless Collector",
        "Res Migration Modernization",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Migration",
        "Modernization",
        "AWS",
        "Application",
        "Discovery",
        "Service",
        "Agentless",
        "Collector",
        "48",
        "svg",
        "resawsapplicationdiscoveryserviceawsagentlesscollector",
        "resmigrationmodernization"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Application Discovery Service AWS Discovery Agent",
      "category": "Res Migration Modernization",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Application-Discovery-Service_AWS-Discovery-Agent_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Application-Discovery-Service_AWS-Discovery-Agent_48.svg",
      "tokens": [
        "Res AWS Application Discovery Service AWS Discovery Agent",
        "Res Migration Modernization",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Migration",
        "Modernization",
        "AWS",
        "Application",
        "Discovery",
        "Service",
        "Agent",
        "48",
        "svg",
        "resawsapplicationdiscoveryserviceawsdiscoveryagent",
        "resmigrationmodernization"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Application Discovery Service Migration Evaluator Collector",
      "category": "Res Migration Modernization",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Application-Discovery-Service_Migration-Evaluator-Collector_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Application-Discovery-Service_Migration-Evaluator-Collector_48.svg",
      "tokens": [
        "Res AWS Application Discovery Service Migration Evaluator Collector",
        "Res Migration Modernization",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Migration",
        "Modernization",
        "AWS",
        "Application",
        "Discovery",
        "Service",
        "Evaluator",
        "Collector",
        "48",
        "svg",
        "resawsapplicationdiscoveryservicemigrationevaluatorcollector",
        "resmigrationmodernization"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Backup Audit Manager",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Audit-Manager_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Audit-Manager_48.svg",
      "tokens": [
        "Res AWS Backup Audit Manager",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Backup",
        "Audit",
        "Manager",
        "48",
        "svg",
        "resawsbackupauditmanager",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Backup AWS Backup For AWS Cloud Formation",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_AWS-Backup-for-AWS-CloudFormation_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_AWS-Backup-for-AWS-CloudFormation_48.svg",
      "tokens": [
        "Res AWS Backup AWS Backup For AWS Cloud Formation",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Backup",
        "for",
        "CloudFormation",
        "48",
        "svg",
        "resawsbackupawsbackupforawscloudformation",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Backup AWS Backup Support For Amazon F Sx For Net App ONTAP",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_AWS-Backup-support-for-Amazon-FSx-for-NetApp-ONTAP_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_AWS-Backup-support-for-Amazon-FSx-for-NetApp-ONTAP_48.svg",
      "tokens": [
        "Res AWS Backup AWS Backup Support For Amazon F Sx For Net App ONTAP",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Backup",
        "support",
        "for",
        "Amazon",
        "FSx",
        "NetApp",
        "ONTAP",
        "48",
        "svg",
        "resawsbackupawsbackupsupportforamazonfsxfornetappontap",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Backup AWS Backup Support For Amazon S3",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_AWS-Backup-support-for-Amazon-S3_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_AWS-Backup-support-for-Amazon-S3_48.svg",
      "tokens": [
        "Res AWS Backup AWS Backup Support For Amazon S3",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Backup",
        "support",
        "for",
        "Amazon",
        "S3",
        "48",
        "svg",
        "resawsbackupawsbackupsupportforamazons3",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Backup AWS Backup Support For V Mware Workloads",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_AWS-Backup-Support-for-VMware-Workloads_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_AWS-Backup-Support-for-VMware-Workloads_48.svg",
      "tokens": [
        "Res AWS Backup AWS Backup Support For V Mware Workloads",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Backup",
        "Support",
        "for",
        "VMware",
        "Workloads",
        "48",
        "svg",
        "resawsbackupawsbackupsupportforvmwareworkloads",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Backup Backup Plan",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Backup-Plan_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Backup-Plan_48.svg",
      "tokens": [
        "Res AWS Backup Backup Plan",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Backup",
        "Plan",
        "48",
        "svg",
        "resawsbackupbackupplan",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Backup Backup Restore",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Backup-Restore_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Backup-Restore_48.svg",
      "tokens": [
        "Res AWS Backup Backup Restore",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Backup",
        "Restore",
        "48",
        "svg",
        "resawsbackupbackuprestore",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Backup Backup Vault",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Backup-Vault_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Backup-Vault_48.svg",
      "tokens": [
        "Res AWS Backup Backup Vault",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Backup",
        "Vault",
        "48",
        "svg",
        "resawsbackupbackupvault",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Backup Compliance Reporting",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Compliance-Reporting_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Compliance-Reporting_48.svg",
      "tokens": [
        "Res AWS Backup Compliance Reporting",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Backup",
        "Compliance",
        "Reporting",
        "48",
        "svg",
        "resawsbackupcompliancereporting",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Backup Compute",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Compute_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Compute_48.svg",
      "tokens": [
        "Res AWS Backup Compute",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Backup",
        "Compute",
        "48",
        "svg",
        "resawsbackupcompute",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Backup Database",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Database_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Database_48.svg",
      "tokens": [
        "Res AWS Backup Database",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Backup",
        "Database",
        "48",
        "svg",
        "resawsbackupdatabase",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Backup Gateway",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Gateway_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Gateway_48.svg",
      "tokens": [
        "Res AWS Backup Gateway",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Backup",
        "Gateway",
        "48",
        "svg",
        "resawsbackupgateway",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Backup Legal Hold",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Legal-Hold_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Legal-Hold_48.svg",
      "tokens": [
        "Res AWS Backup Legal Hold",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Backup",
        "Legal",
        "Hold",
        "48",
        "svg",
        "resawsbackuplegalhold",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Backup Recovery Point Objective",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Recovery-Point-Objective_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Recovery-Point-Objective_48.svg",
      "tokens": [
        "Res AWS Backup Recovery Point Objective",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Backup",
        "Recovery",
        "Point",
        "Objective",
        "48",
        "svg",
        "resawsbackuprecoverypointobjective",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Backup Recovery Time Objective",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Recovery-Time-Objective_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Recovery-Time-Objective_48.svg",
      "tokens": [
        "Res AWS Backup Recovery Time Objective",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Backup",
        "Recovery",
        "Time",
        "Objective",
        "48",
        "svg",
        "resawsbackuprecoverytimeobjective",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Backup Storage",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Storage_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Storage_48.svg",
      "tokens": [
        "Res AWS Backup Storage",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Backup",
        "48",
        "svg",
        "resawsbackupstorage",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Backup Vault Lock",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Vault-Lock_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Vault-Lock_48.svg",
      "tokens": [
        "Res AWS Backup Vault Lock",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Backup",
        "Vault",
        "Lock",
        "48",
        "svg",
        "resawsbackupvaultlock",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Backup Virtual Machine Monitor",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Virtual-Machine-Monitor_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Virtual-Machine-Monitor_48.svg",
      "tokens": [
        "Res AWS Backup Virtual Machine Monitor",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Backup",
        "Virtual",
        "Machine",
        "Monitor",
        "48",
        "svg",
        "resawsbackupvirtualmachinemonitor",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Backup Virtual Machine",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Virtual-Machine_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Backup_Virtual-Machine_48.svg",
      "tokens": [
        "Res AWS Backup Virtual Machine",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Backup",
        "Virtual",
        "Machine",
        "48",
        "svg",
        "resawsbackupvirtualmachine",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Certificate Manager Certificate Authority",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Certificate-Manager_Certificate-Authority_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Certificate-Manager_Certificate-Authority_48.svg",
      "tokens": [
        "Res AWS Certificate Manager Certificate Authority",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "Certificate",
        "Manager",
        "Authority",
        "48",
        "svg",
        "resawscertificatemanagercertificateauthority",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Cloud Digital Interface",
      "category": "Res Media Services",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Media-Services/Res_AWS-Cloud-Digital-Interface_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Media-Services/Res_AWS-Cloud-Digital-Interface_48.svg",
      "tokens": [
        "Res AWS Cloud Digital Interface",
        "Res Media Services",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Media",
        "Services",
        "AWS",
        "Cloud",
        "Digital",
        "Interface",
        "48",
        "svg",
        "resawsclouddigitalinterface",
        "resmediaservices"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Cloud Formation Change Set",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-CloudFormation_Change-Set_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-CloudFormation_Change-Set_48.svg",
      "tokens": [
        "Res AWS Cloud Formation Change Set",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "CloudFormation",
        "Change",
        "Set",
        "48",
        "svg",
        "resawscloudformationchangeset",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Cloud Formation Stack",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-CloudFormation_Stack_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-CloudFormation_Stack_48.svg",
      "tokens": [
        "Res AWS Cloud Formation Stack",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "CloudFormation",
        "Stack",
        "48",
        "svg",
        "resawscloudformationstack",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Cloud Formation Template",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-CloudFormation_Template_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-CloudFormation_Template_48.svg",
      "tokens": [
        "Res AWS Cloud Formation Template",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "CloudFormation",
        "Template",
        "48",
        "svg",
        "resawscloudformationtemplate",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Cloud Map Namespace",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_AWS-Cloud-Map_Namespace_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_AWS-Cloud-Map_Namespace_48.svg",
      "tokens": [
        "Res AWS Cloud Map Namespace",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "AWS",
        "Cloud",
        "Map",
        "Namespace",
        "48",
        "svg",
        "resawscloudmapnamespace",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Cloud Map Resource",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_AWS-Cloud-Map_Resource_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_AWS-Cloud-Map_Resource_48.svg",
      "tokens": [
        "Res AWS Cloud Map Resource",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "AWS",
        "Cloud",
        "Map",
        "48",
        "svg",
        "resawscloudmapresource",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Cloud Map Service",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_AWS-Cloud-Map_Service_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_AWS-Cloud-Map_Service_48.svg",
      "tokens": [
        "Res AWS Cloud Map Service",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "AWS",
        "Cloud",
        "Map",
        "Service",
        "48",
        "svg",
        "resawscloudmapservice",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Cloud Trail Cloud Trail Lake",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-CloudTrail_CloudTrail-Lake_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-CloudTrail_CloudTrail-Lake_48.svg",
      "tokens": [
        "Res AWS Cloud Trail Cloud Trail Lake",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "CloudTrail",
        "Lake",
        "48",
        "svg",
        "resawscloudtrailcloudtraillake",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Cloud WAN Core Network Edge",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_AWS-Cloud-WAN_Core-Network-Edge_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_AWS-Cloud-WAN_Core-Network-Edge_48.svg",
      "tokens": [
        "Res AWS Cloud WAN Core Network Edge",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "AWS",
        "Cloud",
        "WAN",
        "Core",
        "Network",
        "Edge",
        "48",
        "svg",
        "resawscloudwancorenetworkedge",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Cloud WAN Segment Network",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_AWS-Cloud-WAN_Segment-Network_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_AWS-Cloud-WAN_Segment-Network_48.svg",
      "tokens": [
        "Res AWS Cloud WAN Segment Network",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "AWS",
        "Cloud",
        "WAN",
        "Segment",
        "Network",
        "48",
        "svg",
        "resawscloudwansegmentnetwork",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Cloud WAN Transit Gateway Route Table Attachment",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_AWS-Cloud-WAN_Transit-Gateway-Route-Table-Attachment_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_AWS-Cloud-WAN_Transit-Gateway-Route-Table-Attachment_48.svg",
      "tokens": [
        "Res AWS Cloud WAN Transit Gateway Route Table Attachment",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "AWS",
        "Cloud",
        "WAN",
        "Transit",
        "Gateway",
        "Route",
        "Table",
        "Attachment",
        "48",
        "svg",
        "resawscloudwantransitgatewayroutetableattachment",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Cloud9 Cloud9",
      "category": "Res Developer Tools",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Developer-Tools/Res_AWS-Cloud9_Cloud9_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Developer-Tools/Res_AWS-Cloud9_Cloud9_48.svg",
      "tokens": [
        "Res AWS Cloud9 Cloud9",
        "Res Developer Tools",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Developer",
        "Tools",
        "AWS",
        "Cloud9",
        "48",
        "svg",
        "resawscloud9cloud9",
        "resdevelopertools"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Data Exchange For AP Is",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_AWS-Data-Exchange-for-APIs_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_AWS-Data-Exchange-for-APIs_48.svg",
      "tokens": [
        "Res AWS Data Exchange For AP Is",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "AWS",
        "Data",
        "Exchange",
        "for",
        "APIs",
        "48",
        "svg",
        "resawsdataexchangeforapis",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Data Sync Discovery",
      "category": "Res Migration Modernization",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-DataSync_Discovery_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-DataSync_Discovery_48.svg",
      "tokens": [
        "Res AWS Data Sync Discovery",
        "Res Migration Modernization",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Migration",
        "Modernization",
        "AWS",
        "DataSync",
        "Discovery",
        "48",
        "svg",
        "resawsdatasyncdiscovery",
        "resmigrationmodernization"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Database Migration Service Database Migration Workflow Or Job",
      "category": "Res Databases",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Databases/Res_AWS-Database-Migration-Service_Database-migration-workflow-or-job_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Databases/Res_AWS-Database-Migration-Service_Database-migration-workflow-or-job_48.svg",
      "tokens": [
        "Res AWS Database Migration Service Database Migration Workflow Or Job",
        "Res Databases",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Databases",
        "AWS",
        "Database",
        "Migration",
        "Service",
        "migration",
        "workflow",
        "or",
        "job",
        "48",
        "svg",
        "resawsdatabasemigrationservicedatabasemigrationworkfloworjob",
        "resdatabases"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Datasync Agent",
      "category": "Res Migration Modernization",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Datasync_Agent_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Datasync_Agent_48.svg",
      "tokens": [
        "Res AWS Datasync Agent",
        "Res Migration Modernization",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Migration",
        "Modernization",
        "AWS",
        "Datasync",
        "Agent",
        "48",
        "svg",
        "resawsdatasyncagent",
        "resmigrationmodernization"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Direct Connect Gateway",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_AWS-Direct-Connect_Gateway_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_AWS-Direct-Connect_Gateway_48.svg",
      "tokens": [
        "Res AWS Direct Connect Gateway",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "AWS",
        "Direct",
        "Connect",
        "Gateway",
        "48",
        "svg",
        "resawsdirectconnectgateway",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Directory Service AD Connector",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Directory-Service_AD-Connector_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Directory-Service_AD-Connector_48.svg",
      "tokens": [
        "Res AWS Directory Service AD Connector",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "Directory",
        "Service",
        "AD",
        "Connector",
        "48",
        "svg",
        "resawsdirectoryserviceadconnector",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Directory Service AWS Managed Microsoft AD",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Directory-Service_AWS-Managed-Microsoft-AD_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Directory-Service_AWS-Managed-Microsoft-AD_48.svg",
      "tokens": [
        "Res AWS Directory Service AWS Managed Microsoft AD",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "Directory",
        "Service",
        "Managed",
        "Microsoft",
        "AD",
        "48",
        "svg",
        "resawsdirectoryserviceawsmanagedmicrosoftad",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Directory Service Simple AD",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Directory-Service_Simple-AD_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Directory-Service_Simple-AD_48.svg",
      "tokens": [
        "Res AWS Directory Service Simple AD",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "Directory",
        "Service",
        "Simple",
        "AD",
        "48",
        "svg",
        "resawsdirectoryservicesimplead",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Elastic Beanstalk Application",
      "category": "Res Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Compute/Res_AWS-Elastic-Beanstalk_Application_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Compute/Res_AWS-Elastic-Beanstalk_Application_48.svg",
      "tokens": [
        "Res AWS Elastic Beanstalk Application",
        "Res Compute",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Compute",
        "AWS",
        "Elastic",
        "Beanstalk",
        "Application",
        "48",
        "svg",
        "resawselasticbeanstalkapplication",
        "rescompute"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Elastic Beanstalk Deployment",
      "category": "Res Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Compute/Res_AWS-Elastic-Beanstalk_Deployment_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Compute/Res_AWS-Elastic-Beanstalk_Deployment_48.svg",
      "tokens": [
        "Res AWS Elastic Beanstalk Deployment",
        "Res Compute",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Compute",
        "AWS",
        "Elastic",
        "Beanstalk",
        "Deployment",
        "48",
        "svg",
        "resawselasticbeanstalkdeployment",
        "rescompute"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Elemental Media Connect Media Connect Gateway",
      "category": "Res Media Services",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Media-Services/Res_AWS-Elemental-MediaConnect_MediaConnect-Gateway_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Media-Services/Res_AWS-Elemental-MediaConnect_MediaConnect-Gateway_48.svg",
      "tokens": [
        "Res AWS Elemental Media Connect Media Connect Gateway",
        "Res Media Services",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Media",
        "Services",
        "AWS",
        "Elemental",
        "MediaConnect",
        "Gateway",
        "48",
        "svg",
        "resawselementalmediaconnectmediaconnectgateway",
        "resmediaservices"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Glue AWS Glue For Ray",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_AWS-Glue_AWS-Glue-for-Ray_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_AWS-Glue_AWS-Glue-for-Ray_48.svg",
      "tokens": [
        "Res AWS Glue AWS Glue For Ray",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "AWS",
        "Glue",
        "for",
        "Ray",
        "48",
        "svg",
        "resawsglueawsglueforray",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Glue Crawler",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_AWS-Glue_Crawler_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_AWS-Glue_Crawler_48.svg",
      "tokens": [
        "Res AWS Glue Crawler",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "AWS",
        "Glue",
        "Crawler",
        "48",
        "svg",
        "resawsgluecrawler",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Glue Data Catalog",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_AWS-Glue_Data-Catalog_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_AWS-Glue_Data-Catalog_48.svg",
      "tokens": [
        "Res AWS Glue Data Catalog",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "AWS",
        "Glue",
        "Data",
        "Catalog",
        "48",
        "svg",
        "resawsgluedatacatalog",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Glue Data Quality",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_AWS-Glue_Data-Quality_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_AWS-Glue_Data-Quality_48.svg",
      "tokens": [
        "Res AWS Glue Data Quality",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "AWS",
        "Glue",
        "Data",
        "Quality",
        "48",
        "svg",
        "resawsgluedataquality",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Identity Access Management Add On",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Identity-Access-Management_Add-on_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Identity-Access-Management_Add-on_48.svg",
      "tokens": [
        "Res AWS Identity Access Management Add On",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "Access",
        "Management",
        "Add",
        "on",
        "48",
        "svg",
        "resawsidentityaccessmanagementaddon",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Identity Access Management AWS STS Alternate",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Identity-Access-Management_AWS-STS-Alternate_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Identity-Access-Management_AWS-STS-Alternate_48.svg",
      "tokens": [
        "Res AWS Identity Access Management AWS STS Alternate",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "Access",
        "Management",
        "STS",
        "Alternate",
        "48",
        "svg",
        "resawsidentityaccessmanagementawsstsalternate",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Identity Access Management AWS STS",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Identity-Access-Management_AWS-STS_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Identity-Access-Management_AWS-STS_48.svg",
      "tokens": [
        "Res AWS Identity Access Management AWS STS",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "Access",
        "Management",
        "STS",
        "48",
        "svg",
        "resawsidentityaccessmanagementawssts",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Identity Access Management Data Encryption Key",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Identity-Access-Management_Data-Encryption-Key_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Identity-Access-Management_Data-Encryption-Key_48.svg",
      "tokens": [
        "Res AWS Identity Access Management Data Encryption Key",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "Access",
        "Management",
        "Data",
        "Encryption",
        "Key",
        "48",
        "svg",
        "resawsidentityaccessmanagementdataencryptionkey",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Identity Access Management Encrypted Data",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Identity-Access-Management_Encrypted-Data_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Identity-Access-Management_Encrypted-Data_48.svg",
      "tokens": [
        "Res AWS Identity Access Management Encrypted Data",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "Access",
        "Management",
        "Encrypted",
        "Data",
        "48",
        "svg",
        "resawsidentityaccessmanagementencrypteddata",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Identity Access Management IAM Access Analyzer",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Identity-Access-Management_IAM-Access-Analyzer_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Identity-Access-Management_IAM-Access-Analyzer_48.svg",
      "tokens": [
        "Res AWS Identity Access Management IAM Access Analyzer",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "Access",
        "Management",
        "IAM",
        "Analyzer",
        "48",
        "svg",
        "resawsidentityaccessmanagementiamaccessanalyzer",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Identity Access Management IAM Roles Anywhere",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Identity-Access-Management_IAM-Roles-Anywhere_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Identity-Access-Management_IAM-Roles-Anywhere_48.svg",
      "tokens": [
        "Res AWS Identity Access Management IAM Roles Anywhere",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "Access",
        "Management",
        "IAM",
        "Roles",
        "Anywhere",
        "48",
        "svg",
        "resawsidentityaccessmanagementiamrolesanywhere",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Identity Access Management Long Term Security Credential",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Identity-Access-Management_Long-Term-Security-Credential_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Identity-Access-Management_Long-Term-Security-Credential_48.svg",
      "tokens": [
        "Res AWS Identity Access Management Long Term Security Credential",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "Access",
        "Management",
        "Long",
        "Term",
        "Credential",
        "48",
        "svg",
        "resawsidentityaccessmanagementlongtermsecuritycredential",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Identity Access Management MFA Token",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Identity-Access-Management_MFA-Token_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Identity-Access-Management_MFA-Token_48.svg",
      "tokens": [
        "Res AWS Identity Access Management MFA Token",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "Access",
        "Management",
        "MFA",
        "Token",
        "48",
        "svg",
        "resawsidentityaccessmanagementmfatoken",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Identity Access Management Permissions",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Identity-Access-Management_Permissions_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Identity-Access-Management_Permissions_48.svg",
      "tokens": [
        "Res AWS Identity Access Management Permissions",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "Access",
        "Management",
        "Permissions",
        "48",
        "svg",
        "resawsidentityaccessmanagementpermissions",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Identity Access Management Role",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Identity-Access-Management_Role_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Identity-Access-Management_Role_48.svg",
      "tokens": [
        "Res AWS Identity Access Management Role",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "Access",
        "Management",
        "Role",
        "48",
        "svg",
        "resawsidentityaccessmanagementrole",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Identity Access Management Temporary Security Credential",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Identity-Access-Management_Temporary-Security-Credential_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Identity-Access-Management_Temporary-Security-Credential_48.svg",
      "tokens": [
        "Res AWS Identity Access Management Temporary Security Credential",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "Access",
        "Management",
        "Temporary",
        "Credential",
        "48",
        "svg",
        "resawsidentityaccessmanagementtemporarysecuritycredential",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Action",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Action_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Action_48.svg",
      "tokens": [
        "Res AWS Io T Action",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Action",
        "48",
        "svg",
        "resawsiotaction",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Actuator",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Actuator_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Actuator_48.svg",
      "tokens": [
        "Res AWS Io T Actuator",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Actuator",
        "48",
        "svg",
        "resawsiotactuator",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Alexa Enabled Device",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Alexa_Enabled-Device_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Alexa_Enabled-Device_48.svg",
      "tokens": [
        "Res AWS Io T Alexa Enabled Device",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Alexa",
        "Enabled",
        "Device",
        "48",
        "svg",
        "resawsiotalexaenableddevice",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Alexa Skill",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Alexa_Skill_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Alexa_Skill_48.svg",
      "tokens": [
        "Res AWS Io T Alexa Skill",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Alexa",
        "Skill",
        "48",
        "svg",
        "resawsiotalexaskill",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Alexa Voice Service",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Alexa_Voice-Service_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Alexa_Voice-Service_48.svg",
      "tokens": [
        "Res AWS Io T Alexa Voice Service",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Alexa",
        "Voice",
        "Service",
        "48",
        "svg",
        "resawsiotalexavoiceservice",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Certificate",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Certificate_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Certificate_48.svg",
      "tokens": [
        "Res AWS Io T Certificate",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Certificate",
        "48",
        "svg",
        "resawsiotcertificate",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Core Device Advisor",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Core_Device-Advisor_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Core_Device-Advisor_48.svg",
      "tokens": [
        "Res AWS Io T Core Device Advisor",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Core",
        "Device",
        "Advisor",
        "48",
        "svg",
        "resawsiotcoredeviceadvisor",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Core Device Location",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Core_Device-Location_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Core_Device-Location_48.svg",
      "tokens": [
        "Res AWS Io T Core Device Location",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Core",
        "Device",
        "Location",
        "48",
        "svg",
        "resawsiotcoredevicelocation",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Desired State",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Desired-State_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Desired-State_48.svg",
      "tokens": [
        "Res AWS Io T Desired State",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Desired",
        "State",
        "48",
        "svg",
        "resawsiotdesiredstate",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Device Defender Io T Device Jobs",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Device-Defender_IoT-Device-Jobs_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Device-Defender_IoT-Device-Jobs_48.svg",
      "tokens": [
        "Res AWS Io T Device Defender Io T Device Jobs",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Device",
        "Defender",
        "Jobs",
        "48",
        "svg",
        "resawsiotdevicedefenderiotdevicejobs",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Device Gateway",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Device-Gateway_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Device-Gateway_48.svg",
      "tokens": [
        "Res AWS Io T Device Gateway",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Device",
        "Gateway",
        "48",
        "svg",
        "resawsiotdevicegateway",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Device Management Fleet Hub",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Device-Management_Fleet-Hub_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Device-Management_Fleet-Hub_48.svg",
      "tokens": [
        "Res AWS Io T Device Management Fleet Hub",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Device",
        "Management",
        "Fleet",
        "Hub",
        "48",
        "svg",
        "resawsiotdevicemanagementfleethub",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Device Tester",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Device-Tester_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Device-Tester_48.svg",
      "tokens": [
        "Res AWS Io T Device Tester",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Device",
        "Tester",
        "48",
        "svg",
        "resawsiotdevicetester",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Echo",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Echo_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Echo_48.svg",
      "tokens": [
        "Res AWS Io T Echo",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Echo",
        "48",
        "svg",
        "resawsiotecho",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Fire TV Stick",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Fire-TV_Stick_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Fire-TV_Stick_48.svg",
      "tokens": [
        "Res AWS Io T Fire TV Stick",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Fire",
        "TV",
        "Stick",
        "48",
        "svg",
        "resawsiotfiretvstick",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Fire TV",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Fire_TV_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Fire_TV_48.svg",
      "tokens": [
        "Res AWS Io T Fire TV",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Fire",
        "TV",
        "48",
        "svg",
        "resawsiotfiretv",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Greengrass Artifact",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Greengrass_Artifact_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Greengrass_Artifact_48.svg",
      "tokens": [
        "Res AWS Io T Greengrass Artifact",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Greengrass",
        "Artifact",
        "48",
        "svg",
        "resawsiotgreengrassartifact",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Greengrass Component Machine Learning",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Greengrass_Component-Machine-Learning_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Greengrass_Component-Machine-Learning_48.svg",
      "tokens": [
        "Res AWS Io T Greengrass Component Machine Learning",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Greengrass",
        "Component",
        "Machine",
        "Learning",
        "48",
        "svg",
        "resawsiotgreengrasscomponentmachinelearning",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Greengrass Component Nucleus",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Greengrass_Component-Nucleus_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Greengrass_Component-Nucleus_48.svg",
      "tokens": [
        "Res AWS Io T Greengrass Component Nucleus",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Greengrass",
        "Component",
        "Nucleus",
        "48",
        "svg",
        "resawsiotgreengrasscomponentnucleus",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Greengrass Component Private",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Greengrass_Component-Private_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Greengrass_Component-Private_48.svg",
      "tokens": [
        "Res AWS Io T Greengrass Component Private",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Greengrass",
        "Component",
        "Private",
        "48",
        "svg",
        "resawsiotgreengrasscomponentprivate",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Greengrass Component Public",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Greengrass_Component-Public_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Greengrass_Component-Public_48.svg",
      "tokens": [
        "Res AWS Io T Greengrass Component Public",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Greengrass",
        "Component",
        "Public",
        "48",
        "svg",
        "resawsiotgreengrasscomponentpublic",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Greengrass Component",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Greengrass_Component_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Greengrass_Component_48.svg",
      "tokens": [
        "Res AWS Io T Greengrass Component",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Greengrass",
        "Component",
        "48",
        "svg",
        "resawsiotgreengrasscomponent",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Greengrass Connector",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Greengrass_Connector_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Greengrass_Connector_48.svg",
      "tokens": [
        "Res AWS Io T Greengrass Connector",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Greengrass",
        "Connector",
        "48",
        "svg",
        "resawsiotgreengrassconnector",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Greengrass Interprocess Communication",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Greengrass_Interprocess-Communication_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Greengrass_Interprocess-Communication_48.svg",
      "tokens": [
        "Res AWS Io T Greengrass Interprocess Communication",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Greengrass",
        "Interprocess",
        "Communication",
        "48",
        "svg",
        "resawsiotgreengrassinterprocesscommunication",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Greengrass Protocol",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Greengrass_Protocol_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Greengrass_Protocol_48.svg",
      "tokens": [
        "Res AWS Io T Greengrass Protocol",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Greengrass",
        "Protocol",
        "48",
        "svg",
        "resawsiotgreengrassprotocol",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Greengrass Recipe",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Greengrass_Recipe_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Greengrass_Recipe_48.svg",
      "tokens": [
        "Res AWS Io T Greengrass Recipe",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Greengrass",
        "Recipe",
        "48",
        "svg",
        "resawsiotgreengrassrecipe",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Greengrass Stream Manager",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Greengrass_Stream-Manager_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Greengrass_Stream-Manager_48.svg",
      "tokens": [
        "Res AWS Io T Greengrass Stream Manager",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Greengrass",
        "Stream",
        "Manager",
        "48",
        "svg",
        "resawsiotgreengrassstreammanager",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Hardware Board",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Hardware-Board_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Hardware-Board_48.svg",
      "tokens": [
        "Res AWS Io T Hardware Board",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Hardware",
        "Board",
        "48",
        "svg",
        "resawsiothardwareboard",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T HTTP Protocol",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_HTTP_Protocol_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_HTTP_Protocol_48.svg",
      "tokens": [
        "Res AWS Io T HTTP Protocol",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "HTTP",
        "Protocol",
        "48",
        "svg",
        "resawsiothttpprotocol",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T HTTP2 Protocol",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_HTTP2-Protocol_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_HTTP2-Protocol_48.svg",
      "tokens": [
        "Res AWS Io T HTTP2 Protocol",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "HTTP2",
        "Protocol",
        "48",
        "svg",
        "resawsiothttp2protocol",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Lambda Function",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Lambda_Function_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Lambda_Function_48.svg",
      "tokens": [
        "Res AWS Io T Lambda Function",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Lambda",
        "Function",
        "48",
        "svg",
        "resawsiotlambdafunction",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Lo Ra WAN Protocol",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_LoRaWAN-Protocol_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_LoRaWAN-Protocol_48.svg",
      "tokens": [
        "Res AWS Io T Lo Ra WAN Protocol",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "LoRaWAN",
        "Protocol",
        "48",
        "svg",
        "resawsiotlorawanprotocol",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T MQTT Protocol",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_MQTT_Protocol_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_MQTT_Protocol_48.svg",
      "tokens": [
        "Res AWS Io T MQTT Protocol",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "MQTT",
        "Protocol",
        "48",
        "svg",
        "resawsiotmqttprotocol",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Over Air Update",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Over-Air-Update_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Over-Air-Update_48.svg",
      "tokens": [
        "Res AWS Io T Over Air Update",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Over",
        "Air",
        "Update",
        "48",
        "svg",
        "resawsiotoverairupdate",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Policy",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Policy_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Policy_48.svg",
      "tokens": [
        "Res AWS Io T Policy",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Policy",
        "48",
        "svg",
        "resawsiotpolicy",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Reported State",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Reported-State_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Reported-State_48.svg",
      "tokens": [
        "Res AWS Io T Reported State",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Reported",
        "State",
        "48",
        "svg",
        "resawsiotreportedstate",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Rule",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Rule_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-Rule_48.svg",
      "tokens": [
        "Res AWS Io T Rule",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Rule",
        "48",
        "svg",
        "resawsiotrule",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Sailboat",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Sailboat_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Sailboat_48.svg",
      "tokens": [
        "Res AWS Io T Sailboat",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Sailboat",
        "48",
        "svg",
        "resawsiotsailboat",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Sensor",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Sensor_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Sensor_48.svg",
      "tokens": [
        "Res AWS Io T Sensor",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Sensor",
        "48",
        "svg",
        "resawsiotsensor",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Servo",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Servo_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Servo_48.svg",
      "tokens": [
        "Res AWS Io T Servo",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Servo",
        "48",
        "svg",
        "resawsiotservo",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Shadow",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Shadow_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Shadow_48.svg",
      "tokens": [
        "Res AWS Io T Shadow",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Shadow",
        "48",
        "svg",
        "resawsiotshadow",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Simulator",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Simulator_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Simulator_48.svg",
      "tokens": [
        "Res AWS Io T Simulator",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Simulator",
        "48",
        "svg",
        "resawsiotsimulator",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Site Wise Asset Hierarchy",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-SiteWise_Asset-Hierarchy_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-SiteWise_Asset-Hierarchy_48.svg",
      "tokens": [
        "Res AWS Io T Site Wise Asset Hierarchy",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "SiteWise",
        "Asset",
        "Hierarchy",
        "48",
        "svg",
        "resawsiotsitewiseassethierarchy",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Site Wise Asset Model",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-SiteWise_Asset-Model_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-SiteWise_Asset-Model_48.svg",
      "tokens": [
        "Res AWS Io T Site Wise Asset Model",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "SiteWise",
        "Asset",
        "Model",
        "48",
        "svg",
        "resawsiotsitewiseassetmodel",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Site Wise Asset Properties",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-SiteWise_Asset-Properties_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-SiteWise_Asset-Properties_48.svg",
      "tokens": [
        "Res AWS Io T Site Wise Asset Properties",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "SiteWise",
        "Asset",
        "Properties",
        "48",
        "svg",
        "resawsiotsitewiseassetproperties",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Site Wise Asset",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-SiteWise_Asset_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-SiteWise_Asset_48.svg",
      "tokens": [
        "Res AWS Io T Site Wise Asset",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "SiteWise",
        "Asset",
        "48",
        "svg",
        "resawsiotsitewiseasset",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Site Wise Data Streams",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-SiteWise_Data-Streams_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT-SiteWise_Data-Streams_48.svg",
      "tokens": [
        "Res AWS Io T Site Wise Data Streams",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "SiteWise",
        "Data",
        "Streams",
        "48",
        "svg",
        "resawsiotsitewisedatastreams",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing Bank",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Bank_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Bank_48.svg",
      "tokens": [
        "Res AWS Io T Thing Bank",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "Bank",
        "48",
        "svg",
        "resawsiotthingbank",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing Bicycle",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Bicycle_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Bicycle_48.svg",
      "tokens": [
        "Res AWS Io T Thing Bicycle",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "Bicycle",
        "48",
        "svg",
        "resawsiotthingbicycle",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing Camera",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Camera_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Camera_48.svg",
      "tokens": [
        "Res AWS Io T Thing Camera",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "Camera",
        "48",
        "svg",
        "resawsiotthingcamera",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing Car",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Car_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Car_48.svg",
      "tokens": [
        "Res AWS Io T Thing Car",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "Car",
        "48",
        "svg",
        "resawsiotthingcar",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing Cart",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Cart_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Cart_48.svg",
      "tokens": [
        "Res AWS Io T Thing Cart",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "Cart",
        "48",
        "svg",
        "resawsiotthingcart",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing Coffee Pot",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Coffee-Pot_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Coffee-Pot_48.svg",
      "tokens": [
        "Res AWS Io T Thing Coffee Pot",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "Coffee",
        "Pot",
        "48",
        "svg",
        "resawsiotthingcoffeepot",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing Door Lock",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Door-Lock_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Door-Lock_48.svg",
      "tokens": [
        "Res AWS Io T Thing Door Lock",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "Door",
        "Lock",
        "48",
        "svg",
        "resawsiotthingdoorlock",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing Factory",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Factory_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Factory_48.svg",
      "tokens": [
        "Res AWS Io T Thing Factory",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "Factory",
        "48",
        "svg",
        "resawsiotthingfactory",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing Free RTOS Device",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_FreeRTOS-Device_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_FreeRTOS-Device_48.svg",
      "tokens": [
        "Res AWS Io T Thing Free RTOS Device",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "FreeRTOS",
        "Device",
        "48",
        "svg",
        "resawsiotthingfreertosdevice",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing Generic",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Generic_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Generic_48.svg",
      "tokens": [
        "Res AWS Io T Thing Generic",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "Generic",
        "48",
        "svg",
        "resawsiotthinggeneric",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing House",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_House_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_House_48.svg",
      "tokens": [
        "Res AWS Io T Thing House",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "House",
        "48",
        "svg",
        "resawsiotthinghouse",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing Humidity Sensor",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Humidity-Sensor_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Humidity-Sensor_48.svg",
      "tokens": [
        "Res AWS Io T Thing Humidity Sensor",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "Humidity",
        "Sensor",
        "48",
        "svg",
        "resawsiotthinghumiditysensor",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing Industrial PC",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Industrial-PC_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Industrial-PC_48.svg",
      "tokens": [
        "Res AWS Io T Thing Industrial PC",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "Industrial",
        "PC",
        "48",
        "svg",
        "resawsiotthingindustrialpc",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing Lightbulb",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Lightbulb_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Lightbulb_48.svg",
      "tokens": [
        "Res AWS Io T Thing Lightbulb",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "Lightbulb",
        "48",
        "svg",
        "resawsiotthinglightbulb",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing Medical Emergency",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Medical-Emergency_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Medical-Emergency_48.svg",
      "tokens": [
        "Res AWS Io T Thing Medical Emergency",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "Medical",
        "Emergency",
        "48",
        "svg",
        "resawsiotthingmedicalemergency",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing PLC",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_PLC_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_PLC_48.svg",
      "tokens": [
        "Res AWS Io T Thing PLC",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "PLC",
        "48",
        "svg",
        "resawsiotthingplc",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing Police Emergency",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Police-Emergency_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Police-Emergency_48.svg",
      "tokens": [
        "Res AWS Io T Thing Police Emergency",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "Police",
        "Emergency",
        "48",
        "svg",
        "resawsiotthingpoliceemergency",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing Relay",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Relay_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Relay_48.svg",
      "tokens": [
        "Res AWS Io T Thing Relay",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "Relay",
        "48",
        "svg",
        "resawsiotthingrelay",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing Stacklight",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Stacklight_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Stacklight_48.svg",
      "tokens": [
        "Res AWS Io T Thing Stacklight",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "Stacklight",
        "48",
        "svg",
        "resawsiotthingstacklight",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing Temperature Humidity Sensor",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Temperature-Humidity-Sensor_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Temperature-Humidity-Sensor_48.svg",
      "tokens": [
        "Res AWS Io T Thing Temperature Humidity Sensor",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "Temperature",
        "Humidity",
        "Sensor",
        "48",
        "svg",
        "resawsiotthingtemperaturehumiditysensor",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing Temperature Sensor",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Temperature-Sensor_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Temperature-Sensor_48.svg",
      "tokens": [
        "Res AWS Io T Thing Temperature Sensor",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "Temperature",
        "Sensor",
        "48",
        "svg",
        "resawsiotthingtemperaturesensor",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing Temperature Vibration Sensor",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Temperature-Vibration-Sensor_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Temperature-Vibration-Sensor_48.svg",
      "tokens": [
        "Res AWS Io T Thing Temperature Vibration Sensor",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "Temperature",
        "Vibration",
        "Sensor",
        "48",
        "svg",
        "resawsiotthingtemperaturevibrationsensor",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing Thermostat",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Thermostat_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Thermostat_48.svg",
      "tokens": [
        "Res AWS Io T Thing Thermostat",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "Thermostat",
        "48",
        "svg",
        "resawsiotthingthermostat",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing Travel",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Travel_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Travel_48.svg",
      "tokens": [
        "Res AWS Io T Thing Travel",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "Travel",
        "48",
        "svg",
        "resawsiotthingtravel",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing Utility",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Utility_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Utility_48.svg",
      "tokens": [
        "Res AWS Io T Thing Utility",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "Utility",
        "48",
        "svg",
        "resawsiotthingutility",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing Vibration Sensor",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Vibration-Sensor_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Vibration-Sensor_48.svg",
      "tokens": [
        "Res AWS Io T Thing Vibration Sensor",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "Vibration",
        "Sensor",
        "48",
        "svg",
        "resawsiotthingvibrationsensor",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Thing Windfarm",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Windfarm_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Thing_Windfarm_48.svg",
      "tokens": [
        "Res AWS Io T Thing Windfarm",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Thing",
        "Windfarm",
        "48",
        "svg",
        "resawsiotthingwindfarm",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Io T Topic",
      "category": "Res Io T",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Topic_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_IoT/Res_AWS-IoT_Topic_48.svg",
      "tokens": [
        "Res AWS Io T Topic",
        "Res Io T",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "IoT",
        "AWS",
        "Topic",
        "48",
        "svg",
        "resawsiottopic",
        "resiot"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Key Management Service External Key Store",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Key-Management-Service_External-Key-Store_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Key-Management-Service_External-Key-Store_48.svg",
      "tokens": [
        "Res AWS Key Management Service External Key Store",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "Key",
        "Management",
        "Service",
        "External",
        "Store",
        "48",
        "svg",
        "resawskeymanagementserviceexternalkeystore",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Lake Formation Data Lake",
      "category": "Res Analytics",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Analytics/Res_AWS-Lake-Formation_Data-Lake_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Analytics/Res_AWS-Lake-Formation_Data-Lake_48.svg",
      "tokens": [
        "Res AWS Lake Formation Data Lake",
        "Res Analytics",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Analytics",
        "AWS",
        "Lake",
        "Formation",
        "Data",
        "48",
        "svg",
        "resawslakeformationdatalake",
        "resanalytics"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Lambda Lambda Function",
      "category": "Res Compute",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Compute/Res_AWS-Lambda_Lambda-Function_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Compute/Res_AWS-Lambda_Lambda-Function_48.svg",
      "tokens": [
        "Res AWS Lambda Lambda Function",
        "Res Compute",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Compute",
        "AWS",
        "Lambda",
        "Function",
        "48",
        "svg",
        "resawslambdalambdafunction",
        "rescompute"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS License Manager Application Discovery",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-License-Manager_Application-Discovery_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-License-Manager_Application-Discovery_48.svg",
      "tokens": [
        "Res AWS License Manager Application Discovery",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "License",
        "Manager",
        "Application",
        "Discovery",
        "48",
        "svg",
        "resawslicensemanagerapplicationdiscovery",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS License Manager License Blending",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-License-Manager_License-Blending_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-License-Manager_License-Blending_48.svg",
      "tokens": [
        "Res AWS License Manager License Blending",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "License",
        "Manager",
        "Blending",
        "48",
        "svg",
        "resawslicensemanagerlicenseblending",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Mainframe Modernization Analyzer",
      "category": "Res Migration Modernization",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Mainframe-Modernization_Analyzer_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Mainframe-Modernization_Analyzer_48.svg",
      "tokens": [
        "Res AWS Mainframe Modernization Analyzer",
        "Res Migration Modernization",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Migration",
        "Modernization",
        "AWS",
        "Mainframe",
        "Analyzer",
        "48",
        "svg",
        "resawsmainframemodernizationanalyzer",
        "resmigrationmodernization"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Mainframe Modernization Compiler",
      "category": "Res Migration Modernization",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Mainframe-Modernization_Compiler_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Mainframe-Modernization_Compiler_48.svg",
      "tokens": [
        "Res AWS Mainframe Modernization Compiler",
        "Res Migration Modernization",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Migration",
        "Modernization",
        "AWS",
        "Mainframe",
        "Compiler",
        "48",
        "svg",
        "resawsmainframemodernizationcompiler",
        "resmigrationmodernization"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Mainframe Modernization Converter",
      "category": "Res Migration Modernization",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Mainframe-Modernization_Converter_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Mainframe-Modernization_Converter_48.svg",
      "tokens": [
        "Res AWS Mainframe Modernization Converter",
        "Res Migration Modernization",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Migration",
        "Modernization",
        "AWS",
        "Mainframe",
        "Converter",
        "48",
        "svg",
        "resawsmainframemodernizationconverter",
        "resmigrationmodernization"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Mainframe Modernization Developer",
      "category": "Res Migration Modernization",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Mainframe-Modernization_Developer_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Mainframe-Modernization_Developer_48.svg",
      "tokens": [
        "Res AWS Mainframe Modernization Developer",
        "Res Migration Modernization",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Migration",
        "Modernization",
        "AWS",
        "Mainframe",
        "Developer",
        "48",
        "svg",
        "resawsmainframemodernizationdeveloper",
        "resmigrationmodernization"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Mainframe Modernization Runtime",
      "category": "Res Migration Modernization",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Mainframe-Modernization_Runtime_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Mainframe-Modernization_Runtime_48.svg",
      "tokens": [
        "Res AWS Mainframe Modernization Runtime",
        "Res Migration Modernization",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Migration",
        "Modernization",
        "AWS",
        "Mainframe",
        "Runtime",
        "48",
        "svg",
        "resawsmainframemodernizationruntime",
        "resmigrationmodernization"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Management Console 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_AWS-Management-Console_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_AWS-Management-Console_48_Dark.svg",
      "tokens": [
        "Res AWS Management Console 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "AWS",
        "Management",
        "Console",
        "svg",
        "resawsmanagementconsole48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Management Console 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_AWS-Management-Console_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_AWS-Management-Console_48_Light.svg",
      "tokens": [
        "Res AWS Management Console 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "AWS",
        "Management",
        "Console",
        "svg",
        "resawsmanagementconsole48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Migration Hub Refactor Spaces Applications",
      "category": "Res Migration Modernization",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Migration-Hub_Refactor-Spaces-Applications_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Migration-Hub_Refactor-Spaces-Applications_48.svg",
      "tokens": [
        "Res AWS Migration Hub Refactor Spaces Applications",
        "Res Migration Modernization",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Migration",
        "Modernization",
        "AWS",
        "Hub",
        "Refactor",
        "Spaces",
        "Applications",
        "48",
        "svg",
        "resawsmigrationhubrefactorspacesapplications",
        "resmigrationmodernization"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Migration Hub Refactor Spaces Environments",
      "category": "Res Migration Modernization",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Migration-Hub_Refactor-Spaces-Environments_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Migration-Hub_Refactor-Spaces-Environments_48.svg",
      "tokens": [
        "Res AWS Migration Hub Refactor Spaces Environments",
        "Res Migration Modernization",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Migration",
        "Modernization",
        "AWS",
        "Hub",
        "Refactor",
        "Spaces",
        "Environments",
        "48",
        "svg",
        "resawsmigrationhubrefactorspacesenvironments",
        "resmigrationmodernization"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Migration Hub Refactor Spaces Services",
      "category": "Res Migration Modernization",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Migration-Hub_Refactor-Spaces-Services_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Migration-Hub_Refactor-Spaces-Services_48.svg",
      "tokens": [
        "Res AWS Migration Hub Refactor Spaces Services",
        "Res Migration Modernization",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Migration",
        "Modernization",
        "AWS",
        "Hub",
        "Refactor",
        "Spaces",
        "Services",
        "48",
        "svg",
        "resawsmigrationhubrefactorspacesservices",
        "resmigrationmodernization"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Network Firewall Endpoints",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Network-Firewall_Endpoints_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Network-Firewall_Endpoints_48.svg",
      "tokens": [
        "Res AWS Network Firewall Endpoints",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "Network",
        "Firewall",
        "Endpoints",
        "48",
        "svg",
        "resawsnetworkfirewallendpoints",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Organizations Account",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Organizations_Account_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Organizations_Account_48.svg",
      "tokens": [
        "Res AWS Organizations Account",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "Organizations",
        "Account",
        "48",
        "svg",
        "resawsorganizationsaccount",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Organizations Management Account",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Organizations_Management-Account_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Organizations_Management-Account_48.svg",
      "tokens": [
        "Res AWS Organizations Management Account",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "Organizations",
        "Account",
        "48",
        "svg",
        "resawsorganizationsmanagementaccount",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Organizations Organizational Unit",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Organizations_Organizational-Unit_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Organizations_Organizational-Unit_48.svg",
      "tokens": [
        "Res AWS Organizations Organizational Unit",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "Organizations",
        "Organizational",
        "Unit",
        "48",
        "svg",
        "resawsorganizationsorganizationalunit",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Security Hub Finding",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Security-Hub_Finding_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Security-Hub_Finding_48.svg",
      "tokens": [
        "Res AWS Security Hub Finding",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "Hub",
        "Finding",
        "48",
        "svg",
        "resawssecurityhubfinding",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Shield AWS Shield Advanced",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Shield_AWS-Shield-Advanced_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-Shield_AWS-Shield-Advanced_48.svg",
      "tokens": [
        "Res AWS Shield AWS Shield Advanced",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "Shield",
        "Advanced",
        "48",
        "svg",
        "resawsshieldawsshieldadvanced",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Snowball Snowball Import Export",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Snowball_Snowball-Import-Export_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Snowball_Snowball-Import-Export_48.svg",
      "tokens": [
        "Res AWS Snowball Snowball Import Export",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Snowball",
        "Import",
        "Export",
        "48",
        "svg",
        "resawssnowballsnowballimportexport",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Storage Gateway Amazon F Sx File Gateway",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Storage-Gateway_Amazon-FSx-File-Gateway_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Storage-Gateway_Amazon-FSx-File-Gateway_48.svg",
      "tokens": [
        "Res AWS Storage Gateway Amazon F Sx File Gateway",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Gateway",
        "Amazon",
        "FSx",
        "File",
        "48",
        "svg",
        "resawsstoragegatewayamazonfsxfilegateway",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Storage Gateway Amazon S3 File Gateway",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Storage-Gateway_Amazon-S3-File-Gateway_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Storage-Gateway_Amazon-S3-File-Gateway_48.svg",
      "tokens": [
        "Res AWS Storage Gateway Amazon S3 File Gateway",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Gateway",
        "Amazon",
        "S3",
        "File",
        "48",
        "svg",
        "resawsstoragegatewayamazons3filegateway",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Storage Gateway Cached Volume",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Storage-Gateway_Cached-Volume_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Storage-Gateway_Cached-Volume_48.svg",
      "tokens": [
        "Res AWS Storage Gateway Cached Volume",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Gateway",
        "Cached",
        "Volume",
        "48",
        "svg",
        "resawsstoragegatewaycachedvolume",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Storage Gateway File Gateway",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Storage-Gateway_File-Gateway_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Storage-Gateway_File-Gateway_48.svg",
      "tokens": [
        "Res AWS Storage Gateway File Gateway",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Gateway",
        "File",
        "48",
        "svg",
        "resawsstoragegatewayfilegateway",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Storage Gateway Noncached Volume",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Storage-Gateway_Noncached-Volume_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Storage-Gateway_Noncached-Volume_48.svg",
      "tokens": [
        "Res AWS Storage Gateway Noncached Volume",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Gateway",
        "Noncached",
        "Volume",
        "48",
        "svg",
        "resawsstoragegatewaynoncachedvolume",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Storage Gateway Tape Gateway",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Storage-Gateway_Tape-Gateway_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Storage-Gateway_Tape-Gateway_48.svg",
      "tokens": [
        "Res AWS Storage Gateway Tape Gateway",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Gateway",
        "Tape",
        "48",
        "svg",
        "resawsstoragegatewaytapegateway",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Storage Gateway Virtual Tape Library",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Storage-Gateway_Virtual-Tape-Library_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Storage-Gateway_Virtual-Tape-Library_48.svg",
      "tokens": [
        "Res AWS Storage Gateway Virtual Tape Library",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Gateway",
        "Virtual",
        "Tape",
        "Library",
        "48",
        "svg",
        "resawsstoragegatewayvirtualtapelibrary",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Storage Gateway Volume Gateway",
      "category": "Res Storage",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Storage/Res_AWS-Storage-Gateway_Volume-Gateway_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Storage/Res_AWS-Storage-Gateway_Volume-Gateway_48.svg",
      "tokens": [
        "Res AWS Storage Gateway Volume Gateway",
        "Res Storage",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Storage",
        "AWS",
        "Gateway",
        "Volume",
        "48",
        "svg",
        "resawsstoragegatewayvolumegateway",
        "resstorage"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Systems Manager Application Manager",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Application-Manager_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Application-Manager_48.svg",
      "tokens": [
        "Res AWS Systems Manager Application Manager",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "Systems",
        "Manager",
        "Application",
        "48",
        "svg",
        "resawssystemsmanagerapplicationmanager",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Systems Manager Automation",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Automation_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Automation_48.svg",
      "tokens": [
        "Res AWS Systems Manager Automation",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "Systems",
        "Manager",
        "Automation",
        "48",
        "svg",
        "resawssystemsmanagerautomation",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Systems Manager Change Calendar",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Change-Calendar_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Change-Calendar_48.svg",
      "tokens": [
        "Res AWS Systems Manager Change Calendar",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "Systems",
        "Manager",
        "Change",
        "Calendar",
        "48",
        "svg",
        "resawssystemsmanagerchangecalendar",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Systems Manager Change Manager",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Change-Manager_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Change-Manager_48.svg",
      "tokens": [
        "Res AWS Systems Manager Change Manager",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "Systems",
        "Manager",
        "Change",
        "48",
        "svg",
        "resawssystemsmanagerchangemanager",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Systems Manager Compliance",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Compliance_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Compliance_48.svg",
      "tokens": [
        "Res AWS Systems Manager Compliance",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "Systems",
        "Manager",
        "Compliance",
        "48",
        "svg",
        "resawssystemsmanagercompliance",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Systems Manager Distributor",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Distributor_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Distributor_48.svg",
      "tokens": [
        "Res AWS Systems Manager Distributor",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "Systems",
        "Manager",
        "Distributor",
        "48",
        "svg",
        "resawssystemsmanagerdistributor",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Systems Manager Documents",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Documents_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Documents_48.svg",
      "tokens": [
        "Res AWS Systems Manager Documents",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "Systems",
        "Manager",
        "Documents",
        "48",
        "svg",
        "resawssystemsmanagerdocuments",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Systems Manager Incident Manager",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Incident-Manager_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Incident-Manager_48.svg",
      "tokens": [
        "Res AWS Systems Manager Incident Manager",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "Systems",
        "Manager",
        "Incident",
        "48",
        "svg",
        "resawssystemsmanagerincidentmanager",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Systems Manager Inventory",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Inventory_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Inventory_48.svg",
      "tokens": [
        "Res AWS Systems Manager Inventory",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "Systems",
        "Manager",
        "Inventory",
        "48",
        "svg",
        "resawssystemsmanagerinventory",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Systems Manager Maintenance Windows",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Maintenance-Windows_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Maintenance-Windows_48.svg",
      "tokens": [
        "Res AWS Systems Manager Maintenance Windows",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "Systems",
        "Manager",
        "Maintenance",
        "Windows",
        "48",
        "svg",
        "resawssystemsmanagermaintenancewindows",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Systems Manager Ops Center",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_OpsCenter_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_OpsCenter_48.svg",
      "tokens": [
        "Res AWS Systems Manager Ops Center",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "Systems",
        "Manager",
        "OpsCenter",
        "48",
        "svg",
        "resawssystemsmanageropscenter",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Systems Manager Parameter Store",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Parameter-Store_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Parameter-Store_48.svg",
      "tokens": [
        "Res AWS Systems Manager Parameter Store",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "Systems",
        "Manager",
        "Parameter",
        "Store",
        "48",
        "svg",
        "resawssystemsmanagerparameterstore",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Systems Manager Patch Manager",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Patch-Manager_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Patch-Manager_48.svg",
      "tokens": [
        "Res AWS Systems Manager Patch Manager",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "Systems",
        "Manager",
        "Patch",
        "48",
        "svg",
        "resawssystemsmanagerpatchmanager",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Systems Manager Run Command",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Run-Command_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Run-Command_48.svg",
      "tokens": [
        "Res AWS Systems Manager Run Command",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "Systems",
        "Manager",
        "Run",
        "Command",
        "48",
        "svg",
        "resawssystemsmanagerruncommand",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Systems Manager Session Manager",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Session-Manager_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_Session-Manager_48.svg",
      "tokens": [
        "Res AWS Systems Manager Session Manager",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "Systems",
        "Manager",
        "Session",
        "48",
        "svg",
        "resawssystemsmanagersessionmanager",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Systems Manager State Manager",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_State-Manager_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Systems-Manager_State-Manager_48.svg",
      "tokens": [
        "Res AWS Systems Manager State Manager",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "Systems",
        "Manager",
        "State",
        "48",
        "svg",
        "resawssystemsmanagerstatemanager",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Transfer Family AWS AS2",
      "category": "Res Migration Modernization",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Transfer-Family_AWS-AS2_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Transfer-Family_AWS-AS2_48.svg",
      "tokens": [
        "Res AWS Transfer Family AWS AS2",
        "Res Migration Modernization",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Migration",
        "Modernization",
        "AWS",
        "Transfer",
        "Family",
        "AS2",
        "48",
        "svg",
        "resawstransferfamilyawsas2",
        "resmigrationmodernization"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Transfer Family AWS FTP",
      "category": "Res Migration Modernization",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Transfer-Family_AWS-FTP_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Transfer-Family_AWS-FTP_48.svg",
      "tokens": [
        "Res AWS Transfer Family AWS FTP",
        "Res Migration Modernization",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Migration",
        "Modernization",
        "AWS",
        "Transfer",
        "Family",
        "FTP",
        "48",
        "svg",
        "resawstransferfamilyawsftp",
        "resmigrationmodernization"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Transfer Family AWS FTPS",
      "category": "Res Migration Modernization",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Transfer-Family_AWS-FTPS_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Transfer-Family_AWS-FTPS_48.svg",
      "tokens": [
        "Res AWS Transfer Family AWS FTPS",
        "Res Migration Modernization",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Migration",
        "Modernization",
        "AWS",
        "Transfer",
        "Family",
        "FTPS",
        "48",
        "svg",
        "resawstransferfamilyawsftps",
        "resmigrationmodernization"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Transfer Family AWS SFTP",
      "category": "Res Migration Modernization",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Transfer-Family_AWS-SFTP_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Migration-Modernization/Res_AWS-Transfer-Family_AWS-SFTP_48.svg",
      "tokens": [
        "Res AWS Transfer Family AWS SFTP",
        "Res Migration Modernization",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Migration",
        "Modernization",
        "AWS",
        "Transfer",
        "Family",
        "SFTP",
        "48",
        "svg",
        "resawstransferfamilyawssftp",
        "resmigrationmodernization"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Transit Gateway Attachment",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_AWS-Transit-Gateway_Attachment_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_AWS-Transit-Gateway_Attachment_48.svg",
      "tokens": [
        "Res AWS Transit Gateway Attachment",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "AWS",
        "Transit",
        "Gateway",
        "Attachment",
        "48",
        "svg",
        "resawstransitgatewayattachment",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Trusted Advisor Checklist Cost",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Trusted-Advisor_Checklist-Cost_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Trusted-Advisor_Checklist-Cost_48.svg",
      "tokens": [
        "Res AWS Trusted Advisor Checklist Cost",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "Trusted",
        "Advisor",
        "Checklist",
        "Cost",
        "48",
        "svg",
        "resawstrustedadvisorchecklistcost",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Trusted Advisor Checklist Fault Tolerant",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Trusted-Advisor_Checklist-Fault-Tolerant_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Trusted-Advisor_Checklist-Fault-Tolerant_48.svg",
      "tokens": [
        "Res AWS Trusted Advisor Checklist Fault Tolerant",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "Trusted",
        "Advisor",
        "Checklist",
        "Fault",
        "Tolerant",
        "48",
        "svg",
        "resawstrustedadvisorchecklistfaulttolerant",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Trusted Advisor Checklist Performance",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Trusted-Advisor_Checklist-Performance_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Trusted-Advisor_Checklist-Performance_48.svg",
      "tokens": [
        "Res AWS Trusted Advisor Checklist Performance",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "Trusted",
        "Advisor",
        "Checklist",
        "Performance",
        "48",
        "svg",
        "resawstrustedadvisorchecklistperformance",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Trusted Advisor Checklist Security",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Trusted-Advisor_Checklist-Security_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Trusted-Advisor_Checklist-Security_48.svg",
      "tokens": [
        "Res AWS Trusted Advisor Checklist Security",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "Trusted",
        "Advisor",
        "Checklist",
        "Security",
        "48",
        "svg",
        "resawstrustedadvisorchecklistsecurity",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS Trusted Advisor Checklist",
      "category": "Res Management Governance",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Trusted-Advisor_Checklist_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Management-Governance/Res_AWS-Trusted-Advisor_Checklist_48.svg",
      "tokens": [
        "Res AWS Trusted Advisor Checklist",
        "Res Management Governance",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Management",
        "Governance",
        "AWS",
        "Trusted",
        "Advisor",
        "Checklist",
        "48",
        "svg",
        "resawstrustedadvisorchecklist",
        "resmanagementgovernance"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS WAF Bad Bot",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-WAF_Bad-Bot_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-WAF_Bad-Bot_48.svg",
      "tokens": [
        "Res AWS WAF Bad Bot",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "WAF",
        "Bad",
        "Bot",
        "48",
        "svg",
        "resawswafbadbot",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS WAF Bot Control",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-WAF_Bot-Control_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-WAF_Bot-Control_48.svg",
      "tokens": [
        "Res AWS WAF Bot Control",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "WAF",
        "Bot",
        "Control",
        "48",
        "svg",
        "resawswafbotcontrol",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS WAF Bot",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-WAF_Bot_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-WAF_Bot_48.svg",
      "tokens": [
        "Res AWS WAF Bot",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "WAF",
        "Bot",
        "48",
        "svg",
        "resawswafbot",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS WAF Filtering Rule",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-WAF_Filtering-Rule_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-WAF_Filtering-Rule_48.svg",
      "tokens": [
        "Res AWS WAF Filtering Rule",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "WAF",
        "Filtering",
        "Rule",
        "48",
        "svg",
        "resawswaffilteringrule",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS WAF Labels",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-WAF_Labels_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-WAF_Labels_48.svg",
      "tokens": [
        "Res AWS WAF Labels",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "WAF",
        "Labels",
        "48",
        "svg",
        "resawswaflabels",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS WAF Managed Rule",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-WAF_Managed-Rule_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-WAF_Managed-Rule_48.svg",
      "tokens": [
        "Res AWS WAF Managed Rule",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "WAF",
        "Managed",
        "Rule",
        "48",
        "svg",
        "resawswafmanagedrule",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res AWS WAF Rule",
      "category": "Res Security Identity",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Security-Identity/Res_AWS-WAF_Rule_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Security-Identity/Res_AWS-WAF_Rule_48.svg",
      "tokens": [
        "Res AWS WAF Rule",
        "Res Security Identity",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Security",
        "Identity",
        "AWS",
        "WAF",
        "Rule",
        "48",
        "svg",
        "resawswafrule",
        "ressecurityidentity"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Camera 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Camera_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Camera_48_Dark.svg",
      "tokens": [
        "Res Camera 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Camera",
        "svg",
        "rescamera48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Camera 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Camera_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Camera_48_Light.svg",
      "tokens": [
        "Res Camera 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Camera",
        "svg",
        "rescamera48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Chat 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Chat_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Chat_48_Dark.svg",
      "tokens": [
        "Res Chat 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Chat",
        "svg",
        "reschat48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Chat 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Chat_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Chat_48_Light.svg",
      "tokens": [
        "Res Chat 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Chat",
        "svg",
        "reschat48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Client 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Client_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Client_48_Dark.svg",
      "tokens": [
        "Res Client 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Client",
        "svg",
        "resclient48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Client 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Client_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Client_48_Light.svg",
      "tokens": [
        "Res Client 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Client",
        "svg",
        "resclient48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Cold Storage 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Cold-Storage_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Cold-Storage_48_Dark.svg",
      "tokens": [
        "Res Cold Storage 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Cold",
        "Storage",
        "svg",
        "rescoldstorage48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Cold Storage 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Cold-Storage_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Cold-Storage_48_Light.svg",
      "tokens": [
        "Res Cold Storage 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Cold",
        "Storage",
        "svg",
        "rescoldstorage48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Credentials 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Credentials_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Credentials_48_Dark.svg",
      "tokens": [
        "Res Credentials 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Credentials",
        "svg",
        "rescredentials48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Credentials 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Credentials_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Credentials_48_Light.svg",
      "tokens": [
        "Res Credentials 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Credentials",
        "svg",
        "rescredentials48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Data Stream 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Data-Stream_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Data-Stream_48_Dark.svg",
      "tokens": [
        "Res Data Stream 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Data",
        "Stream",
        "svg",
        "resdatastream48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Data Stream 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Data-Stream_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Data-Stream_48_Light.svg",
      "tokens": [
        "Res Data Stream 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Data",
        "Stream",
        "svg",
        "resdatastream48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Data Table 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Data-Table_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Data-Table_48_Dark.svg",
      "tokens": [
        "Res Data Table 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Data",
        "Table",
        "svg",
        "resdatatable48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Data Table 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Data-Table_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Data-Table_48_Light.svg",
      "tokens": [
        "Res Data Table 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Data",
        "Table",
        "svg",
        "resdatatable48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Database 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Database_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Database_48_Dark.svg",
      "tokens": [
        "Res Database 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Database",
        "svg",
        "resdatabase48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Database 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Database_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Database_48_Light.svg",
      "tokens": [
        "Res Database 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Database",
        "svg",
        "resdatabase48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Disk 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Disk_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Disk_48_Dark.svg",
      "tokens": [
        "Res Disk 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Disk",
        "svg",
        "resdisk48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Disk 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Disk_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Disk_48_Light.svg",
      "tokens": [
        "Res Disk 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Disk",
        "svg",
        "resdisk48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Document 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Document_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Document_48_Dark.svg",
      "tokens": [
        "Res Document 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Document",
        "svg",
        "resdocument48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Document 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Document_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Document_48_Light.svg",
      "tokens": [
        "Res Document 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Document",
        "svg",
        "resdocument48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Documents 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Documents_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Documents_48_Dark.svg",
      "tokens": [
        "Res Documents 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Documents",
        "svg",
        "resdocuments48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Documents 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Documents_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Documents_48_Light.svg",
      "tokens": [
        "Res Documents 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Documents",
        "svg",
        "resdocuments48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Elastic Load Balancing Application Load Balancer",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Elastic-Load-Balancing_Application-Load-Balancer_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Elastic-Load-Balancing_Application-Load-Balancer_48.svg",
      "tokens": [
        "Res Elastic Load Balancing Application Load Balancer",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Elastic",
        "Load",
        "Balancing",
        "Application",
        "Balancer",
        "48",
        "svg",
        "reselasticloadbalancingapplicationloadbalancer",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Elastic Load Balancing Classic Load Balancer",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Elastic-Load-Balancing_Classic-Load-Balancer_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Elastic-Load-Balancing_Classic-Load-Balancer_48.svg",
      "tokens": [
        "Res Elastic Load Balancing Classic Load Balancer",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Elastic",
        "Load",
        "Balancing",
        "Classic",
        "Balancer",
        "48",
        "svg",
        "reselasticloadbalancingclassicloadbalancer",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Elastic Load Balancing Gateway Load Balancer",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Elastic-Load-Balancing_Gateway-Load-Balancer_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Elastic-Load-Balancing_Gateway-Load-Balancer_48.svg",
      "tokens": [
        "Res Elastic Load Balancing Gateway Load Balancer",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Elastic",
        "Load",
        "Balancing",
        "Gateway",
        "Balancer",
        "48",
        "svg",
        "reselasticloadbalancinggatewayloadbalancer",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Elastic Load Balancing Network Load Balancer",
      "category": "Res Networking Content Delivery",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Elastic-Load-Balancing_Network-Load-Balancer_48.svg",
      "sourcePath": "Resource-Icons_04302026/Res_Networking-Content-Delivery/Res_Elastic-Load-Balancing_Network-Load-Balancer_48.svg",
      "tokens": [
        "Res Elastic Load Balancing Network Load Balancer",
        "Res Networking Content Delivery",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "Networking",
        "Content",
        "Delivery",
        "Elastic",
        "Load",
        "Balancing",
        "Network",
        "Balancer",
        "48",
        "svg",
        "reselasticloadbalancingnetworkloadbalancer",
        "resnetworkingcontentdelivery"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Email 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Email_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Email_48_Dark.svg",
      "tokens": [
        "Res Email 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Email",
        "svg",
        "resemail48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Email 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Email_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Email_48_Light.svg",
      "tokens": [
        "Res Email 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Email",
        "svg",
        "resemail48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Firewall 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Firewall_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Firewall_48_Dark.svg",
      "tokens": [
        "Res Firewall 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Firewall",
        "svg",
        "resfirewall48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Firewall 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Firewall_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Firewall_48_Light.svg",
      "tokens": [
        "Res Firewall 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Firewall",
        "svg",
        "resfirewall48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Folder 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Folder_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Folder_48_Dark.svg",
      "tokens": [
        "Res Folder 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Folder",
        "svg",
        "resfolder48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Folder 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Folder_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Folder_48_Light.svg",
      "tokens": [
        "Res Folder 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Folder",
        "svg",
        "resfolder48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Folders 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Folders_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Folders_48_Dark.svg",
      "tokens": [
        "Res Folders 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Folders",
        "svg",
        "resfolders48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Folders 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Folders_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Folders_48_Light.svg",
      "tokens": [
        "Res Folders 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Folders",
        "svg",
        "resfolders48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Forums 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Forums_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Forums_48_Dark.svg",
      "tokens": [
        "Res Forums 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Forums",
        "svg",
        "resforums48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Forums 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Forums_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Forums_48_Light.svg",
      "tokens": [
        "Res Forums 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Forums",
        "svg",
        "resforums48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Gear 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Gear_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Gear_48_Dark.svg",
      "tokens": [
        "Res Gear 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Gear",
        "svg",
        "resgear48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Gear 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Gear_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Gear_48_Light.svg",
      "tokens": [
        "Res Gear 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Gear",
        "svg",
        "resgear48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Generic Application 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Generic-Application_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Generic-Application_48_Dark.svg",
      "tokens": [
        "Res Generic Application 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Generic",
        "Application",
        "svg",
        "resgenericapplication48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Generic Application 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Generic-Application_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Generic-Application_48_Light.svg",
      "tokens": [
        "Res Generic Application 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Generic",
        "Application",
        "svg",
        "resgenericapplication48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Git Repository 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Git-Repository_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Git-Repository_48_Dark.svg",
      "tokens": [
        "Res Git Repository 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Git",
        "Repository",
        "svg",
        "resgitrepository48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Git Repository 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Git-Repository_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Git-Repository_48_Light.svg",
      "tokens": [
        "Res Git Repository 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Git",
        "Repository",
        "svg",
        "resgitrepository48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Globe 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Globe_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Globe_48_Dark.svg",
      "tokens": [
        "Res Globe 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Globe",
        "svg",
        "resglobe48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Globe 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Globe_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Globe_48_Light.svg",
      "tokens": [
        "Res Globe 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Globe",
        "svg",
        "resglobe48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Internet 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Internet_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Internet_48_Dark.svg",
      "tokens": [
        "Res Internet 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Internet",
        "svg",
        "resinternet48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Internet 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Internet_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Internet_48_Light.svg",
      "tokens": [
        "Res Internet 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Internet",
        "svg",
        "resinternet48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Internet Alt1 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Internet-alt1_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Internet-alt1_48_Dark.svg",
      "tokens": [
        "Res Internet Alt1 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Internet",
        "alt1",
        "svg",
        "resinternetalt148dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Internet Alt1 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Internet-alt1_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Internet-alt1_48_Light.svg",
      "tokens": [
        "Res Internet Alt1 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Internet",
        "alt1",
        "svg",
        "resinternetalt148light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Internet Alt2 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Internet-alt2_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Internet-alt2_48_Dark.svg",
      "tokens": [
        "Res Internet Alt2 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Internet",
        "alt2",
        "svg",
        "resinternetalt248dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Internet Alt2 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Internet-alt2_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Internet-alt2_48_Light.svg",
      "tokens": [
        "Res Internet Alt2 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Internet",
        "alt2",
        "svg",
        "resinternetalt248light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res JSON Script 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_JSON-Script_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_JSON-Script_48_Dark.svg",
      "tokens": [
        "Res JSON Script 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "JSON",
        "Script",
        "svg",
        "resjsonscript48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res JSON Script 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_JSON-Script_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_JSON-Script_48_Light.svg",
      "tokens": [
        "Res JSON Script 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "JSON",
        "Script",
        "svg",
        "resjsonscript48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Logs 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Logs_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Logs_48_Dark.svg",
      "tokens": [
        "Res Logs 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Logs",
        "svg",
        "reslogs48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Logs 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Logs_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Logs_48_Light.svg",
      "tokens": [
        "Res Logs 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Logs",
        "svg",
        "reslogs48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Magnifying Glass 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Magnifying-Glass_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Magnifying-Glass_48_Dark.svg",
      "tokens": [
        "Res Magnifying Glass 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Magnifying",
        "Glass",
        "svg",
        "resmagnifyingglass48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Magnifying Glass 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Magnifying-Glass_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Magnifying-Glass_48_Light.svg",
      "tokens": [
        "Res Magnifying Glass 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Magnifying",
        "Glass",
        "svg",
        "resmagnifyingglass48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Metrics 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Metrics_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Metrics_48_Dark.svg",
      "tokens": [
        "Res Metrics 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Metrics",
        "svg",
        "resmetrics48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Metrics 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Metrics_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Metrics_48_Light.svg",
      "tokens": [
        "Res Metrics 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Metrics",
        "svg",
        "resmetrics48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Mobile Client 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Mobile-client_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Mobile-client_48_Dark.svg",
      "tokens": [
        "Res Mobile Client 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Mobile",
        "client",
        "svg",
        "resmobileclient48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Mobile Client 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Mobile-client_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Mobile-client_48_Light.svg",
      "tokens": [
        "Res Mobile Client 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Mobile",
        "client",
        "svg",
        "resmobileclient48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Multimedia 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Multimedia_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Multimedia_48_Dark.svg",
      "tokens": [
        "Res Multimedia 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Multimedia",
        "svg",
        "resmultimedia48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Multimedia 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Multimedia_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Multimedia_48_Light.svg",
      "tokens": [
        "Res Multimedia 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Multimedia",
        "svg",
        "resmultimedia48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Office Building 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Office-building_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Office-building_48_Dark.svg",
      "tokens": [
        "Res Office Building 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Office",
        "building",
        "svg",
        "resofficebuilding48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Office Building 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Office-building_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Office-building_48_Light.svg",
      "tokens": [
        "Res Office Building 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Office",
        "building",
        "svg",
        "resofficebuilding48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Programming Language 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Programming-Language_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Programming-Language_48_Dark.svg",
      "tokens": [
        "Res Programming Language 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Programming",
        "Language",
        "svg",
        "resprogramminglanguage48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Programming Language 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Programming-Language_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Programming-Language_48_Light.svg",
      "tokens": [
        "Res Programming Language 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Programming",
        "Language",
        "svg",
        "resprogramminglanguage48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Question 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Question_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Question_48_Dark.svg",
      "tokens": [
        "Res Question 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Question",
        "svg",
        "resquestion48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Question 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Question_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Question_48_Light.svg",
      "tokens": [
        "Res Question 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Question",
        "svg",
        "resquestion48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Recover 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Recover_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Recover_48_Dark.svg",
      "tokens": [
        "Res Recover 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Recover",
        "svg",
        "resrecover48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Recover 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Recover_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Recover_48_Light.svg",
      "tokens": [
        "Res Recover 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Recover",
        "svg",
        "resrecover48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res SAML Token 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_SAML-token_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_SAML-token_48_Dark.svg",
      "tokens": [
        "Res SAML Token 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "SAML",
        "token",
        "svg",
        "ressamltoken48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res SAML Token 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_SAML-token_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_SAML-token_48_Light.svg",
      "tokens": [
        "Res SAML Token 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "SAML",
        "token",
        "svg",
        "ressamltoken48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res SDK 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_SDK_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_SDK_48_Dark.svg",
      "tokens": [
        "Res SDK 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "SDK",
        "svg",
        "ressdk48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res SDK 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_SDK_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_SDK_48_Light.svg",
      "tokens": [
        "Res SDK 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "SDK",
        "svg",
        "ressdk48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Server 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Server_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Server_48_Dark.svg",
      "tokens": [
        "Res Server 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Server",
        "svg",
        "resserver48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Server 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Server_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Server_48_Light.svg",
      "tokens": [
        "Res Server 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Server",
        "svg",
        "resserver48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Servers 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Servers_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Servers_48_Dark.svg",
      "tokens": [
        "Res Servers 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Servers",
        "svg",
        "resservers48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Servers 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Servers_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Servers_48_Light.svg",
      "tokens": [
        "Res Servers 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Servers",
        "svg",
        "resservers48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Shield 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Shield_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Shield_48_Dark.svg",
      "tokens": [
        "Res Shield 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Shield",
        "svg",
        "resshield48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Shield 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Shield_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Shield_48_Light.svg",
      "tokens": [
        "Res Shield 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Shield",
        "svg",
        "resshield48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Source Code 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Source-Code_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Source-Code_48_Dark.svg",
      "tokens": [
        "Res Source Code 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Source",
        "Code",
        "svg",
        "ressourcecode48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Source Code 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Source-Code_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Source-Code_48_Light.svg",
      "tokens": [
        "Res Source Code 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Source",
        "Code",
        "svg",
        "ressourcecode48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res SSL Padlock 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_SSL-padlock_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_SSL-padlock_48_Dark.svg",
      "tokens": [
        "Res SSL Padlock 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "SSL",
        "padlock",
        "svg",
        "ressslpadlock48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res SSL Padlock 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_SSL-padlock_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_SSL-padlock_48_Light.svg",
      "tokens": [
        "Res SSL Padlock 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "SSL",
        "padlock",
        "svg",
        "ressslpadlock48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Tape Storage 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Tape-storage_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Tape-storage_48_Dark.svg",
      "tokens": [
        "Res Tape Storage 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Tape",
        "storage",
        "svg",
        "restapestorage48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Tape Storage 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Tape-storage_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Tape-storage_48_Light.svg",
      "tokens": [
        "Res Tape Storage 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Tape",
        "storage",
        "svg",
        "restapestorage48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Toolkit 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Toolkit_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Toolkit_48_Dark.svg",
      "tokens": [
        "Res Toolkit 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Toolkit",
        "svg",
        "restoolkit48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Toolkit 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Toolkit_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Toolkit_48_Light.svg",
      "tokens": [
        "Res Toolkit 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Toolkit",
        "svg",
        "restoolkit48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res User 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_User_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_User_48_Dark.svg",
      "tokens": [
        "Res User 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "User",
        "svg",
        "resuser48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res User 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_User_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_User_48_Light.svg",
      "tokens": [
        "Res User 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "User",
        "svg",
        "resuser48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Users 48 Dark",
      "category": "Res 48 Dark",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Users_48_Dark.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Dark/Res_Users_48_Dark.svg",
      "tokens": [
        "Res Users 48 Dark",
        "Res 48 Dark",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Dark",
        "Users",
        "svg",
        "resusers48dark",
        "res48dark"
      ]
    },
    {
      "provider": "aws",
      "label": "Res Users 48 Light",
      "category": "Res 48 Light",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Users_48_Light.svg",
      "sourcePath": "Resource-Icons_04302026/Res_General-Icons/Res_48_Light/Res_Users_48_Light.svg",
      "tokens": [
        "Res Users 48 Light",
        "Res 48 Light",
        "Resource",
        "Icons",
        "04302026",
        "Res",
        "General",
        "48",
        "Light",
        "Users",
        "svg",
        "resusers48light",
        "res48light"
      ]
    },
    {
      "provider": "aws",
      "label": "Reserved Instance Reporting",
      "category": "Arch Cloud Financial Management",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Cloud-Financial-Management/64/Arch_Reserved-Instance-Reporting_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Cloud-Financial-Management/64/Arch_Reserved-Instance-Reporting_64.svg",
      "tokens": [
        "Reserved Instance Reporting",
        "Arch Cloud Financial Management",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Cloud",
        "Financial",
        "Management",
        "64",
        "Reserved",
        "Instance",
        "Reporting",
        "svg",
        "reservedinstancereporting",
        "archcloudfinancialmanagement"
      ]
    },
    {
      "provider": "aws",
      "label": "Savings Plans",
      "category": "Arch Cloud Financial Management",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Cloud-Financial-Management/64/Arch_Savings-Plans_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Cloud-Financial-Management/64/Arch_Savings-Plans_64.svg",
      "tokens": [
        "Savings Plans",
        "Arch Cloud Financial Management",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Cloud",
        "Financial",
        "Management",
        "64",
        "Savings",
        "Plans",
        "svg",
        "savingsplans",
        "archcloudfinancialmanagement"
      ]
    },
    {
      "provider": "aws",
      "label": "Server Contents",
      "category": "Architecture Group Icons 04302026",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Group-Icons_04302026/Server-contents_32.svg",
      "sourcePath": "Architecture-Group-Icons_04302026/Server-contents_32.svg",
      "tokens": [
        "Server Contents",
        "Architecture Group Icons 04302026",
        "Architecture",
        "Group",
        "Icons",
        "04302026",
        "Server",
        "contents",
        "32",
        "svg",
        "servercontents",
        "architecturegroupicons04302026"
      ]
    },
    {
      "provider": "aws",
      "label": "Spot Fleet",
      "category": "Architecture Group Icons 04302026",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Group-Icons_04302026/Spot-Fleet_32.svg",
      "sourcePath": "Architecture-Group-Icons_04302026/Spot-Fleet_32.svg",
      "tokens": [
        "Spot Fleet",
        "Architecture Group Icons 04302026",
        "Architecture",
        "Group",
        "Icons",
        "04302026",
        "Spot",
        "Fleet",
        "32",
        "svg",
        "spotfleet",
        "architecturegroupicons04302026"
      ]
    },
    {
      "provider": "aws",
      "label": "Tensor Flow On AWS",
      "category": "Arch Artificial Intelligence",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_TensorFlow-on-AWS_64.svg",
      "sourcePath": "Architecture-Service-Icons_04302026/Arch_Artificial-Intelligence/64/Arch_TensorFlow-on-AWS_64.svg",
      "tokens": [
        "Tensor Flow On AWS",
        "Arch Artificial Intelligence",
        "Architecture",
        "Service",
        "Icons",
        "04302026",
        "Arch",
        "Artificial",
        "Intelligence",
        "64",
        "TensorFlow",
        "on",
        "AWS",
        "svg",
        "tensorflowonaws",
        "archartificialintelligence"
      ]
    },
    {
      "provider": "aws",
      "label": "Virtual Private Cloud VPC",
      "category": "Architecture Group Icons 04302026",
      "url": "/assets/network-icons/aws/Icon-package_04302026/Architecture-Group-Icons_04302026/Virtual-private-cloud-VPC_32.svg",
      "sourcePath": "Architecture-Group-Icons_04302026/Virtual-private-cloud-VPC_32.svg",
      "tokens": [
        "Virtual Private Cloud VPC",
        "Architecture Group Icons 04302026",
        "Architecture",
        "Group",
        "Icons",
        "04302026",
        "Virtual",
        "private",
        "cloud",
        "VPC",
        "32",
        "svg",
        "virtualprivatecloudvpc",
        "architecturegroupicons04302026"
      ]
    },
    {
      "provider": "azure",
      "label": "030777508 Icon Service Service Group Relationships",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/030777508--icon-service-Service-Group-Relationships.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/030777508 -icon-service-Service-Group-Relationships.svg",
      "tokens": [
        "030777508 Icon Service Service Group Relationships",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "030777508",
        "icon",
        "service",
        "Group",
        "Relationships",
        "svg",
        "030777508iconserviceservicegrouprelationships",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "ABS Member",
      "category": "Blockchain",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/blockchain/10374-icon-service-ABS-Member.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/blockchain/10374-icon-service-ABS-Member.svg",
      "tokens": [
        "ABS Member",
        "Blockchain",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "blockchain",
        "10374",
        "icon",
        "service",
        "ABS",
        "Member",
        "svg",
        "absmember"
      ]
    },
    {
      "provider": "azure",
      "label": "Active Directory Connect Health",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/10224-icon-service-Active-Directory-Connect-Health.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/10224-icon-service-Active-Directory-Connect-Health.svg",
      "tokens": [
        "Active Directory Connect Health",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "10224",
        "icon",
        "service",
        "Active",
        "Directory",
        "Connect",
        "Health",
        "svg",
        "activedirectoryconnecthealth"
      ]
    },
    {
      "provider": "azure",
      "label": "Activity Log",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/00007-icon-service-Activity-Log.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/00007-icon-service-Activity-Log.svg",
      "tokens": [
        "Activity Log",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "00007",
        "icon",
        "service",
        "Activity",
        "Log",
        "svg",
        "activitylog",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Activity Log",
      "category": "Monitor",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/monitor/00007-icon-service-Activity-Log.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/monitor/00007-icon-service-Activity-Log.svg",
      "tokens": [
        "Activity Log",
        "Monitor",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "monitor",
        "00007",
        "icon",
        "service",
        "Activity",
        "Log",
        "svg",
        "activitylog"
      ]
    },
    {
      "provider": "azure",
      "label": "Administrative Units",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/00919-icon-service-Administrative-Units.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/00919-icon-service-Administrative-Units.svg",
      "tokens": [
        "Administrative Units",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "00919",
        "icon",
        "service",
        "Administrative",
        "Units",
        "svg",
        "administrativeunits"
      ]
    },
    {
      "provider": "azure",
      "label": "Advisor",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/00003-icon-service-Advisor.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/00003-icon-service-Advisor.svg",
      "tokens": [
        "Advisor",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "00003",
        "icon",
        "service",
        "svg",
        "advisor",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "AI At Edge",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/03687-icon-service-AI-at-Edge.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/03687-icon-service-AI-at-Edge.svg",
      "tokens": [
        "AI At Edge",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "03687",
        "icon",
        "service",
        "AI",
        "at",
        "Edge",
        "svg",
        "aiatedge",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "AI Studio",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/03513-icon-service-AI-Studio.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/03513-icon-service-AI-Studio.svg",
      "tokens": [
        "AI Studio",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "03513",
        "icon",
        "service",
        "AI",
        "Studio",
        "svg",
        "aistudio",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "AKS Automatic",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/03543-icon-service-AKS-Automatic.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/03543-icon-service-AKS-Automatic.svg",
      "tokens": [
        "AKS Automatic",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "03543",
        "icon",
        "service",
        "AKS",
        "Automatic",
        "svg",
        "aksautomatic"
      ]
    },
    {
      "provider": "azure",
      "label": "AKS Istio",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03399-icon-service-AKS-Istio.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03399-icon-service-AKS-Istio.svg",
      "tokens": [
        "AKS Istio",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03399",
        "icon",
        "service",
        "AKS",
        "Istio",
        "svg",
        "aksistio"
      ]
    },
    {
      "provider": "azure",
      "label": "AKS Network Policy",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/032487601-icon-service-AKS-Network-Policy.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/032487601-icon-service-AKS-Network-Policy.svg",
      "tokens": [
        "AKS Network Policy",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "032487601",
        "icon",
        "service",
        "AKS",
        "Network",
        "Policy",
        "svg",
        "aksnetworkpolicy",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Alerts",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/00002-icon-service-Alerts.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/00002-icon-service-Alerts.svg",
      "tokens": [
        "Alerts",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "00002",
        "icon",
        "service",
        "svg",
        "alerts",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "All Resources",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10001-icon-service-All-Resources.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10001-icon-service-All-Resources.svg",
      "tokens": [
        "All Resources",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10001",
        "icon",
        "service",
        "All",
        "Resources",
        "svg",
        "allresources"
      ]
    },
    {
      "provider": "azure",
      "label": "Analysis Services",
      "category": "Analytics",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/analytics/10148-icon-service-Analysis-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/analytics/10148-icon-service-Analysis-Services.svg",
      "tokens": [
        "Analysis Services",
        "Analytics",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "analytics",
        "10148",
        "icon",
        "service",
        "Analysis",
        "Services",
        "svg",
        "analysisservices"
      ]
    },
    {
      "provider": "azure",
      "label": "Anomaly Detector",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/00814-icon-service-Anomaly-Detector.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/00814-icon-service-Anomaly-Detector.svg",
      "tokens": [
        "Anomaly Detector",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "00814",
        "icon",
        "service",
        "Anomaly",
        "Detector",
        "svg",
        "anomalydetector",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "API Center",
      "category": "Web",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/web/03291-icon-service-API-Center.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/web/03291-icon-service-API-Center.svg",
      "tokens": [
        "API Center",
        "Web",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "web",
        "03291",
        "icon",
        "service",
        "API",
        "Center",
        "svg",
        "apicenter"
      ]
    },
    {
      "provider": "azure",
      "label": "API Connections",
      "category": "Devops",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/devops/10048-icon-service-API-Connections.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/devops/10048-icon-service-API-Connections.svg",
      "tokens": [
        "API Connections",
        "Devops",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "devops",
        "10048",
        "icon",
        "service",
        "API",
        "Connections",
        "svg",
        "apiconnections"
      ]
    },
    {
      "provider": "azure",
      "label": "API Connections",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/10048-icon-service-API-Connections.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/10048-icon-service-API-Connections.svg",
      "tokens": [
        "API Connections",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "10048",
        "icon",
        "service",
        "API",
        "Connections",
        "svg",
        "apiconnections"
      ]
    },
    {
      "provider": "azure",
      "label": "API Connections",
      "category": "Web",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/web/10048-icon-service-API-Connections.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/web/10048-icon-service-API-Connections.svg",
      "tokens": [
        "API Connections",
        "Web",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "web",
        "10048",
        "icon",
        "service",
        "API",
        "Connections",
        "svg",
        "apiconnections"
      ]
    },
    {
      "provider": "azure",
      "label": "API Management Services",
      "category": "Devops",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/devops/10042-icon-service-API-Management-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/devops/10042-icon-service-API-Management-Services.svg",
      "tokens": [
        "API Management Services",
        "Devops",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "devops",
        "10042",
        "icon",
        "service",
        "API",
        "Management",
        "Services",
        "svg",
        "apimanagementservices"
      ]
    },
    {
      "provider": "azure",
      "label": "API Management Services",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/10042-icon-service-API-Management-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/10042-icon-service-API-Management-Services.svg",
      "tokens": [
        "API Management Services",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "10042",
        "icon",
        "service",
        "API",
        "Management",
        "Services",
        "svg",
        "apimanagementservices"
      ]
    },
    {
      "provider": "azure",
      "label": "API Management Services",
      "category": "Web",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/web/10042-icon-service-API-Management-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/web/10042-icon-service-API-Management-Services.svg",
      "tokens": [
        "API Management Services",
        "Web",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "web",
        "10042",
        "icon",
        "service",
        "API",
        "Management",
        "Services",
        "svg",
        "apimanagementservices"
      ]
    },
    {
      "provider": "azure",
      "label": "API Proxy",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/02386-icon-service-API-Proxy.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/02386-icon-service-API-Proxy.svg",
      "tokens": [
        "API Proxy",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "02386",
        "icon",
        "service",
        "API",
        "Proxy",
        "svg",
        "apiproxy"
      ]
    },
    {
      "provider": "azure",
      "label": "App Compliance Automation",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03071-icon-service-App-Compliance-Automation.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03071-icon-service-App-Compliance-Automation.svg",
      "tokens": [
        "App Compliance Automation",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03071",
        "icon",
        "service",
        "App",
        "Compliance",
        "Automation",
        "svg",
        "appcomplianceautomation"
      ]
    },
    {
      "provider": "azure",
      "label": "App Configuration",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/10219-icon-service-App-Configuration.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/10219-icon-service-App-Configuration.svg",
      "tokens": [
        "App Configuration",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "10219",
        "icon",
        "service",
        "App",
        "Configuration",
        "svg",
        "appconfiguration"
      ]
    },
    {
      "provider": "azure",
      "label": "App Registrations",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/10232-icon-service-App-Registrations.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/10232-icon-service-App-Registrations.svg",
      "tokens": [
        "App Registrations",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "10232",
        "icon",
        "service",
        "App",
        "Registrations",
        "svg",
        "appregistrations"
      ]
    },
    {
      "provider": "azure",
      "label": "App Registrations",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/10232-icon-service-App-Registrations.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/10232-icon-service-App-Registrations.svg",
      "tokens": [
        "App Registrations",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "10232",
        "icon",
        "service",
        "App",
        "Registrations",
        "svg",
        "appregistrations"
      ]
    },
    {
      "provider": "azure",
      "label": "App Service Certificates",
      "category": "App Services",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/app-services/00049-icon-service-App-Service-Certificates.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/app services/00049-icon-service-App-Service-Certificates.svg",
      "tokens": [
        "App Service Certificates",
        "App Services",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "app",
        "services",
        "00049",
        "icon",
        "service",
        "App",
        "Certificates",
        "svg",
        "appservicecertificates",
        "appservices"
      ]
    },
    {
      "provider": "azure",
      "label": "App Service Certificates",
      "category": "Web",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/web/00049-icon-service-App-Service-Certificates.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/web/00049-icon-service-App-Service-Certificates.svg",
      "tokens": [
        "App Service Certificates",
        "Web",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "web",
        "00049",
        "icon",
        "service",
        "App",
        "Certificates",
        "svg",
        "appservicecertificates"
      ]
    },
    {
      "provider": "azure",
      "label": "App Service Domains",
      "category": "App Services",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/app-services/00050-icon-service-App-Service-Domains.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/app services/00050-icon-service-App-Service-Domains.svg",
      "tokens": [
        "App Service Domains",
        "App Services",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "app",
        "services",
        "00050",
        "icon",
        "service",
        "App",
        "Domains",
        "svg",
        "appservicedomains",
        "appservices"
      ]
    },
    {
      "provider": "azure",
      "label": "App Service Domains",
      "category": "Web",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/web/00050-icon-service-App-Service-Domains.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/web/00050-icon-service-App-Service-Domains.svg",
      "tokens": [
        "App Service Domains",
        "Web",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "web",
        "00050",
        "icon",
        "service",
        "App",
        "Domains",
        "svg",
        "appservicedomains"
      ]
    },
    {
      "provider": "azure",
      "label": "App Service Environments",
      "category": "App Services",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/app-services/10047-icon-service-App-Service-Environments.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/app services/10047-icon-service-App-Service-Environments.svg",
      "tokens": [
        "App Service Environments",
        "App Services",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "app",
        "services",
        "10047",
        "icon",
        "service",
        "App",
        "Environments",
        "svg",
        "appserviceenvironments",
        "appservices"
      ]
    },
    {
      "provider": "azure",
      "label": "App Service Environments",
      "category": "Web",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/web/10047-icon-service-App-Service-Environments.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/web/10047-icon-service-App-Service-Environments.svg",
      "tokens": [
        "App Service Environments",
        "Web",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "web",
        "10047",
        "icon",
        "service",
        "App",
        "Environments",
        "svg",
        "appserviceenvironments"
      ]
    },
    {
      "provider": "azure",
      "label": "App Service Plans",
      "category": "App Services",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/app-services/00046-icon-service-App-Service-Plans.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/app services/00046-icon-service-App-Service-Plans.svg",
      "tokens": [
        "App Service Plans",
        "App Services",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "app",
        "services",
        "00046",
        "icon",
        "service",
        "App",
        "Plans",
        "svg",
        "appserviceplans",
        "appservices"
      ]
    },
    {
      "provider": "azure",
      "label": "App Service Plans",
      "category": "Web",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/web/00046-icon-service-App-Service-Plans.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/web/00046-icon-service-App-Service-Plans.svg",
      "tokens": [
        "App Service Plans",
        "Web",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "web",
        "00046",
        "icon",
        "service",
        "App",
        "Plans",
        "svg",
        "appserviceplans"
      ]
    },
    {
      "provider": "azure",
      "label": "App Services",
      "category": "App Services",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/app-services/10035-icon-service-App-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/app services/10035-icon-service-App-Services.svg",
      "tokens": [
        "App Services",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "app",
        "services",
        "10035",
        "icon",
        "service",
        "App",
        "Services",
        "svg",
        "appservices"
      ]
    },
    {
      "provider": "azure",
      "label": "App Services",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/10035-icon-service-App-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/10035-icon-service-App-Services.svg",
      "tokens": [
        "App Services",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "10035",
        "icon",
        "service",
        "App",
        "Services",
        "svg",
        "appservices"
      ]
    },
    {
      "provider": "azure",
      "label": "App Services",
      "category": "Containers",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/containers/10035-icon-service-App-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/containers/10035-icon-service-App-Services.svg",
      "tokens": [
        "App Services",
        "Containers",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "containers",
        "10035",
        "icon",
        "service",
        "App",
        "Services",
        "svg",
        "appservices"
      ]
    },
    {
      "provider": "azure",
      "label": "App Services",
      "category": "Mobile",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/mobile/10035-icon-service-App-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/mobile/10035-icon-service-App-Services.svg",
      "tokens": [
        "App Services",
        "Mobile",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "mobile",
        "10035",
        "icon",
        "service",
        "App",
        "Services",
        "svg",
        "appservices"
      ]
    },
    {
      "provider": "azure",
      "label": "App Services",
      "category": "Web",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/web/10035-icon-service-App-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/web/10035-icon-service-App-Services.svg",
      "tokens": [
        "App Services",
        "Web",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "web",
        "10035",
        "icon",
        "service",
        "App",
        "Services",
        "svg",
        "appservices"
      ]
    },
    {
      "provider": "azure",
      "label": "App Space Component",
      "category": "Web",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/web/03595-icon-service-App-Space-Component.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/web/03595-icon-service-App-Space-Component.svg",
      "tokens": [
        "App Space Component",
        "Web",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "web",
        "03595",
        "icon",
        "service",
        "App",
        "Space",
        "Component",
        "svg",
        "appspacecomponent"
      ]
    },
    {
      "provider": "azure",
      "label": "App Space",
      "category": "Web",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/web/03397-icon-service-App-Space.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/web/03397-icon-service-App-Space.svg",
      "tokens": [
        "App Space",
        "Web",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "web",
        "03397",
        "icon",
        "service",
        "App",
        "Space",
        "svg",
        "appspace"
      ]
    },
    {
      "provider": "azure",
      "label": "Applens",
      "category": "Azure Ecosystem",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/azure-ecosystem/02354-icon-service-Applens.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/azure ecosystem/02354-icon-service-Applens.svg",
      "tokens": [
        "Applens",
        "Azure Ecosystem",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "azure",
        "ecosystem",
        "02354",
        "icon",
        "service",
        "svg",
        "applens",
        "azureecosystem"
      ]
    },
    {
      "provider": "azure",
      "label": "Application Gateway Containers",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/03328-icon-service-Application-Gateway-Containers.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/03328-icon-service-Application-Gateway-Containers.svg",
      "tokens": [
        "Application Gateway Containers",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "03328",
        "icon",
        "service",
        "Application",
        "Gateway",
        "Containers",
        "svg",
        "applicationgatewaycontainers"
      ]
    },
    {
      "provider": "azure",
      "label": "Application Gateways",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10076-icon-service-Application-Gateways.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10076-icon-service-Application-Gateways.svg",
      "tokens": [
        "Application Gateways",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10076",
        "icon",
        "service",
        "Application",
        "Gateways",
        "svg",
        "applicationgateways"
      ]
    },
    {
      "provider": "azure",
      "label": "Application Group",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/00329-icon-service-Application-Group.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/00329-icon-service-Application-Group.svg",
      "tokens": [
        "Application Group",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "00329",
        "icon",
        "service",
        "Application",
        "Group",
        "svg",
        "applicationgroup"
      ]
    },
    {
      "provider": "azure",
      "label": "Application Insights",
      "category": "Devops",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/devops/00012-icon-service-Application-Insights.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/devops/00012-icon-service-Application-Insights.svg",
      "tokens": [
        "Application Insights",
        "Devops",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "devops",
        "00012",
        "icon",
        "service",
        "Application",
        "Insights",
        "svg",
        "applicationinsights"
      ]
    },
    {
      "provider": "azure",
      "label": "Application Insights",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/00012-icon-service-Application-Insights.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/00012-icon-service-Application-Insights.svg",
      "tokens": [
        "Application Insights",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "00012",
        "icon",
        "service",
        "Application",
        "Insights",
        "svg",
        "applicationinsights",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Application Insights",
      "category": "Monitor",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/monitor/00012-icon-service-Application-Insights.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/monitor/00012-icon-service-Application-Insights.svg",
      "tokens": [
        "Application Insights",
        "Monitor",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "monitor",
        "00012",
        "icon",
        "service",
        "Application",
        "Insights",
        "svg",
        "applicationinsights"
      ]
    },
    {
      "provider": "azure",
      "label": "Application Security Groups",
      "category": "Security",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/security/10244-icon-service-Application-Security-Groups.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/security/10244-icon-service-Application-Security-Groups.svg",
      "tokens": [
        "Application Security Groups",
        "Security",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "security",
        "10244",
        "icon",
        "service",
        "Application",
        "Groups",
        "svg",
        "applicationsecuritygroups"
      ]
    },
    {
      "provider": "azure",
      "label": "Aquila",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02625-icon-service-Aquila.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02625-icon-service-Aquila.svg",
      "tokens": [
        "Aquila",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02625",
        "icon",
        "service",
        "svg",
        "aquila"
      ]
    },
    {
      "provider": "azure",
      "label": "Arc Data Services",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02356-icon-service-Arc-Data-services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02356-icon-service-Arc-Data-services.svg",
      "tokens": [
        "Arc Data Services",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02356",
        "icon",
        "service",
        "Arc",
        "Data",
        "services",
        "svg",
        "arcdataservices"
      ]
    },
    {
      "provider": "azure",
      "label": "Arc Kubernetes",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/01088-icon-service-Arc-Kubernetes.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/01088-icon-service-Arc-Kubernetes.svg",
      "tokens": [
        "Arc Kubernetes",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "01088",
        "icon",
        "service",
        "Arc",
        "Kubernetes",
        "svg",
        "arckubernetes"
      ]
    },
    {
      "provider": "azure",
      "label": "Arc Machines",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/01710-icon-service-Arc-Machines.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/01710-icon-service-Arc-Machines.svg",
      "tokens": [
        "Arc Machines",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "01710",
        "icon",
        "service",
        "Arc",
        "Machines",
        "svg",
        "arcmachines",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Arc Postgre SQL",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/01848-icon-service-Arc-PostgreSQL-.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/01848-icon-service-Arc-PostgreSQL .svg",
      "tokens": [
        "Arc Postgre SQL",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "01848",
        "icon",
        "service",
        "Arc",
        "PostgreSQL",
        "svg",
        "arcpostgresql"
      ]
    },
    {
      "provider": "azure",
      "label": "Arc SQL Managed Instance",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/01849-icon-service-Arc-SQL-Managed-Instance.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/01849-icon-service-Arc-SQL-Managed-Instance.svg",
      "tokens": [
        "Arc SQL Managed Instance",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "01849",
        "icon",
        "service",
        "Arc",
        "SQL",
        "Managed",
        "Instance",
        "svg",
        "arcsqlmanagedinstance"
      ]
    },
    {
      "provider": "azure",
      "label": "Arc SQL Server",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/01850-icon-service-Arc-SQL-Server.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/01850-icon-service-Arc-SQL-Server.svg",
      "tokens": [
        "Arc SQL Server",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "01850",
        "icon",
        "service",
        "Arc",
        "SQL",
        "Server",
        "svg",
        "arcsqlserver"
      ]
    },
    {
      "provider": "azure",
      "label": "ATM Multistack",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/03460-icon-service-ATM-Multistack.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/03460-icon-service-ATM-Multistack.svg",
      "tokens": [
        "ATM Multistack",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "03460",
        "icon",
        "service",
        "ATM",
        "Multistack",
        "svg",
        "atmmultistack"
      ]
    },
    {
      "provider": "azure",
      "label": "Auto Scale",
      "category": "Monitor",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/monitor/10832-icon-service-Auto-Scale.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/monitor/10832-icon-service-Auto-Scale.svg",
      "tokens": [
        "Auto Scale",
        "Monitor",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "monitor",
        "10832",
        "icon",
        "service",
        "Auto",
        "Scale",
        "svg",
        "autoscale"
      ]
    },
    {
      "provider": "azure",
      "label": "Automanaged VM",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/02112-icon-service-Automanaged-VM.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/02112-icon-service-Automanaged-VM.svg",
      "tokens": [
        "Automanaged VM",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "02112",
        "icon",
        "service",
        "Automanaged",
        "VM",
        "svg",
        "automanagedvm"
      ]
    },
    {
      "provider": "azure",
      "label": "Automation Accounts",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/00022-icon-service-Automation-Accounts.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/00022-icon-service-Automation-Accounts.svg",
      "tokens": [
        "Automation Accounts",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "00022",
        "icon",
        "service",
        "Automation",
        "Accounts",
        "svg",
        "automationaccounts",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Availability Sets",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/10025-icon-service-Availability-Sets.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/10025-icon-service-Availability-Sets.svg",
      "tokens": [
        "Availability Sets",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "10025",
        "icon",
        "service",
        "Availability",
        "Sets",
        "svg",
        "availabilitysets"
      ]
    },
    {
      "provider": "azure",
      "label": "AVS VM",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/01846-icon-service-AVS-VM.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/01846-icon-service-AVS-VM.svg",
      "tokens": [
        "AVS VM",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "01846",
        "icon",
        "service",
        "AVS",
        "VM",
        "svg",
        "avsvm"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure A",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/10018-icon-service-Azure-A.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/10018-icon-service-Azure-A.svg",
      "tokens": [
        "Azure A",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "10018",
        "icon",
        "service",
        "A",
        "svg",
        "azurea"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure AD B2 C",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/10228-icon-service-Azure-AD-B2C.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/10228-icon-service-Azure-AD-B2C.svg",
      "tokens": [
        "Azure AD B2 C",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "10228",
        "icon",
        "service",
        "AD",
        "B2C",
        "svg",
        "azureadb2c"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure API For FHIR",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/10212-icon-service-Azure-API-for-FHIR.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/10212-icon-service-Azure-API-for-FHIR.svg",
      "tokens": [
        "Azure API For FHIR",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "10212",
        "icon",
        "service",
        "API",
        "for",
        "FHIR",
        "svg",
        "azureapiforfhir"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure App Testing",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/033805167-icon-service-Azure-App-Testing.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/033805167-icon-service-Azure-App-Testing.svg",
      "tokens": [
        "Azure App Testing",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "033805167",
        "icon",
        "service",
        "App",
        "Testing",
        "svg",
        "azureapptesting",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Applied AI Services",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/02749-icon-service-Azure-Applied-AI-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/02749-icon-service-Azure-Applied-AI-Services.svg",
      "tokens": [
        "Azure Applied AI Services",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "02749",
        "icon",
        "service",
        "Applied",
        "AI",
        "Services",
        "svg",
        "azureappliedaiservices",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Arc",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/00756-icon-service-Azure-Arc.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/00756-icon-service-Azure-Arc.svg",
      "tokens": [
        "Azure Arc",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "00756",
        "icon",
        "service",
        "Arc",
        "svg",
        "azurearc",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Attestation",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/10422-icon-service-AzureAttestation.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/10422-icon-service-AzureAttestation.svg",
      "tokens": [
        "Azure Attestation",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "10422",
        "icon",
        "service",
        "AzureAttestation",
        "svg",
        "azureattestation"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Backup Center",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02360-icon-service-Azure-Backup-Center.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02360-icon-service-Azure-Backup-Center.svg",
      "tokens": [
        "Azure Backup Center",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02360",
        "icon",
        "service",
        "Backup",
        "Center",
        "svg",
        "azurebackupcenter"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Blockchain Service",
      "category": "Blockchain",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/blockchain/10366-icon-service-Azure-Blockchain-Service.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/blockchain/10366-icon-service-Azure-Blockchain-Service.svg",
      "tokens": [
        "Azure Blockchain Service",
        "Blockchain",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "blockchain",
        "10366",
        "icon",
        "service",
        "svg",
        "azureblockchainservice"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Center For SAP",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03090-icon-service-Azure-Center-for-SAP.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03090-icon-service-Azure-Center-for-SAP.svg",
      "tokens": [
        "Azure Center For SAP",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03090",
        "icon",
        "service",
        "Center",
        "for",
        "SAP",
        "svg",
        "azurecenterforsap"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Chaos Studio",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02223-icon-service-Azure-Chaos-Studio.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02223-icon-service-Azure-Chaos-Studio.svg",
      "tokens": [
        "Azure Chaos Studio",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02223",
        "icon",
        "service",
        "Chaos",
        "Studio",
        "svg",
        "azurechaosstudio"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Cloud Shell",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/00559-icon-service-Azure-Cloud-Shell.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/00559-icon-service-Azure-Cloud-Shell.svg",
      "tokens": [
        "Azure Cloud Shell",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "00559",
        "icon",
        "service",
        "Cloud",
        "Shell",
        "svg",
        "azurecloudshell"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Communication Services",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/00968-icon-service-Azure-Communication-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/00968-icon-service-Azure-Communication-Services.svg",
      "tokens": [
        "Azure Communication Services",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "00968",
        "icon",
        "service",
        "Communication",
        "Services",
        "svg",
        "azurecommunicationservices"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Communications Gateway",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/03311-icon-service-Azure-Communications-Gateway.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/03311-icon-service-Azure-Communications-Gateway.svg",
      "tokens": [
        "Azure Communications Gateway",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "03311",
        "icon",
        "service",
        "Communications",
        "Gateway",
        "svg",
        "azurecommunicationsgateway"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Compute Galleries",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/02864-icon-service-Azure-Compute-Galleries.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/02864-icon-service-Azure-Compute-Galleries.svg",
      "tokens": [
        "Azure Compute Galleries",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "02864",
        "icon",
        "service",
        "Galleries",
        "svg",
        "azurecomputegalleries"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Compute Galleries",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02864-icon-service-Azure-Compute-Galleries.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02864-icon-service-Azure-Compute-Galleries.svg",
      "tokens": [
        "Azure Compute Galleries",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02864",
        "icon",
        "service",
        "Compute",
        "Galleries",
        "svg",
        "azurecomputegalleries"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Consumption Commitment",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/03495-icon-service-Azure-Consumption-Commitment.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/03495-icon-service-Azure-Consumption-Commitment.svg",
      "tokens": [
        "Azure Consumption Commitment",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "03495",
        "icon",
        "service",
        "Consumption",
        "Commitment",
        "svg",
        "azureconsumptioncommitment",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Container Storage",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/03401-icon-service-Azure-Container-Storage.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/03401-icon-service-Azure-Container-Storage.svg",
      "tokens": [
        "Azure Container Storage",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "03401",
        "icon",
        "service",
        "Container",
        "Storage",
        "svg",
        "azurecontainerstorage",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Cosmos DB",
      "category": "Databases",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/databases/10121-icon-service-Azure-Cosmos-DB.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/databases/10121-icon-service-Azure-Cosmos-DB.svg",
      "tokens": [
        "Azure Cosmos DB",
        "Databases",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "databases",
        "10121",
        "icon",
        "service",
        "Cosmos",
        "DB",
        "svg",
        "azurecosmosdb"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Cosmos DB",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/10121-icon-service-Azure-Cosmos-DB.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/10121-icon-service-Azure-Cosmos-DB.svg",
      "tokens": [
        "Azure Cosmos DB",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "10121",
        "icon",
        "service",
        "Cosmos",
        "DB",
        "svg",
        "azurecosmosdb"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Data Catalog",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/10216-icon-service-Azure-Data-Catalog.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/10216-icon-service-Azure-Data-Catalog.svg",
      "tokens": [
        "Azure Data Catalog",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "10216",
        "icon",
        "service",
        "Data",
        "Catalog",
        "svg",
        "azuredatacatalog"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Data Explorer Clusters",
      "category": "Analytics",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/analytics/10145-icon-service-Azure-Data-Explorer-Clusters.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/analytics/10145-icon-service-Azure-Data-Explorer-Clusters.svg",
      "tokens": [
        "Azure Data Explorer Clusters",
        "Analytics",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "analytics",
        "10145",
        "icon",
        "service",
        "Data",
        "Explorer",
        "Clusters",
        "svg",
        "azuredataexplorerclusters"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Data Explorer Clusters",
      "category": "Databases",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/databases/10145-icon-service-Azure-Data-Explorer-Clusters.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/databases/10145-icon-service-Azure-Data-Explorer-Clusters.svg",
      "tokens": [
        "Azure Data Explorer Clusters",
        "Databases",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "databases",
        "10145",
        "icon",
        "service",
        "Data",
        "Explorer",
        "Clusters",
        "svg",
        "azuredataexplorerclusters"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Database Maria DB Server",
      "category": "Databases",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/databases/10123-icon-service-Azure-Database-MariaDB-Server.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/databases/10123-icon-service-Azure-Database-MariaDB-Server.svg",
      "tokens": [
        "Azure Database Maria DB Server",
        "Databases",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "databases",
        "10123",
        "icon",
        "service",
        "Database",
        "MariaDB",
        "Server",
        "svg",
        "azuredatabasemariadbserver"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Database Migration Services",
      "category": "Databases",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/databases/10133-icon-service-Azure-Database-Migration-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/databases/10133-icon-service-Azure-Database-Migration-Services.svg",
      "tokens": [
        "Azure Database Migration Services",
        "Databases",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "databases",
        "10133",
        "icon",
        "service",
        "Database",
        "Migration",
        "Services",
        "svg",
        "azuredatabasemigrationservices"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Database Migration Services",
      "category": "Migration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/migration/10133-icon-service-Azure-Database-Migration-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/migration/10133-icon-service-Azure-Database-Migration-Services.svg",
      "tokens": [
        "Azure Database Migration Services",
        "Migration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "migration",
        "10133",
        "icon",
        "service",
        "Database",
        "Services",
        "svg",
        "azuredatabasemigrationservices"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Database My SQL Server",
      "category": "Databases",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/databases/10122-icon-service-Azure-Database-MySQL-Server.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/databases/10122-icon-service-Azure-Database-MySQL-Server.svg",
      "tokens": [
        "Azure Database My SQL Server",
        "Databases",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "databases",
        "10122",
        "icon",
        "service",
        "Database",
        "MySQL",
        "Server",
        "svg",
        "azuredatabasemysqlserver"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Database Postgre SQL Server Group",
      "category": "Databases",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/databases/02827-icon-service-Azure-Database-PostgreSQL-Server-Group.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/databases/02827-icon-service-Azure-Database-PostgreSQL-Server-Group.svg",
      "tokens": [
        "Azure Database Postgre SQL Server Group",
        "Databases",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "databases",
        "02827",
        "icon",
        "service",
        "Database",
        "PostgreSQL",
        "Server",
        "Group",
        "svg",
        "azuredatabasepostgresqlservergroup"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Database Postgre SQL Server",
      "category": "Databases",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/databases/10131-icon-service-Azure-Database-PostgreSQL-Server.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/databases/10131-icon-service-Azure-Database-PostgreSQL-Server.svg",
      "tokens": [
        "Azure Database Postgre SQL Server",
        "Databases",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "databases",
        "10131",
        "icon",
        "service",
        "Database",
        "PostgreSQL",
        "Server",
        "svg",
        "azuredatabasepostgresqlserver"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Databox Gateway",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/00691-icon-service-Azure-Databox-Gateway.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/00691-icon-service-Azure-Databox-Gateway.svg",
      "tokens": [
        "Azure Databox Gateway",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "00691",
        "icon",
        "service",
        "Databox",
        "Gateway",
        "svg",
        "azuredataboxgateway"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Databox Gateway",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/00691-icon-service-Azure-Databox-Gateway.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/00691-icon-service-Azure-Databox-Gateway.svg",
      "tokens": [
        "Azure Databox Gateway",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "00691",
        "icon",
        "service",
        "Databox",
        "Gateway",
        "svg",
        "azuredataboxgateway"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Databox Gateway",
      "category": "Migrate",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/migrate/00691-icon-service-Azure-Databox-Gateway.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/migrate/00691-icon-service-Azure-Databox-Gateway.svg",
      "tokens": [
        "Azure Databox Gateway",
        "Migrate",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "migrate",
        "00691",
        "icon",
        "service",
        "Databox",
        "Gateway",
        "svg",
        "azuredataboxgateway"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Databox Gateway",
      "category": "Storage",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/storage/00691-icon-service-Azure-Databox-Gateway.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/storage/00691-icon-service-Azure-Databox-Gateway.svg",
      "tokens": [
        "Azure Databox Gateway",
        "Storage",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "storage",
        "00691",
        "icon",
        "service",
        "Databox",
        "Gateway",
        "svg",
        "azuredataboxgateway"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Databricks",
      "category": "Analytics",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/analytics/10787-icon-service-Azure-Databricks.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/analytics/10787-icon-service-Azure-Databricks.svg",
      "tokens": [
        "Azure Databricks",
        "Analytics",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "analytics",
        "10787",
        "icon",
        "service",
        "Databricks",
        "svg",
        "azuredatabricks"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Deployment Environments",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03251-icon-service-Azure-Deployment-Environments.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03251-icon-service-Azure-Deployment-Environments.svg",
      "tokens": [
        "Azure Deployment Environments",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03251",
        "icon",
        "service",
        "Deployment",
        "Environments",
        "svg",
        "azuredeploymentenvironments"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Dev Ops",
      "category": "Devops",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/devops/10261-icon-service-Azure-DevOps.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/devops/10261-icon-service-Azure-DevOps.svg",
      "tokens": [
        "Azure Dev Ops",
        "Devops",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "devops",
        "10261",
        "icon",
        "service",
        "DevOps",
        "svg",
        "azuredevops"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Dev Tunnels",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03308-icon-service-Azure-Dev-Tunnels.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03308-icon-service-Azure-Dev-Tunnels.svg",
      "tokens": [
        "Azure Dev Tunnels",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03308",
        "icon",
        "service",
        "Dev",
        "Tunnels",
        "svg",
        "azuredevtunnels"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Edge Hardware Center",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02810-icon-service-Azure-Edge-Hardware-Center.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02810-icon-service-Azure-Edge-Hardware-Center.svg",
      "tokens": [
        "Azure Edge Hardware Center",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02810",
        "icon",
        "service",
        "Edge",
        "Hardware",
        "Center",
        "svg",
        "azureedgehardwarecenter"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Experimentation Studio",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/01239-icon-service-Azure-Experimentation-Studio.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/01239-icon-service-Azure-Experimentation-Studio.svg",
      "tokens": [
        "Azure Experimentation Studio",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "01239",
        "icon",
        "service",
        "Experimentation",
        "Studio",
        "svg",
        "azureexperimentationstudio",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Fileshares",
      "category": "Storage",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/storage/10400-icon-service-Azure-Fileshares.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/storage/10400-icon-service-Azure-Fileshares.svg",
      "tokens": [
        "Azure Fileshares",
        "Storage",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "storage",
        "10400",
        "icon",
        "service",
        "Fileshares",
        "svg",
        "azurefileshares"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Firewall Manager",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/00271-icon-service-Azure-Firewall-Manager.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/00271-icon-service-Azure-Firewall-Manager.svg",
      "tokens": [
        "Azure Firewall Manager",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "00271",
        "icon",
        "service",
        "Firewall",
        "Manager",
        "svg",
        "azurefirewallmanager"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Firewall Policy",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/00272-icon-service-Azure-Firewall-Policy.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/00272-icon-service-Azure-Firewall-Policy.svg",
      "tokens": [
        "Azure Firewall Policy",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "00272",
        "icon",
        "service",
        "Firewall",
        "Policy",
        "svg",
        "azurefirewallpolicy"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure HCP Cache",
      "category": "Storage",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/storage/00776-icon-service-Azure-HCP-Cache.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/storage/00776-icon-service-Azure-HCP-Cache.svg",
      "tokens": [
        "Azure HCP Cache",
        "Storage",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "storage",
        "00776",
        "icon",
        "service",
        "HCP",
        "Cache",
        "svg",
        "azurehcpcache"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure HPC Workbenches",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02518-icon-service-Azure-HPC-Workbenches.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02518-icon-service-Azure-HPC-Workbenches.svg",
      "tokens": [
        "Azure HPC Workbenches",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02518",
        "icon",
        "service",
        "HPC",
        "Workbenches",
        "svg",
        "azurehpcworkbenches"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Hybrid Center",
      "category": "Azure Ecosystem",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/azure-ecosystem/02573-icon-service-Azure-Hybrid-Center.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/azure ecosystem/02573-icon-service-Azure-Hybrid-Center.svg",
      "tokens": [
        "Azure Hybrid Center",
        "Azure Ecosystem",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "azure",
        "ecosystem",
        "02573",
        "icon",
        "service",
        "Hybrid",
        "Center",
        "svg",
        "azurehybridcenter",
        "azureecosystem"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Information Protection",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/10229-icon-service-Azure-Information-Protection.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/10229-icon-service-Azure-Information-Protection.svg",
      "tokens": [
        "Azure Information Protection",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "10229",
        "icon",
        "service",
        "Information",
        "Protection",
        "svg",
        "azureinformationprotection"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Information Protection",
      "category": "Security",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/security/10229-icon-service-Azure-Information-Protection.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/security/10229-icon-service-Azure-Information-Protection.svg",
      "tokens": [
        "Azure Information Protection",
        "Security",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "security",
        "10229",
        "icon",
        "service",
        "Information",
        "Protection",
        "svg",
        "azureinformationprotection"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Io T Operations",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/03485-icon-service-Azure-IoT-Operations.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/03485-icon-service-Azure-IoT-Operations.svg",
      "tokens": [
        "Azure Io T Operations",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "03485",
        "icon",
        "service",
        "IoT",
        "Operations",
        "svg",
        "azureiotoperations"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Lighthouse",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/00471-icon-service-Azure-Lighthouse.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/00471-icon-service-Azure-Lighthouse.svg",
      "tokens": [
        "Azure Lighthouse",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "00471",
        "icon",
        "service",
        "Lighthouse",
        "svg",
        "azurelighthouse",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Linux",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/03645-icon-service-Azure-Linux.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/03645-icon-service-Azure-Linux.svg",
      "tokens": [
        "Azure Linux",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "03645",
        "icon",
        "service",
        "Linux",
        "svg",
        "azurelinux",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Load Testing",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02944-icon-service-Azure-Load-Testing.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02944-icon-service-Azure-Load-Testing.svg",
      "tokens": [
        "Azure Load Testing",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02944",
        "icon",
        "service",
        "Load",
        "Testing",
        "svg",
        "azureloadtesting"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Local",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/033745116-icon-service-Azure-Local.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/033745116-icon-service-Azure-Local.svg",
      "tokens": [
        "Azure Local",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "033745116",
        "icon",
        "service",
        "Local",
        "svg",
        "azurelocal",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Managed Grafana",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02905-icon-service-Azure-Managed-Grafana.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02905-icon-service-Azure-Managed-Grafana.svg",
      "tokens": [
        "Azure Managed Grafana",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02905",
        "icon",
        "service",
        "Managed",
        "Grafana",
        "svg",
        "azuremanagedgrafana"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Managed Redis",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/03675-icon-service-Azure-Managed-Redis.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/03675-icon-service-Azure-Managed-Redis.svg",
      "tokens": [
        "Azure Managed Redis",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "03675",
        "icon",
        "service",
        "Managed",
        "Redis",
        "svg",
        "azuremanagedredis",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Maps Accounts",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/10185-icon-service-Azure-Maps-Accounts.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/10185-icon-service-Azure-Maps-Accounts.svg",
      "tokens": [
        "Azure Maps Accounts",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "10185",
        "icon",
        "service",
        "Maps",
        "Accounts",
        "svg",
        "azuremapsaccounts"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Media Service",
      "category": "Web",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/web/10309-icon-service-Azure-Media-Service.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/web/10309-icon-service-Azure-Media-Service.svg",
      "tokens": [
        "Azure Media Service",
        "Web",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "web",
        "10309",
        "icon",
        "service",
        "Media",
        "svg",
        "azuremediaservice"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Migrate",
      "category": "Migrate",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/migrate/10281-icon-service-Azure-Migrate.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/migrate/10281-icon-service-Azure-Migrate.svg",
      "tokens": [
        "Azure Migrate",
        "Migrate",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "migrate",
        "10281",
        "icon",
        "service",
        "svg",
        "azuremigrate"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Monitor Dashboard",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02488-icon-service-Azure-Monitor-Dashboard.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02488-icon-service-Azure-Monitor-Dashboard.svg",
      "tokens": [
        "Azure Monitor Dashboard",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02488",
        "icon",
        "service",
        "Monitor",
        "Dashboard",
        "svg",
        "azuremonitordashboard"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Monitor Pipeline",
      "category": "Hybrid + Multicloud",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/hybrid-%2B-multicloud/03585-icon-service-Azure-Monitor-Pipeline.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/hybrid + multicloud/03585-icon-service-Azure-Monitor-Pipeline.svg",
      "tokens": [
        "Azure Monitor Pipeline",
        "Hybrid + Multicloud",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "hybrid",
        "+",
        "multicloud",
        "03585",
        "icon",
        "service",
        "Monitor",
        "Pipeline",
        "svg",
        "azuremonitorpipeline",
        "hybridmulticloud"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Monitors For SAP Solutions",
      "category": "Monitor",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/monitor/00438-icon-service-Azure-Monitors-for-SAP-Solutions.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/monitor/00438-icon-service-Azure-Monitors-for-SAP-Solutions.svg",
      "tokens": [
        "Azure Monitors For SAP Solutions",
        "Monitor",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "monitor",
        "00438",
        "icon",
        "service",
        "Monitors",
        "for",
        "SAP",
        "Solutions",
        "svg",
        "azuremonitorsforsapsolutions"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Net App Files",
      "category": "Storage",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/storage/10096-icon-service-Azure-NetApp-Files.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/storage/10096-icon-service-Azure-NetApp-Files.svg",
      "tokens": [
        "Azure Net App Files",
        "Storage",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "storage",
        "10096",
        "icon",
        "service",
        "NetApp",
        "Files",
        "svg",
        "azurenetappfiles"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Network Function Manager Functions",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/01001-icon-service-Azure-Network-Function-Manager-Functions.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/01001-icon-service-Azure-Network-Function-Manager-Functions.svg",
      "tokens": [
        "Azure Network Function Manager Functions",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "01001",
        "icon",
        "service",
        "Network",
        "Function",
        "Manager",
        "Functions",
        "svg",
        "azurenetworkfunctionmanagerfunctions"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Network Function Manager",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02740-icon-service-Azure-Network-Function-Manager.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02740-icon-service-Azure-Network-Function-Manager.svg",
      "tokens": [
        "Azure Network Function Manager",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02740",
        "icon",
        "service",
        "Network",
        "Function",
        "Manager",
        "svg",
        "azurenetworkfunctionmanager"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Object Understanding",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/01688-icon-service-Azure-Object-Understanding.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/01688-icon-service-Azure-Object-Understanding.svg",
      "tokens": [
        "Azure Object Understanding",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "01688",
        "icon",
        "service",
        "Object",
        "Understanding",
        "svg",
        "azureobjectunderstanding",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Open AI",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/03438-icon-service-Azure-OpenAI.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/03438-icon-service-Azure-OpenAI.svg",
      "tokens": [
        "Azure Open AI",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "03438",
        "icon",
        "service",
        "OpenAI",
        "svg",
        "azureopenai",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Operator 5 G Core",
      "category": "Hybrid + Multicloud",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/hybrid-%2B-multicloud/03248-icon-service-Azure-Operator-5G-Core.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/hybrid + multicloud/03248-icon-service-Azure-Operator-5G-Core.svg",
      "tokens": [
        "Azure Operator 5 G Core",
        "Hybrid + Multicloud",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "hybrid",
        "+",
        "multicloud",
        "03248",
        "icon",
        "service",
        "Operator",
        "5G",
        "Core",
        "svg",
        "azureoperator5gcore",
        "hybridmulticloud"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Operator Insights",
      "category": "Hybrid + Multicloud",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/hybrid-%2B-multicloud/03333-icon-service-Azure-Operator-Insights.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/hybrid + multicloud/03333-icon-service-Azure-Operator-Insights.svg",
      "tokens": [
        "Azure Operator Insights",
        "Hybrid + Multicloud",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "hybrid",
        "+",
        "multicloud",
        "03333",
        "icon",
        "service",
        "Operator",
        "Insights",
        "svg",
        "azureoperatorinsights",
        "hybridmulticloud"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Operator Nexus",
      "category": "Hybrid + Multicloud",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/hybrid-%2B-multicloud/03324-icon-service-Azure-Operator-Nexus.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/hybrid + multicloud/03324-icon-service-Azure-Operator-Nexus.svg",
      "tokens": [
        "Azure Operator Nexus",
        "Hybrid + Multicloud",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "hybrid",
        "+",
        "multicloud",
        "03324",
        "icon",
        "service",
        "Operator",
        "Nexus",
        "svg",
        "azureoperatornexus",
        "hybridmulticloud"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Operator Service Manager",
      "category": "Hybrid + Multicloud",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/hybrid-%2B-multicloud/03334-icon-service-Azure-Operator-Service-Manager.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/hybrid + multicloud/03334-icon-service-Azure-Operator-Service-Manager.svg",
      "tokens": [
        "Azure Operator Service Manager",
        "Hybrid + Multicloud",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "hybrid",
        "+",
        "multicloud",
        "03334",
        "icon",
        "service",
        "Operator",
        "Manager",
        "svg",
        "azureoperatorservicemanager",
        "hybridmulticloud"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Orbital",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02697-icon-service-Azure-Orbital.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02697-icon-service-Azure-Orbital.svg",
      "tokens": [
        "Azure Orbital",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02697",
        "icon",
        "service",
        "Orbital",
        "svg",
        "azureorbital"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Programmable Connectivity",
      "category": "Hybrid + Multicloud",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/hybrid-%2B-multicloud/03347-icon-service-Azure-Programmable-Connectivity.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/hybrid + multicloud/03347-icon-service-Azure-Programmable-Connectivity.svg",
      "tokens": [
        "Azure Programmable Connectivity",
        "Hybrid + Multicloud",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "hybrid",
        "+",
        "multicloud",
        "03347",
        "icon",
        "service",
        "Programmable",
        "Connectivity",
        "svg",
        "azureprogrammableconnectivity",
        "hybridmulticloud"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Quotas",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02951-icon-service-Azure-Quotas.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02951-icon-service-Azure-Quotas.svg",
      "tokens": [
        "Azure Quotas",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02951",
        "icon",
        "service",
        "Quotas",
        "svg",
        "azurequotas"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Red Hat Open Shift",
      "category": "Containers",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/containers/03331-icon-service-Azure-Red-Hat-OpenShift.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/containers/03331-icon-service-Azure-Red-Hat-OpenShift.svg",
      "tokens": [
        "Azure Red Hat Open Shift",
        "Containers",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "containers",
        "03331",
        "icon",
        "service",
        "Red",
        "Hat",
        "OpenShift",
        "svg",
        "azureredhatopenshift"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Sentinel",
      "category": "Security",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/security/10248-icon-service-Azure-Sentinel.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/security/10248-icon-service-Azure-Sentinel.svg",
      "tokens": [
        "Azure Sentinel",
        "Security",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "security",
        "10248",
        "icon",
        "service",
        "Sentinel",
        "svg",
        "azuresentinel"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Service Bus",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/10836-icon-service-Azure-Service-Bus.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/10836-icon-service-Azure-Service-Bus.svg",
      "tokens": [
        "Azure Service Bus",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "10836",
        "icon",
        "service",
        "Bus",
        "svg",
        "azureservicebus"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Sphere",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/10190-icon-service-Azure-Sphere.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/10190-icon-service-Azure-Sphere.svg",
      "tokens": [
        "Azure Sphere",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "10190",
        "icon",
        "service",
        "Sphere",
        "svg",
        "azuresphere"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Spring Apps",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/10370-icon-service-Azure-Spring-Apps.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/10370-icon-service-Azure-Spring-Apps.svg",
      "tokens": [
        "Azure Spring Apps",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "10370",
        "icon",
        "service",
        "Spring",
        "Apps",
        "svg",
        "azurespringapps"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Spring Apps",
      "category": "Web",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/web/10370-icon-service-Azure-Spring-Apps.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/web/10370-icon-service-Azure-Spring-Apps.svg",
      "tokens": [
        "Azure Spring Apps",
        "Web",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "web",
        "10370",
        "icon",
        "service",
        "Spring",
        "Apps",
        "svg",
        "azurespringapps"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure SQL Edge",
      "category": "Databases",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/databases/02750-icon-service-Azure-SQL-Edge.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/databases/02750-icon-service-Azure-SQL-Edge.svg",
      "tokens": [
        "Azure SQL Edge",
        "Databases",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "databases",
        "02750",
        "icon",
        "service",
        "SQL",
        "Edge",
        "svg",
        "azuresqledge"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure SQL Server Stretch Databases",
      "category": "Databases",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/databases/10137-icon-service-Azure-SQL-Server-Stretch-Databases.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/databases/10137-icon-service-Azure-SQL-Server-Stretch-Databases.svg",
      "tokens": [
        "Azure SQL Server Stretch Databases",
        "Databases",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "databases",
        "10137",
        "icon",
        "service",
        "SQL",
        "Server",
        "Stretch",
        "svg",
        "azuresqlserverstretchdatabases"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure SQL Server Stretch Databases",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/10137-icon-service-Azure-SQL-Server-Stretch-Databases.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/10137-icon-service-Azure-SQL-Server-Stretch-Databases.svg",
      "tokens": [
        "Azure SQL Server Stretch Databases",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "10137",
        "icon",
        "service",
        "SQL",
        "Server",
        "Stretch",
        "Databases",
        "svg",
        "azuresqlserverstretchdatabases"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure SQL VM",
      "category": "Databases",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/databases/10124-icon-service-Azure-SQL-VM.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/databases/10124-icon-service-Azure-SQL-VM.svg",
      "tokens": [
        "Azure SQL VM",
        "Databases",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "databases",
        "10124",
        "icon",
        "service",
        "SQL",
        "VM",
        "svg",
        "azuresqlvm"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure SQL",
      "category": "Databases",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/databases/02390-icon-service-Azure-SQL.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/databases/02390-icon-service-Azure-SQL.svg",
      "tokens": [
        "Azure SQL",
        "Databases",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "databases",
        "02390",
        "icon",
        "service",
        "SQL",
        "svg",
        "azuresql"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Stack Edge",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/10095-icon-service-Azure-Stack-Edge.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/10095-icon-service-Azure-Stack-Edge.svg",
      "tokens": [
        "Azure Stack Edge",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "10095",
        "icon",
        "service",
        "Stack",
        "Edge",
        "svg",
        "azurestackedge"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Stack Edge",
      "category": "Migrate",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/migrate/10095-icon-service-Azure-Stack-Edge.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/migrate/10095-icon-service-Azure-Stack-Edge.svg",
      "tokens": [
        "Azure Stack Edge",
        "Migrate",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "migrate",
        "10095",
        "icon",
        "service",
        "Stack",
        "Edge",
        "svg",
        "azurestackedge"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Stack Edge",
      "category": "Storage",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/storage/10095-icon-service-Azure-Stack-Edge.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/storage/10095-icon-service-Azure-Stack-Edge.svg",
      "tokens": [
        "Azure Stack Edge",
        "Storage",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "storage",
        "10095",
        "icon",
        "service",
        "Stack",
        "Edge",
        "svg",
        "azurestackedge"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Stack HCI Sizer",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/03293-icon-service-Azure-Stack-HCI-Sizer.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/03293-icon-service-Azure-Stack-HCI-Sizer.svg",
      "tokens": [
        "Azure Stack HCI Sizer",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "03293",
        "icon",
        "service",
        "Stack",
        "HCI",
        "Sizer",
        "svg",
        "azurestackhcisizer"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Stack",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/10114-icon-service-Azure-Stack.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/10114-icon-service-Azure-Stack.svg",
      "tokens": [
        "Azure Stack",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "10114",
        "icon",
        "service",
        "Stack",
        "svg",
        "azurestack"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Storage Mover",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03091-icon-service-Azure-Storage-Mover.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03091-icon-service-Azure-Storage-Mover.svg",
      "tokens": [
        "Azure Storage Mover",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03091",
        "icon",
        "service",
        "Storage",
        "Mover",
        "svg",
        "azurestoragemover"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Support Center Blue",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02507-icon-service-Azure-Support-Center-Blue.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02507-icon-service-Azure-Support-Center-Blue.svg",
      "tokens": [
        "Azure Support Center Blue",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02507",
        "icon",
        "service",
        "Support",
        "Center",
        "Blue",
        "svg",
        "azuresupportcenterblue"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Sustainability",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03314-icon-service-Azure-Sustainability.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03314-icon-service-Azure-Sustainability.svg",
      "tokens": [
        "Azure Sustainability",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03314",
        "icon",
        "service",
        "Sustainability",
        "svg",
        "azuresustainability"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Synapse Analytics",
      "category": "Analytics",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/analytics/00606-icon-service-Azure-Synapse-Analytics.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/analytics/00606-icon-service-Azure-Synapse-Analytics.svg",
      "tokens": [
        "Azure Synapse Analytics",
        "Analytics",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "analytics",
        "00606",
        "icon",
        "service",
        "Synapse",
        "svg",
        "azuresynapseanalytics"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Synapse Analytics",
      "category": "Databases",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/databases/00606-icon-service-Azure-Synapse-Analytics.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/databases/00606-icon-service-Azure-Synapse-Analytics.svg",
      "tokens": [
        "Azure Synapse Analytics",
        "Databases",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "databases",
        "00606",
        "icon",
        "service",
        "Synapse",
        "Analytics",
        "svg",
        "azuresynapseanalytics"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Token Service",
      "category": "Blockchain",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/blockchain/10367-icon-service-Azure-Token-Service.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/blockchain/10367-icon-service-Azure-Token-Service.svg",
      "tokens": [
        "Azure Token Service",
        "Blockchain",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "blockchain",
        "10367",
        "icon",
        "service",
        "Token",
        "svg",
        "azuretokenservice"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure V Mware Solution",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/01219-icon-service-Azure-VMware-Solution.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/01219-icon-service-Azure-VMware-Solution.svg",
      "tokens": [
        "Azure V Mware Solution",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "01219",
        "icon",
        "service",
        "VMware",
        "Solution",
        "svg",
        "azurevmwaresolution"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Video Indexer",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/01800-icon-service-Azure-Video-Indexer.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/01800-icon-service-Azure-Video-Indexer.svg",
      "tokens": [
        "Azure Video Indexer",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "01800",
        "icon",
        "service",
        "Video",
        "Indexer",
        "svg",
        "azurevideoindexer"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Virtual Desktop",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/00327-icon-service-Azure-Virtual-Desktop.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/00327-icon-service-Azure-Virtual-Desktop.svg",
      "tokens": [
        "Azure Virtual Desktop",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "00327",
        "icon",
        "service",
        "Virtual",
        "Desktop",
        "svg",
        "azurevirtualdesktop"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Workbooks",
      "category": "Analytics",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/analytics/02189-icon-service-Azure-Workbooks.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/analytics/02189-icon-service-Azure-Workbooks.svg",
      "tokens": [
        "Azure Workbooks",
        "Analytics",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "analytics",
        "02189",
        "icon",
        "service",
        "Workbooks",
        "svg",
        "azureworkbooks"
      ]
    },
    {
      "provider": "azure",
      "label": "Azure Workbooks",
      "category": "Monitor",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/monitor/02189-icon-service-Azure-Workbooks.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/monitor/02189-icon-service-Azure-Workbooks.svg",
      "tokens": [
        "Azure Workbooks",
        "Monitor",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "monitor",
        "02189",
        "icon",
        "service",
        "Workbooks",
        "svg",
        "azureworkbooks"
      ]
    },
    {
      "provider": "azure",
      "label": "Azurite",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02842-icon-service-Azurite.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02842-icon-service-Azurite.svg",
      "tokens": [
        "Azurite",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02842",
        "icon",
        "service",
        "svg",
        "azurite"
      ]
    },
    {
      "provider": "azure",
      "label": "Backlog",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10853-icon-service-Backlog.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10853-icon-service-Backlog.svg",
      "tokens": [
        "Backlog",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10853",
        "icon",
        "service",
        "svg",
        "backlog"
      ]
    },
    {
      "provider": "azure",
      "label": "Backup Vault",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02361-icon-service-Backup-Vault.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02361-icon-service-Backup-Vault.svg",
      "tokens": [
        "Backup Vault",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02361",
        "icon",
        "service",
        "Backup",
        "Vault",
        "svg",
        "backupvault"
      ]
    },
    {
      "provider": "azure",
      "label": "Bare Metal Infrastructure",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02561-icon-service-Bare-Metal-Infrastructure.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02561-icon-service-Bare-Metal-Infrastructure.svg",
      "tokens": [
        "Bare Metal Infrastructure",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02561",
        "icon",
        "service",
        "Bare",
        "Metal",
        "Infrastructure",
        "svg",
        "baremetalinfrastructure"
      ]
    },
    {
      "provider": "azure",
      "label": "Bastions",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/02422-icon-service-Bastions.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/02422-icon-service-Bastions.svg",
      "tokens": [
        "Bastions",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "02422",
        "icon",
        "service",
        "svg",
        "bastions"
      ]
    },
    {
      "provider": "azure",
      "label": "Batch Accounts",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/10031-icon-service-Batch-Accounts.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/10031-icon-service-Batch-Accounts.svg",
      "tokens": [
        "Batch Accounts",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "10031",
        "icon",
        "service",
        "Batch",
        "Accounts",
        "svg",
        "batchaccounts"
      ]
    },
    {
      "provider": "azure",
      "label": "Batch Accounts",
      "category": "Containers",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/containers/10031-icon-service-Batch-Accounts.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/containers/10031-icon-service-Batch-Accounts.svg",
      "tokens": [
        "Batch Accounts",
        "Containers",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "containers",
        "10031",
        "icon",
        "service",
        "Batch",
        "Accounts",
        "svg",
        "batchaccounts"
      ]
    },
    {
      "provider": "azure",
      "label": "Batch AI",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/00028-icon-service-Batch-AI.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/00028-icon-service-Batch-AI.svg",
      "tokens": [
        "Batch AI",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "00028",
        "icon",
        "service",
        "Batch",
        "AI",
        "svg",
        "batchai",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Biz Talk",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10779-icon-service-Biz-Talk.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10779-icon-service-Biz-Talk.svg",
      "tokens": [
        "Biz Talk",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10779",
        "icon",
        "service",
        "Biz",
        "Talk",
        "svg",
        "biztalk"
      ]
    },
    {
      "provider": "azure",
      "label": "Blob Block",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10780-icon-service-Blob-Block.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10780-icon-service-Blob-Block.svg",
      "tokens": [
        "Blob Block",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10780",
        "icon",
        "service",
        "Blob",
        "Block",
        "svg",
        "blobblock"
      ]
    },
    {
      "provider": "azure",
      "label": "Blob Page",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10781-icon-service-Blob-Page.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10781-icon-service-Blob-Page.svg",
      "tokens": [
        "Blob Page",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10781",
        "icon",
        "service",
        "Blob",
        "Page",
        "svg",
        "blobpage"
      ]
    },
    {
      "provider": "azure",
      "label": "Blockchain Applications",
      "category": "Blockchain",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/blockchain/10210-icon-service-Blockchain-Applications.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/blockchain/10210-icon-service-Blockchain-Applications.svg",
      "tokens": [
        "Blockchain Applications",
        "Blockchain",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "blockchain",
        "10210",
        "icon",
        "service",
        "Applications",
        "svg",
        "blockchainapplications"
      ]
    },
    {
      "provider": "azure",
      "label": "Blueprints",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/00006-icon-service-Blueprints.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/00006-icon-service-Blueprints.svg",
      "tokens": [
        "Blueprints",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "00006",
        "icon",
        "service",
        "svg",
        "blueprints",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Bonsai",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/03337-icon-service-Bonsai.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/03337-icon-service-Bonsai.svg",
      "tokens": [
        "Bonsai",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "03337",
        "icon",
        "service",
        "svg",
        "bonsai",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Bot Services",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/10165-icon-service-Bot-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/10165-icon-service-Bot-Services.svg",
      "tokens": [
        "Bot Services",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "10165",
        "icon",
        "service",
        "Bot",
        "Services",
        "svg",
        "botservices",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Branch",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10782-icon-service-Branch.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10782-icon-service-Branch.svg",
      "tokens": [
        "Branch",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10782",
        "icon",
        "service",
        "svg",
        "branch"
      ]
    },
    {
      "provider": "azure",
      "label": "Breeze",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/03633-icon-service-Breeze.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/03633-icon-service-Breeze.svg",
      "tokens": [
        "Breeze",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "03633",
        "icon",
        "service",
        "svg",
        "breeze",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Browser",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10783-icon-service-Browser.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10783-icon-service-Browser.svg",
      "tokens": [
        "Browser",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10783",
        "icon",
        "service",
        "svg",
        "browser"
      ]
    },
    {
      "provider": "azure",
      "label": "Bug",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10784-icon-service-Bug.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10784-icon-service-Bug.svg",
      "tokens": [
        "Bug",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10784",
        "icon",
        "service",
        "svg",
        "bug"
      ]
    },
    {
      "provider": "azure",
      "label": "Builds",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10785-icon-service-Builds.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10785-icon-service-Builds.svg",
      "tokens": [
        "Builds",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10785",
        "icon",
        "service",
        "svg",
        "builds"
      ]
    },
    {
      "provider": "azure",
      "label": "Business Process Tracking",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/03637-icon-service-Business-Process-Tracking.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/03637-icon-service-Business-Process-Tracking.svg",
      "tokens": [
        "Business Process Tracking",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "03637",
        "icon",
        "service",
        "Business",
        "Process",
        "Tracking",
        "svg",
        "businessprocesstracking"
      ]
    },
    {
      "provider": "azure",
      "label": "Cache Redis",
      "category": "Databases",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/databases/10137-icon-service-Cache-Redis.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/databases/10137-icon-service-Cache-Redis.svg",
      "tokens": [
        "Cache Redis",
        "Databases",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "databases",
        "10137",
        "icon",
        "service",
        "Cache",
        "Redis",
        "svg",
        "cacheredis"
      ]
    },
    {
      "provider": "azure",
      "label": "Cache",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10786-icon-service-Cache.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10786-icon-service-Cache.svg",
      "tokens": [
        "Cache",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10786",
        "icon",
        "service",
        "svg",
        "cache"
      ]
    },
    {
      "provider": "azure",
      "label": "Capacity Reservation Groups",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02732-icon-service-Capacity-Reservation-Groups.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02732-icon-service-Capacity-Reservation-Groups.svg",
      "tokens": [
        "Capacity Reservation Groups",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02732",
        "icon",
        "service",
        "Capacity",
        "Reservation",
        "Groups",
        "svg",
        "capacityreservationgroups"
      ]
    },
    {
      "provider": "azure",
      "label": "Capacity",
      "category": "Azure Stack",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/azure-stack/10109-icon-service-Capacity.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/azure stack/10109-icon-service-Capacity.svg",
      "tokens": [
        "Capacity",
        "Azure Stack",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "azure",
        "stack",
        "10109",
        "icon",
        "service",
        "svg",
        "capacity",
        "azurestack"
      ]
    },
    {
      "provider": "azure",
      "label": "CDN Profiles",
      "category": "App Services",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/app-services/00056-icon-service-CDN-Profiles.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/app services/00056-icon-service-CDN-Profiles.svg",
      "tokens": [
        "CDN Profiles",
        "App Services",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "app",
        "services",
        "00056",
        "icon",
        "service",
        "CDN",
        "Profiles",
        "svg",
        "cdnprofiles",
        "appservices"
      ]
    },
    {
      "provider": "azure",
      "label": "CDN Profiles",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/00056-icon-service-CDN-Profiles.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/00056-icon-service-CDN-Profiles.svg",
      "tokens": [
        "CDN Profiles",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "00056",
        "icon",
        "service",
        "CDN",
        "Profiles",
        "svg",
        "cdnprofiles"
      ]
    },
    {
      "provider": "azure",
      "label": "Central Service Instance For SAP",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03092-icon-service-Central-Service-Instance-For-SAP.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03092-icon-service-Central-Service-Instance-For-SAP.svg",
      "tokens": [
        "Central Service Instance For SAP",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03092",
        "icon",
        "service",
        "Central",
        "Instance",
        "For",
        "SAP",
        "svg",
        "centralserviceinstanceforsap"
      ]
    },
    {
      "provider": "azure",
      "label": "Ceres",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02828-icon-service-Ceres.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02828-icon-service-Ceres.svg",
      "tokens": [
        "Ceres",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02828",
        "icon",
        "service",
        "svg",
        "ceres"
      ]
    },
    {
      "provider": "azure",
      "label": "Change Analysis",
      "category": "Devops",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/devops/00563-icon-service-Change-Analysis.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/devops/00563-icon-service-Change-Analysis.svg",
      "tokens": [
        "Change Analysis",
        "Devops",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "devops",
        "00563",
        "icon",
        "service",
        "Change",
        "Analysis",
        "svg",
        "changeanalysis"
      ]
    },
    {
      "provider": "azure",
      "label": "Change Analysis",
      "category": "Monitor",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/monitor/00563-icon-service-Change-Analysis.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/monitor/00563-icon-service-Change-Analysis.svg",
      "tokens": [
        "Change Analysis",
        "Monitor",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "monitor",
        "00563",
        "icon",
        "service",
        "Change",
        "Analysis",
        "svg",
        "changeanalysis"
      ]
    },
    {
      "provider": "azure",
      "label": "Client Apps",
      "category": "Intune",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/intune/10331-icon-service-Client-Apps.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/intune/10331-icon-service-Client-Apps.svg",
      "tokens": [
        "Client Apps",
        "Intune",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "intune",
        "10331",
        "icon",
        "service",
        "Client",
        "Apps",
        "svg",
        "clientapps"
      ]
    },
    {
      "provider": "azure",
      "label": "Cloud Services (Classic)",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/10030-icon-service-Cloud-Services-(Classic).svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/10030-icon-service-Cloud-Services-(Classic).svg",
      "tokens": [
        "Cloud Services (Classic)",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "10030",
        "icon",
        "service",
        "Cloud",
        "Services",
        "(Classic)",
        "svg",
        "cloudservicesclassic"
      ]
    },
    {
      "provider": "azure",
      "label": "Cloud Services (extended Support)",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02505-icon-service-Cloud-Services-(extended-support).svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02505-icon-service-Cloud-Services-(extended-support).svg",
      "tokens": [
        "Cloud Services (extended Support)",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02505",
        "icon",
        "service",
        "Cloud",
        "Services",
        "(extended",
        "support)",
        "svg",
        "cloudservicesextendedsupport"
      ]
    },
    {
      "provider": "azure",
      "label": "Cloud Test",
      "category": "Devops",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/devops/02373-icon-service-CloudTest.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/devops/02373-icon-service-CloudTest.svg",
      "tokens": [
        "Cloud Test",
        "Devops",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "devops",
        "02373",
        "icon",
        "service",
        "CloudTest",
        "svg",
        "cloudtest"
      ]
    },
    {
      "provider": "azure",
      "label": "Code Optimization",
      "category": "Devops",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/devops/03455-icon-service-Code-Optimization.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/devops/03455-icon-service-Code-Optimization.svg",
      "tokens": [
        "Code Optimization",
        "Devops",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "devops",
        "03455",
        "icon",
        "service",
        "Code",
        "Optimization",
        "svg",
        "codeoptimization"
      ]
    },
    {
      "provider": "azure",
      "label": "Code",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10787-icon-service-Code.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10787-icon-service-Code.svg",
      "tokens": [
        "Code",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10787",
        "icon",
        "service",
        "svg",
        "code"
      ]
    },
    {
      "provider": "azure",
      "label": "Cognitive Search",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/10044-icon-service-Cognitive-Search.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/10044-icon-service-Cognitive-Search.svg",
      "tokens": [
        "Cognitive Search",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "10044",
        "icon",
        "service",
        "Cognitive",
        "Search",
        "svg",
        "cognitivesearch",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Cognitive Search",
      "category": "App Services",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/app-services/10044-icon-service-Cognitive-Search.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/app services/10044-icon-service-Cognitive-Search.svg",
      "tokens": [
        "Cognitive Search",
        "App Services",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "app",
        "services",
        "10044",
        "icon",
        "service",
        "Cognitive",
        "Search",
        "svg",
        "cognitivesearch",
        "appservices"
      ]
    },
    {
      "provider": "azure",
      "label": "Cognitive Search",
      "category": "Web",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/web/10044-icon-service-Cognitive-Search.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/web/10044-icon-service-Cognitive-Search.svg",
      "tokens": [
        "Cognitive Search",
        "Web",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "web",
        "10044",
        "icon",
        "service",
        "Cognitive",
        "Search",
        "svg",
        "cognitivesearch"
      ]
    },
    {
      "provider": "azure",
      "label": "Cognitive Services Decisions",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/03173-icon-service-Cognitive-Services-Decisions.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/03173-icon-service-Cognitive-Services-Decisions.svg",
      "tokens": [
        "Cognitive Services Decisions",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "03173",
        "icon",
        "service",
        "Cognitive",
        "Services",
        "Decisions",
        "svg",
        "cognitiveservicesdecisions",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Cognitive Services",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/10162-icon-service-Cognitive-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/10162-icon-service-Cognitive-Services.svg",
      "tokens": [
        "Cognitive Services",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "10162",
        "icon",
        "service",
        "Cognitive",
        "Services",
        "svg",
        "cognitiveservices",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Cognitive Services",
      "category": "Web",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/web/10162-icon-service-Cognitive-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/web/10162-icon-service-Cognitive-Services.svg",
      "tokens": [
        "Cognitive Services",
        "Web",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "web",
        "10162",
        "icon",
        "service",
        "Cognitive",
        "Services",
        "svg",
        "cognitiveservices"
      ]
    },
    {
      "provider": "azure",
      "label": "Collaborative Service",
      "category": "Azure Ecosystem",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/azure-ecosystem/01038-icon-service-Collaborative-Service.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/azure ecosystem/01038-icon-service-Collaborative-Service.svg",
      "tokens": [
        "Collaborative Service",
        "Azure Ecosystem",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "azure",
        "ecosystem",
        "01038",
        "icon",
        "service",
        "Collaborative",
        "svg",
        "collaborativeservice",
        "azureecosystem"
      ]
    },
    {
      "provider": "azure",
      "label": "Commit",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10788-icon-service-Commit.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10788-icon-service-Commit.svg",
      "tokens": [
        "Commit",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10788",
        "icon",
        "service",
        "svg",
        "commit"
      ]
    },
    {
      "provider": "azure",
      "label": "Community Images",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02865-icon-service-Community-Images.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02865-icon-service-Community-Images.svg",
      "tokens": [
        "Community Images",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02865",
        "icon",
        "service",
        "Community",
        "Images",
        "svg",
        "communityimages"
      ]
    },
    {
      "provider": "azure",
      "label": "Compliance Center",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02931-icon-service-Compliance-Center.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02931-icon-service-Compliance-Center.svg",
      "tokens": [
        "Compliance Center",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02931",
        "icon",
        "service",
        "Compliance",
        "Center",
        "svg",
        "compliancecenter"
      ]
    },
    {
      "provider": "azure",
      "label": "Compliance",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/00011-icon-service-Compliance.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/00011-icon-service-Compliance.svg",
      "tokens": [
        "Compliance",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "00011",
        "icon",
        "service",
        "svg",
        "compliance",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Compute Fleet",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/03487-icon-service-Compute-Fleet.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/03487-icon-service-Compute-Fleet.svg",
      "tokens": [
        "Compute Fleet",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "03487",
        "icon",
        "service",
        "Fleet",
        "svg",
        "computefleet"
      ]
    },
    {
      "provider": "azure",
      "label": "Computer Vision",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/00792-icon-service-Computer-Vision.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/00792-icon-service-Computer-Vision.svg",
      "tokens": [
        "Computer Vision",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "00792",
        "icon",
        "service",
        "Computer",
        "Vision",
        "svg",
        "computervision",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Conditional Access",
      "category": "Security",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/security/10233-icon-service-Conditional-Access.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/security/10233-icon-service-Conditional-Access.svg",
      "tokens": [
        "Conditional Access",
        "Security",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "security",
        "10233",
        "icon",
        "service",
        "Conditional",
        "Access",
        "svg",
        "conditionalaccess"
      ]
    },
    {
      "provider": "azure",
      "label": "Confidential Ledgers",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02668-icon-service-Confidential-Ledgers.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02668-icon-service-Confidential-Ledgers.svg",
      "tokens": [
        "Confidential Ledgers",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02668",
        "icon",
        "service",
        "Confidential",
        "Ledgers",
        "svg",
        "confidentialledgers"
      ]
    },
    {
      "provider": "azure",
      "label": "Connected Cache",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/02509-icon-service-Connected-Cache.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/02509-icon-service-Connected-Cache.svg",
      "tokens": [
        "Connected Cache",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "02509",
        "icon",
        "service",
        "Connected",
        "Cache",
        "svg",
        "connectedcache"
      ]
    },
    {
      "provider": "azure",
      "label": "Connected Vehicle Platform",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02573-icon-service-Connected-Vehicle-Platform.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02573-icon-service-Connected-Vehicle-Platform.svg",
      "tokens": [
        "Connected Vehicle Platform",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02573",
        "icon",
        "service",
        "Connected",
        "Vehicle",
        "Platform",
        "svg",
        "connectedvehicleplatform"
      ]
    },
    {
      "provider": "azure",
      "label": "Connections",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10081-icon-service-Connections.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10081-icon-service-Connections.svg",
      "tokens": [
        "Connections",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10081",
        "icon",
        "service",
        "svg",
        "connections"
      ]
    },
    {
      "provider": "azure",
      "label": "Consortium",
      "category": "Blockchain",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/blockchain/10375-icon-service-Consortium.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/blockchain/10375-icon-service-Consortium.svg",
      "tokens": [
        "Consortium",
        "Blockchain",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "blockchain",
        "10375",
        "icon",
        "service",
        "svg",
        "consortium"
      ]
    },
    {
      "provider": "azure",
      "label": "Container Apps Environments",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02989-icon-service-Container-Apps-Environments.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02989-icon-service-Container-Apps-Environments.svg",
      "tokens": [
        "Container Apps Environments",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02989",
        "icon",
        "service",
        "Container",
        "Apps",
        "Environments",
        "svg",
        "containerappsenvironments"
      ]
    },
    {
      "provider": "azure",
      "label": "Container Instances",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/10104-icon-service-Container-Instances.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/10104-icon-service-Container-Instances.svg",
      "tokens": [
        "Container Instances",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "10104",
        "icon",
        "service",
        "Container",
        "Instances",
        "svg",
        "containerinstances"
      ]
    },
    {
      "provider": "azure",
      "label": "Container Instances",
      "category": "Containers",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/containers/10104-icon-service-Container-Instances.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/containers/10104-icon-service-Container-Instances.svg",
      "tokens": [
        "Container Instances",
        "Containers",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "containers",
        "10104",
        "icon",
        "service",
        "Container",
        "Instances",
        "svg",
        "containerinstances"
      ]
    },
    {
      "provider": "azure",
      "label": "Container Registries",
      "category": "Containers",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/containers/10105-icon-service-Container-Registries.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/containers/10105-icon-service-Container-Registries.svg",
      "tokens": [
        "Container Registries",
        "Containers",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "containers",
        "10105",
        "icon",
        "service",
        "Container",
        "Registries",
        "svg",
        "containerregistries"
      ]
    },
    {
      "provider": "azure",
      "label": "Container Services (Deprecated)",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/10049-icon-service-Container-Services-(Deprecated).svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/10049-icon-service-Container-Services-(Deprecated).svg",
      "tokens": [
        "Container Services (Deprecated)",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "10049",
        "icon",
        "service",
        "Container",
        "Services",
        "(Deprecated)",
        "svg",
        "containerservicesdeprecated"
      ]
    },
    {
      "provider": "azure",
      "label": "Content Moderators",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/00795-icon-service-Content-Moderators.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/00795-icon-service-Content-Moderators.svg",
      "tokens": [
        "Content Moderators",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "00795",
        "icon",
        "service",
        "Content",
        "Moderators",
        "svg",
        "contentmoderators",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Content Safety",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/03390-icon-service-Content-Safety.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/03390-icon-service-Content-Safety.svg",
      "tokens": [
        "Content Safety",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "03390",
        "icon",
        "service",
        "Content",
        "Safety",
        "svg",
        "contentsafety",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Controls Horizontal",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10790-icon-service-Controls-Horizontal.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10790-icon-service-Controls-Horizontal.svg",
      "tokens": [
        "Controls Horizontal",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10790",
        "icon",
        "service",
        "Controls",
        "Horizontal",
        "svg",
        "controlshorizontal"
      ]
    },
    {
      "provider": "azure",
      "label": "Controls",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10789-icon-service-Controls.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10789-icon-service-Controls.svg",
      "tokens": [
        "Controls",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10789",
        "icon",
        "service",
        "svg",
        "controls"
      ]
    },
    {
      "provider": "azure",
      "label": "Cost Alerts",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10791-icon-service-Cost-Alerts.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10791-icon-service-Cost-Alerts.svg",
      "tokens": [
        "Cost Alerts",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10791",
        "icon",
        "service",
        "Cost",
        "Alerts",
        "svg",
        "costalerts"
      ]
    },
    {
      "provider": "azure",
      "label": "Cost Analysis",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10792-icon-service-Cost-Analysis.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10792-icon-service-Cost-Analysis.svg",
      "tokens": [
        "Cost Analysis",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10792",
        "icon",
        "service",
        "Cost",
        "Analysis",
        "svg",
        "costanalysis"
      ]
    },
    {
      "provider": "azure",
      "label": "Cost Budgets",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10793-icon-service-Cost-Budgets.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10793-icon-service-Cost-Budgets.svg",
      "tokens": [
        "Cost Budgets",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10793",
        "icon",
        "service",
        "Cost",
        "Budgets",
        "svg",
        "costbudgets"
      ]
    },
    {
      "provider": "azure",
      "label": "Cost Export",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/00913-icon-service-Cost-Export.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/00913-icon-service-Cost-Export.svg",
      "tokens": [
        "Cost Export",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "00913",
        "icon",
        "service",
        "Cost",
        "Export",
        "svg",
        "costexport"
      ]
    },
    {
      "provider": "azure",
      "label": "Cost Management And Billing",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/00004-icon-service-Cost-Management-and-Billing.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/00004-icon-service-Cost-Management-and-Billing.svg",
      "tokens": [
        "Cost Management And Billing",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "00004",
        "icon",
        "service",
        "Cost",
        "Management",
        "and",
        "Billing",
        "svg",
        "costmanagementandbilling"
      ]
    },
    {
      "provider": "azure",
      "label": "Cost Management And Billing",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/00004-icon-service-Cost-Management-and-Billing.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/00004-icon-service-Cost-Management-and-Billing.svg",
      "tokens": [
        "Cost Management And Billing",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "00004",
        "icon",
        "service",
        "Cost",
        "Management",
        "and",
        "Billing",
        "svg",
        "costmanagementandbilling",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Cost Management And Billing",
      "category": "Migrate",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/migrate/00004-icon-service-Cost-Management-and-Billing.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/migrate/00004-icon-service-Cost-Management-and-Billing.svg",
      "tokens": [
        "Cost Management And Billing",
        "Migrate",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "migrate",
        "00004",
        "icon",
        "service",
        "Cost",
        "Management",
        "and",
        "Billing",
        "svg",
        "costmanagementandbilling"
      ]
    },
    {
      "provider": "azure",
      "label": "Cost Management",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10019-icon-service-Cost-Management.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10019-icon-service-Cost-Management.svg",
      "tokens": [
        "Cost Management",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10019",
        "icon",
        "service",
        "Cost",
        "Management",
        "svg",
        "costmanagement"
      ]
    },
    {
      "provider": "azure",
      "label": "Counter",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10794-icon-service-Counter.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10794-icon-service-Counter.svg",
      "tokens": [
        "Counter",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10794",
        "icon",
        "service",
        "svg",
        "counter"
      ]
    },
    {
      "provider": "azure",
      "label": "Cubes",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10795-icon-service-Cubes.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10795-icon-service-Cubes.svg",
      "tokens": [
        "Cubes",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10795",
        "icon",
        "service",
        "svg",
        "cubes"
      ]
    },
    {
      "provider": "azure",
      "label": "Custom IP Prefix",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02654-icon-service-Custom-IP-Prefix.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02654-icon-service-Custom-IP-Prefix.svg",
      "tokens": [
        "Custom IP Prefix",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02654",
        "icon",
        "service",
        "Custom",
        "IP",
        "Prefix",
        "svg",
        "customipprefix"
      ]
    },
    {
      "provider": "azure",
      "label": "Custom Vision",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/00793-icon-service-Custom-Vision.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/00793-icon-service-Custom-Vision.svg",
      "tokens": [
        "Custom Vision",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "00793",
        "icon",
        "service",
        "Custom",
        "Vision",
        "svg",
        "customvision",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Customer Lockbox For Microsoft Azure",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/10314-icon-service-Customer-Lockbox-for-Microsoft-Azure.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/10314-icon-service-Customer-Lockbox-for-Microsoft-Azure.svg",
      "tokens": [
        "Customer Lockbox For Microsoft Azure",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "10314",
        "icon",
        "service",
        "Customer",
        "Lockbox",
        "for",
        "Microsoft",
        "svg",
        "customerlockboxformicrosoftazure",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "D Do S Protection Plans",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10072-icon-service-DDoS-Protection-Plans.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10072-icon-service-DDoS-Protection-Plans.svg",
      "tokens": [
        "D Do S Protection Plans",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10072",
        "icon",
        "service",
        "DDoS",
        "Protection",
        "Plans",
        "svg",
        "ddosprotectionplans"
      ]
    },
    {
      "provider": "azure",
      "label": "Dashboard Hub",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/01757-icon-service-Dashboard-Hub.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/01757-icon-service-Dashboard-Hub.svg",
      "tokens": [
        "Dashboard Hub",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "01757",
        "icon",
        "service",
        "Dashboard",
        "Hub",
        "svg",
        "dashboardhub"
      ]
    },
    {
      "provider": "azure",
      "label": "Dashboard",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10015-icon-service-Dashboard.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10015-icon-service-Dashboard.svg",
      "tokens": [
        "Dashboard",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10015",
        "icon",
        "service",
        "svg",
        "dashboard"
      ]
    },
    {
      "provider": "azure",
      "label": "Data Box",
      "category": "Migrate",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/migrate/10094-icon-service-Data-Box.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/migrate/10094-icon-service-Data-Box.svg",
      "tokens": [
        "Data Box",
        "Migrate",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "migrate",
        "10094",
        "icon",
        "service",
        "Data",
        "Box",
        "svg",
        "databox"
      ]
    },
    {
      "provider": "azure",
      "label": "Data Box",
      "category": "Storage",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/storage/10094-icon-service-Data-Box.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/storage/10094-icon-service-Data-Box.svg",
      "tokens": [
        "Data Box",
        "Storage",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "storage",
        "10094",
        "icon",
        "service",
        "Data",
        "Box",
        "svg",
        "databox"
      ]
    },
    {
      "provider": "azure",
      "label": "Data Collection Rules",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/01857-icon-service-Data-Collection-Rules.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/01857-icon-service-Data-Collection-Rules.svg",
      "tokens": [
        "Data Collection Rules",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "01857",
        "icon",
        "service",
        "Data",
        "Collection",
        "Rules",
        "svg",
        "datacollectionrules"
      ]
    },
    {
      "provider": "azure",
      "label": "Data Factories",
      "category": "Analytics",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/analytics/10126-icon-service-Data-Factories.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/analytics/10126-icon-service-Data-Factories.svg",
      "tokens": [
        "Data Factories",
        "Analytics",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "analytics",
        "10126",
        "icon",
        "service",
        "Data",
        "Factories",
        "svg",
        "datafactories"
      ]
    },
    {
      "provider": "azure",
      "label": "Data Factories",
      "category": "Databases",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/databases/10126-icon-service-Data-Factories.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/databases/10126-icon-service-Data-Factories.svg",
      "tokens": [
        "Data Factories",
        "Databases",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "databases",
        "10126",
        "icon",
        "service",
        "Data",
        "Factories",
        "svg",
        "datafactories"
      ]
    },
    {
      "provider": "azure",
      "label": "Data Factories",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/10126-icon-service-Data-Factories.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/10126-icon-service-Data-Factories.svg",
      "tokens": [
        "Data Factories",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "10126",
        "icon",
        "service",
        "Data",
        "Factories",
        "svg",
        "datafactories"
      ]
    },
    {
      "provider": "azure",
      "label": "Data Lake Analytics",
      "category": "Analytics",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/analytics/10143-icon-service-Data-Lake-Analytics.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/analytics/10143-icon-service-Data-Lake-Analytics.svg",
      "tokens": [
        "Data Lake Analytics",
        "Analytics",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "analytics",
        "10143",
        "icon",
        "service",
        "Data",
        "Lake",
        "svg",
        "datalakeanalytics"
      ]
    },
    {
      "provider": "azure",
      "label": "Data Lake Storage Gen1",
      "category": "Storage",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/storage/10090-icon-service-Data-Lake-Storage-Gen1.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/storage/10090-icon-service-Data-Lake-Storage-Gen1.svg",
      "tokens": [
        "Data Lake Storage Gen1",
        "Storage",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "storage",
        "10090",
        "icon",
        "service",
        "Data",
        "Lake",
        "Gen1",
        "svg",
        "datalakestoragegen1"
      ]
    },
    {
      "provider": "azure",
      "label": "Data Lake Store Gen1",
      "category": "Analytics",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/analytics/10150-icon-service-Data-Lake-Store-Gen1.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/analytics/10150-icon-service-Data-Lake-Store-Gen1.svg",
      "tokens": [
        "Data Lake Store Gen1",
        "Analytics",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "analytics",
        "10150",
        "icon",
        "service",
        "Data",
        "Lake",
        "Store",
        "Gen1",
        "svg",
        "datalakestoregen1"
      ]
    },
    {
      "provider": "azure",
      "label": "Data Share Invitations",
      "category": "Storage",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/storage/10097-icon-service-Data-Share-Invitations.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/storage/10097-icon-service-Data-Share-Invitations.svg",
      "tokens": [
        "Data Share Invitations",
        "Storage",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "storage",
        "10097",
        "icon",
        "service",
        "Data",
        "Share",
        "Invitations",
        "svg",
        "datashareinvitations"
      ]
    },
    {
      "provider": "azure",
      "label": "Data Shares",
      "category": "Storage",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/storage/10098-icon-service-Data-Shares.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/storage/10098-icon-service-Data-Shares.svg",
      "tokens": [
        "Data Shares",
        "Storage",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "storage",
        "10098",
        "icon",
        "service",
        "Data",
        "Shares",
        "svg",
        "datashares"
      ]
    },
    {
      "provider": "azure",
      "label": "Data Virtualization",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/029203566-icon-service-Data-Virtualization.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/029203566-icon-service-Data-Virtualization.svg",
      "tokens": [
        "Data Virtualization",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "029203566",
        "icon",
        "service",
        "Data",
        "Virtualization",
        "svg",
        "datavirtualization",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Database Instance For SAP",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03175-icon-service-Database-Instance-For-SAP.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03175-icon-service-Database-Instance-For-SAP.svg",
      "tokens": [
        "Database Instance For SAP",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03175",
        "icon",
        "service",
        "Database",
        "Instance",
        "For",
        "SAP",
        "svg",
        "databaseinstanceforsap"
      ]
    },
    {
      "provider": "azure",
      "label": "Dedicated HSM",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02322-icon-service-Dedicated-HSM.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02322-icon-service-Dedicated-HSM.svg",
      "tokens": [
        "Dedicated HSM",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02322",
        "icon",
        "service",
        "Dedicated",
        "HSM",
        "svg",
        "dedicatedhsm"
      ]
    },
    {
      "provider": "azure",
      "label": "Defender CM Local Manager",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03402-icon-service-Defender-CM-Local-Manager.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03402-icon-service-Defender-CM-Local-Manager.svg",
      "tokens": [
        "Defender CM Local Manager",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03402",
        "icon",
        "service",
        "Defender",
        "CM",
        "Local",
        "Manager",
        "svg",
        "defendercmlocalmanager"
      ]
    },
    {
      "provider": "azure",
      "label": "Defender DCS Controller",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03412-icon-service-Defender-DCS-Controller.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03412-icon-service-Defender-DCS-Controller.svg",
      "tokens": [
        "Defender DCS Controller",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03412",
        "icon",
        "service",
        "Defender",
        "DCS",
        "Controller",
        "svg",
        "defenderdcscontroller"
      ]
    },
    {
      "provider": "azure",
      "label": "Defender Distributer Control System",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03413-icon-service-Defender-Distributer-Control-System.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03413-icon-service-Defender-Distributer-Control-System.svg",
      "tokens": [
        "Defender Distributer Control System",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03413",
        "icon",
        "service",
        "Defender",
        "Distributer",
        "Control",
        "System",
        "svg",
        "defenderdistributercontrolsystem"
      ]
    },
    {
      "provider": "azure",
      "label": "Defender Engineering Station",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03414-icon-service-Defender-Engineering-Station.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03414-icon-service-Defender-Engineering-Station.svg",
      "tokens": [
        "Defender Engineering Station",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03414",
        "icon",
        "service",
        "Defender",
        "Engineering",
        "Station",
        "svg",
        "defenderengineeringstation"
      ]
    },
    {
      "provider": "azure",
      "label": "Defender External Management",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03403-icon-service-Defender-External-Management.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03403-icon-service-Defender-External-Management.svg",
      "tokens": [
        "Defender External Management",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03403",
        "icon",
        "service",
        "Defender",
        "External",
        "Management",
        "svg",
        "defenderexternalmanagement"
      ]
    },
    {
      "provider": "azure",
      "label": "Defender Freezer Monitor",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03404-icon-service-Defender-Freezer-Monitor.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03404-icon-service-Defender-Freezer-Monitor.svg",
      "tokens": [
        "Defender Freezer Monitor",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03404",
        "icon",
        "service",
        "Defender",
        "Freezer",
        "Monitor",
        "svg",
        "defenderfreezermonitor"
      ]
    },
    {
      "provider": "azure",
      "label": "Defender Historian",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03405-icon-service-Defender-Historian.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03405-icon-service-Defender-Historian.svg",
      "tokens": [
        "Defender Historian",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03405",
        "icon",
        "service",
        "Defender",
        "Historian",
        "svg",
        "defenderhistorian"
      ]
    },
    {
      "provider": "azure",
      "label": "Defender HMI",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03406-icon-service-Defender-HMI.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03406-icon-service-Defender-HMI.svg",
      "tokens": [
        "Defender HMI",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03406",
        "icon",
        "service",
        "Defender",
        "HMI",
        "svg",
        "defenderhmi"
      ]
    },
    {
      "provider": "azure",
      "label": "Defender Industrial Packaging System",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03415-icon-service-Defender-Industrial-Packaging-System.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03415-icon-service-Defender-Industrial-Packaging-System.svg",
      "tokens": [
        "Defender Industrial Packaging System",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03415",
        "icon",
        "service",
        "Defender",
        "Industrial",
        "Packaging",
        "System",
        "svg",
        "defenderindustrialpackagingsystem"
      ]
    },
    {
      "provider": "azure",
      "label": "Defender Industrial Printer",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03416-icon-service-Defender-Industrial-Printer.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03416-icon-service-Defender-Industrial-Printer.svg",
      "tokens": [
        "Defender Industrial Printer",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03416",
        "icon",
        "service",
        "Defender",
        "Industrial",
        "Printer",
        "svg",
        "defenderindustrialprinter"
      ]
    },
    {
      "provider": "azure",
      "label": "Defender Industrial Robot",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03418-icon-service-Defender-Industrial-Robot.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03418-icon-service-Defender-Industrial-Robot.svg",
      "tokens": [
        "Defender Industrial Robot",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03418",
        "icon",
        "service",
        "Defender",
        "Industrial",
        "Robot",
        "svg",
        "defenderindustrialrobot"
      ]
    },
    {
      "provider": "azure",
      "label": "Defender Industrial Scale System",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03417-icon-service-Defender-Industrial-Scale-System.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03417-icon-service-Defender-Industrial-Scale-System.svg",
      "tokens": [
        "Defender Industrial Scale System",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03417",
        "icon",
        "service",
        "Defender",
        "Industrial",
        "Scale",
        "System",
        "svg",
        "defenderindustrialscalesystem"
      ]
    },
    {
      "provider": "azure",
      "label": "Defender Marquee",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03407-icon-service-Defender-Marquee.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03407-icon-service-Defender-Marquee.svg",
      "tokens": [
        "Defender Marquee",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03407",
        "icon",
        "service",
        "Defender",
        "Marquee",
        "svg",
        "defendermarquee"
      ]
    },
    {
      "provider": "azure",
      "label": "Defender Meter",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03419-icon-service-Defender-Meter.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03419-icon-service-Defender-Meter.svg",
      "tokens": [
        "Defender Meter",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03419",
        "icon",
        "service",
        "Defender",
        "Meter",
        "svg",
        "defendermeter"
      ]
    },
    {
      "provider": "azure",
      "label": "Defender PLC",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03420-icon-service-Defender-PLC.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03420-icon-service-Defender-PLC.svg",
      "tokens": [
        "Defender PLC",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03420",
        "icon",
        "service",
        "Defender",
        "PLC",
        "svg",
        "defenderplc"
      ]
    },
    {
      "provider": "azure",
      "label": "Defender Pneumatic Device",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03421-icon-service-Defender-Pneumatic-Device.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03421-icon-service-Defender-Pneumatic-Device.svg",
      "tokens": [
        "Defender Pneumatic Device",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03421",
        "icon",
        "service",
        "Defender",
        "Pneumatic",
        "Device",
        "svg",
        "defenderpneumaticdevice"
      ]
    },
    {
      "provider": "azure",
      "label": "Defender Programable Board",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03422-icon-service-Defender-Programable-Board.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03422-icon-service-Defender-Programable-Board.svg",
      "tokens": [
        "Defender Programable Board",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03422",
        "icon",
        "service",
        "Defender",
        "Programable",
        "Board",
        "svg",
        "defenderprogramableboard"
      ]
    },
    {
      "provider": "azure",
      "label": "Defender Relay",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03423-icon-service-Defender-Relay.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03423-icon-service-Defender-Relay.svg",
      "tokens": [
        "Defender Relay",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03423",
        "icon",
        "service",
        "Defender",
        "Relay",
        "svg",
        "defenderrelay"
      ]
    },
    {
      "provider": "azure",
      "label": "Defender Robot Controller",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03408-icon-service-Defender-Robot-Controller.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03408-icon-service-Defender-Robot-Controller.svg",
      "tokens": [
        "Defender Robot Controller",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03408",
        "icon",
        "service",
        "Defender",
        "Robot",
        "Controller",
        "svg",
        "defenderrobotcontroller"
      ]
    },
    {
      "provider": "azure",
      "label": "Defender RTU",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03424-icon-service-Defender-RTU.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03424-icon-service-Defender-RTU.svg",
      "tokens": [
        "Defender RTU",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03424",
        "icon",
        "service",
        "Defender",
        "RTU",
        "svg",
        "defenderrtu"
      ]
    },
    {
      "provider": "azure",
      "label": "Defender Sensor",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03409-icon-service-Defender-Sensor.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03409-icon-service-Defender-Sensor.svg",
      "tokens": [
        "Defender Sensor",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03409",
        "icon",
        "service",
        "Defender",
        "Sensor",
        "svg",
        "defendersensor"
      ]
    },
    {
      "provider": "azure",
      "label": "Defender Slot",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03410-icon-service-Defender-Slot.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03410-icon-service-Defender-Slot.svg",
      "tokens": [
        "Defender Slot",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03410",
        "icon",
        "service",
        "Defender",
        "Slot",
        "svg",
        "defenderslot"
      ]
    },
    {
      "provider": "azure",
      "label": "Defender Web Guiding System",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03411-icon-service-Defender-Web-Guiding-System.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03411-icon-service-Defender-Web-Guiding-System.svg",
      "tokens": [
        "Defender Web Guiding System",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03411",
        "icon",
        "service",
        "Defender",
        "Web",
        "Guiding",
        "System",
        "svg",
        "defenderwebguidingsystem"
      ]
    },
    {
      "provider": "azure",
      "label": "Detonation",
      "category": "Security",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/security/00378-icon-service-Detonation.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/security/00378-icon-service-Detonation.svg",
      "tokens": [
        "Detonation",
        "Security",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "security",
        "00378",
        "icon",
        "service",
        "svg",
        "detonation"
      ]
    },
    {
      "provider": "azure",
      "label": "Dev Console",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10796-icon-service-Dev-Console.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10796-icon-service-Dev-Console.svg",
      "tokens": [
        "Dev Console",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10796",
        "icon",
        "service",
        "Dev",
        "Console",
        "svg",
        "devconsole"
      ]
    },
    {
      "provider": "azure",
      "label": "Dev Ops Starter",
      "category": "Devops",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/devops/03339-icon-service-DevOps-Starter.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/devops/03339-icon-service-DevOps-Starter.svg",
      "tokens": [
        "Dev Ops Starter",
        "Devops",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "devops",
        "03339",
        "icon",
        "service",
        "DevOps",
        "Starter",
        "svg",
        "devopsstarter"
      ]
    },
    {
      "provider": "azure",
      "label": "Dev Test Labs",
      "category": "Devops",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/devops/10264-icon-service-DevTest-Labs.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/devops/10264-icon-service-DevTest-Labs.svg",
      "tokens": [
        "Dev Test Labs",
        "Devops",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "devops",
        "10264",
        "icon",
        "service",
        "DevTest",
        "Labs",
        "svg",
        "devtestlabs"
      ]
    },
    {
      "provider": "azure",
      "label": "Device Compliance",
      "category": "Intune",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/intune/10333-icon-service-Device-Compliance.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/intune/10333-icon-service-Device-Compliance.svg",
      "tokens": [
        "Device Compliance",
        "Intune",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "intune",
        "10333",
        "icon",
        "service",
        "Device",
        "Compliance",
        "svg",
        "devicecompliance"
      ]
    },
    {
      "provider": "azure",
      "label": "Device Configuration",
      "category": "Intune",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/intune/10338-icon-service-Device-Configuration.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/intune/10338-icon-service-Device-Configuration.svg",
      "tokens": [
        "Device Configuration",
        "Intune",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "intune",
        "10338",
        "icon",
        "service",
        "Device",
        "Configuration",
        "svg",
        "deviceconfiguration"
      ]
    },
    {
      "provider": "azure",
      "label": "Device Enrollment",
      "category": "Intune",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/intune/10337-icon-service-Device-Enrollment.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/intune/10337-icon-service-Device-Enrollment.svg",
      "tokens": [
        "Device Enrollment",
        "Intune",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "intune",
        "10337",
        "icon",
        "service",
        "Device",
        "Enrollment",
        "svg",
        "deviceenrollment"
      ]
    },
    {
      "provider": "azure",
      "label": "Device Provisioning Services",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/10369-icon-service-Device-Provisioning-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/10369-icon-service-Device-Provisioning-Services.svg",
      "tokens": [
        "Device Provisioning Services",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "10369",
        "icon",
        "service",
        "Device",
        "Provisioning",
        "Services",
        "svg",
        "deviceprovisioningservices"
      ]
    },
    {
      "provider": "azure",
      "label": "Device Security Apple",
      "category": "Intune",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/intune/00399-icon-service-Device-Security-Apple.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/intune/00399-icon-service-Device-Security-Apple.svg",
      "tokens": [
        "Device Security Apple",
        "Intune",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "intune",
        "00399",
        "icon",
        "service",
        "Device",
        "Security",
        "Apple",
        "svg",
        "devicesecurityapple"
      ]
    },
    {
      "provider": "azure",
      "label": "Device Security Google",
      "category": "Intune",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/intune/00399-icon-service-Device-Security-Google.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/intune/00399-icon-service-Device-Security-Google.svg",
      "tokens": [
        "Device Security Google",
        "Intune",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "intune",
        "00399",
        "icon",
        "service",
        "Device",
        "Security",
        "Google",
        "svg",
        "devicesecuritygoogle"
      ]
    },
    {
      "provider": "azure",
      "label": "Device Security Windows",
      "category": "Intune",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/intune/00399-icon-service-Device-Security-Windows.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/intune/00399-icon-service-Device-Security-Windows.svg",
      "tokens": [
        "Device Security Windows",
        "Intune",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "intune",
        "00399",
        "icon",
        "service",
        "Device",
        "Security",
        "Windows",
        "svg",
        "devicesecuritywindows"
      ]
    },
    {
      "provider": "azure",
      "label": "Device Update Io T Hub",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02475-icon-service-Device-Update-IoT-Hub.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02475-icon-service-Device-Update-IoT-Hub.svg",
      "tokens": [
        "Device Update Io T Hub",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02475",
        "icon",
        "service",
        "Device",
        "Update",
        "IoT",
        "Hub",
        "svg",
        "deviceupdateiothub"
      ]
    },
    {
      "provider": "azure",
      "label": "Devices",
      "category": "Intune",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/intune/10332-icon-service-Devices.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/intune/10332-icon-service-Devices.svg",
      "tokens": [
        "Devices",
        "Intune",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "intune",
        "10332",
        "icon",
        "service",
        "svg",
        "devices"
      ]
    },
    {
      "provider": "azure",
      "label": "Diagnostics Settings",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/00008-icon-service-Diagnostics-Settings.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/00008-icon-service-Diagnostics-Settings.svg",
      "tokens": [
        "Diagnostics Settings",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "00008",
        "icon",
        "service",
        "Diagnostics",
        "Settings",
        "svg",
        "diagnosticssettings",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Diagnostics Settings",
      "category": "Monitor",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/monitor/00008-icon-service-Diagnostics-Settings.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/monitor/00008-icon-service-Diagnostics-Settings.svg",
      "tokens": [
        "Diagnostics Settings",
        "Monitor",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "monitor",
        "00008",
        "icon",
        "service",
        "Diagnostics",
        "Settings",
        "svg",
        "diagnosticssettings"
      ]
    },
    {
      "provider": "azure",
      "label": "Digital Twins",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/01030-icon-service-Digital-Twins.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/01030-icon-service-Digital-Twins.svg",
      "tokens": [
        "Digital Twins",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "01030",
        "icon",
        "service",
        "Digital",
        "Twins",
        "svg",
        "digitaltwins"
      ]
    },
    {
      "provider": "azure",
      "label": "Disk Encryption Sets",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/00398-icon-service-Disk-Encryption-Sets.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/00398-icon-service-Disk-Encryption-Sets.svg",
      "tokens": [
        "Disk Encryption Sets",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "00398",
        "icon",
        "service",
        "Disk",
        "Encryption",
        "Sets",
        "svg",
        "diskencryptionsets"
      ]
    },
    {
      "provider": "azure",
      "label": "Disk Pool",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02560-icon-service-Disk-Pool.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02560-icon-service-Disk-Pool.svg",
      "tokens": [
        "Disk Pool",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02560",
        "icon",
        "service",
        "Disk",
        "Pool",
        "svg",
        "diskpool"
      ]
    },
    {
      "provider": "azure",
      "label": "Disks (Classic)",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/10041-icon-service-Disks-(Classic).svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/10041-icon-service-Disks-(Classic).svg",
      "tokens": [
        "Disks (Classic)",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "10041",
        "icon",
        "service",
        "Disks",
        "(Classic)",
        "svg",
        "disksclassic"
      ]
    },
    {
      "provider": "azure",
      "label": "Disks Snapshots",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/10026-icon-service-Disks-Snapshots.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/10026-icon-service-Disks-Snapshots.svg",
      "tokens": [
        "Disks Snapshots",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "10026",
        "icon",
        "service",
        "Disks",
        "Snapshots",
        "svg",
        "diskssnapshots"
      ]
    },
    {
      "provider": "azure",
      "label": "Disks",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/10032-icon-service-Disks.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/10032-icon-service-Disks.svg",
      "tokens": [
        "Disks",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "10032",
        "icon",
        "service",
        "svg",
        "disks"
      ]
    },
    {
      "provider": "azure",
      "label": "DNS Multistack",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/03459-icon-service-DNS-Multistack.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/03459-icon-service-DNS-Multistack.svg",
      "tokens": [
        "DNS Multistack",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "03459",
        "icon",
        "service",
        "DNS",
        "Multistack",
        "svg",
        "dnsmultistack"
      ]
    },
    {
      "provider": "azure",
      "label": "DNS Private Resolver",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/02882-icon-service-DNS-Private-Resolver.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/02882-icon-service-DNS-Private-Resolver.svg",
      "tokens": [
        "DNS Private Resolver",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "02882",
        "icon",
        "service",
        "DNS",
        "Private",
        "Resolver",
        "svg",
        "dnsprivateresolver"
      ]
    },
    {
      "provider": "azure",
      "label": "DNS Security Policy",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/03368-icon-service-DNS-Security-Policy.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/03368-icon-service-DNS-Security-Policy.svg",
      "tokens": [
        "DNS Security Policy",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "03368",
        "icon",
        "service",
        "DNS",
        "Security",
        "Policy",
        "svg",
        "dnssecuritypolicy"
      ]
    },
    {
      "provider": "azure",
      "label": "DNS Zones",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10064-icon-service-DNS-Zones.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10064-icon-service-DNS-Zones.svg",
      "tokens": [
        "DNS Zones",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10064",
        "icon",
        "service",
        "DNS",
        "Zones",
        "svg",
        "dnszones"
      ]
    },
    {
      "provider": "azure",
      "label": "Download",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10797-icon-service-Download.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10797-icon-service-Download.svg",
      "tokens": [
        "Download",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10797",
        "icon",
        "service",
        "svg",
        "download"
      ]
    },
    {
      "provider": "azure",
      "label": "E Books",
      "category": "Intune",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/intune/10330-icon-service-eBooks.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/intune/10330-icon-service-eBooks.svg",
      "tokens": [
        "E Books",
        "Intune",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "intune",
        "10330",
        "icon",
        "service",
        "eBooks",
        "svg",
        "ebooks"
      ]
    },
    {
      "provider": "azure",
      "label": "Edge Actions",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/029273094-icon-service-Edge-Actions.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/029273094-icon-service-Edge-Actions.svg",
      "tokens": [
        "Edge Actions",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "029273094",
        "icon",
        "service",
        "Edge",
        "Actions",
        "svg",
        "edgeactions",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Edge Management",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/10117-icon-service-Edge-Management.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/10117-icon-service-Edge-Management.svg",
      "tokens": [
        "Edge Management",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "10117",
        "icon",
        "service",
        "Edge",
        "Management",
        "svg",
        "edgemanagement"
      ]
    },
    {
      "provider": "azure",
      "label": "Edge Storage Accelerator",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/03521-icon-service-Edge-Storage-Accelerator.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/03521-icon-service-Edge-Storage-Accelerator.svg",
      "tokens": [
        "Edge Storage Accelerator",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "03521",
        "icon",
        "service",
        "Edge",
        "Storage",
        "Accelerator",
        "svg",
        "edgestorageaccelerator",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Education",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/00026-icon-service-Education.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/00026-icon-service-Education.svg",
      "tokens": [
        "Education",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "00026",
        "icon",
        "service",
        "svg",
        "education",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Elastic Job Agents",
      "category": "Databases",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/databases/10128-icon-service-Elastic-Job-Agents.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/databases/10128-icon-service-Elastic-Job-Agents.svg",
      "tokens": [
        "Elastic Job Agents",
        "Databases",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "databases",
        "10128",
        "icon",
        "service",
        "Elastic",
        "Job",
        "Agents",
        "svg",
        "elasticjobagents"
      ]
    },
    {
      "provider": "azure",
      "label": "Elastic SAN",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03190-icon-service-Elastic-SAN.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03190-icon-service-Elastic-SAN.svg",
      "tokens": [
        "Elastic SAN",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03190",
        "icon",
        "service",
        "Elastic",
        "SAN",
        "svg",
        "elasticsan"
      ]
    },
    {
      "provider": "azure",
      "label": "Endpoint Analytics",
      "category": "Analytics",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/analytics/00562-icon-service-Endpoint-Analytics.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/analytics/00562-icon-service-Endpoint-Analytics.svg",
      "tokens": [
        "Endpoint Analytics",
        "Analytics",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "analytics",
        "00562",
        "icon",
        "service",
        "Endpoint",
        "svg",
        "endpointanalytics"
      ]
    },
    {
      "provider": "azure",
      "label": "Engage Center Connect",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/029797391-icon-service-Engage-Center-Connect.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/029797391-icon-service-Engage-Center-Connect.svg",
      "tokens": [
        "Engage Center Connect",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "029797391",
        "icon",
        "service",
        "Engage",
        "Center",
        "Connect",
        "svg",
        "engagecenterconnect",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Enterprise Applications",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/10225-icon-service-Enterprise-Applications.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/10225-icon-service-Enterprise-Applications.svg",
      "tokens": [
        "Enterprise Applications",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "10225",
        "icon",
        "service",
        "Enterprise",
        "Applications",
        "svg",
        "enterpriseapplications"
      ]
    },
    {
      "provider": "azure",
      "label": "Entra Connect Health",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/10224-icon-service-Entra-Connect-Health.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/10224-icon-service-Entra-Connect-Health.svg",
      "tokens": [
        "Entra Connect Health",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "10224",
        "icon",
        "service",
        "Entra",
        "Connect",
        "Health",
        "svg",
        "entraconnecthealth"
      ]
    },
    {
      "provider": "azure",
      "label": "Entra Connect Sync",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/03533-icon-service-Entra-Connect-Sync.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/03533-icon-service-Entra-Connect-Sync.svg",
      "tokens": [
        "Entra Connect Sync",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "03533",
        "icon",
        "service",
        "Entra",
        "Connect",
        "Sync",
        "svg",
        "entraconnectsync"
      ]
    },
    {
      "provider": "azure",
      "label": "Entra Connect",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/02854-icon-service-Entra-Connect.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/02854-icon-service-Entra-Connect.svg",
      "tokens": [
        "Entra Connect",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "02854",
        "icon",
        "service",
        "Entra",
        "Connect",
        "svg",
        "entraconnect"
      ]
    },
    {
      "provider": "azure",
      "label": "Entra Domain Services",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/10222-icon-service-Entra-Domain-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/10222-icon-service-Entra-Domain-Services.svg",
      "tokens": [
        "Entra Domain Services",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "10222",
        "icon",
        "service",
        "Entra",
        "Domain",
        "Services",
        "svg",
        "entradomainservices"
      ]
    },
    {
      "provider": "azure",
      "label": "Entra Global Secure Access",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/03309-icon-service-Entra-Global-Secure-Access.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/03309-icon-service-Entra-Global-Secure-Access.svg",
      "tokens": [
        "Entra Global Secure Access",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "03309",
        "icon",
        "service",
        "Entra",
        "Global",
        "Secure",
        "Access",
        "svg",
        "entraglobalsecureaccess"
      ]
    },
    {
      "provider": "azure",
      "label": "Entra ID Protection",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/10231-icon-service-Entra-ID-Protection.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/10231-icon-service-Entra-ID-Protection.svg",
      "tokens": [
        "Entra ID Protection",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "10231",
        "icon",
        "service",
        "Entra",
        "ID",
        "Protection",
        "svg",
        "entraidprotection"
      ]
    },
    {
      "provider": "azure",
      "label": "Entra Identity Custom Roles",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/02680-icon-service-Entra-Identity-Custom-Roles.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/02680-icon-service-Entra-Identity-Custom-Roles.svg",
      "tokens": [
        "Entra Identity Custom Roles",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "02680",
        "icon",
        "service",
        "Entra",
        "Custom",
        "Roles",
        "svg",
        "entraidentitycustomroles"
      ]
    },
    {
      "provider": "azure",
      "label": "Entra Identity Licenses",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/02681-icon-service-Entra-Identity-Licenses.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/02681-icon-service-Entra-Identity-Licenses.svg",
      "tokens": [
        "Entra Identity Licenses",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "02681",
        "icon",
        "service",
        "Entra",
        "Licenses",
        "svg",
        "entraidentitylicenses"
      ]
    },
    {
      "provider": "azure",
      "label": "Entra Identity Licenses",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02681-icon-service-Entra-Identity-Licenses.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02681-icon-service-Entra-Identity-Licenses.svg",
      "tokens": [
        "Entra Identity Licenses",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02681",
        "icon",
        "service",
        "Entra",
        "Identity",
        "Licenses",
        "svg",
        "entraidentitylicenses"
      ]
    },
    {
      "provider": "azure",
      "label": "Entra Identity Risky Signins",
      "category": "Security",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/security/03341-icon-service-Entra-Identity-Risky-Signins.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/security/03341-icon-service-Entra-Identity-Risky-Signins.svg",
      "tokens": [
        "Entra Identity Risky Signins",
        "Security",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "security",
        "03341",
        "icon",
        "service",
        "Entra",
        "Identity",
        "Risky",
        "Signins",
        "svg",
        "entraidentityriskysignins"
      ]
    },
    {
      "provider": "azure",
      "label": "Entra Identity Risky Users",
      "category": "Security",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/security/03342-icon-service-Entra-Identity-Risky-Users.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/security/03342-icon-service-Entra-Identity-Risky-Users.svg",
      "tokens": [
        "Entra Identity Risky Users",
        "Security",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "security",
        "03342",
        "icon",
        "service",
        "Entra",
        "Identity",
        "Risky",
        "Users",
        "svg",
        "entraidentityriskyusers"
      ]
    },
    {
      "provider": "azure",
      "label": "Entra Identity Roles And Administrators",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/10340-icon-service-Entra-Identity-Roles-and-Administrators.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/10340-icon-service-Entra-Identity-Roles-and-Administrators.svg",
      "tokens": [
        "Entra Identity Roles And Administrators",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "10340",
        "icon",
        "service",
        "Entra",
        "Roles",
        "and",
        "Administrators",
        "svg",
        "entraidentityrolesandadministrators"
      ]
    },
    {
      "provider": "azure",
      "label": "Entra Identity Roles And Administrators",
      "category": "Intune",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/intune/10340-icon-service-Entra-Identity-Roles-and-Administrators.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/intune/10340-icon-service-Entra-Identity-Roles-and-Administrators.svg",
      "tokens": [
        "Entra Identity Roles And Administrators",
        "Intune",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "intune",
        "10340",
        "icon",
        "service",
        "Entra",
        "Identity",
        "Roles",
        "and",
        "Administrators",
        "svg",
        "entraidentityrolesandadministrators"
      ]
    },
    {
      "provider": "azure",
      "label": "Entra Internet Access",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/03383-icon-service-Entra-Internet-Access.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/03383-icon-service-Entra-Internet-Access.svg",
      "tokens": [
        "Entra Internet Access",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "03383",
        "icon",
        "service",
        "Entra",
        "Internet",
        "Access",
        "svg",
        "entrainternetaccess"
      ]
    },
    {
      "provider": "azure",
      "label": "Entra Managed Identities",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/10227-icon-service-Entra-Managed-Identities.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/10227-icon-service-Entra-Managed-Identities.svg",
      "tokens": [
        "Entra Managed Identities",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "10227",
        "icon",
        "service",
        "Entra",
        "Managed",
        "Identities",
        "svg",
        "entramanagedidentities"
      ]
    },
    {
      "provider": "azure",
      "label": "Entra Private Access",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/03382-icon-service-Entra-Private-Access.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/03382-icon-service-Entra-Private-Access.svg",
      "tokens": [
        "Entra Private Access",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "03382",
        "icon",
        "service",
        "Entra",
        "Private",
        "Access",
        "svg",
        "entraprivateaccess"
      ]
    },
    {
      "provider": "azure",
      "label": "Entra Privleged Identity Management",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/02251-icon-service-Entra-Privleged-Identity-Management.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/02251-icon-service-Entra-Privleged-Identity-Management.svg",
      "tokens": [
        "Entra Privleged Identity Management",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "02251",
        "icon",
        "service",
        "Entra",
        "Privleged",
        "Management",
        "svg",
        "entraprivlegedidentitymanagement"
      ]
    },
    {
      "provider": "azure",
      "label": "Entra Verified ID",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/03143-icon-service-Entra-Verified-ID.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/03143-icon-service-Entra-Verified-ID.svg",
      "tokens": [
        "Entra Verified ID",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "03143",
        "icon",
        "service",
        "Entra",
        "Verified",
        "ID",
        "svg",
        "entraverifiedid"
      ]
    },
    {
      "provider": "azure",
      "label": "Error",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10798-icon-service-Error.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10798-icon-service-Error.svg",
      "tokens": [
        "Error",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10798",
        "icon",
        "service",
        "svg",
        "error"
      ]
    },
    {
      "provider": "azure",
      "label": "Event Grid Domains",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/10215-icon-service-Event-Grid-Domains.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/10215-icon-service-Event-Grid-Domains.svg",
      "tokens": [
        "Event Grid Domains",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "10215",
        "icon",
        "service",
        "Event",
        "Grid",
        "Domains",
        "svg",
        "eventgriddomains"
      ]
    },
    {
      "provider": "azure",
      "label": "Event Grid Subscriptions",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/10221-icon-service-Event-Grid-Subscriptions.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/10221-icon-service-Event-Grid-Subscriptions.svg",
      "tokens": [
        "Event Grid Subscriptions",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "10221",
        "icon",
        "service",
        "Event",
        "Grid",
        "Subscriptions",
        "svg",
        "eventgridsubscriptions"
      ]
    },
    {
      "provider": "azure",
      "label": "Event Grid Subscriptions",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/10221-icon-service-Event-Grid-Subscriptions.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/10221-icon-service-Event-Grid-Subscriptions.svg",
      "tokens": [
        "Event Grid Subscriptions",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "10221",
        "icon",
        "service",
        "Event",
        "Grid",
        "Subscriptions",
        "svg",
        "eventgridsubscriptions"
      ]
    },
    {
      "provider": "azure",
      "label": "Event Grid Topics",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/10206-icon-service-Event-Grid-Topics.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/10206-icon-service-Event-Grid-Topics.svg",
      "tokens": [
        "Event Grid Topics",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "10206",
        "icon",
        "service",
        "Event",
        "Grid",
        "Topics",
        "svg",
        "eventgridtopics"
      ]
    },
    {
      "provider": "azure",
      "label": "Event Hub Clusters",
      "category": "Analytics",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/analytics/10149-icon-service-Event-Hub-Clusters.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/analytics/10149-icon-service-Event-Hub-Clusters.svg",
      "tokens": [
        "Event Hub Clusters",
        "Analytics",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "analytics",
        "10149",
        "icon",
        "service",
        "Event",
        "Hub",
        "Clusters",
        "svg",
        "eventhubclusters"
      ]
    },
    {
      "provider": "azure",
      "label": "Event Hub Clusters",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/10149-icon-service-Event-Hub-Clusters.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/10149-icon-service-Event-Hub-Clusters.svg",
      "tokens": [
        "Event Hub Clusters",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "10149",
        "icon",
        "service",
        "Event",
        "Hub",
        "Clusters",
        "svg",
        "eventhubclusters"
      ]
    },
    {
      "provider": "azure",
      "label": "Event Hubs",
      "category": "Analytics",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/analytics/00039-icon-service-Event-Hubs.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/analytics/00039-icon-service-Event-Hubs.svg",
      "tokens": [
        "Event Hubs",
        "Analytics",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "analytics",
        "00039",
        "icon",
        "service",
        "Event",
        "Hubs",
        "svg",
        "eventhubs"
      ]
    },
    {
      "provider": "azure",
      "label": "Event Hubs",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/00039-icon-service-Event-Hubs.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/00039-icon-service-Event-Hubs.svg",
      "tokens": [
        "Event Hubs",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "00039",
        "icon",
        "service",
        "Event",
        "Hubs",
        "svg",
        "eventhubs"
      ]
    },
    {
      "provider": "azure",
      "label": "Exchange Access",
      "category": "Intune",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/intune/10339-icon-service-Exchange-Access.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/intune/10339-icon-service-Exchange-Access.svg",
      "tokens": [
        "Exchange Access",
        "Intune",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "intune",
        "10339",
        "icon",
        "service",
        "Exchange",
        "Access",
        "svg",
        "exchangeaccess"
      ]
    },
    {
      "provider": "azure",
      "label": "Exchange On Premises Access",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/10334-icon-service-Exchange-On-Premises-Access.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/10334-icon-service-Exchange-On-Premises-Access.svg",
      "tokens": [
        "Exchange On Premises Access",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "10334",
        "icon",
        "service",
        "Exchange",
        "On",
        "Premises",
        "Access",
        "svg",
        "exchangeonpremisesaccess"
      ]
    },
    {
      "provider": "azure",
      "label": "Express Route Circuits",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10079-icon-service-ExpressRoute-Circuits.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10079-icon-service-ExpressRoute-Circuits.svg",
      "tokens": [
        "Express Route Circuits",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10079",
        "icon",
        "service",
        "ExpressRoute",
        "Circuits",
        "svg",
        "expressroutecircuits"
      ]
    },
    {
      "provider": "azure",
      "label": "Express Route Direct",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/00903-icon-service-ExpressRoute-Direct.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/00903-icon-service-ExpressRoute-Direct.svg",
      "tokens": [
        "Express Route Direct",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "00903",
        "icon",
        "service",
        "ExpressRoute",
        "Direct",
        "svg",
        "expressroutedirect"
      ]
    },
    {
      "provider": "azure",
      "label": "Express Route Traffic Collector",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03137-icon-service-Express-Route-Traffic-Collector.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03137-icon-service-Express-Route-Traffic-Collector.svg",
      "tokens": [
        "Express Route Traffic Collector",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03137",
        "icon",
        "service",
        "Express",
        "Route",
        "Traffic",
        "Collector",
        "svg",
        "expressroutetrafficcollector"
      ]
    },
    {
      "provider": "azure",
      "label": "Extended Security Updates",
      "category": "Security",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/security/10572-icon-service-ExtendedSecurityUpdates.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/security/10572-icon-service-ExtendedSecurityUpdates.svg",
      "tokens": [
        "Extended Security Updates",
        "Security",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "security",
        "10572",
        "icon",
        "service",
        "ExtendedSecurityUpdates",
        "svg",
        "extendedsecurityupdates"
      ]
    },
    {
      "provider": "azure",
      "label": "Extensions",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10799-icon-service-Extensions.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10799-icon-service-Extensions.svg",
      "tokens": [
        "Extensions",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10799",
        "icon",
        "service",
        "svg",
        "extensions"
      ]
    },
    {
      "provider": "azure",
      "label": "External Id Modified",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/034251-icon-service-external-id-modified.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/034251-icon-service-external-id-modified.svg",
      "tokens": [
        "External Id Modified",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "034251",
        "icon",
        "service",
        "external",
        "id",
        "modified",
        "svg",
        "externalidmodified",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "External Id",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/03425-icon-service-external-id.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/03425-icon-service-external-id.svg",
      "tokens": [
        "External Id",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "03425",
        "icon",
        "service",
        "external",
        "id",
        "svg",
        "externalid",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "External Identities",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/03338-icon-service-External-Identities.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/03338-icon-service-External-Identities.svg",
      "tokens": [
        "External Identities",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "03338",
        "icon",
        "service",
        "External",
        "Identities",
        "svg",
        "externalidentities"
      ]
    },
    {
      "provider": "azure",
      "label": "Face AP Is",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/00794-icon-service-Face-APIs.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/00794-icon-service-Face-APIs.svg",
      "tokens": [
        "Face AP Is",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "00794",
        "icon",
        "service",
        "Face",
        "APIs",
        "svg",
        "faceapis",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Feature Previews",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10827-icon-service-Feature-Previews.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10827-icon-service-Feature-Previews.svg",
      "tokens": [
        "Feature Previews",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10827",
        "icon",
        "service",
        "Feature",
        "Previews",
        "svg",
        "featurepreviews"
      ]
    },
    {
      "provider": "azure",
      "label": "FHIR Service",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02658-icon-service-FHIR-Service.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02658-icon-service-FHIR-Service.svg",
      "tokens": [
        "FHIR Service",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02658",
        "icon",
        "service",
        "FHIR",
        "svg",
        "fhirservice"
      ]
    },
    {
      "provider": "azure",
      "label": "Fiji",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02486-icon-service-Fiji.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02486-icon-service-Fiji.svg",
      "tokens": [
        "Fiji",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02486",
        "icon",
        "service",
        "svg",
        "fiji"
      ]
    },
    {
      "provider": "azure",
      "label": "File",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10800-icon-service-File.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10800-icon-service-File.svg",
      "tokens": [
        "File",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10800",
        "icon",
        "service",
        "svg",
        "file"
      ]
    },
    {
      "provider": "azure",
      "label": "Files",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10801-icon-service-Files.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10801-icon-service-Files.svg",
      "tokens": [
        "Files",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10801",
        "icon",
        "service",
        "svg",
        "files"
      ]
    },
    {
      "provider": "azure",
      "label": "Firewalls",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10084-icon-service-Firewalls.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10084-icon-service-Firewalls.svg",
      "tokens": [
        "Firewalls",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10084",
        "icon",
        "service",
        "svg",
        "firewalls"
      ]
    },
    {
      "provider": "azure",
      "label": "Folder Blank",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10802-icon-service-Folder-Blank.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10802-icon-service-Folder-Blank.svg",
      "tokens": [
        "Folder Blank",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10802",
        "icon",
        "service",
        "Folder",
        "Blank",
        "svg",
        "folderblank"
      ]
    },
    {
      "provider": "azure",
      "label": "Folder Website",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10803-icon-service-Folder-Website.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10803-icon-service-Folder-Website.svg",
      "tokens": [
        "Folder Website",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10803",
        "icon",
        "service",
        "Folder",
        "Website",
        "svg",
        "folderwebsite"
      ]
    },
    {
      "provider": "azure",
      "label": "Form Recognizers",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/00819-icon-service-Form-Recognizers.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/00819-icon-service-Form-Recognizers.svg",
      "tokens": [
        "Form Recognizers",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "00819",
        "icon",
        "service",
        "Form",
        "Recognizers",
        "svg",
        "formrecognizers",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "FRD QA",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/029455661-icon-service-FRD-QA.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/029455661-icon-service-FRD-QA.svg",
      "tokens": [
        "FRD QA",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "029455661",
        "icon",
        "service",
        "FRD",
        "QA",
        "svg",
        "frdqa",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Free Services",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10016-icon-service-Free-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10016-icon-service-Free-Services.svg",
      "tokens": [
        "Free Services",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10016",
        "icon",
        "service",
        "Free",
        "Services",
        "svg",
        "freeservices"
      ]
    },
    {
      "provider": "azure",
      "label": "Front Door And CDN Profiles",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10073-icon-service-Front-Door-and-CDN-Profiles.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10073-icon-service-Front-Door-and-CDN-Profiles.svg",
      "tokens": [
        "Front Door And CDN Profiles",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10073",
        "icon",
        "service",
        "Front",
        "Door",
        "and",
        "CDN",
        "Profiles",
        "svg",
        "frontdoorandcdnprofiles"
      ]
    },
    {
      "provider": "azure",
      "label": "Front Door And CDN Profiles",
      "category": "Web",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/web/10073-icon-service-Front-Door-and-CDN-Profiles.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/web/10073-icon-service-Front-Door-and-CDN-Profiles.svg",
      "tokens": [
        "Front Door And CDN Profiles",
        "Web",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "web",
        "10073",
        "icon",
        "service",
        "Front",
        "Door",
        "and",
        "CDN",
        "Profiles",
        "svg",
        "frontdoorandcdnprofiles"
      ]
    },
    {
      "provider": "azure",
      "label": "FTP",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10804-icon-service-FTP.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10804-icon-service-FTP.svg",
      "tokens": [
        "FTP",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10804",
        "icon",
        "service",
        "svg",
        "ftp"
      ]
    },
    {
      "provider": "azure",
      "label": "Function Apps",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/10029-icon-service-Function-Apps.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/10029-icon-service-Function-Apps.svg",
      "tokens": [
        "Function Apps",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "10029",
        "icon",
        "service",
        "Function",
        "Apps",
        "svg",
        "functionapps"
      ]
    },
    {
      "provider": "azure",
      "label": "Function Apps",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/10029-icon-service-Function-Apps.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/10029-icon-service-Function-Apps.svg",
      "tokens": [
        "Function Apps",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "10029",
        "icon",
        "service",
        "Function",
        "Apps",
        "svg",
        "functionapps"
      ]
    },
    {
      "provider": "azure",
      "label": "Gear",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10805-icon-service-Gear.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10805-icon-service-Gear.svg",
      "tokens": [
        "Gear",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10805",
        "icon",
        "service",
        "svg",
        "gear"
      ]
    },
    {
      "provider": "azure",
      "label": "Genomics Accounts",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/10164-icon-service-Genomics-Accounts.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/10164-icon-service-Genomics-Accounts.svg",
      "tokens": [
        "Genomics Accounts",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "10164",
        "icon",
        "service",
        "Genomics",
        "Accounts",
        "svg",
        "genomicsaccounts",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Genomics",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/00031-icon-service-Genomics.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/00031-icon-service-Genomics.svg",
      "tokens": [
        "Genomics",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "00031",
        "icon",
        "service",
        "svg",
        "genomics",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Globe Error",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10807-icon-service-Globe-Error.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10807-icon-service-Globe-Error.svg",
      "tokens": [
        "Globe Error",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10807",
        "icon",
        "service",
        "Globe",
        "Error",
        "svg",
        "globeerror"
      ]
    },
    {
      "provider": "azure",
      "label": "Globe Success",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10808-icon-service-Globe-Success.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10808-icon-service-Globe-Success.svg",
      "tokens": [
        "Globe Success",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10808",
        "icon",
        "service",
        "Globe",
        "Success",
        "svg",
        "globesuccess"
      ]
    },
    {
      "provider": "azure",
      "label": "Globe Warning",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10809-icon-service-Globe-Warning.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10809-icon-service-Globe-Warning.svg",
      "tokens": [
        "Globe Warning",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10809",
        "icon",
        "service",
        "Globe",
        "Warning",
        "svg",
        "globewarning"
      ]
    },
    {
      "provider": "azure",
      "label": "Groups",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/10223-icon-service-Groups.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/10223-icon-service-Groups.svg",
      "tokens": [
        "Groups",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "10223",
        "icon",
        "service",
        "svg",
        "groups"
      ]
    },
    {
      "provider": "azure",
      "label": "Guide",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10810-icon-service-Guide.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10810-icon-service-Guide.svg",
      "tokens": [
        "Guide",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10810",
        "icon",
        "service",
        "svg",
        "guide"
      ]
    },
    {
      "provider": "azure",
      "label": "HD Insight Clusters",
      "category": "Analytics",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/analytics/10142-icon-service-HD-Insight-Clusters.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/analytics/10142-icon-service-HD-Insight-Clusters.svg",
      "tokens": [
        "HD Insight Clusters",
        "Analytics",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "analytics",
        "10142",
        "icon",
        "service",
        "HD",
        "Insight",
        "Clusters",
        "svg",
        "hdinsightclusters"
      ]
    },
    {
      "provider": "azure",
      "label": "HDI AKS Cluster",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03468-icon-service-HDI-AKS-Cluster.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03468-icon-service-HDI-AKS-Cluster.svg",
      "tokens": [
        "HDI AKS Cluster",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03468",
        "icon",
        "service",
        "HDI",
        "AKS",
        "Cluster",
        "svg",
        "hdiakscluster"
      ]
    },
    {
      "provider": "azure",
      "label": "Heart",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10811-icon-service-Heart.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10811-icon-service-Heart.svg",
      "tokens": [
        "Heart",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10811",
        "icon",
        "service",
        "svg",
        "heart"
      ]
    },
    {
      "provider": "azure",
      "label": "Help And Support",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10013-icon-service-Help-and-Support.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10013-icon-service-Help-and-Support.svg",
      "tokens": [
        "Help And Support",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10013",
        "icon",
        "service",
        "Help",
        "and",
        "Support",
        "svg",
        "helpandsupport"
      ]
    },
    {
      "provider": "azure",
      "label": "Host Groups",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/10346-icon-service-Host-Groups.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/10346-icon-service-Host-Groups.svg",
      "tokens": [
        "Host Groups",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "10346",
        "icon",
        "service",
        "Host",
        "Groups",
        "svg",
        "hostgroups"
      ]
    },
    {
      "provider": "azure",
      "label": "Host Pools",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/00328-icon-service-Host-Pools.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/00328-icon-service-Host-Pools.svg",
      "tokens": [
        "Host Pools",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "00328",
        "icon",
        "service",
        "Host",
        "Pools",
        "svg",
        "hostpools"
      ]
    },
    {
      "provider": "azure",
      "label": "Hosts",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/10347-icon-service-Hosts.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/10347-icon-service-Hosts.svg",
      "tokens": [
        "Hosts",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "10347",
        "icon",
        "service",
        "svg",
        "hosts"
      ]
    },
    {
      "provider": "azure",
      "label": "Hybrid Connectivity Hub",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/03656-icon-service-Hybrid-Connectivity-Hub.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/03656-icon-service-Hybrid-Connectivity-Hub.svg",
      "tokens": [
        "Hybrid Connectivity Hub",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "03656",
        "icon",
        "service",
        "Hybrid",
        "Connectivity",
        "Hub",
        "svg",
        "hybridconnectivityhub",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Ic M Troubleshooting",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03361-icon-service-IcM-Troubleshooting.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03361-icon-service-IcM-Troubleshooting.svg",
      "tokens": [
        "Ic M Troubleshooting",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03361",
        "icon",
        "service",
        "IcM",
        "Troubleshooting",
        "svg",
        "icmtroubleshooting"
      ]
    },
    {
      "provider": "azure",
      "label": "Identity Governance",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/10235-icon-service-Identity-Governance.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/10235-icon-service-Identity-Governance.svg",
      "tokens": [
        "Identity Governance",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "10235",
        "icon",
        "service",
        "Governance",
        "svg",
        "identitygovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Identity Secure Score",
      "category": "Security",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/security/03340-icon-service-Identity-Secure-Score.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/security/03340-icon-service-Identity-Secure-Score.svg",
      "tokens": [
        "Identity Secure Score",
        "Security",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "security",
        "03340",
        "icon",
        "service",
        "Identity",
        "Secure",
        "Score",
        "svg",
        "identitysecurescore"
      ]
    },
    {
      "provider": "azure",
      "label": "Image Definitions",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/10037-icon-service-Image-Definitions.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/10037-icon-service-Image-Definitions.svg",
      "tokens": [
        "Image Definitions",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "10037",
        "icon",
        "service",
        "Image",
        "Definitions",
        "svg",
        "imagedefinitions"
      ]
    },
    {
      "provider": "azure",
      "label": "Image Templates",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/02634-icon-service-Image-Templates.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/02634-icon-service-Image-Templates.svg",
      "tokens": [
        "Image Templates",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "02634",
        "icon",
        "service",
        "Image",
        "Templates",
        "svg",
        "imagetemplates"
      ]
    },
    {
      "provider": "azure",
      "label": "Image Versions",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/10038-icon-service-Image-Versions.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/10038-icon-service-Image-Versions.svg",
      "tokens": [
        "Image Versions",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "10038",
        "icon",
        "service",
        "Image",
        "Versions",
        "svg",
        "imageversions"
      ]
    },
    {
      "provider": "azure",
      "label": "Image",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10812-icon-service-Image.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10812-icon-service-Image.svg",
      "tokens": [
        "Image",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10812",
        "icon",
        "service",
        "svg",
        "image"
      ]
    },
    {
      "provider": "azure",
      "label": "Images",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/10033-icon-service-Images.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/10033-icon-service-Images.svg",
      "tokens": [
        "Images",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "10033",
        "icon",
        "service",
        "svg",
        "images"
      ]
    },
    {
      "provider": "azure",
      "label": "Immersive Readers",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/00812-icon-service-Immersive-Readers.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/00812-icon-service-Immersive-Readers.svg",
      "tokens": [
        "Immersive Readers",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "00812",
        "icon",
        "service",
        "Immersive",
        "Readers",
        "svg",
        "immersivereaders",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Import Export Jobs",
      "category": "Storage",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/storage/10100-icon-service-Import-Export-Jobs.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/storage/10100-icon-service-Import-Export-Jobs.svg",
      "tokens": [
        "Import Export Jobs",
        "Storage",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "storage",
        "10100",
        "icon",
        "service",
        "Import",
        "Export",
        "Jobs",
        "svg",
        "importexportjobs"
      ]
    },
    {
      "provider": "azure",
      "label": "Industrial Io T",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/02359-icon-service-Industrial-IoT.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/02359-icon-service-Industrial-IoT.svg",
      "tokens": [
        "Industrial Io T",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "02359",
        "icon",
        "service",
        "Industrial",
        "IoT",
        "svg",
        "industrialiot"
      ]
    },
    {
      "provider": "azure",
      "label": "Information",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10005-icon-service-Information.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10005-icon-service-Information.svg",
      "tokens": [
        "Information",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10005",
        "icon",
        "service",
        "svg",
        "information"
      ]
    },
    {
      "provider": "azure",
      "label": "Infrastructure Backup",
      "category": "Azure Stack",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/azure-stack/10108-icon-service-Infrastructure-Backup.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/azure stack/10108-icon-service-Infrastructure-Backup.svg",
      "tokens": [
        "Infrastructure Backup",
        "Azure Stack",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "azure",
        "stack",
        "10108",
        "icon",
        "service",
        "Infrastructure",
        "Backup",
        "svg",
        "infrastructurebackup",
        "azurestack"
      ]
    },
    {
      "provider": "azure",
      "label": "Input Output",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10813-icon-service-Input-Output.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10813-icon-service-Input-Output.svg",
      "tokens": [
        "Input Output",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10813",
        "icon",
        "service",
        "Input",
        "Output",
        "svg",
        "inputoutput"
      ]
    },
    {
      "provider": "azure",
      "label": "Instance Pools",
      "category": "Databases",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/databases/10139-icon-service-Instance-Pools.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/databases/10139-icon-service-Instance-Pools.svg",
      "tokens": [
        "Instance Pools",
        "Databases",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "databases",
        "10139",
        "icon",
        "service",
        "Instance",
        "Pools",
        "svg",
        "instancepools"
      ]
    },
    {
      "provider": "azure",
      "label": "Instance Pools",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/10139-icon-service-Instance-Pools.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/10139-icon-service-Instance-Pools.svg",
      "tokens": [
        "Instance Pools",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "10139",
        "icon",
        "service",
        "Instance",
        "Pools",
        "svg",
        "instancepools"
      ]
    },
    {
      "provider": "azure",
      "label": "Integration Accounts",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/10218-icon-service-Integration-Accounts.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/10218-icon-service-Integration-Accounts.svg",
      "tokens": [
        "Integration Accounts",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "10218",
        "icon",
        "service",
        "Accounts",
        "svg",
        "integrationaccounts"
      ]
    },
    {
      "provider": "azure",
      "label": "Integration Environments",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/03345-icon-service-Integration-Environments.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/03345-icon-service-Integration-Environments.svg",
      "tokens": [
        "Integration Environments",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "03345",
        "icon",
        "service",
        "Environments",
        "svg",
        "integrationenvironments"
      ]
    },
    {
      "provider": "azure",
      "label": "Integration Service Environments",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/00555-icon-service-Integration-Service-Environments.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/00555-icon-service-Integration-Service-Environments.svg",
      "tokens": [
        "Integration Service Environments",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "00555",
        "icon",
        "service",
        "Environments",
        "svg",
        "integrationserviceenvironments"
      ]
    },
    {
      "provider": "azure",
      "label": "Internet Analyzer Profiles",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/00469-icon-service-Internet-Analyzer-Profiles.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/00469-icon-service-Internet-Analyzer-Profiles.svg",
      "tokens": [
        "Internet Analyzer Profiles",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "00469",
        "icon",
        "service",
        "Internet",
        "Analyzer",
        "Profiles",
        "svg",
        "internetanalyzerprofiles"
      ]
    },
    {
      "provider": "azure",
      "label": "Intune App Protection",
      "category": "Intune",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/intune/10344-icon-service-Intune-App-Protection.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/intune/10344-icon-service-Intune-App-Protection.svg",
      "tokens": [
        "Intune App Protection",
        "Intune",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "intune",
        "10344",
        "icon",
        "service",
        "App",
        "Protection",
        "svg",
        "intuneappprotection"
      ]
    },
    {
      "provider": "azure",
      "label": "Intune For Education",
      "category": "Intune",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/intune/10343-icon-service-Intune-For-Education.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/intune/10343-icon-service-Intune-For-Education.svg",
      "tokens": [
        "Intune For Education",
        "Intune",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "intune",
        "10343",
        "icon",
        "service",
        "For",
        "Education",
        "svg",
        "intuneforeducation"
      ]
    },
    {
      "provider": "azure",
      "label": "Intune Trends",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/00408-icon-service-Intune-Trends.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/00408-icon-service-Intune-Trends.svg",
      "tokens": [
        "Intune Trends",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "00408",
        "icon",
        "service",
        "Intune",
        "Trends",
        "svg",
        "intunetrends",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Intune",
      "category": "Intune",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/intune/10329-icon-service-Intune.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/intune/10329-icon-service-Intune.svg",
      "tokens": [
        "Intune",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "intune",
        "10329",
        "icon",
        "service",
        "svg"
      ]
    },
    {
      "provider": "azure",
      "label": "Io T Central Applications",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/10184-icon-service-IoT-Central-Applications.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/10184-icon-service-IoT-Central-Applications.svg",
      "tokens": [
        "Io T Central Applications",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "10184",
        "icon",
        "service",
        "IoT",
        "Central",
        "Applications",
        "svg",
        "iotcentralapplications"
      ]
    },
    {
      "provider": "azure",
      "label": "Io T Edge",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/10186-icon-service-IoT-Edge.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/10186-icon-service-IoT-Edge.svg",
      "tokens": [
        "Io T Edge",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "10186",
        "icon",
        "service",
        "IoT",
        "Edge",
        "svg",
        "iotedge"
      ]
    },
    {
      "provider": "azure",
      "label": "Io T Hub",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/10182-icon-service-IoT-Hub.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/10182-icon-service-IoT-Hub.svg",
      "tokens": [
        "Io T Hub",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "10182",
        "icon",
        "service",
        "IoT",
        "Hub",
        "svg",
        "iothub"
      ]
    },
    {
      "provider": "azure",
      "label": "IP Address Manager",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/03461-icon-service-IP-Address-manager.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/03461-icon-service-IP-Address-manager.svg",
      "tokens": [
        "IP Address Manager",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "03461",
        "icon",
        "service",
        "IP",
        "Address",
        "manager",
        "svg",
        "ipaddressmanager"
      ]
    },
    {
      "provider": "azure",
      "label": "IP Groups",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/00701-icon-service-IP-Groups.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/00701-icon-service-IP-Groups.svg",
      "tokens": [
        "IP Groups",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "00701",
        "icon",
        "service",
        "IP",
        "Groups",
        "svg",
        "ipgroups"
      ]
    },
    {
      "provider": "azure",
      "label": "Journey Hub",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10814-icon-service-Journey-Hub.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10814-icon-service-Journey-Hub.svg",
      "tokens": [
        "Journey Hub",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10814",
        "icon",
        "service",
        "Journey",
        "Hub",
        "svg",
        "journeyhub"
      ]
    },
    {
      "provider": "azure",
      "label": "Key Vaults",
      "category": "Security",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/security/10245-icon-service-Key-Vaults.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/security/10245-icon-service-Key-Vaults.svg",
      "tokens": [
        "Key Vaults",
        "Security",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "security",
        "10245",
        "icon",
        "service",
        "Key",
        "Vaults",
        "svg",
        "keyvaults"
      ]
    },
    {
      "provider": "azure",
      "label": "Keys",
      "category": "Menu",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/menu/00787-icon-service-Keys.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/menu/00787-icon-service-Keys.svg",
      "tokens": [
        "Keys",
        "Menu",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "menu",
        "00787",
        "icon",
        "service",
        "svg",
        "keys"
      ]
    },
    {
      "provider": "azure",
      "label": "Kubernetes Fleet Manager",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03134-icon-service-Kubernetes-Fleet-Manager.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03134-icon-service-Kubernetes-Fleet-Manager.svg",
      "tokens": [
        "Kubernetes Fleet Manager",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03134",
        "icon",
        "service",
        "Kubernetes",
        "Fleet",
        "Manager",
        "svg",
        "kubernetesfleetmanager"
      ]
    },
    {
      "provider": "azure",
      "label": "Kubernetes Hub",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/033545113-icon-service-Kubernetes-Hub.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/033545113-icon-service-Kubernetes-Hub.svg",
      "tokens": [
        "Kubernetes Hub",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "033545113",
        "icon",
        "service",
        "Kubernetes",
        "Hub",
        "svg",
        "kuberneteshub",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Kubernetes Services",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/10023-icon-service-Kubernetes-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/10023-icon-service-Kubernetes-Services.svg",
      "tokens": [
        "Kubernetes Services",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "10023",
        "icon",
        "service",
        "Kubernetes",
        "Services",
        "svg",
        "kubernetesservices"
      ]
    },
    {
      "provider": "azure",
      "label": "Kubernetes Services",
      "category": "Containers",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/containers/10023-icon-service-Kubernetes-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/containers/10023-icon-service-Kubernetes-Services.svg",
      "tokens": [
        "Kubernetes Services",
        "Containers",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "containers",
        "10023",
        "icon",
        "service",
        "Kubernetes",
        "Services",
        "svg",
        "kubernetesservices"
      ]
    },
    {
      "provider": "azure",
      "label": "Lab Accounts",
      "category": "Devops",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/devops/02761-icon-service-Lab-Accounts.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/devops/02761-icon-service-Lab-Accounts.svg",
      "tokens": [
        "Lab Accounts",
        "Devops",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "devops",
        "02761",
        "icon",
        "service",
        "Lab",
        "Accounts",
        "svg",
        "labaccounts"
      ]
    },
    {
      "provider": "azure",
      "label": "Lab Services",
      "category": "Devops",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/devops/10265-icon-service-Lab-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/devops/10265-icon-service-Lab-Services.svg",
      "tokens": [
        "Lab Services",
        "Devops",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "devops",
        "10265",
        "icon",
        "service",
        "Lab",
        "Services",
        "svg",
        "labservices"
      ]
    },
    {
      "provider": "azure",
      "label": "Landing Zone",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/029636048-icon-service-Landing-Zone.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/029636048-icon-service-Landing-Zone.svg",
      "tokens": [
        "Landing Zone",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "029636048",
        "icon",
        "service",
        "Landing",
        "Zone",
        "svg",
        "landingzone",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Language Understanding",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/00801-icon-service-Language-Understanding.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/00801-icon-service-Language-Understanding.svg",
      "tokens": [
        "Language Understanding",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "00801",
        "icon",
        "service",
        "Language",
        "Understanding",
        "svg",
        "languageunderstanding",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Language",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/02876-icon-service-Language.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/02876-icon-service-Language.svg",
      "tokens": [
        "Language",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "02876",
        "icon",
        "service",
        "svg",
        "language",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Launch Portal",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10815-icon-service-Launch-Portal.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10815-icon-service-Launch-Portal.svg",
      "tokens": [
        "Launch Portal",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10815",
        "icon",
        "service",
        "Launch",
        "Portal",
        "svg",
        "launchportal"
      ]
    },
    {
      "provider": "azure",
      "label": "Learn",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10816-icon-service-Learn.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10816-icon-service-Learn.svg",
      "tokens": [
        "Learn",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10816",
        "icon",
        "service",
        "svg",
        "learn"
      ]
    },
    {
      "provider": "azure",
      "label": "Load Balancer Hub",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/02302-icon-service-Load-Balancer-Hub.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/02302-icon-service-Load-Balancer-Hub.svg",
      "tokens": [
        "Load Balancer Hub",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "02302",
        "icon",
        "service",
        "Load",
        "Balancer",
        "Hub",
        "svg",
        "loadbalancerhub"
      ]
    },
    {
      "provider": "azure",
      "label": "Load Balancer Hub",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/029029174-icon-service-Load-Balancer-Hub.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/029029174-icon-service-Load-Balancer-Hub.svg",
      "tokens": [
        "Load Balancer Hub",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "029029174",
        "icon",
        "service",
        "Load",
        "Balancer",
        "Hub",
        "svg",
        "loadbalancerhub",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Load Balancers",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10062-icon-service-Load-Balancers.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10062-icon-service-Load-Balancers.svg",
      "tokens": [
        "Load Balancers",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10062",
        "icon",
        "service",
        "Load",
        "Balancers",
        "svg",
        "loadbalancers"
      ]
    },
    {
      "provider": "azure",
      "label": "Load Test",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10817-icon-service-Load-Test.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10817-icon-service-Load-Test.svg",
      "tokens": [
        "Load Test",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10817",
        "icon",
        "service",
        "Load",
        "Test",
        "svg",
        "loadtest"
      ]
    },
    {
      "provider": "azure",
      "label": "Load Testing",
      "category": "Devops",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/devops/02423-icon-service-Load-Testing.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/devops/02423-icon-service-Load-Testing.svg",
      "tokens": [
        "Load Testing",
        "Devops",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "devops",
        "02423",
        "icon",
        "service",
        "Load",
        "Testing",
        "svg",
        "loadtesting"
      ]
    },
    {
      "provider": "azure",
      "label": "Local Network Gateways",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10077-icon-service-Local-Network-Gateways.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10077-icon-service-Local-Network-Gateways.svg",
      "tokens": [
        "Local Network Gateways",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10077",
        "icon",
        "service",
        "Local",
        "Network",
        "Gateways",
        "svg",
        "localnetworkgateways"
      ]
    },
    {
      "provider": "azure",
      "label": "Local Network Gateways",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/10077-icon-service-Local-Network-Gateways.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/10077-icon-service-Local-Network-Gateways.svg",
      "tokens": [
        "Local Network Gateways",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "10077",
        "icon",
        "service",
        "Local",
        "Network",
        "Gateways",
        "svg",
        "localnetworkgateways"
      ]
    },
    {
      "provider": "azure",
      "label": "Location",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10818-icon-service-Location.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10818-icon-service-Location.svg",
      "tokens": [
        "Location",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10818",
        "icon",
        "service",
        "svg",
        "location"
      ]
    },
    {
      "provider": "azure",
      "label": "Log Analytics Query Pack",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/01085-icon-service-Log-Analytics-Query-Pack.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/01085-icon-service-Log-Analytics-Query-Pack.svg",
      "tokens": [
        "Log Analytics Query Pack",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "01085",
        "icon",
        "service",
        "Log",
        "Analytics",
        "Query",
        "Pack",
        "svg",
        "loganalyticsquerypack"
      ]
    },
    {
      "provider": "azure",
      "label": "Log Analytics Workspaces",
      "category": "Analytics",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/analytics/00009-icon-service-Log-Analytics-Workspaces.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/analytics/00009-icon-service-Log-Analytics-Workspaces.svg",
      "tokens": [
        "Log Analytics Workspaces",
        "Analytics",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "analytics",
        "00009",
        "icon",
        "service",
        "Log",
        "Workspaces",
        "svg",
        "loganalyticsworkspaces"
      ]
    },
    {
      "provider": "azure",
      "label": "Log Analytics Workspaces",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/00009-icon-service-Log-Analytics-Workspaces.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/00009-icon-service-Log-Analytics-Workspaces.svg",
      "tokens": [
        "Log Analytics Workspaces",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "00009",
        "icon",
        "service",
        "Log",
        "Analytics",
        "Workspaces",
        "svg",
        "loganalyticsworkspaces",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Log Analytics Workspaces",
      "category": "Monitor",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/monitor/00009-icon-service-Log-Analytics-Workspaces.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/monitor/00009-icon-service-Log-Analytics-Workspaces.svg",
      "tokens": [
        "Log Analytics Workspaces",
        "Monitor",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "monitor",
        "00009",
        "icon",
        "service",
        "Log",
        "Analytics",
        "Workspaces",
        "svg",
        "loganalyticsworkspaces"
      ]
    },
    {
      "provider": "azure",
      "label": "Log Streaming",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10819-icon-service-Log-Streaming.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10819-icon-service-Log-Streaming.svg",
      "tokens": [
        "Log Streaming",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10819",
        "icon",
        "service",
        "Log",
        "Streaming",
        "svg",
        "logstreaming"
      ]
    },
    {
      "provider": "azure",
      "label": "Logic Apps Custom Connector",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/10363-icon-service-Logic-Apps-Custom-Connector.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/10363-icon-service-Logic-Apps-Custom-Connector.svg",
      "tokens": [
        "Logic Apps Custom Connector",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "10363",
        "icon",
        "service",
        "Logic",
        "Apps",
        "Custom",
        "Connector",
        "svg",
        "logicappscustomconnector"
      ]
    },
    {
      "provider": "azure",
      "label": "Logic Apps Template",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/032130874-icon-service-Logic-Apps-Template.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/032130874-icon-service-Logic-Apps-Template.svg",
      "tokens": [
        "Logic Apps Template",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "032130874",
        "icon",
        "service",
        "Logic",
        "Apps",
        "Template",
        "svg",
        "logicappstemplate",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Logic Apps",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/02631-icon-service-Logic-Apps.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/02631-icon-service-Logic-Apps.svg",
      "tokens": [
        "Logic Apps",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "02631",
        "icon",
        "service",
        "Logic",
        "Apps",
        "svg",
        "logicapps"
      ]
    },
    {
      "provider": "azure",
      "label": "Logic Apps",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/02631-icon-service-Logic-Apps.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/02631-icon-service-Logic-Apps.svg",
      "tokens": [
        "Logic Apps",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "02631",
        "icon",
        "service",
        "Logic",
        "Apps",
        "svg",
        "logicapps"
      ]
    },
    {
      "provider": "azure",
      "label": "Machine Learning Studio (Classic) Web Services",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/00030-icon-service-Machine-Learning-Studio-(Classic)-Web-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/00030-icon-service-Machine-Learning-Studio-(Classic)-Web-Services.svg",
      "tokens": [
        "Machine Learning Studio (Classic) Web Services",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "00030",
        "icon",
        "service",
        "Machine",
        "Learning",
        "Studio",
        "(Classic)",
        "Web",
        "Services",
        "svg",
        "machinelearningstudioclassicwebservices",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Machine Learning Studio (Classic) Web Services",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/00030-icon-service-Machine-Learning-Studio-(Classic)-Web-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/00030-icon-service-Machine-Learning-Studio-(Classic)-Web-Services.svg",
      "tokens": [
        "Machine Learning Studio (Classic) Web Services",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "00030",
        "icon",
        "service",
        "Machine",
        "Learning",
        "Studio",
        "(Classic)",
        "Web",
        "Services",
        "svg",
        "machinelearningstudioclassicwebservices"
      ]
    },
    {
      "provider": "azure",
      "label": "Machine Learning Studio Web Service Plans",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/10168-icon-service-Machine-Learning-Studio-Web-Service-Plans.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/10168-icon-service-Machine-Learning-Studio-Web-Service-Plans.svg",
      "tokens": [
        "Machine Learning Studio Web Service Plans",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "10168",
        "icon",
        "service",
        "Machine",
        "Learning",
        "Studio",
        "Web",
        "Plans",
        "svg",
        "machinelearningstudiowebserviceplans",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Machine Learning Studio Web Service Plans",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/10168-icon-service-Machine-Learning-Studio-Web-Service-Plans.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/10168-icon-service-Machine-Learning-Studio-Web-Service-Plans.svg",
      "tokens": [
        "Machine Learning Studio Web Service Plans",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "10168",
        "icon",
        "service",
        "Machine",
        "Learning",
        "Studio",
        "Web",
        "Plans",
        "svg",
        "machinelearningstudiowebserviceplans"
      ]
    },
    {
      "provider": "azure",
      "label": "Machine Learning Studio Workspaces",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/10167-icon-service-Machine-Learning-Studio-Workspaces.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/10167-icon-service-Machine-Learning-Studio-Workspaces.svg",
      "tokens": [
        "Machine Learning Studio Workspaces",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "10167",
        "icon",
        "service",
        "Machine",
        "Learning",
        "Studio",
        "Workspaces",
        "svg",
        "machinelearningstudioworkspaces",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Machine Learning Studio Workspaces",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/10167-icon-service-Machine-Learning-Studio-Workspaces.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/10167-icon-service-Machine-Learning-Studio-Workspaces.svg",
      "tokens": [
        "Machine Learning Studio Workspaces",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "10167",
        "icon",
        "service",
        "Machine",
        "Learning",
        "Studio",
        "Workspaces",
        "svg",
        "machinelearningstudioworkspaces"
      ]
    },
    {
      "provider": "azure",
      "label": "Machine Learning",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/10166-icon-service-Machine-Learning.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/10166-icon-service-Machine-Learning.svg",
      "tokens": [
        "Machine Learning",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "10166",
        "icon",
        "service",
        "Machine",
        "Learning",
        "svg",
        "machinelearning",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Machines Azure Arc",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/10450-icon-service-MachinesAzureArc.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/10450-icon-service-MachinesAzureArc.svg",
      "tokens": [
        "Machines Azure Arc",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "10450",
        "icon",
        "service",
        "MachinesAzureArc",
        "svg",
        "machinesazurearc",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Maintenance Configuration",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/00195-icon-service-Maintenance-Configuration.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/00195-icon-service-Maintenance-Configuration.svg",
      "tokens": [
        "Maintenance Configuration",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "00195",
        "icon",
        "service",
        "Maintenance",
        "Configuration",
        "svg",
        "maintenanceconfiguration"
      ]
    },
    {
      "provider": "azure",
      "label": "Managed Applications Center",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/10313-icon-service-Managed-Applications-Center.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/10313-icon-service-Managed-Applications-Center.svg",
      "tokens": [
        "Managed Applications Center",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "10313",
        "icon",
        "service",
        "Managed",
        "Applications",
        "Center",
        "svg",
        "managedapplicationscenter",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Managed Database",
      "category": "Databases",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/databases/10135-icon-service-Managed-Database.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/databases/10135-icon-service-Managed-Database.svg",
      "tokens": [
        "Managed Database",
        "Databases",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "databases",
        "10135",
        "icon",
        "service",
        "Managed",
        "Database",
        "svg",
        "manageddatabase"
      ]
    },
    {
      "provider": "azure",
      "label": "Managed Desktop",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/10311-icon-service-Managed-Desktop.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/10311-icon-service-Managed-Desktop.svg",
      "tokens": [
        "Managed Desktop",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "10311",
        "icon",
        "service",
        "Managed",
        "Desktop",
        "svg",
        "manageddesktop",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Managed Dev Ops Pools",
      "category": "Devops",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/devops/03393-icon-service-Managed-DevOps-Pools.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/devops/03393-icon-service-Managed-DevOps-Pools.svg",
      "tokens": [
        "Managed Dev Ops Pools",
        "Devops",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "devops",
        "03393",
        "icon",
        "service",
        "Managed",
        "DevOps",
        "Pools",
        "svg",
        "manageddevopspools"
      ]
    },
    {
      "provider": "azure",
      "label": "Managed File Shares",
      "category": "Storage",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/storage/03549-icon-service-Managed-File-Shares.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/storage/03549-icon-service-Managed-File-Shares.svg",
      "tokens": [
        "Managed File Shares",
        "Storage",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "storage",
        "03549",
        "icon",
        "service",
        "Managed",
        "File",
        "Shares",
        "svg",
        "managedfileshares"
      ]
    },
    {
      "provider": "azure",
      "label": "Managed Identities",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/10227-icon-service-Managed-Identities.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/10227-icon-service-Managed-Identities.svg",
      "tokens": [
        "Managed Identities",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "10227",
        "icon",
        "service",
        "Managed",
        "Identities",
        "svg",
        "managedidentities"
      ]
    },
    {
      "provider": "azure",
      "label": "Managed Instance Apache Cassandra",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02663-icon-service-Managed-Instance-Apache-Cassandra.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02663-icon-service-Managed-Instance-Apache-Cassandra.svg",
      "tokens": [
        "Managed Instance Apache Cassandra",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02663",
        "icon",
        "service",
        "Managed",
        "Instance",
        "Apache",
        "Cassandra",
        "svg",
        "managedinstanceapachecassandra"
      ]
    },
    {
      "provider": "azure",
      "label": "Managed Service Fabric",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/02370-icon-service-Managed-Service-Fabric.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/02370-icon-service-Managed-Service-Fabric.svg",
      "tokens": [
        "Managed Service Fabric",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "02370",
        "icon",
        "service",
        "Managed",
        "Fabric",
        "svg",
        "managedservicefabric"
      ]
    },
    {
      "provider": "azure",
      "label": "Management Groups",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10011-icon-service-Management-Groups.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10011-icon-service-Management-Groups.svg",
      "tokens": [
        "Management Groups",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10011",
        "icon",
        "service",
        "Management",
        "Groups",
        "svg",
        "managementgroups"
      ]
    },
    {
      "provider": "azure",
      "label": "Management Portal",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10820-icon-service-Management-Portal.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10820-icon-service-Management-Portal.svg",
      "tokens": [
        "Management Portal",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10820",
        "icon",
        "service",
        "Management",
        "Portal",
        "svg",
        "managementportal"
      ]
    },
    {
      "provider": "azure",
      "label": "Marketplace Management",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10112-icon-service-Marketplace-Management.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10112-icon-service-Marketplace-Management.svg",
      "tokens": [
        "Marketplace Management",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10112",
        "icon",
        "service",
        "Marketplace",
        "Management",
        "svg",
        "marketplacemanagement"
      ]
    },
    {
      "provider": "azure",
      "label": "Marketplace",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10008-icon-service-Marketplace.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10008-icon-service-Marketplace.svg",
      "tokens": [
        "Marketplace",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10008",
        "icon",
        "service",
        "svg",
        "marketplace"
      ]
    },
    {
      "provider": "azure",
      "label": "Med Tech Service",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02660-icon-service-MedTech-Service.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02660-icon-service-MedTech-Service.svg",
      "tokens": [
        "Med Tech Service",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02660",
        "icon",
        "service",
        "MedTech",
        "svg",
        "medtechservice"
      ]
    },
    {
      "provider": "azure",
      "label": "Media File",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10821-icon-service-Media-File.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10821-icon-service-Media-File.svg",
      "tokens": [
        "Media File",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10821",
        "icon",
        "service",
        "Media",
        "File",
        "svg",
        "mediafile"
      ]
    },
    {
      "provider": "azure",
      "label": "Media",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10854-icon-service-Media.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10854-icon-service-Media.svg",
      "tokens": [
        "Media",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10854",
        "icon",
        "service",
        "svg",
        "media"
      ]
    },
    {
      "provider": "azure",
      "label": "Mesh Applications",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/10024-icon-service-Mesh-Applications.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/10024-icon-service-Mesh-Applications.svg",
      "tokens": [
        "Mesh Applications",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "10024",
        "icon",
        "service",
        "Mesh",
        "Applications",
        "svg",
        "meshapplications"
      ]
    },
    {
      "provider": "azure",
      "label": "Metrics Advisor",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/02409-icon-service-Metrics-Advisor.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/02409-icon-service-Metrics-Advisor.svg",
      "tokens": [
        "Metrics Advisor",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "02409",
        "icon",
        "service",
        "Metrics",
        "Advisor",
        "svg",
        "metricsadvisor",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Metrics Advisor",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/02409-icon-service-Metrics-Advisor.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/02409-icon-service-Metrics-Advisor.svg",
      "tokens": [
        "Metrics Advisor",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "02409",
        "icon",
        "service",
        "Metrics",
        "Advisor",
        "svg",
        "metricsadvisor"
      ]
    },
    {
      "provider": "azure",
      "label": "Metrics",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/00020-icon-service-Metrics.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/00020-icon-service-Metrics.svg",
      "tokens": [
        "Metrics",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "00020",
        "icon",
        "service",
        "svg",
        "metrics",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Metrics",
      "category": "Monitor",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/monitor/00020-icon-service-Metrics.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/monitor/00020-icon-service-Metrics.svg",
      "tokens": [
        "Metrics",
        "Monitor",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "monitor",
        "00020",
        "icon",
        "service",
        "svg",
        "metrics"
      ]
    },
    {
      "provider": "azure",
      "label": "Microsoft Defender EASM",
      "category": "Security",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/security/03336-icon-service-Microsoft-Defender-EASM.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/security/03336-icon-service-Microsoft-Defender-EASM.svg",
      "tokens": [
        "Microsoft Defender EASM",
        "Security",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "security",
        "03336",
        "icon",
        "service",
        "Microsoft",
        "Defender",
        "EASM",
        "svg",
        "microsoftdefendereasm"
      ]
    },
    {
      "provider": "azure",
      "label": "Microsoft Defender For Cloud",
      "category": "Security",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/security/10241-icon-service-Microsoft-Defender-for-Cloud.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/security/10241-icon-service-Microsoft-Defender-for-Cloud.svg",
      "tokens": [
        "Microsoft Defender For Cloud",
        "Security",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "security",
        "10241",
        "icon",
        "service",
        "Microsoft",
        "Defender",
        "for",
        "Cloud",
        "svg",
        "microsoftdefenderforcloud"
      ]
    },
    {
      "provider": "azure",
      "label": "Microsoft Defender For Io T",
      "category": "Security",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/security/02247-icon-service-Microsoft-Defender-for-IoT.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/security/02247-icon-service-Microsoft-Defender-for-IoT.svg",
      "tokens": [
        "Microsoft Defender For Io T",
        "Security",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "security",
        "02247",
        "icon",
        "service",
        "Microsoft",
        "Defender",
        "for",
        "IoT",
        "svg",
        "microsoftdefenderforiot"
      ]
    },
    {
      "provider": "azure",
      "label": "Microsoft Dev Box",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03250-icon-service-Microsoft-Dev-Box.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03250-icon-service-Microsoft-Dev-Box.svg",
      "tokens": [
        "Microsoft Dev Box",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03250",
        "icon",
        "service",
        "Microsoft",
        "Dev",
        "Box",
        "svg",
        "microsoftdevbox"
      ]
    },
    {
      "provider": "azure",
      "label": "Microsoft Discovery",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/032869111-icon-service-Microsoft-Discovery.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/032869111-icon-service-Microsoft-Discovery.svg",
      "tokens": [
        "Microsoft Discovery",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "032869111",
        "icon",
        "service",
        "Microsoft",
        "Discovery",
        "svg",
        "microsoftdiscovery",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Mindaro",
      "category": "Intune",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/intune/10350-icon-service-Mindaro.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/intune/10350-icon-service-Mindaro.svg",
      "tokens": [
        "Mindaro",
        "Intune",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "intune",
        "10350",
        "icon",
        "service",
        "svg",
        "mindaro"
      ]
    },
    {
      "provider": "azure",
      "label": "Mission Landing Zone",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02793-icon-service-Mission-Landing-Zone.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02793-icon-service-Mission-Landing-Zone.svg",
      "tokens": [
        "Mission Landing Zone",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02793",
        "icon",
        "service",
        "Mission",
        "Landing",
        "Zone",
        "svg",
        "missionlandingzone"
      ]
    },
    {
      "provider": "azure",
      "label": "Mobile Engagement",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10823-icon-service-Mobile-Engagement.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10823-icon-service-Mobile-Engagement.svg",
      "tokens": [
        "Mobile Engagement",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10823",
        "icon",
        "service",
        "Mobile",
        "Engagement",
        "svg",
        "mobileengagement"
      ]
    },
    {
      "provider": "azure",
      "label": "Mobile Networks",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02794-icon-service-Mobile-Networks.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02794-icon-service-Mobile-Networks.svg",
      "tokens": [
        "Mobile Networks",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02794",
        "icon",
        "service",
        "Mobile",
        "Networks",
        "svg",
        "mobilenetworks"
      ]
    },
    {
      "provider": "azure",
      "label": "Mobile",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10822-icon-service-Mobile.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10822-icon-service-Mobile.svg",
      "tokens": [
        "Mobile",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10822",
        "icon",
        "service",
        "svg",
        "mobile"
      ]
    },
    {
      "provider": "azure",
      "label": "Modular Data Center",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02323-icon-service-Modular-Data-Center.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02323-icon-service-Modular-Data-Center.svg",
      "tokens": [
        "Modular Data Center",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02323",
        "icon",
        "service",
        "Modular",
        "Data",
        "Center",
        "svg",
        "modulardatacenter"
      ]
    },
    {
      "provider": "azure",
      "label": "Module",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10855-icon-service-Module.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10855-icon-service-Module.svg",
      "tokens": [
        "Module",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10855",
        "icon",
        "service",
        "svg",
        "module"
      ]
    },
    {
      "provider": "azure",
      "label": "Monitor Health Models",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03528-icon-service-Monitor-Health-Models.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03528-icon-service-Monitor-Health-Models.svg",
      "tokens": [
        "Monitor Health Models",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03528",
        "icon",
        "service",
        "Monitor",
        "Health",
        "Models",
        "svg",
        "monitorhealthmodels"
      ]
    },
    {
      "provider": "azure",
      "label": "Monitor Issues",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/034855501-icon-service-Monitor-Issues.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/034855501-icon-service-Monitor-Issues.svg",
      "tokens": [
        "Monitor Issues",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "034855501",
        "icon",
        "service",
        "Monitor",
        "Issues",
        "svg",
        "monitorissues",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Monitor",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/00001-icon-service-Monitor.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/00001-icon-service-Monitor.svg",
      "tokens": [
        "Monitor",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "00001",
        "icon",
        "service",
        "svg",
        "monitor",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Monitor",
      "category": "Monitor",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/monitor/00001-icon-service-Monitor.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/monitor/00001-icon-service-Monitor.svg",
      "tokens": [
        "Monitor",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "monitor",
        "00001",
        "icon",
        "service",
        "svg"
      ]
    },
    {
      "provider": "azure",
      "label": "Multi Factor Authentication",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/03256-icon-service-Multi-Factor-Authentication.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/03256-icon-service-Multi-Factor-Authentication.svg",
      "tokens": [
        "Multi Factor Authentication",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "03256",
        "icon",
        "service",
        "Multi",
        "Factor",
        "Authentication",
        "svg",
        "multifactorauthentication"
      ]
    },
    {
      "provider": "azure",
      "label": "Multi Tenancy",
      "category": "Azure Stack",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/azure-stack/00965-icon-service-Multi-Tenancy.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/azure stack/00965-icon-service-Multi-Tenancy.svg",
      "tokens": [
        "Multi Tenancy",
        "Azure Stack",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "azure",
        "stack",
        "00965",
        "icon",
        "service",
        "Multi",
        "Tenancy",
        "svg",
        "multitenancy",
        "azurestack"
      ]
    },
    {
      "provider": "azure",
      "label": "Multifactor Authentication",
      "category": "Security",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/security/03344-icon-service-Multifactor-Authentication.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/security/03344-icon-service-Multifactor-Authentication.svg",
      "tokens": [
        "Multifactor Authentication",
        "Security",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "security",
        "03344",
        "icon",
        "service",
        "Multifactor",
        "Authentication",
        "svg",
        "multifactorauthentication"
      ]
    },
    {
      "provider": "azure",
      "label": "My Customers",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/00014-icon-service-My-Customers.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/00014-icon-service-My-Customers.svg",
      "tokens": [
        "My Customers",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "00014",
        "icon",
        "service",
        "My",
        "Customers",
        "svg",
        "mycustomers",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "NAT",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10310-icon-service-NAT.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10310-icon-service-NAT.svg",
      "tokens": [
        "NAT",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10310",
        "icon",
        "service",
        "svg",
        "nat"
      ]
    },
    {
      "provider": "azure",
      "label": "Network Foundation Hub",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/03643-icon-service-Network-Foundation-Hub.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/03643-icon-service-Network-Foundation-Hub.svg",
      "tokens": [
        "Network Foundation Hub",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "03643",
        "icon",
        "service",
        "Network",
        "Foundation",
        "Hub",
        "svg",
        "networkfoundationhub",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Network Interfaces",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10080-icon-service-Network-Interfaces.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10080-icon-service-Network-Interfaces.svg",
      "tokens": [
        "Network Interfaces",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10080",
        "icon",
        "service",
        "Network",
        "Interfaces",
        "svg",
        "networkinterfaces"
      ]
    },
    {
      "provider": "azure",
      "label": "Network Managers",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02237-icon-service-Network-Managers.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02237-icon-service-Network-Managers.svg",
      "tokens": [
        "Network Managers",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02237",
        "icon",
        "service",
        "Network",
        "Managers",
        "svg",
        "networkmanagers"
      ]
    },
    {
      "provider": "azure",
      "label": "Network Security Groups",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10067-icon-service-Network-Security-Groups.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10067-icon-service-Network-Security-Groups.svg",
      "tokens": [
        "Network Security Groups",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10067",
        "icon",
        "service",
        "Network",
        "Security",
        "Groups",
        "svg",
        "networksecuritygroups"
      ]
    },
    {
      "provider": "azure",
      "label": "Network Security Hub",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/03650-icon-service-Network-Security-Hub.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/03650-icon-service-Network-Security-Hub.svg",
      "tokens": [
        "Network Security Hub",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "03650",
        "icon",
        "service",
        "Network",
        "Security",
        "Hub",
        "svg",
        "networksecurityhub",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Network Security Perimeters",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02939-icon-service-Network-Security-Perimeters.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02939-icon-service-Network-Security-Perimeters.svg",
      "tokens": [
        "Network Security Perimeters",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02939",
        "icon",
        "service",
        "Network",
        "Security",
        "Perimeters",
        "svg",
        "networksecurityperimeters"
      ]
    },
    {
      "provider": "azure",
      "label": "Network Watcher",
      "category": "Monitor",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/monitor/10066-icon-service-Network-Watcher.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/monitor/10066-icon-service-Network-Watcher.svg",
      "tokens": [
        "Network Watcher",
        "Monitor",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "monitor",
        "10066",
        "icon",
        "service",
        "Network",
        "Watcher",
        "svg",
        "networkwatcher"
      ]
    },
    {
      "provider": "azure",
      "label": "Network Watcher",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10066-icon-service-Network-Watcher.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10066-icon-service-Network-Watcher.svg",
      "tokens": [
        "Network Watcher",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10066",
        "icon",
        "service",
        "Network",
        "Watcher",
        "svg",
        "networkwatcher"
      ]
    },
    {
      "provider": "azure",
      "label": "Notification Hub Namespaces",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/10053-icon-service-Notification-Hub-Namespaces.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/10053-icon-service-Notification-Hub-Namespaces.svg",
      "tokens": [
        "Notification Hub Namespaces",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "10053",
        "icon",
        "service",
        "Notification",
        "Hub",
        "Namespaces",
        "svg",
        "notificationhubnamespaces"
      ]
    },
    {
      "provider": "azure",
      "label": "Notification Hub Namespaces",
      "category": "Web",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/web/10053-icon-service-Notification-Hub-Namespaces.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/web/10053-icon-service-Notification-Hub-Namespaces.svg",
      "tokens": [
        "Notification Hub Namespaces",
        "Web",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "web",
        "10053",
        "icon",
        "service",
        "Notification",
        "Hub",
        "Namespaces",
        "svg",
        "notificationhubnamespaces"
      ]
    },
    {
      "provider": "azure",
      "label": "Notification Hubs",
      "category": "App Services",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/app-services/10045-icon-service-Notification-Hubs.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/app services/10045-icon-service-Notification-Hubs.svg",
      "tokens": [
        "Notification Hubs",
        "App Services",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "app",
        "services",
        "10045",
        "icon",
        "service",
        "Notification",
        "Hubs",
        "svg",
        "notificationhubs",
        "appservices"
      ]
    },
    {
      "provider": "azure",
      "label": "Notification Hubs",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/10045-icon-service-Notification-Hubs.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/10045-icon-service-Notification-Hubs.svg",
      "tokens": [
        "Notification Hubs",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "10045",
        "icon",
        "service",
        "Notification",
        "Hubs",
        "svg",
        "notificationhubs"
      ]
    },
    {
      "provider": "azure",
      "label": "Notification Hubs",
      "category": "Mobile",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/mobile/10045-icon-service-Notification-Hubs.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/mobile/10045-icon-service-Notification-Hubs.svg",
      "tokens": [
        "Notification Hubs",
        "Mobile",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "mobile",
        "10045",
        "icon",
        "service",
        "Notification",
        "Hubs",
        "svg",
        "notificationhubs"
      ]
    },
    {
      "provider": "azure",
      "label": "Offers",
      "category": "Azure Stack",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/azure-stack/10110-icon-service-Offers.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/azure stack/10110-icon-service-Offers.svg",
      "tokens": [
        "Offers",
        "Azure Stack",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "azure",
        "stack",
        "10110",
        "icon",
        "service",
        "svg",
        "offers",
        "azurestack"
      ]
    },
    {
      "provider": "azure",
      "label": "On Premises Data Gateways",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10070-icon-service-On-Premises-Data-Gateways.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10070-icon-service-On-Premises-Data-Gateways.svg",
      "tokens": [
        "On Premises Data Gateways",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10070",
        "icon",
        "service",
        "On",
        "Premises",
        "Data",
        "Gateways",
        "svg",
        "onpremisesdatagateways"
      ]
    },
    {
      "provider": "azure",
      "label": "Open Supply Chain Platform",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02602-icon-service-Open-Supply-Chain-Platform.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02602-icon-service-Open-Supply-Chain-Platform.svg",
      "tokens": [
        "Open Supply Chain Platform",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02602",
        "icon",
        "service",
        "Open",
        "Supply",
        "Chain",
        "Platform",
        "svg",
        "opensupplychainplatform"
      ]
    },
    {
      "provider": "azure",
      "label": "Operation Center",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/035572279-icon-service-Operation-Center.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/035572279-icon-service-Operation-Center.svg",
      "tokens": [
        "Operation Center",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "035572279",
        "icon",
        "service",
        "Operation",
        "Center",
        "svg",
        "operationcenter",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Operation Log (Classic)",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/00024-icon-service-Operation-Log-(Classic).svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/00024-icon-service-Operation-Log-(Classic).svg",
      "tokens": [
        "Operation Log (Classic)",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "00024",
        "icon",
        "service",
        "Operation",
        "Log",
        "(Classic)",
        "svg",
        "operationlogclassic",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Oracle Database",
      "category": "Databases",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/databases/03490-icon-service-Oracle-Database.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/databases/03490-icon-service-Oracle-Database.svg",
      "tokens": [
        "Oracle Database",
        "Databases",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "databases",
        "03490",
        "icon",
        "service",
        "Oracle",
        "Database",
        "svg",
        "oracledatabase"
      ]
    },
    {
      "provider": "azure",
      "label": "OS Config",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03365-icon-service-OSConfig.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03365-icon-service-OSConfig.svg",
      "tokens": [
        "OS Config",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03365",
        "icon",
        "service",
        "OSConfig",
        "svg",
        "osconfig"
      ]
    },
    {
      "provider": "azure",
      "label": "OS Images (Classic)",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/10027-icon-service-OS-Images-(Classic).svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/10027-icon-service-OS-Images-(Classic).svg",
      "tokens": [
        "OS Images (Classic)",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "10027",
        "icon",
        "service",
        "OS",
        "Images",
        "(Classic)",
        "svg",
        "osimagesclassic"
      ]
    },
    {
      "provider": "azure",
      "label": "Outbound Connection",
      "category": "Blockchain",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/blockchain/10364-icon-service-Outbound-Connection.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/blockchain/10364-icon-service-Outbound-Connection.svg",
      "tokens": [
        "Outbound Connection",
        "Blockchain",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "blockchain",
        "10364",
        "icon",
        "service",
        "Outbound",
        "Connection",
        "svg",
        "outboundconnection"
      ]
    },
    {
      "provider": "azure",
      "label": "Partner Namespace",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/02266-icon-service-Partner-Namespace.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/02266-icon-service-Partner-Namespace.svg",
      "tokens": [
        "Partner Namespace",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "02266",
        "icon",
        "service",
        "Partner",
        "Namespace",
        "svg",
        "partnernamespace"
      ]
    },
    {
      "provider": "azure",
      "label": "Partner Registration",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/02265-icon-service-Partner-Registration.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/02265-icon-service-Partner-Registration.svg",
      "tokens": [
        "Partner Registration",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "02265",
        "icon",
        "service",
        "Partner",
        "Registration",
        "svg",
        "partnerregistration"
      ]
    },
    {
      "provider": "azure",
      "label": "Partner Topic",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/02072-icon-service-Partner-Topic.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/02072-icon-service-Partner-Topic.svg",
      "tokens": [
        "Partner Topic",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "02072",
        "icon",
        "service",
        "Partner",
        "Topic",
        "svg",
        "partnertopic"
      ]
    },
    {
      "provider": "azure",
      "label": "Peering Service",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/00970-icon-service-Peering-Service.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/00970-icon-service-Peering-Service.svg",
      "tokens": [
        "Peering Service",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "00970",
        "icon",
        "service",
        "Peering",
        "svg",
        "peeringservice"
      ]
    },
    {
      "provider": "azure",
      "label": "Peerings",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/01285-icon-service-Peerings.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/01285-icon-service-Peerings.svg",
      "tokens": [
        "Peerings",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "01285",
        "icon",
        "service",
        "svg",
        "peerings"
      ]
    },
    {
      "provider": "azure",
      "label": "Personalizers",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/00796-icon-service-Personalizers.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/00796-icon-service-Personalizers.svg",
      "tokens": [
        "Personalizers",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "00796",
        "icon",
        "service",
        "svg",
        "personalizers",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Planetary Computer Pro",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/03755-icon-service-Planetary-Computer-Pro.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/03755-icon-service-Planetary-Computer-Pro.svg",
      "tokens": [
        "Planetary Computer Pro",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "03755",
        "icon",
        "service",
        "Planetary",
        "Computer",
        "Pro",
        "svg",
        "planetarycomputerpro",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Plans",
      "category": "Azure Stack",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/azure-stack/10113-icon-service-Plans.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/azure stack/10113-icon-service-Plans.svg",
      "tokens": [
        "Plans",
        "Azure Stack",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "azure",
        "stack",
        "10113",
        "icon",
        "service",
        "svg",
        "plans",
        "azurestack"
      ]
    },
    {
      "provider": "azure",
      "label": "Policy",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/10316-icon-service-Policy.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/10316-icon-service-Policy.svg",
      "tokens": [
        "Policy",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "10316",
        "icon",
        "service",
        "svg",
        "policy",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Power BI Embedded",
      "category": "Analytics",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/analytics/03332-icon-service-Power-BI-Embedded.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/analytics/03332-icon-service-Power-BI-Embedded.svg",
      "tokens": [
        "Power BI Embedded",
        "Analytics",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "analytics",
        "03332",
        "icon",
        "service",
        "Power",
        "BI",
        "Embedded",
        "svg",
        "powerbiembedded"
      ]
    },
    {
      "provider": "azure",
      "label": "Power Platform",
      "category": "Analytics",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/analytics/03335-icon-service-Power-Platform.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/analytics/03335-icon-service-Power-Platform.svg",
      "tokens": [
        "Power Platform",
        "Analytics",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "analytics",
        "03335",
        "icon",
        "service",
        "Power",
        "Platform",
        "svg",
        "powerplatform"
      ]
    },
    {
      "provider": "azure",
      "label": "Power Platform",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/03335-icon-service-Power-Platform.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/03335-icon-service-Power-Platform.svg",
      "tokens": [
        "Power Platform",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "03335",
        "icon",
        "service",
        "Power",
        "Platform",
        "svg",
        "powerplatform"
      ]
    },
    {
      "provider": "azure",
      "label": "Power Platform",
      "category": "Mobile",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/mobile/03335-icon-service-Power-Platform.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/mobile/03335-icon-service-Power-Platform.svg",
      "tokens": [
        "Power Platform",
        "Mobile",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "mobile",
        "03335",
        "icon",
        "service",
        "Power",
        "Platform",
        "svg",
        "powerplatform"
      ]
    },
    {
      "provider": "azure",
      "label": "Power Platform",
      "category": "Web",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/web/03335-icon-service-Power-Platform.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/web/03335-icon-service-Power-Platform.svg",
      "tokens": [
        "Power Platform",
        "Web",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "web",
        "03335",
        "icon",
        "service",
        "Power",
        "Platform",
        "svg",
        "powerplatform"
      ]
    },
    {
      "provider": "azure",
      "label": "Power Up",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10826-icon-service-Power-Up.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10826-icon-service-Power-Up.svg",
      "tokens": [
        "Power Up",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10826",
        "icon",
        "service",
        "Power",
        "Up",
        "svg",
        "powerup"
      ]
    },
    {
      "provider": "azure",
      "label": "Power",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10824-icon-service-Power.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10824-icon-service-Power.svg",
      "tokens": [
        "Power",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10824",
        "icon",
        "service",
        "svg",
        "power"
      ]
    },
    {
      "provider": "azure",
      "label": "Powershell",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10825-icon-service-Powershell.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10825-icon-service-Powershell.svg",
      "tokens": [
        "Powershell",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10825",
        "icon",
        "service",
        "svg",
        "powershell"
      ]
    },
    {
      "provider": "azure",
      "label": "Preview Features",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/00456-icon-service-Preview-Features.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/00456-icon-service-Preview-Features.svg",
      "tokens": [
        "Preview Features",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "00456",
        "icon",
        "service",
        "Preview",
        "Features",
        "svg",
        "previewfeatures"
      ]
    },
    {
      "provider": "azure",
      "label": "Private Endpoints",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02579-icon-service-Private-Endpoints.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02579-icon-service-Private-Endpoints.svg",
      "tokens": [
        "Private Endpoints",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02579",
        "icon",
        "service",
        "Private",
        "Endpoints",
        "svg",
        "privateendpoints"
      ]
    },
    {
      "provider": "azure",
      "label": "Private Link Service",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/01105-icon-service-Private-Link-Service.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/01105-icon-service-Private-Link-Service.svg",
      "tokens": [
        "Private Link Service",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "01105",
        "icon",
        "service",
        "Private",
        "Link",
        "svg",
        "privatelinkservice"
      ]
    },
    {
      "provider": "azure",
      "label": "Private Link Services",
      "category": "Analytics",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/analytics/02209-icon-service-Private-Link-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/analytics/02209-icon-service-Private-Link-Services.svg",
      "tokens": [
        "Private Link Services",
        "Analytics",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "analytics",
        "02209",
        "icon",
        "service",
        "Private",
        "Link",
        "Services",
        "svg",
        "privatelinkservices"
      ]
    },
    {
      "provider": "azure",
      "label": "Private Link Services",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/02209-icon-service-Private-Link-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/02209-icon-service-Private-Link-Services.svg",
      "tokens": [
        "Private Link Services",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "02209",
        "icon",
        "service",
        "Private",
        "Link",
        "Services",
        "svg",
        "privatelinkservices"
      ]
    },
    {
      "provider": "azure",
      "label": "Private Link",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/00427-icon-service-Private-Link.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/00427-icon-service-Private-Link.svg",
      "tokens": [
        "Private Link",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "00427",
        "icon",
        "service",
        "Private",
        "Link",
        "svg",
        "privatelink"
      ]
    },
    {
      "provider": "azure",
      "label": "Process Explorer",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10828-icon-service-Process-Explorer.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10828-icon-service-Process-Explorer.svg",
      "tokens": [
        "Process Explorer",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10828",
        "icon",
        "service",
        "Process",
        "Explorer",
        "svg",
        "processexplorer"
      ]
    },
    {
      "provider": "azure",
      "label": "Production Ready Database",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10829-icon-service-Production-Ready-Database.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10829-icon-service-Production-Ready-Database.svg",
      "tokens": [
        "Production Ready Database",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10829",
        "icon",
        "service",
        "Production",
        "Ready",
        "Database",
        "svg",
        "productionreadydatabase"
      ]
    },
    {
      "provider": "azure",
      "label": "Promethus",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/033112809-icon-service-promethus.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/033112809-icon-service-promethus.svg",
      "tokens": [
        "Promethus",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "033112809",
        "icon",
        "service",
        "promethus",
        "svg",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Proximity Placement Groups",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10365-icon-service-Proximity-Placement-Groups.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10365-icon-service-Proximity-Placement-Groups.svg",
      "tokens": [
        "Proximity Placement Groups",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10365",
        "icon",
        "service",
        "Proximity",
        "Placement",
        "Groups",
        "svg",
        "proximityplacementgroups"
      ]
    },
    {
      "provider": "azure",
      "label": "Public IP Addresses (Classic)",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10068-icon-service-Public-IP-Addresses-(Classic).svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10068-icon-service-Public-IP-Addresses-(Classic).svg",
      "tokens": [
        "Public IP Addresses (Classic)",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10068",
        "icon",
        "service",
        "IP",
        "Addresses",
        "(Classic)",
        "svg",
        "publicipaddressesclassic"
      ]
    },
    {
      "provider": "azure",
      "label": "Public IP Addresses",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10069-icon-service-Public-IP-Addresses.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10069-icon-service-Public-IP-Addresses.svg",
      "tokens": [
        "Public IP Addresses",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10069",
        "icon",
        "service",
        "IP",
        "Addresses",
        "svg",
        "publicipaddresses"
      ]
    },
    {
      "provider": "azure",
      "label": "Public IP Prefixes",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10372-icon-service-Public-IP-Prefixes.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10372-icon-service-Public-IP-Prefixes.svg",
      "tokens": [
        "Public IP Prefixes",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10372",
        "icon",
        "service",
        "IP",
        "Prefixes",
        "svg",
        "publicipprefixes"
      ]
    },
    {
      "provider": "azure",
      "label": "Pubsub",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/02987-icon-service-pubsub.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/02987-icon-service-pubsub.svg",
      "tokens": [
        "Pubsub",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "02987",
        "icon",
        "service",
        "pubsub",
        "svg",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Qn A Makers",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/00799-icon-service-QnA-Makers.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/00799-icon-service-QnA-Makers.svg",
      "tokens": [
        "Qn A Makers",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "00799",
        "icon",
        "service",
        "QnA",
        "Makers",
        "svg",
        "qnamakers",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Quickstart Center",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10010-icon-service-Quickstart-Center.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10010-icon-service-Quickstart-Center.svg",
      "tokens": [
        "Quickstart Center",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10010",
        "icon",
        "service",
        "Quickstart",
        "Center",
        "svg",
        "quickstartcenter"
      ]
    },
    {
      "provider": "azure",
      "label": "Recent",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10006-icon-service-Recent.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10006-icon-service-Recent.svg",
      "tokens": [
        "Recent",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10006",
        "icon",
        "service",
        "svg",
        "recent"
      ]
    },
    {
      "provider": "azure",
      "label": "Recovery Services Vaults",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/00017-icon-service-Recovery-Services-Vaults.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/00017-icon-service-Recovery-Services-Vaults.svg",
      "tokens": [
        "Recovery Services Vaults",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "00017",
        "icon",
        "service",
        "Recovery",
        "Services",
        "Vaults",
        "svg",
        "recoveryservicesvaults",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Recovery Services Vaults",
      "category": "Migrate",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/migrate/00017-icon-service-Recovery-Services-Vaults.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/migrate/00017-icon-service-Recovery-Services-Vaults.svg",
      "tokens": [
        "Recovery Services Vaults",
        "Migrate",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "migrate",
        "00017",
        "icon",
        "service",
        "Recovery",
        "Services",
        "Vaults",
        "svg",
        "recoveryservicesvaults"
      ]
    },
    {
      "provider": "azure",
      "label": "Recovery Services Vaults",
      "category": "Storage",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/storage/00017-icon-service-Recovery-Services-Vaults.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/storage/00017-icon-service-Recovery-Services-Vaults.svg",
      "tokens": [
        "Recovery Services Vaults",
        "Storage",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "storage",
        "00017",
        "icon",
        "service",
        "Recovery",
        "Services",
        "Vaults",
        "svg",
        "recoveryservicesvaults"
      ]
    },
    {
      "provider": "azure",
      "label": "Region Management",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10116-icon-service-Region-Management.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10116-icon-service-Region-Management.svg",
      "tokens": [
        "Region Management",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10116",
        "icon",
        "service",
        "Region",
        "Management",
        "svg",
        "regionmanagement"
      ]
    },
    {
      "provider": "azure",
      "label": "Relays",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/10209-icon-service-Relays.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/10209-icon-service-Relays.svg",
      "tokens": [
        "Relays",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "10209",
        "icon",
        "service",
        "svg",
        "relays"
      ]
    },
    {
      "provider": "azure",
      "label": "Remote Rendering",
      "category": "Mixed Reality",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/mixed-reality/00698-icon-service-Remote-Rendering.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/mixed reality/00698-icon-service-Remote-Rendering.svg",
      "tokens": [
        "Remote Rendering",
        "Mixed Reality",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "mixed",
        "reality",
        "00698",
        "icon",
        "service",
        "Remote",
        "Rendering",
        "svg",
        "remoterendering",
        "mixedreality"
      ]
    },
    {
      "provider": "azure",
      "label": "Reservations",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10003-icon-service-Reservations.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10003-icon-service-Reservations.svg",
      "tokens": [
        "Reservations",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10003",
        "icon",
        "service",
        "svg",
        "reservations"
      ]
    },
    {
      "provider": "azure",
      "label": "Reserved Capacity",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02638-icon-service-Reserved-Capacity.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02638-icon-service-Reserved-Capacity.svg",
      "tokens": [
        "Reserved Capacity",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02638",
        "icon",
        "service",
        "Reserved",
        "Capacity",
        "svg",
        "reservedcapacity"
      ]
    },
    {
      "provider": "azure",
      "label": "Reserved IP Addresses (Classic)",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10371-icon-service-Reserved-IP-Addresses-(Classic).svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10371-icon-service-Reserved-IP-Addresses-(Classic).svg",
      "tokens": [
        "Reserved IP Addresses (Classic)",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10371",
        "icon",
        "service",
        "Reserved",
        "IP",
        "Addresses",
        "(Classic)",
        "svg",
        "reservedipaddressesclassic"
      ]
    },
    {
      "provider": "azure",
      "label": "Resource Explorer",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10349-icon-service-Resource-Explorer.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10349-icon-service-Resource-Explorer.svg",
      "tokens": [
        "Resource Explorer",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10349",
        "icon",
        "service",
        "Resource",
        "Explorer",
        "svg",
        "resourceexplorer"
      ]
    },
    {
      "provider": "azure",
      "label": "Resource Graph Explorer",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/10318-icon-service-Resource-Graph-Explorer.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/10318-icon-service-Resource-Graph-Explorer.svg",
      "tokens": [
        "Resource Graph Explorer",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "10318",
        "icon",
        "service",
        "Resource",
        "Graph",
        "Explorer",
        "svg",
        "resourcegraphexplorer",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Resource Group List",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10830-icon-service-Resource-Group-List.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10830-icon-service-Resource-Group-List.svg",
      "tokens": [
        "Resource Group List",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10830",
        "icon",
        "service",
        "Resource",
        "Group",
        "List",
        "svg",
        "resourcegrouplist"
      ]
    },
    {
      "provider": "azure",
      "label": "Resource Groups",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10007-icon-service-Resource-Groups.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10007-icon-service-Resource-Groups.svg",
      "tokens": [
        "Resource Groups",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10007",
        "icon",
        "service",
        "Resource",
        "Groups",
        "svg",
        "resourcegroups"
      ]
    },
    {
      "provider": "azure",
      "label": "Resource Guard",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02819-icon-service-Resource-Guard.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02819-icon-service-Resource-Guard.svg",
      "tokens": [
        "Resource Guard",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02819",
        "icon",
        "service",
        "Resource",
        "Guard",
        "svg",
        "resourceguard"
      ]
    },
    {
      "provider": "azure",
      "label": "Resource Linked",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10831-icon-service-Resource-Linked.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10831-icon-service-Resource-Linked.svg",
      "tokens": [
        "Resource Linked",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10831",
        "icon",
        "service",
        "Resource",
        "Linked",
        "svg",
        "resourcelinked"
      ]
    },
    {
      "provider": "azure",
      "label": "Resource Management Private Link",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/02145-icon-service-Resource-Management-Private-Link.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/02145-icon-service-Resource-Management-Private-Link.svg",
      "tokens": [
        "Resource Management Private Link",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "02145",
        "icon",
        "service",
        "Resource",
        "Management",
        "Private",
        "Link",
        "svg",
        "resourcemanagementprivatelink"
      ]
    },
    {
      "provider": "azure",
      "label": "Resource Mover",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02200-icon-service-Resource-Mover.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02200-icon-service-Resource-Mover.svg",
      "tokens": [
        "Resource Mover",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02200",
        "icon",
        "service",
        "Resource",
        "Mover",
        "svg",
        "resourcemover"
      ]
    },
    {
      "provider": "azure",
      "label": "Resources Provider",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/03366-icon-service-Resources-Provider.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/03366-icon-service-Resources-Provider.svg",
      "tokens": [
        "Resources Provider",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "03366",
        "icon",
        "service",
        "Resources",
        "Provider",
        "svg",
        "resourcesprovider",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Restore Points Collections",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/02818-icon-service-Restore-Points-Collections.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/02818-icon-service-Restore-Points-Collections.svg",
      "tokens": [
        "Restore Points Collections",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "02818",
        "icon",
        "service",
        "Restore",
        "Points",
        "Collections",
        "svg",
        "restorepointscollections"
      ]
    },
    {
      "provider": "azure",
      "label": "Restore Points",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/02817-icon-service-Restore-Points.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/02817-icon-service-Restore-Points.svg",
      "tokens": [
        "Restore Points",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "02817",
        "icon",
        "service",
        "Restore",
        "Points",
        "svg",
        "restorepoints"
      ]
    },
    {
      "provider": "azure",
      "label": "Route Filters",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10071-icon-service-Route-Filters.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10071-icon-service-Route-Filters.svg",
      "tokens": [
        "Route Filters",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10071",
        "icon",
        "service",
        "Route",
        "Filters",
        "svg",
        "routefilters"
      ]
    },
    {
      "provider": "azure",
      "label": "Route Tables",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10082-icon-service-Route-Tables.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10082-icon-service-Route-Tables.svg",
      "tokens": [
        "Route Tables",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10082",
        "icon",
        "service",
        "Route",
        "Tables",
        "svg",
        "routetables"
      ]
    },
    {
      "provider": "azure",
      "label": "RTOS",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/10778-icon-service-RTOS.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/10778-icon-service-RTOS.svg",
      "tokens": [
        "RTOS",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "10778",
        "icon",
        "service",
        "svg",
        "rtos"
      ]
    },
    {
      "provider": "azure",
      "label": "Savings Plans",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02880-icon-service-Savings-Plans.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02880-icon-service-Savings-Plans.svg",
      "tokens": [
        "Savings Plans",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02880",
        "icon",
        "service",
        "Savings",
        "Plans",
        "svg",
        "savingsplans"
      ]
    },
    {
      "provider": "azure",
      "label": "Scheduled Actions",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/033049334-icon-service-Scheduled-Actions.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/033049334-icon-service-Scheduled-Actions.svg",
      "tokens": [
        "Scheduled Actions",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "033049334",
        "icon",
        "service",
        "Scheduled",
        "Actions",
        "svg",
        "scheduledactions",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Scheduler Job Collections",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/00010-icon-service-Scheduler-Job-Collections.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/00010-icon-service-Scheduler-Job-Collections.svg",
      "tokens": [
        "Scheduler Job Collections",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "00010",
        "icon",
        "service",
        "Scheduler",
        "Job",
        "Collections",
        "svg",
        "schedulerjobcollections",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Scheduler",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10833-icon-service-Scheduler.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10833-icon-service-Scheduler.svg",
      "tokens": [
        "Scheduler",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10833",
        "icon",
        "service",
        "svg",
        "scheduler"
      ]
    },
    {
      "provider": "azure",
      "label": "SCVMM Management Servers",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02503-icon-service-SCVMM-Management-Servers.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02503-icon-service-SCVMM-Management-Servers.svg",
      "tokens": [
        "SCVMM Management Servers",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02503",
        "icon",
        "service",
        "SCVMM",
        "Management",
        "Servers",
        "svg",
        "scvmmmanagementservers"
      ]
    },
    {
      "provider": "azure",
      "label": "Search Grid",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10856-icon-service-Search-Grid.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10856-icon-service-Search-Grid.svg",
      "tokens": [
        "Search Grid",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10856",
        "icon",
        "service",
        "Search",
        "Grid",
        "svg",
        "searchgrid"
      ]
    },
    {
      "provider": "azure",
      "label": "Search",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10834-icon-service-Search.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10834-icon-service-Search.svg",
      "tokens": [
        "Search",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10834",
        "icon",
        "service",
        "svg",
        "search"
      ]
    },
    {
      "provider": "azure",
      "label": "Security Baselines",
      "category": "Intune",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/intune/10336-icon-service-Security-Baselines.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/intune/10336-icon-service-Security-Baselines.svg",
      "tokens": [
        "Security Baselines",
        "Intune",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "intune",
        "10336",
        "icon",
        "service",
        "Security",
        "Baselines",
        "svg",
        "securitybaselines"
      ]
    },
    {
      "provider": "azure",
      "label": "Security",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/00321-icon-service-Security.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/00321-icon-service-Security.svg",
      "tokens": [
        "Security",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "00321",
        "icon",
        "service",
        "svg",
        "security"
      ]
    },
    {
      "provider": "azure",
      "label": "Send Grid Accounts",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/10220-icon-service-SendGrid-Accounts.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/10220-icon-service-SendGrid-Accounts.svg",
      "tokens": [
        "Send Grid Accounts",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "10220",
        "icon",
        "service",
        "SendGrid",
        "Accounts",
        "svg",
        "sendgridaccounts"
      ]
    },
    {
      "provider": "azure",
      "label": "Server Farm",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10835-icon-service-Server-Farm.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10835-icon-service-Server-Farm.svg",
      "tokens": [
        "Server Farm",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10835",
        "icon",
        "service",
        "Server",
        "Farm",
        "svg",
        "serverfarm"
      ]
    },
    {
      "provider": "azure",
      "label": "Serverless Search",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/03321-icon-service-Serverless-Search.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/03321-icon-service-Serverless-Search.svg",
      "tokens": [
        "Serverless Search",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "03321",
        "icon",
        "service",
        "Serverless",
        "Search",
        "svg",
        "serverlesssearch",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Service Catalog MAD",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/00027-icon-service-Service-Catalog-MAD.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/00027-icon-service-Service-Catalog-MAD.svg",
      "tokens": [
        "Service Catalog MAD",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "00027",
        "icon",
        "service",
        "Catalog",
        "MAD",
        "svg",
        "servicecatalogmad",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Service Endpoint Policies",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10085-icon-service-Service-Endpoint-Policies.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10085-icon-service-Service-Endpoint-Policies.svg",
      "tokens": [
        "Service Endpoint Policies",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10085",
        "icon",
        "service",
        "Endpoint",
        "Policies",
        "svg",
        "serviceendpointpolicies"
      ]
    },
    {
      "provider": "azure",
      "label": "Service Fabric Clusters",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/10036-icon-service-Service-Fabric-Clusters.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/10036-icon-service-Service-Fabric-Clusters.svg",
      "tokens": [
        "Service Fabric Clusters",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "10036",
        "icon",
        "service",
        "Fabric",
        "Clusters",
        "svg",
        "servicefabricclusters"
      ]
    },
    {
      "provider": "azure",
      "label": "Service Fabric Clusters",
      "category": "Containers",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/containers/10036-icon-service-Service-Fabric-Clusters.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/containers/10036-icon-service-Service-Fabric-Clusters.svg",
      "tokens": [
        "Service Fabric Clusters",
        "Containers",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "containers",
        "10036",
        "icon",
        "service",
        "Fabric",
        "Clusters",
        "svg",
        "servicefabricclusters"
      ]
    },
    {
      "provider": "azure",
      "label": "Service Groups",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/029637767-icon-service-Service-Groups.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/029637767-icon-service-Service-Groups.svg",
      "tokens": [
        "Service Groups",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "029637767",
        "icon",
        "service",
        "Groups",
        "svg",
        "servicegroups",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Service Health",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10004-icon-service-Service-Health.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10004-icon-service-Service-Health.svg",
      "tokens": [
        "Service Health",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10004",
        "icon",
        "service",
        "Health",
        "svg",
        "servicehealth"
      ]
    },
    {
      "provider": "azure",
      "label": "Service Providers",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/00025-icon-service-Service-Providers.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/00025-icon-service-Service-Providers.svg",
      "tokens": [
        "Service Providers",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "00025",
        "icon",
        "service",
        "Providers",
        "svg",
        "serviceproviders",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Shared Image Galleries",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/10039-icon-service-Shared-Image-Galleries.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/10039-icon-service-Shared-Image-Galleries.svg",
      "tokens": [
        "Shared Image Galleries",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "10039",
        "icon",
        "service",
        "Shared",
        "Image",
        "Galleries",
        "svg",
        "sharedimagegalleries"
      ]
    },
    {
      "provider": "azure",
      "label": "Signal R",
      "category": "Web",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/web/10052-icon-service-SignalR.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/web/10052-icon-service-SignalR.svg",
      "tokens": [
        "Signal R",
        "Web",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "web",
        "10052",
        "icon",
        "service",
        "SignalR",
        "svg",
        "signalr"
      ]
    },
    {
      "provider": "azure",
      "label": "Software As A Service",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/10213-icon-service-Software-as-a-Service.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/10213-icon-service-Software-as-a-Service.svg",
      "tokens": [
        "Software As A Service",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "10213",
        "icon",
        "service",
        "Software",
        "as",
        "a",
        "svg",
        "softwareasaservice"
      ]
    },
    {
      "provider": "azure",
      "label": "Software Updates",
      "category": "Intune",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/intune/10335-icon-service-Software-Updates.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/intune/10335-icon-service-Software-Updates.svg",
      "tokens": [
        "Software Updates",
        "Intune",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "intune",
        "10335",
        "icon",
        "service",
        "Software",
        "Updates",
        "svg",
        "softwareupdates"
      ]
    },
    {
      "provider": "azure",
      "label": "Solutions",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/00021-icon-service-Solutions.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/00021-icon-service-Solutions.svg",
      "tokens": [
        "Solutions",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "00021",
        "icon",
        "service",
        "svg",
        "solutions",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Sonic Dash",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02922-icon-service-Sonic-Dash.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02922-icon-service-Sonic-Dash.svg",
      "tokens": [
        "Sonic Dash",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02922",
        "icon",
        "service",
        "Sonic",
        "Dash",
        "svg",
        "sonicdash"
      ]
    },
    {
      "provider": "azure",
      "label": "Spatial Anchor Accounts",
      "category": "Mixed Reality",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/mixed-reality/10352-icon-service-Spatial-Anchor-Accounts.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/mixed reality/10352-icon-service-Spatial-Anchor-Accounts.svg",
      "tokens": [
        "Spatial Anchor Accounts",
        "Mixed Reality",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "mixed",
        "reality",
        "10352",
        "icon",
        "service",
        "Spatial",
        "Anchor",
        "Accounts",
        "svg",
        "spatialanchoraccounts",
        "mixedreality"
      ]
    },
    {
      "provider": "azure",
      "label": "Speech Services",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/00797-icon-service-Speech-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/00797-icon-service-Speech-Services.svg",
      "tokens": [
        "Speech Services",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "00797",
        "icon",
        "service",
        "Speech",
        "Services",
        "svg",
        "speechservices",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Spot VM",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/02695-icon-service-Spot-VM.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/02695-icon-service-Spot-VM.svg",
      "tokens": [
        "Spot VM",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "02695",
        "icon",
        "service",
        "Spot",
        "VM",
        "svg",
        "spotvm"
      ]
    },
    {
      "provider": "azure",
      "label": "Spot VMSS",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/02692-icon-service-Spot-VMSS.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/02692-icon-service-Spot-VMSS.svg",
      "tokens": [
        "Spot VMSS",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "02692",
        "icon",
        "service",
        "Spot",
        "VMSS",
        "svg",
        "spotvmss"
      ]
    },
    {
      "provider": "azure",
      "label": "SQL Data Warehouses",
      "category": "Databases",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/databases/00036-icon-service-SQL-Data-Warehouses.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/databases/00036-icon-service-SQL-Data-Warehouses.svg",
      "tokens": [
        "SQL Data Warehouses",
        "Databases",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "databases",
        "00036",
        "icon",
        "service",
        "SQL",
        "Data",
        "Warehouses",
        "svg",
        "sqldatawarehouses"
      ]
    },
    {
      "provider": "azure",
      "label": "SQL Data Warehouses",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/00036-icon-service-SQL-Data-Warehouses.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/00036-icon-service-SQL-Data-Warehouses.svg",
      "tokens": [
        "SQL Data Warehouses",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "00036",
        "icon",
        "service",
        "SQL",
        "Data",
        "Warehouses",
        "svg",
        "sqldatawarehouses"
      ]
    },
    {
      "provider": "azure",
      "label": "SQL Database Fleet Manager",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/03565-icon-service-SQL-Database-Fleet-Manager.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/03565-icon-service-SQL-Database-Fleet-Manager.svg",
      "tokens": [
        "SQL Database Fleet Manager",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "03565",
        "icon",
        "service",
        "SQL",
        "Database",
        "Fleet",
        "Manager",
        "svg",
        "sqldatabasefleetmanager",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "SQL Database",
      "category": "Databases",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/databases/10130-icon-service-SQL-Database.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/databases/10130-icon-service-SQL-Database.svg",
      "tokens": [
        "SQL Database",
        "Databases",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "databases",
        "10130",
        "icon",
        "service",
        "SQL",
        "Database",
        "svg",
        "sqldatabase"
      ]
    },
    {
      "provider": "azure",
      "label": "SQL Elastic Pools",
      "category": "Databases",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/databases/10134-icon-service-SQL-Elastic-Pools.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/databases/10134-icon-service-SQL-Elastic-Pools.svg",
      "tokens": [
        "SQL Elastic Pools",
        "Databases",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "databases",
        "10134",
        "icon",
        "service",
        "SQL",
        "Elastic",
        "Pools",
        "svg",
        "sqlelasticpools"
      ]
    },
    {
      "provider": "azure",
      "label": "SQL Managed Instance",
      "category": "Databases",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/databases/10136-icon-service-SQL-Managed-Instance.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/databases/10136-icon-service-SQL-Managed-Instance.svg",
      "tokens": [
        "SQL Managed Instance",
        "Databases",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "databases",
        "10136",
        "icon",
        "service",
        "SQL",
        "Managed",
        "Instance",
        "svg",
        "sqlmanagedinstance"
      ]
    },
    {
      "provider": "azure",
      "label": "SQL Server Registries",
      "category": "Databases",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/databases/10351-icon-service-SQL-Server-Registries.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/databases/10351-icon-service-SQL-Server-Registries.svg",
      "tokens": [
        "SQL Server Registries",
        "Databases",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "databases",
        "10351",
        "icon",
        "service",
        "SQL",
        "Server",
        "Registries",
        "svg",
        "sqlserverregistries"
      ]
    },
    {
      "provider": "azure",
      "label": "SQL Server",
      "category": "Databases",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/databases/10132-icon-service-SQL-Server.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/databases/10132-icon-service-SQL-Server.svg",
      "tokens": [
        "SQL Server",
        "Databases",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "databases",
        "10132",
        "icon",
        "service",
        "SQL",
        "Server",
        "svg",
        "sqlserver"
      ]
    },
    {
      "provider": "azure",
      "label": "SSD",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10837-icon-service-SSD.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10837-icon-service-SSD.svg",
      "tokens": [
        "SSD",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10837",
        "icon",
        "service",
        "svg",
        "ssd"
      ]
    },
    {
      "provider": "azure",
      "label": "SSH Keys",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/00412-icon-service-SSH-Keys.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/00412-icon-service-SSH-Keys.svg",
      "tokens": [
        "SSH Keys",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "00412",
        "icon",
        "service",
        "SSH",
        "Keys",
        "svg",
        "sshkeys"
      ]
    },
    {
      "provider": "azure",
      "label": "SSIS Lift And Shift IR",
      "category": "Databases",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/databases/02392-icon-service-SSIS-Lift-And-Shift-IR.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/databases/02392-icon-service-SSIS-Lift-And-Shift-IR.svg",
      "tokens": [
        "SSIS Lift And Shift IR",
        "Databases",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "databases",
        "02392",
        "icon",
        "service",
        "SSIS",
        "Lift",
        "And",
        "Shift",
        "IR",
        "svg",
        "ssisliftandshiftir"
      ]
    },
    {
      "provider": "azure",
      "label": "Stack HCI Premium",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/03466-icon-service-Stack-HCI-Premium.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/03466-icon-service-Stack-HCI-Premium.svg",
      "tokens": [
        "Stack HCI Premium",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "03466",
        "icon",
        "service",
        "Stack",
        "HCI",
        "Premium",
        "svg",
        "stackhcipremium"
      ]
    },
    {
      "provider": "azure",
      "label": "Stage Maps",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/030868929-icon-service-Stage-Maps.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/030868929-icon-service-Stage-Maps.svg",
      "tokens": [
        "Stage Maps",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "030868929",
        "icon",
        "service",
        "Stage",
        "Maps",
        "svg",
        "stagemaps",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Static Apps",
      "category": "Web",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/web/01007-icon-service-Static-Apps.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/web/01007-icon-service-Static-Apps.svg",
      "tokens": [
        "Static Apps",
        "Web",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "web",
        "01007",
        "icon",
        "service",
        "Static",
        "Apps",
        "svg",
        "staticapps"
      ]
    },
    {
      "provider": "azure",
      "label": "Stor Simple Data Managers",
      "category": "Storage",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/storage/10092-icon-service-StorSimple-Data-Managers.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/storage/10092-icon-service-StorSimple-Data-Managers.svg",
      "tokens": [
        "Stor Simple Data Managers",
        "Storage",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "storage",
        "10092",
        "icon",
        "service",
        "StorSimple",
        "Data",
        "Managers",
        "svg",
        "storsimpledatamanagers"
      ]
    },
    {
      "provider": "azure",
      "label": "Stor Simple Device Managers",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/10089-icon-service-StorSimple-Device-Managers.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/10089-icon-service-StorSimple-Device-Managers.svg",
      "tokens": [
        "Stor Simple Device Managers",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "10089",
        "icon",
        "service",
        "StorSimple",
        "Device",
        "Managers",
        "svg",
        "storsimpledevicemanagers"
      ]
    },
    {
      "provider": "azure",
      "label": "Stor Simple Device Managers",
      "category": "Storage",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/storage/10089-icon-service-StorSimple-Device-Managers.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/storage/10089-icon-service-StorSimple-Device-Managers.svg",
      "tokens": [
        "Stor Simple Device Managers",
        "Storage",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "storage",
        "10089",
        "icon",
        "service",
        "StorSimple",
        "Device",
        "Managers",
        "svg",
        "storsimpledevicemanagers"
      ]
    },
    {
      "provider": "azure",
      "label": "Storage Accounts (Classic)",
      "category": "Storage",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/storage/10087-icon-service-Storage-Accounts-(Classic).svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/storage/10087-icon-service-Storage-Accounts-(Classic).svg",
      "tokens": [
        "Storage Accounts (Classic)",
        "Storage",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "storage",
        "10087",
        "icon",
        "service",
        "Accounts",
        "(Classic)",
        "svg",
        "storageaccountsclassic"
      ]
    },
    {
      "provider": "azure",
      "label": "Storage Accounts",
      "category": "Storage",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/storage/10086-icon-service-Storage-Accounts.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/storage/10086-icon-service-Storage-Accounts.svg",
      "tokens": [
        "Storage Accounts",
        "Storage",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "storage",
        "10086",
        "icon",
        "service",
        "Accounts",
        "svg",
        "storageaccounts"
      ]
    },
    {
      "provider": "azure",
      "label": "Storage Actions",
      "category": "Storage",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/storage/03502-icon-service-Storage-Actions.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/storage/03502-icon-service-Storage-Actions.svg",
      "tokens": [
        "Storage Actions",
        "Storage",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "storage",
        "03502",
        "icon",
        "service",
        "Actions",
        "svg",
        "storageactions"
      ]
    },
    {
      "provider": "azure",
      "label": "Storage Azure Files",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10838-icon-service-Storage-Azure-Files.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10838-icon-service-Storage-Azure-Files.svg",
      "tokens": [
        "Storage Azure Files",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10838",
        "icon",
        "service",
        "Storage",
        "Files",
        "svg",
        "storageazurefiles"
      ]
    },
    {
      "provider": "azure",
      "label": "Storage Container",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10839-icon-service-Storage-Container.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10839-icon-service-Storage-Container.svg",
      "tokens": [
        "Storage Container",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10839",
        "icon",
        "service",
        "Storage",
        "Container",
        "svg",
        "storagecontainer"
      ]
    },
    {
      "provider": "azure",
      "label": "Storage Explorer",
      "category": "Storage",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/storage/10091-icon-service-Storage-Explorer.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/storage/10091-icon-service-Storage-Explorer.svg",
      "tokens": [
        "Storage Explorer",
        "Storage",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "storage",
        "10091",
        "icon",
        "service",
        "Explorer",
        "svg",
        "storageexplorer"
      ]
    },
    {
      "provider": "azure",
      "label": "Storage Functions",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02909-icon-service-Storage-Functions.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02909-icon-service-Storage-Functions.svg",
      "tokens": [
        "Storage Functions",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02909",
        "icon",
        "service",
        "Storage",
        "Functions",
        "svg",
        "storagefunctions"
      ]
    },
    {
      "provider": "azure",
      "label": "Storage Hubs",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/030486388-icon-service-Storage-Hubs.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/030486388-icon-service-Storage-Hubs.svg",
      "tokens": [
        "Storage Hubs",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "030486388",
        "icon",
        "service",
        "Storage",
        "Hubs",
        "svg",
        "storagehubs",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Storage Queue",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10840-icon-service-Storage-Queue.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10840-icon-service-Storage-Queue.svg",
      "tokens": [
        "Storage Queue",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10840",
        "icon",
        "service",
        "Storage",
        "Queue",
        "svg",
        "storagequeue"
      ]
    },
    {
      "provider": "azure",
      "label": "Storage Sync Services",
      "category": "Storage",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/storage/10093-icon-service-Storage-Sync-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/storage/10093-icon-service-Storage-Sync-Services.svg",
      "tokens": [
        "Storage Sync Services",
        "Storage",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "storage",
        "10093",
        "icon",
        "service",
        "Sync",
        "Services",
        "svg",
        "storagesyncservices"
      ]
    },
    {
      "provider": "azure",
      "label": "Stream Analytics Jobs",
      "category": "Analytics",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/analytics/00042-icon-service-Stream-Analytics-Jobs.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/analytics/00042-icon-service-Stream-Analytics-Jobs.svg",
      "tokens": [
        "Stream Analytics Jobs",
        "Analytics",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "analytics",
        "00042",
        "icon",
        "service",
        "Stream",
        "Jobs",
        "svg",
        "streamanalyticsjobs"
      ]
    },
    {
      "provider": "azure",
      "label": "Stream Analytics Jobs",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/00042-icon-service-Stream-Analytics-Jobs.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/00042-icon-service-Stream-Analytics-Jobs.svg",
      "tokens": [
        "Stream Analytics Jobs",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "00042",
        "icon",
        "service",
        "Stream",
        "Analytics",
        "Jobs",
        "svg",
        "streamanalyticsjobs"
      ]
    },
    {
      "provider": "azure",
      "label": "Subnet",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/02742-icon-service-Subnet.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/02742-icon-service-Subnet.svg",
      "tokens": [
        "Subnet",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "02742",
        "icon",
        "service",
        "svg",
        "subnet"
      ]
    },
    {
      "provider": "azure",
      "label": "Subscriptions",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10002-icon-service-Subscriptions.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10002-icon-service-Subscriptions.svg",
      "tokens": [
        "Subscriptions",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10002",
        "icon",
        "service",
        "svg",
        "subscriptions"
      ]
    },
    {
      "provider": "azure",
      "label": "System Topic",
      "category": "Integration",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/integration/02073-icon-service-System-Topic.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/integration/02073-icon-service-System-Topic.svg",
      "tokens": [
        "System Topic",
        "Integration",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "integration",
        "02073",
        "icon",
        "service",
        "System",
        "Topic",
        "svg",
        "systemtopic"
      ]
    },
    {
      "provider": "azure",
      "label": "Table",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10841-icon-service-Table.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10841-icon-service-Table.svg",
      "tokens": [
        "Table",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10841",
        "icon",
        "service",
        "svg",
        "table"
      ]
    },
    {
      "provider": "azure",
      "label": "Tag",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10014-icon-service-Tag.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10014-icon-service-Tag.svg",
      "tokens": [
        "Tag",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10014",
        "icon",
        "service",
        "svg",
        "tag"
      ]
    },
    {
      "provider": "azure",
      "label": "Tags",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10842-icon-service-Tags.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10842-icon-service-Tags.svg",
      "tokens": [
        "Tags",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10842",
        "icon",
        "service",
        "svg",
        "tags"
      ]
    },
    {
      "provider": "azure",
      "label": "Targets Management",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02908-icon-service-Targets-Management.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02908-icon-service-Targets-Management.svg",
      "tokens": [
        "Targets Management",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02908",
        "icon",
        "service",
        "Targets",
        "Management",
        "svg",
        "targetsmanagement"
      ]
    },
    {
      "provider": "azure",
      "label": "Template Specs",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02340-icon-service-Template-Specs.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02340-icon-service-Template-Specs.svg",
      "tokens": [
        "Template Specs",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02340",
        "icon",
        "service",
        "Template",
        "Specs",
        "svg",
        "templatespecs"
      ]
    },
    {
      "provider": "azure",
      "label": "Templates",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10009-icon-service-Templates.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10009-icon-service-Templates.svg",
      "tokens": [
        "Templates",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10009",
        "icon",
        "service",
        "svg",
        "templates"
      ]
    },
    {
      "provider": "azure",
      "label": "Tenant Properties",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/02679-icon-service-Tenant-Properties.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/02679-icon-service-Tenant-Properties.svg",
      "tokens": [
        "Tenant Properties",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "02679",
        "icon",
        "service",
        "Tenant",
        "Properties",
        "svg",
        "tenantproperties"
      ]
    },
    {
      "provider": "azure",
      "label": "Tenant Status",
      "category": "Intune",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/intune/10342-icon-service-Tenant-Status.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/intune/10342-icon-service-Tenant-Status.svg",
      "tokens": [
        "Tenant Status",
        "Intune",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "intune",
        "10342",
        "icon",
        "service",
        "Tenant",
        "Status",
        "svg",
        "tenantstatus"
      ]
    },
    {
      "provider": "azure",
      "label": "Test Base",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02691-icon-service-Test-Base.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02691-icon-service-Test-Base.svg",
      "tokens": [
        "Test Base",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02691",
        "icon",
        "service",
        "Test",
        "Base",
        "svg",
        "testbase"
      ]
    },
    {
      "provider": "azure",
      "label": "TFS VC Repository",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10843-icon-service-TFS-VC-Repository.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10843-icon-service-TFS-VC-Repository.svg",
      "tokens": [
        "TFS VC Repository",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10843",
        "icon",
        "service",
        "TFS",
        "VC",
        "Repository",
        "svg",
        "tfsvcrepository"
      ]
    },
    {
      "provider": "azure",
      "label": "Time Series Data Sets",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/10198-icon-service-Time-Series-Data-Sets.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/10198-icon-service-Time-Series-Data-Sets.svg",
      "tokens": [
        "Time Series Data Sets",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "10198",
        "icon",
        "service",
        "Time",
        "Series",
        "Data",
        "Sets",
        "svg",
        "timeseriesdatasets"
      ]
    },
    {
      "provider": "azure",
      "label": "Time Series Insights Access Policies",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/10192-icon-service-Time-Series-Insights-Access-Policies.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/10192-icon-service-Time-Series-Insights-Access-Policies.svg",
      "tokens": [
        "Time Series Insights Access Policies",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "10192",
        "icon",
        "service",
        "Time",
        "Series",
        "Insights",
        "Access",
        "Policies",
        "svg",
        "timeseriesinsightsaccesspolicies"
      ]
    },
    {
      "provider": "azure",
      "label": "Time Series Insights Environments",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/10181-icon-service-Time-Series-Insights-Environments.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/10181-icon-service-Time-Series-Insights-Environments.svg",
      "tokens": [
        "Time Series Insights Environments",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "10181",
        "icon",
        "service",
        "Time",
        "Series",
        "Insights",
        "Environments",
        "svg",
        "timeseriesinsightsenvironments"
      ]
    },
    {
      "provider": "azure",
      "label": "Time Series Insights Event Sources",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/10188-icon-service-Time-Series-Insights-Event-Sources.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/10188-icon-service-Time-Series-Insights-Event-Sources.svg",
      "tokens": [
        "Time Series Insights Event Sources",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "10188",
        "icon",
        "service",
        "Time",
        "Series",
        "Insights",
        "Event",
        "Sources",
        "svg",
        "timeseriesinsightseventsources"
      ]
    },
    {
      "provider": "azure",
      "label": "Toolbox",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10844-icon-service-Toolbox.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10844-icon-service-Toolbox.svg",
      "tokens": [
        "Toolbox",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10844",
        "icon",
        "service",
        "svg",
        "toolbox"
      ]
    },
    {
      "provider": "azure",
      "label": "Toolchain Orchestrator",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/029109619-icon-service-Toolchain-Orchestrator.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/029109619-icon-service-Toolchain-Orchestrator.svg",
      "tokens": [
        "Toolchain Orchestrator",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "029109619",
        "icon",
        "service",
        "Toolchain",
        "Orchestrator",
        "svg",
        "toolchainorchestrator",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Traffic Manager Profiles",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10065-icon-service-Traffic-Manager-Profiles.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10065-icon-service-Traffic-Manager-Profiles.svg",
      "tokens": [
        "Traffic Manager Profiles",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10065",
        "icon",
        "service",
        "Traffic",
        "Manager",
        "Profiles",
        "svg",
        "trafficmanagerprofiles"
      ]
    },
    {
      "provider": "azure",
      "label": "Translator Text",
      "category": "Ai + Machine Learning",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/ai-%2B-machine-learning/00800-icon-service-Translator-Text.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/ai + machine learning/00800-icon-service-Translator-Text.svg",
      "tokens": [
        "Translator Text",
        "Ai + Machine Learning",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "ai",
        "+",
        "machine",
        "learning",
        "00800",
        "icon",
        "service",
        "Translator",
        "Text",
        "svg",
        "translatortext",
        "aimachinelearning"
      ]
    },
    {
      "provider": "azure",
      "label": "Troubleshoot",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10341-icon-service-Troubleshoot.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10341-icon-service-Troubleshoot.svg",
      "tokens": [
        "Troubleshoot",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10341",
        "icon",
        "service",
        "svg",
        "troubleshoot"
      ]
    },
    {
      "provider": "azure",
      "label": "Universal Print",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/00571-icon-service-Universal-Print.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/00571-icon-service-Universal-Print.svg",
      "tokens": [
        "Universal Print",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "00571",
        "icon",
        "service",
        "Universal",
        "Print",
        "svg",
        "universalprint",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "Update Management Center",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02846-icon-service-Update-Management-Center.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02846-icon-service-Update-Management-Center.svg",
      "tokens": [
        "Update Management Center",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02846",
        "icon",
        "service",
        "Update",
        "Management",
        "Center",
        "svg",
        "updatemanagementcenter"
      ]
    },
    {
      "provider": "azure",
      "label": "Updates",
      "category": "Azure Stack",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/azure-stack/10115-icon-service-Updates.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/azure stack/10115-icon-service-Updates.svg",
      "tokens": [
        "Updates",
        "Azure Stack",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "azure",
        "stack",
        "10115",
        "icon",
        "service",
        "svg",
        "updates",
        "azurestack"
      ]
    },
    {
      "provider": "azure",
      "label": "User Privacy",
      "category": "Management + Governance",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/management-%2B-governance/10303-icon-service-User-Privacy.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/management + governance/10303-icon-service-User-Privacy.svg",
      "tokens": [
        "User Privacy",
        "Management + Governance",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "management",
        "+",
        "governance",
        "10303",
        "icon",
        "service",
        "User",
        "Privacy",
        "svg",
        "userprivacy",
        "managementgovernance"
      ]
    },
    {
      "provider": "azure",
      "label": "User Settings",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/10433-icon-service-User-Settings.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/10433-icon-service-User-Settings.svg",
      "tokens": [
        "User Settings",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "10433",
        "icon",
        "service",
        "User",
        "Settings",
        "svg",
        "usersettings"
      ]
    },
    {
      "provider": "azure",
      "label": "User Settings",
      "category": "Security",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/security/10433-icon-service-User-Settings.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/security/10433-icon-service-User-Settings.svg",
      "tokens": [
        "User Settings",
        "Security",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "security",
        "10433",
        "icon",
        "service",
        "User",
        "Settings",
        "svg",
        "usersettings"
      ]
    },
    {
      "provider": "azure",
      "label": "User Subscriptions",
      "category": "Azure Stack",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/azure-stack/10111-icon-service-User-Subscriptions.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/azure stack/10111-icon-service-User-Subscriptions.svg",
      "tokens": [
        "User Subscriptions",
        "Azure Stack",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "azure",
        "stack",
        "10111",
        "icon",
        "service",
        "User",
        "Subscriptions",
        "svg",
        "usersubscriptions",
        "azurestack"
      ]
    },
    {
      "provider": "azure",
      "label": "Users",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/10230-icon-service-Users.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/10230-icon-service-Users.svg",
      "tokens": [
        "Users",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "10230",
        "icon",
        "service",
        "svg",
        "users"
      ]
    },
    {
      "provider": "azure",
      "label": "V Net Appliance",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/034412066-icon-service-VNet-Appliance.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/034412066-icon-service-VNet-Appliance.svg",
      "tokens": [
        "V Net Appliance",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "034412066",
        "icon",
        "service",
        "VNet",
        "Appliance",
        "svg",
        "vnetappliance",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Verifiable Credentials",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/01084-icon-service-Verifiable-Credentials.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/01084-icon-service-Verifiable-Credentials.svg",
      "tokens": [
        "Verifiable Credentials",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "01084",
        "icon",
        "service",
        "Verifiable",
        "Credentials",
        "svg",
        "verifiablecredentials"
      ]
    },
    {
      "provider": "azure",
      "label": "Verification As A Service",
      "category": "Identity",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/identity/03225-icon-service-Verification-As-A-Service.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/identity/03225-icon-service-Verification-As-A-Service.svg",
      "tokens": [
        "Verification As A Service",
        "Identity",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "identity",
        "03225",
        "icon",
        "service",
        "Verification",
        "As",
        "A",
        "svg",
        "verificationasaservice"
      ]
    },
    {
      "provider": "azure",
      "label": "Versions",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10845-icon-service-Versions.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10845-icon-service-Versions.svg",
      "tokens": [
        "Versions",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10845",
        "icon",
        "service",
        "svg",
        "versions"
      ]
    },
    {
      "provider": "azure",
      "label": "Video Analyzers",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/00712-icon-service-Video-Analyzers.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/00712-icon-service-Video-Analyzers.svg",
      "tokens": [
        "Video Analyzers",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "00712",
        "icon",
        "service",
        "Video",
        "Analyzers",
        "svg",
        "videoanalyzers"
      ]
    },
    {
      "provider": "azure",
      "label": "Virtual Clusters",
      "category": "Databases",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/databases/10127-icon-service-Virtual-Clusters.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/databases/10127-icon-service-Virtual-Clusters.svg",
      "tokens": [
        "Virtual Clusters",
        "Databases",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "databases",
        "10127",
        "icon",
        "service",
        "Virtual",
        "Clusters",
        "svg",
        "virtualclusters"
      ]
    },
    {
      "provider": "azure",
      "label": "Virtual Enclaves",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03394-icon-service-Virtual-Enclaves.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03394-icon-service-Virtual-Enclaves.svg",
      "tokens": [
        "Virtual Enclaves",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03394",
        "icon",
        "service",
        "Virtual",
        "Enclaves",
        "svg",
        "virtualenclaves"
      ]
    },
    {
      "provider": "azure",
      "label": "Virtual Instance For SAP",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03089-icon-service-Virtual-Instance-for-SAP.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03089-icon-service-Virtual-Instance-for-SAP.svg",
      "tokens": [
        "Virtual Instance For SAP",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03089",
        "icon",
        "service",
        "Virtual",
        "Instance",
        "for",
        "SAP",
        "svg",
        "virtualinstanceforsap"
      ]
    },
    {
      "provider": "azure",
      "label": "Virtual Machine",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/10021-icon-service-Virtual-Machine.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/10021-icon-service-Virtual-Machine.svg",
      "tokens": [
        "Virtual Machine",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "10021",
        "icon",
        "service",
        "Virtual",
        "Machine",
        "svg",
        "virtualmachine"
      ]
    },
    {
      "provider": "azure",
      "label": "Virtual Machines (Classic)",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/10028-icon-service-Virtual-Machines-(Classic).svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/10028-icon-service-Virtual-Machines-(Classic).svg",
      "tokens": [
        "Virtual Machines (Classic)",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "10028",
        "icon",
        "service",
        "Virtual",
        "Machines",
        "(Classic)",
        "svg",
        "virtualmachinesclassic"
      ]
    },
    {
      "provider": "azure",
      "label": "Virtual Network Gateways",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10063-icon-service-Virtual-Network-Gateways.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10063-icon-service-Virtual-Network-Gateways.svg",
      "tokens": [
        "Virtual Network Gateways",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10063",
        "icon",
        "service",
        "Virtual",
        "Network",
        "Gateways",
        "svg",
        "virtualnetworkgateways"
      ]
    },
    {
      "provider": "azure",
      "label": "Virtual Networks (Classic)",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10075-icon-service-Virtual-Networks-(Classic).svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10075-icon-service-Virtual-Networks-(Classic).svg",
      "tokens": [
        "Virtual Networks (Classic)",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10075",
        "icon",
        "service",
        "Virtual",
        "Networks",
        "(Classic)",
        "svg",
        "virtualnetworksclassic"
      ]
    },
    {
      "provider": "azure",
      "label": "Virtual Networks",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10061-icon-service-Virtual-Networks.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10061-icon-service-Virtual-Networks.svg",
      "tokens": [
        "Virtual Networks",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10061",
        "icon",
        "service",
        "Virtual",
        "Networks",
        "svg",
        "virtualnetworks"
      ]
    },
    {
      "provider": "azure",
      "label": "Virtual Router",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/02496-icon-service-Virtual-Router.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/02496-icon-service-Virtual-Router.svg",
      "tokens": [
        "Virtual Router",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "02496",
        "icon",
        "service",
        "Virtual",
        "Router",
        "svg",
        "virtualrouter"
      ]
    },
    {
      "provider": "azure",
      "label": "Virtual Visits Builder",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02949-icon-service-Virtual-Visits-Builder.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02949-icon-service-Virtual-Visits-Builder.svg",
      "tokens": [
        "Virtual Visits Builder",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02949",
        "icon",
        "service",
        "Virtual",
        "Visits",
        "Builder",
        "svg",
        "virtualvisitsbuilder"
      ]
    },
    {
      "provider": "azure",
      "label": "Virtual WA Ns",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10353-icon-service-Virtual-WANs.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10353-icon-service-Virtual-WANs.svg",
      "tokens": [
        "Virtual WA Ns",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10353",
        "icon",
        "service",
        "Virtual",
        "WANs",
        "svg",
        "virtualwans"
      ]
    },
    {
      "provider": "azure",
      "label": "Virtual WAN Hub",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/00860-icon-service-Virtual-WAN-Hub.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/00860-icon-service-Virtual-WAN-Hub.svg",
      "tokens": [
        "Virtual WAN Hub",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "00860",
        "icon",
        "service",
        "Virtual",
        "WAN",
        "Hub",
        "svg",
        "virtualwanhub"
      ]
    },
    {
      "provider": "azure",
      "label": "VM App Definitions",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02805-icon-service-VM-App-Definitions.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02805-icon-service-VM-App-Definitions.svg",
      "tokens": [
        "VM App Definitions",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02805",
        "icon",
        "service",
        "VM",
        "App",
        "Definitions",
        "svg",
        "vmappdefinitions"
      ]
    },
    {
      "provider": "azure",
      "label": "VM App Versions",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02806-icon-service-VM-App-Versions.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02806-icon-service-VM-App-Versions.svg",
      "tokens": [
        "VM App Versions",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02806",
        "icon",
        "service",
        "VM",
        "App",
        "Versions",
        "svg",
        "vmappversions"
      ]
    },
    {
      "provider": "azure",
      "label": "VM Image Version",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02866-icon-service-VM-Image-Version.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02866-icon-service-VM-Image-Version.svg",
      "tokens": [
        "VM Image Version",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02866",
        "icon",
        "service",
        "VM",
        "Image",
        "Version",
        "svg",
        "vmimageversion"
      ]
    },
    {
      "provider": "azure",
      "label": "VM Images (Classic)",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/10040-icon-service-VM-Images-(Classic).svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/10040-icon-service-VM-Images-(Classic).svg",
      "tokens": [
        "VM Images (Classic)",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "10040",
        "icon",
        "service",
        "VM",
        "Images",
        "(Classic)",
        "svg",
        "vmimagesclassic"
      ]
    },
    {
      "provider": "azure",
      "label": "VM Scale Sets",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/10034-icon-service-VM-Scale-Sets.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/10034-icon-service-VM-Scale-Sets.svg",
      "tokens": [
        "VM Scale Sets",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "10034",
        "icon",
        "service",
        "VM",
        "Scale",
        "Sets",
        "svg",
        "vmscalesets"
      ]
    },
    {
      "provider": "azure",
      "label": "VPN Client Windows",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/03694-icon-service-VPNClientWindows.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/03694-icon-service-VPNClientWindows.svg",
      "tokens": [
        "VPN Client Windows",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "03694",
        "icon",
        "service",
        "VPNClientWindows",
        "svg",
        "vpnclientwindows",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "WAC Installer",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/03563-icon-service-WAC-Installer.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/03563-icon-service-WAC-Installer.svg",
      "tokens": [
        "WAC Installer",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "03563",
        "icon",
        "service",
        "WAC",
        "Installer",
        "svg",
        "wacinstaller"
      ]
    },
    {
      "provider": "azure",
      "label": "WAC",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/10355-icon-service-WAC.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/10355-icon-service-WAC.svg",
      "tokens": [
        "WAC",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "10355",
        "icon",
        "service",
        "svg",
        "wac"
      ]
    },
    {
      "provider": "azure",
      "label": "Web App + Database",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02515-icon-service-Web-App-%2B-Database.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02515-icon-service-Web-App-+-Database.svg",
      "tokens": [
        "Web App + Database",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02515",
        "icon",
        "service",
        "Web",
        "App",
        "+",
        "Database",
        "svg",
        "webappdatabase"
      ]
    },
    {
      "provider": "azure",
      "label": "Web Application Firewall Policies(WAF)",
      "category": "Networking",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/networking/10362-icon-service-Web-Application-Firewall-Policies(WAF).svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/networking/10362-icon-service-Web-Application-Firewall-Policies(WAF).svg",
      "tokens": [
        "Web Application Firewall Policies(WAF)",
        "Networking",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "networking",
        "10362",
        "icon",
        "service",
        "Web",
        "Application",
        "Firewall",
        "Policies(WAF)",
        "svg",
        "webapplicationfirewallpolicieswaf"
      ]
    },
    {
      "provider": "azure",
      "label": "Web Jobs",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/10846-icon-service-Web-Jobs.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/10846-icon-service-Web-Jobs.svg",
      "tokens": [
        "Web Jobs",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "10846",
        "icon",
        "service",
        "Web",
        "Jobs",
        "svg",
        "webjobs"
      ]
    },
    {
      "provider": "azure",
      "label": "Web Slots",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10849-icon-service-Web-Slots.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10849-icon-service-Web-Slots.svg",
      "tokens": [
        "Web Slots",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10849",
        "icon",
        "service",
        "Web",
        "Slots",
        "svg",
        "webslots"
      ]
    },
    {
      "provider": "azure",
      "label": "Web Test",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10850-icon-service-Web-Test.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10850-icon-service-Web-Test.svg",
      "tokens": [
        "Web Test",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10850",
        "icon",
        "service",
        "Web",
        "Test",
        "svg",
        "webtest"
      ]
    },
    {
      "provider": "azure",
      "label": "Website Power",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10847-icon-service-Website-Power.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10847-icon-service-Website-Power.svg",
      "tokens": [
        "Website Power",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10847",
        "icon",
        "service",
        "Website",
        "Power",
        "svg",
        "websitepower"
      ]
    },
    {
      "provider": "azure",
      "label": "Website Staging",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10848-icon-service-Website-Staging.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10848-icon-service-Website-Staging.svg",
      "tokens": [
        "Website Staging",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10848",
        "icon",
        "service",
        "Website",
        "Staging",
        "svg",
        "websitestaging"
      ]
    },
    {
      "provider": "azure",
      "label": "Windows Notification Services",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02733-icon-service-Windows-Notification-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02733-icon-service-Windows-Notification-Services.svg",
      "tokens": [
        "Windows Notification Services",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02733",
        "icon",
        "service",
        "Windows",
        "Notification",
        "Services",
        "svg",
        "windowsnotificationservices"
      ]
    },
    {
      "provider": "azure",
      "label": "Windows10 Core Services",
      "category": "Iot",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/iot/10203-icon-service-Windows10-Core-Services.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/iot/10203-icon-service-Windows10-Core-Services.svg",
      "tokens": [
        "Windows10 Core Services",
        "Iot",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "iot",
        "10203",
        "icon",
        "service",
        "Windows10",
        "Core",
        "Services",
        "svg",
        "windows10coreservices"
      ]
    },
    {
      "provider": "azure",
      "label": "Workbooks",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10851-icon-service-Workbooks.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10851-icon-service-Workbooks.svg",
      "tokens": [
        "Workbooks",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10851",
        "icon",
        "service",
        "svg",
        "workbooks"
      ]
    },
    {
      "provider": "azure",
      "label": "Worker Container App",
      "category": "Other",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/other/02884-icon-service-Worker-Container-App.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/other/02884-icon-service-Worker-Container-App.svg",
      "tokens": [
        "Worker Container App",
        "Other",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "other",
        "02884",
        "icon",
        "service",
        "Worker",
        "Container",
        "App",
        "svg",
        "workercontainerapp"
      ]
    },
    {
      "provider": "azure",
      "label": "Workflow",
      "category": "General",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/general/10852-icon-service-Workflow.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/general/10852-icon-service-Workflow.svg",
      "tokens": [
        "Workflow",
        "General",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "general",
        "10852",
        "icon",
        "service",
        "svg",
        "workflow"
      ]
    },
    {
      "provider": "azure",
      "label": "Workload Orchestration",
      "category": "New Icons",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/new-icons/029109619-icon-service-Workload-Orchestration.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/new icons/029109619-icon-service-Workload-Orchestration.svg",
      "tokens": [
        "Workload Orchestration",
        "New Icons",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "new",
        "icons",
        "029109619",
        "icon",
        "service",
        "Workload",
        "Orchestration",
        "svg",
        "workloadorchestration",
        "newicons"
      ]
    },
    {
      "provider": "azure",
      "label": "Workspace Gateway",
      "category": "Devops",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/devops/03623-icon-service-Workspace-Gateway.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/devops/03623-icon-service-Workspace-Gateway.svg",
      "tokens": [
        "Workspace Gateway",
        "Devops",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "devops",
        "03623",
        "icon",
        "service",
        "Workspace",
        "Gateway",
        "svg",
        "workspacegateway"
      ]
    },
    {
      "provider": "azure",
      "label": "Workspaces",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/00330-icon-service-Workspaces.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/00330-icon-service-Workspaces.svg",
      "tokens": [
        "Workspaces",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "00330",
        "icon",
        "service",
        "svg",
        "workspaces"
      ]
    },
    {
      "provider": "azure",
      "label": "Workspaces",
      "category": "Compute",
      "url": "/assets/network-icons/azure/Azure_Public_Service_Icons_V23/Icons/compute/00400-icon-service-Workspaces.svg",
      "sourcePath": "Azure_Public_Service_Icons/Icons/compute/00400-icon-service-Workspaces.svg",
      "tokens": [
        "Workspaces",
        "Compute",
        "Azure",
        "Public",
        "Service",
        "Icons",
        "compute",
        "00400",
        "icon",
        "service",
        "svg",
        "workspaces"
      ]
    },
    {
      "provider": "gcp",
      "label": "Access Context Manager",
      "category": "Access Context Manager",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/access_context_manager/access_context_manager.svg",
      "sourcePath": "access_context_manager/access_context_manager.svg",
      "tokens": [
        "Access Context Manager",
        "access",
        "context",
        "manager",
        "svg",
        "accesscontextmanager"
      ]
    },
    {
      "provider": "gcp",
      "label": "Administration",
      "category": "Administration",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/administration/administration.svg",
      "sourcePath": "administration/administration.svg",
      "tokens": [
        "Administration",
        "administration",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Advanced Agent Modeling",
      "category": "Advanced Agent Modeling",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/advanced_agent_modeling/advanced_agent_modeling.svg",
      "sourcePath": "advanced_agent_modeling/advanced_agent_modeling.svg",
      "tokens": [
        "Advanced Agent Modeling",
        "advanced",
        "agent",
        "modeling",
        "svg",
        "advancedagentmodeling"
      ]
    },
    {
      "provider": "gcp",
      "label": "Advanced Solutions Lab",
      "category": "Advanced Solutions Lab",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/advanced_solutions_lab/advanced_solutions_lab.svg",
      "sourcePath": "advanced_solutions_lab/advanced_solutions_lab.svg",
      "tokens": [
        "Advanced Solutions Lab",
        "advanced",
        "solutions",
        "lab",
        "svg",
        "advancedsolutionslab"
      ]
    },
    {
      "provider": "gcp",
      "label": "Agent Assist",
      "category": "Agent Assist",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/agent_assist/agent_assist.svg",
      "sourcePath": "agent_assist/agent_assist.svg",
      "tokens": [
        "Agent Assist",
        "agent",
        "assist",
        "svg",
        "agentassist"
      ]
    },
    {
      "provider": "gcp",
      "label": "Agents",
      "category": "Agents",
      "url": "/assets/network-icons/gcp/category-icons/Category-Icons/Agents/SVG/Agents-512-color.svg",
      "sourcePath": "Category Icons/Agents/SVG/Agents-512-color.svg",
      "tokens": [
        "Agents",
        "Category",
        "Icons",
        "SVG",
        "512",
        "color",
        "svg",
        "agents"
      ]
    },
    {
      "provider": "gcp",
      "label": "Ai Hub",
      "category": "Ai Hub",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/ai_hub/ai_hub.svg",
      "sourcePath": "ai_hub/ai_hub.svg",
      "tokens": [
        "Ai Hub",
        "ai",
        "hub",
        "svg",
        "aihub"
      ]
    },
    {
      "provider": "gcp",
      "label": "AI Hypercomputer",
      "category": "AI Hypercomputer",
      "url": "/assets/network-icons/gcp/core-products-icons/unique-icons/AI-Hypercomputer/SVG/AIHypercomputer-512-color.svg",
      "sourcePath": "Unique Icons/AI Hypercomputer/SVG/AIHypercomputer-512-color.svg",
      "tokens": [
        "AI Hypercomputer",
        "Unique",
        "Icons",
        "AI",
        "Hypercomputer",
        "SVG",
        "AIHypercomputer",
        "512",
        "color",
        "svg",
        "aihypercomputer"
      ]
    },
    {
      "provider": "gcp",
      "label": "AI Machine Learning",
      "category": "AI Machine Learning",
      "url": "/assets/network-icons/gcp/category-icons/Category-Icons/AI-_-Machine-Learning/SVG/AIMachineLearning-512-color.svg",
      "sourcePath": "Category Icons/AI _ Machine Learning/SVG/AIMachineLearning-512-color.svg",
      "tokens": [
        "AI Machine Learning",
        "Category",
        "Icons",
        "AI",
        "Machine",
        "Learning",
        "SVG",
        "AIMachineLearning",
        "512",
        "color",
        "svg",
        "aimachinelearning"
      ]
    },
    {
      "provider": "gcp",
      "label": "Ai Platform Unified",
      "category": "Ai Platform Unified",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/ai_platform_unified/ai_platform_unified.svg",
      "sourcePath": "ai_platform_unified/ai_platform_unified.svg",
      "tokens": [
        "Ai Platform Unified",
        "ai",
        "platform",
        "unified",
        "svg",
        "aiplatformunified"
      ]
    },
    {
      "provider": "gcp",
      "label": "Ai Platform",
      "category": "Ai Platform",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/ai_platform/ai_platform.svg",
      "sourcePath": "ai_platform/ai_platform.svg",
      "tokens": [
        "Ai Platform",
        "ai",
        "platform",
        "svg",
        "aiplatform"
      ]
    },
    {
      "provider": "gcp",
      "label": "Alloy DB",
      "category": "Alloy DB",
      "url": "/assets/network-icons/gcp/core-products-icons/unique-icons/AlloyDB/SVG/AlloyDB-512-color.svg",
      "sourcePath": "Unique Icons/AlloyDB/SVG/AlloyDB-512-color.svg",
      "tokens": [
        "Alloy DB",
        "Unique",
        "Icons",
        "AlloyDB",
        "SVG",
        "512",
        "color",
        "svg",
        "alloydb"
      ]
    },
    {
      "provider": "gcp",
      "label": "Analytics Hub",
      "category": "Analytics Hub",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/analytics_hub/analytics_hub.svg",
      "sourcePath": "analytics_hub/analytics_hub.svg",
      "tokens": [
        "Analytics Hub",
        "analytics",
        "hub",
        "svg",
        "analyticshub"
      ]
    },
    {
      "provider": "gcp",
      "label": "Anthos Config Management",
      "category": "Anthos Config Management",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/anthos_config_management/anthos_config_management.svg",
      "sourcePath": "anthos_config_management/anthos_config_management.svg",
      "tokens": [
        "Anthos Config Management",
        "anthos",
        "config",
        "management",
        "svg",
        "anthosconfigmanagement"
      ]
    },
    {
      "provider": "gcp",
      "label": "Anthos Service Mesh",
      "category": "Anthos Service Mesh",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/anthos_service_mesh/anthos_service_mesh.svg",
      "sourcePath": "anthos_service_mesh/anthos_service_mesh.svg",
      "tokens": [
        "Anthos Service Mesh",
        "anthos",
        "service",
        "mesh",
        "svg",
        "anthosservicemesh"
      ]
    },
    {
      "provider": "gcp",
      "label": "Anthos",
      "category": "Anthos",
      "url": "/assets/network-icons/gcp/core-products-icons/unique-icons/Anthos/SVG/Anthos-512-color.svg",
      "sourcePath": "Unique Icons/Anthos/SVG/Anthos-512-color.svg",
      "tokens": [
        "Anthos",
        "Unique",
        "Icons",
        "SVG",
        "512",
        "color",
        "svg",
        "anthos"
      ]
    },
    {
      "provider": "gcp",
      "label": "Anthos",
      "category": "Anthos",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/anthos/anthos.svg",
      "sourcePath": "anthos/anthos.svg",
      "tokens": [
        "Anthos",
        "anthos",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Api Analytics",
      "category": "Api Analytics",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/api_analytics/api_analytics.svg",
      "sourcePath": "api_analytics/api_analytics.svg",
      "tokens": [
        "Api Analytics",
        "api",
        "analytics",
        "svg",
        "apianalytics"
      ]
    },
    {
      "provider": "gcp",
      "label": "Api Monetization",
      "category": "Api Monetization",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/api_monetization/api_monetization.svg",
      "sourcePath": "api_monetization/api_monetization.svg",
      "tokens": [
        "Api Monetization",
        "api",
        "monetization",
        "svg",
        "apimonetization"
      ]
    },
    {
      "provider": "gcp",
      "label": "Api",
      "category": "Api",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/api/api.svg",
      "sourcePath": "api/api.svg",
      "tokens": [
        "Api",
        "api",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Apigee Api Platform",
      "category": "Apigee Api Platform",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/apigee_api_platform/apigee_api_platform.svg",
      "sourcePath": "apigee_api_platform/apigee_api_platform.svg",
      "tokens": [
        "Apigee Api Platform",
        "apigee",
        "api",
        "platform",
        "svg",
        "apigeeapiplatform"
      ]
    },
    {
      "provider": "gcp",
      "label": "Apigee Sense",
      "category": "Apigee Sense",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/apigee_sense/apigee_sense.svg",
      "sourcePath": "apigee_sense/apigee_sense.svg",
      "tokens": [
        "Apigee Sense",
        "apigee",
        "sense",
        "svg",
        "apigeesense"
      ]
    },
    {
      "provider": "gcp",
      "label": "Apigee",
      "category": "Apigee",
      "url": "/assets/network-icons/gcp/core-products-icons/unique-icons/Apigee/SVG/Apigee-512-color-rgb.svg",
      "sourcePath": "Unique Icons/Apigee/SVG/Apigee-512-color-rgb.svg",
      "tokens": [
        "Apigee",
        "Unique",
        "Icons",
        "SVG",
        "512",
        "color",
        "rgb",
        "svg",
        "apigee"
      ]
    },
    {
      "provider": "gcp",
      "label": "App Engine",
      "category": "App Engine",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/app_engine/app_engine.svg",
      "sourcePath": "app_engine/app_engine.svg",
      "tokens": [
        "App Engine",
        "app",
        "engine",
        "svg",
        "appengine"
      ]
    },
    {
      "provider": "gcp",
      "label": "Artifact Registry",
      "category": "Artifact Registry",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/artifact_registry/artifact_registry.svg",
      "sourcePath": "artifact_registry/artifact_registry.svg",
      "tokens": [
        "Artifact Registry",
        "artifact",
        "registry",
        "svg",
        "artifactregistry"
      ]
    },
    {
      "provider": "gcp",
      "label": "Asset Inventory",
      "category": "Asset Inventory",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/asset_inventory/asset_inventory.svg",
      "sourcePath": "asset_inventory/asset_inventory.svg",
      "tokens": [
        "Asset Inventory",
        "asset",
        "inventory",
        "svg",
        "assetinventory"
      ]
    },
    {
      "provider": "gcp",
      "label": "Assured Workloads",
      "category": "Assured Workloads",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/assured_workloads/assured_workloads.svg",
      "sourcePath": "assured_workloads/assured_workloads.svg",
      "tokens": [
        "Assured Workloads",
        "assured",
        "workloads",
        "svg",
        "assuredworkloads"
      ]
    },
    {
      "provider": "gcp",
      "label": "Automl Natural Language",
      "category": "Automl Natural Language",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/automl_natural_language/automl_natural_language.svg",
      "sourcePath": "automl_natural_language/automl_natural_language.svg",
      "tokens": [
        "Automl Natural Language",
        "automl",
        "natural",
        "language",
        "svg",
        "automlnaturallanguage"
      ]
    },
    {
      "provider": "gcp",
      "label": "Automl Tables",
      "category": "Automl Tables",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/automl_tables/automl_tables.svg",
      "sourcePath": "automl_tables/automl_tables.svg",
      "tokens": [
        "Automl Tables",
        "automl",
        "tables",
        "svg",
        "automltables"
      ]
    },
    {
      "provider": "gcp",
      "label": "Automl Translation",
      "category": "Automl Translation",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/automl_translation/automl_translation.svg",
      "sourcePath": "automl_translation/automl_translation.svg",
      "tokens": [
        "Automl Translation",
        "automl",
        "translation",
        "svg",
        "automltranslation"
      ]
    },
    {
      "provider": "gcp",
      "label": "Automl Video Intelligence",
      "category": "Automl Video Intelligence",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/automl_video_intelligence/automl_video_intelligence.svg",
      "sourcePath": "automl_video_intelligence/automl_video_intelligence.svg",
      "tokens": [
        "Automl Video Intelligence",
        "automl",
        "video",
        "intelligence",
        "svg",
        "automlvideointelligence"
      ]
    },
    {
      "provider": "gcp",
      "label": "Automl Vision",
      "category": "Automl Vision",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/automl_vision/automl_vision.svg",
      "sourcePath": "automl_vision/automl_vision.svg",
      "tokens": [
        "Automl Vision",
        "automl",
        "vision",
        "svg",
        "automlvision"
      ]
    },
    {
      "provider": "gcp",
      "label": "Automl",
      "category": "Automl",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/automl/automl.svg",
      "sourcePath": "automl/automl.svg",
      "tokens": [
        "Automl",
        "automl",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Bare Metal Solutions",
      "category": "Bare Metal Solutions",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/bare_metal_solutions/bare_metal_solutions.svg",
      "sourcePath": "bare_metal_solutions/bare_metal_solutions.svg",
      "tokens": [
        "Bare Metal Solutions",
        "bare",
        "metal",
        "solutions",
        "svg",
        "baremetalsolutions"
      ]
    },
    {
      "provider": "gcp",
      "label": "Batch",
      "category": "Batch",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/batch/batch.svg",
      "sourcePath": "batch/batch.svg",
      "tokens": [
        "Batch",
        "batch",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Beyondcorp",
      "category": "Beyondcorp",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/beyondcorp/beyondcorp.svg",
      "sourcePath": "beyondcorp/beyondcorp.svg",
      "tokens": [
        "Beyondcorp",
        "beyondcorp",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Big Query",
      "category": "Big Query",
      "url": "/assets/network-icons/gcp/core-products-icons/unique-icons/BigQuery/SVG/BigQuery-512-color.svg",
      "sourcePath": "Unique Icons/BigQuery/SVG/BigQuery-512-color.svg",
      "tokens": [
        "Big Query",
        "Unique",
        "Icons",
        "BigQuery",
        "SVG",
        "512",
        "color",
        "svg",
        "bigquery"
      ]
    },
    {
      "provider": "gcp",
      "label": "Bigquery",
      "category": "Bigquery",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/bigquery/bigquery.svg",
      "sourcePath": "bigquery/bigquery.svg",
      "tokens": [
        "Bigquery",
        "bigquery",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Bigtable",
      "category": "Bigtable",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/bigtable/bigtable.svg",
      "sourcePath": "bigtable/bigtable.svg",
      "tokens": [
        "Bigtable",
        "bigtable",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Billing",
      "category": "Billing",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/billing/billing.svg",
      "sourcePath": "billing/billing.svg",
      "tokens": [
        "Billing",
        "billing",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Binary Authorization",
      "category": "Binary Authorization",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/binary_authorization/binary_authorization.svg",
      "sourcePath": "binary_authorization/binary_authorization.svg",
      "tokens": [
        "Binary Authorization",
        "binary",
        "authorization",
        "svg",
        "binaryauthorization"
      ]
    },
    {
      "provider": "gcp",
      "label": "Business Intelligence",
      "category": "Business Intelligence",
      "url": "/assets/network-icons/gcp/category-icons/Category-Icons/Business-Intelligence/SVG/BusinessIntelligence-512-color.svg",
      "sourcePath": "Category Icons/Business Intelligence/SVG/BusinessIntelligence-512-color.svg",
      "tokens": [
        "Business Intelligence",
        "Category",
        "Icons",
        "Business",
        "Intelligence",
        "SVG",
        "BusinessIntelligence",
        "512",
        "color",
        "svg",
        "businessintelligence"
      ]
    },
    {
      "provider": "gcp",
      "label": "Catalog",
      "category": "Catalog",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/catalog/catalog.svg",
      "sourcePath": "catalog/catalog.svg",
      "tokens": [
        "Catalog",
        "catalog",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Certificate Authority Service",
      "category": "Certificate Authority Service",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/certificate_authority_service/certificate_authority_service.svg",
      "sourcePath": "certificate_authority_service/certificate_authority_service.svg",
      "tokens": [
        "Certificate Authority Service",
        "certificate",
        "authority",
        "service",
        "svg",
        "certificateauthorityservice"
      ]
    },
    {
      "provider": "gcp",
      "label": "Certificate Manager",
      "category": "Certificate Manager",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/certificate_manager/certificate_manager.svg",
      "sourcePath": "certificate_manager/certificate_manager.svg",
      "tokens": [
        "Certificate Manager",
        "certificate",
        "manager",
        "svg",
        "certificatemanager"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Api Gateway",
      "category": "Cloud Api Gateway",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_api_gateway/cloud_api_gateway.svg",
      "sourcePath": "cloud_api_gateway/cloud_api_gateway.svg",
      "tokens": [
        "Cloud Api Gateway",
        "cloud",
        "api",
        "gateway",
        "svg",
        "cloudapigateway"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Apis",
      "category": "Cloud Apis",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_apis/cloud_apis.svg",
      "sourcePath": "cloud_apis/cloud_apis.svg",
      "tokens": [
        "Cloud Apis",
        "cloud",
        "apis",
        "svg",
        "cloudapis"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Armor",
      "category": "Cloud Armor",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_armor/cloud_armor.svg",
      "sourcePath": "cloud_armor/cloud_armor.svg",
      "tokens": [
        "Cloud Armor",
        "cloud",
        "armor",
        "svg",
        "cloudarmor"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Asset Inventory",
      "category": "Cloud Asset Inventory",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_asset_inventory/cloud_asset_inventory.svg",
      "sourcePath": "cloud_asset_inventory/cloud_asset_inventory.svg",
      "tokens": [
        "Cloud Asset Inventory",
        "cloud",
        "asset",
        "inventory",
        "svg",
        "cloudassetinventory"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Audit Logs",
      "category": "Cloud Audit Logs",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_audit_logs/cloud_audit_logs.svg",
      "sourcePath": "cloud_audit_logs/cloud_audit_logs.svg",
      "tokens": [
        "Cloud Audit Logs",
        "cloud",
        "audit",
        "logs",
        "svg",
        "cloudauditlogs"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Build",
      "category": "Cloud Build",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_build/cloud_build.svg",
      "sourcePath": "cloud_build/cloud_build.svg",
      "tokens": [
        "Cloud Build",
        "cloud",
        "build",
        "svg",
        "cloudbuild"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Cdn",
      "category": "Cloud Cdn",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_cdn/cloud_cdn.svg",
      "sourcePath": "cloud_cdn/cloud_cdn.svg",
      "tokens": [
        "Cloud Cdn",
        "cloud",
        "cdn",
        "svg",
        "cloudcdn"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Code",
      "category": "Cloud Code",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_code/cloud_code.svg",
      "sourcePath": "cloud_code/cloud_code.svg",
      "tokens": [
        "Cloud Code",
        "cloud",
        "code",
        "svg",
        "cloudcode"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Composer",
      "category": "Cloud Composer",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_composer/cloud_composer.svg",
      "sourcePath": "cloud_composer/cloud_composer.svg",
      "tokens": [
        "Cloud Composer",
        "cloud",
        "composer",
        "svg",
        "cloudcomposer"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Data Fusion",
      "category": "Cloud Data Fusion",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_data_fusion/cloud_data_fusion.svg",
      "sourcePath": "cloud_data_fusion/cloud_data_fusion.svg",
      "tokens": [
        "Cloud Data Fusion",
        "cloud",
        "data",
        "fusion",
        "svg",
        "clouddatafusion"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Deploy",
      "category": "Cloud Deploy",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_deploy/cloud_deploy.svg",
      "sourcePath": "cloud_deploy/cloud_deploy.svg",
      "tokens": [
        "Cloud Deploy",
        "cloud",
        "deploy",
        "svg",
        "clouddeploy"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Deployment Manager",
      "category": "Cloud Deployment Manager",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_deployment_manager/cloud_deployment_manager.svg",
      "sourcePath": "cloud_deployment_manager/cloud_deployment_manager.svg",
      "tokens": [
        "Cloud Deployment Manager",
        "cloud",
        "deployment",
        "manager",
        "svg",
        "clouddeploymentmanager"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Dns",
      "category": "Cloud Dns",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_dns/cloud_dns.svg",
      "sourcePath": "cloud_dns/cloud_dns.svg",
      "tokens": [
        "Cloud Dns",
        "cloud",
        "dns",
        "svg",
        "clouddns"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Domains",
      "category": "Cloud Domains",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_domains/cloud_domains.svg",
      "sourcePath": "cloud_domains/cloud_domains.svg",
      "tokens": [
        "Cloud Domains",
        "cloud",
        "domains",
        "svg",
        "clouddomains"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Ekm",
      "category": "Cloud Ekm",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_ekm/cloud_ekm.svg",
      "sourcePath": "cloud_ekm/cloud_ekm.svg",
      "tokens": [
        "Cloud Ekm",
        "cloud",
        "ekm",
        "svg",
        "cloudekm"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Endpoints",
      "category": "Cloud Endpoints",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_endpoints/cloud_endpoints.svg",
      "sourcePath": "cloud_endpoints/cloud_endpoints.svg",
      "tokens": [
        "Cloud Endpoints",
        "cloud",
        "endpoints",
        "svg",
        "cloudendpoints"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud External Ip Addresses",
      "category": "Cloud External Ip Addresses",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_external_ip_addresses/cloud_external_ip_addresses.svg",
      "sourcePath": "cloud_external_ip_addresses/cloud_external_ip_addresses.svg",
      "tokens": [
        "Cloud External Ip Addresses",
        "cloud",
        "external",
        "ip",
        "addresses",
        "svg",
        "cloudexternalipaddresses"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Firewall Rules",
      "category": "Cloud Firewall Rules",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_firewall_rules/cloud_firewall_rules.svg",
      "sourcePath": "cloud_firewall_rules/cloud_firewall_rules.svg",
      "tokens": [
        "Cloud Firewall Rules",
        "cloud",
        "firewall",
        "rules",
        "svg",
        "cloudfirewallrules"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud For Marketing",
      "category": "Cloud For Marketing",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_for_marketing/cloud_for_marketing.svg",
      "sourcePath": "cloud_for_marketing/cloud_for_marketing.svg",
      "tokens": [
        "Cloud For Marketing",
        "cloud",
        "for",
        "marketing",
        "svg",
        "cloudformarketing"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Functions",
      "category": "Cloud Functions",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_functions/cloud_functions.svg",
      "sourcePath": "cloud_functions/cloud_functions.svg",
      "tokens": [
        "Cloud Functions",
        "cloud",
        "functions",
        "svg",
        "cloudfunctions"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Generic",
      "category": "Cloud Generic",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_generic/cloud_generic.svg",
      "sourcePath": "cloud_generic/cloud_generic.svg",
      "tokens": [
        "Cloud Generic",
        "cloud",
        "generic",
        "svg",
        "cloudgeneric"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Gpu",
      "category": "Cloud Gpu",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_gpu/cloud_gpu.svg",
      "sourcePath": "cloud_gpu/cloud_gpu.svg",
      "tokens": [
        "Cloud Gpu",
        "cloud",
        "gpu",
        "svg",
        "cloudgpu"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Healthcare Api",
      "category": "Cloud Healthcare Api",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_healthcare_api/cloud_healthcare_api.svg",
      "sourcePath": "cloud_healthcare_api/cloud_healthcare_api.svg",
      "tokens": [
        "Cloud Healthcare Api",
        "cloud",
        "healthcare",
        "api",
        "svg",
        "cloudhealthcareapi"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Healthcare Marketplace",
      "category": "Cloud Healthcare Marketplace",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_healthcare_marketplace/cloud_healthcare_marketplace.svg",
      "sourcePath": "cloud_healthcare_marketplace/cloud_healthcare_marketplace.svg",
      "tokens": [
        "Cloud Healthcare Marketplace",
        "cloud",
        "healthcare",
        "marketplace",
        "svg",
        "cloudhealthcaremarketplace"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Hsm",
      "category": "Cloud Hsm",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_hsm/cloud_hsm.svg",
      "sourcePath": "cloud_hsm/cloud_hsm.svg",
      "tokens": [
        "Cloud Hsm",
        "cloud",
        "hsm",
        "svg",
        "cloudhsm"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Ids",
      "category": "Cloud Ids",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_ids/cloud_ids.svg",
      "sourcePath": "cloud_ids/cloud_ids.svg",
      "tokens": [
        "Cloud Ids",
        "cloud",
        "ids",
        "svg",
        "cloudids"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Inference Api",
      "category": "Cloud Inference Api",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_inference_api/cloud_inference_api.svg",
      "sourcePath": "cloud_inference_api/cloud_inference_api.svg",
      "tokens": [
        "Cloud Inference Api",
        "cloud",
        "inference",
        "api",
        "svg",
        "cloudinferenceapi"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Interconnect",
      "category": "Cloud Interconnect",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_interconnect/cloud_interconnect.svg",
      "sourcePath": "cloud_interconnect/cloud_interconnect.svg",
      "tokens": [
        "Cloud Interconnect",
        "cloud",
        "interconnect",
        "svg",
        "cloudinterconnect"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Jobs Api",
      "category": "Cloud Jobs Api",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_jobs_api/cloud_jobs_api.svg",
      "sourcePath": "cloud_jobs_api/cloud_jobs_api.svg",
      "tokens": [
        "Cloud Jobs Api",
        "cloud",
        "jobs",
        "api",
        "svg",
        "cloudjobsapi"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Load Balancing",
      "category": "Cloud Load Balancing",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_load_balancing/cloud_load_balancing.svg",
      "sourcePath": "cloud_load_balancing/cloud_load_balancing.svg",
      "tokens": [
        "Cloud Load Balancing",
        "cloud",
        "load",
        "balancing",
        "svg",
        "cloudloadbalancing"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Logging",
      "category": "Cloud Logging",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_logging/cloud_logging.svg",
      "sourcePath": "cloud_logging/cloud_logging.svg",
      "tokens": [
        "Cloud Logging",
        "cloud",
        "logging",
        "svg",
        "cloudlogging"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Media Edge",
      "category": "Cloud Media Edge",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_media_edge/cloud_media_edge.svg",
      "sourcePath": "cloud_media_edge/cloud_media_edge.svg",
      "tokens": [
        "Cloud Media Edge",
        "cloud",
        "media",
        "edge",
        "svg",
        "cloudmediaedge"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Monitoring",
      "category": "Cloud Monitoring",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_monitoring/cloud_monitoring.svg",
      "sourcePath": "cloud_monitoring/cloud_monitoring.svg",
      "tokens": [
        "Cloud Monitoring",
        "cloud",
        "monitoring",
        "svg",
        "cloudmonitoring"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Nat",
      "category": "Cloud Nat",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_nat/cloud_nat.svg",
      "sourcePath": "cloud_nat/cloud_nat.svg",
      "tokens": [
        "Cloud Nat",
        "cloud",
        "nat",
        "svg",
        "cloudnat"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Natural Language Api",
      "category": "Cloud Natural Language Api",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_natural_language_api/cloud_natural_language_api.svg",
      "sourcePath": "cloud_natural_language_api/cloud_natural_language_api.svg",
      "tokens": [
        "Cloud Natural Language Api",
        "cloud",
        "natural",
        "language",
        "api",
        "svg",
        "cloudnaturallanguageapi"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Network",
      "category": "Cloud Network",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_network/cloud_network.svg",
      "sourcePath": "cloud_network/cloud_network.svg",
      "tokens": [
        "Cloud Network",
        "cloud",
        "network",
        "svg",
        "cloudnetwork"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Ops",
      "category": "Cloud Ops",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_ops/cloud_ops.svg",
      "sourcePath": "cloud_ops/cloud_ops.svg",
      "tokens": [
        "Cloud Ops",
        "cloud",
        "ops",
        "svg",
        "cloudops"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Optimization Ai Fleet Routing Api",
      "category": "Cloud Optimization Ai Fleet Routing Api",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_optimization_ai_-_fleet_routing_api/cloud_optimization_ai_-_fleet_routing_api.svg",
      "sourcePath": "cloud_optimization_ai_-_fleet_routing_api/cloud_optimization_ai_-_fleet_routing_api.svg",
      "tokens": [
        "Cloud Optimization Ai Fleet Routing Api",
        "cloud",
        "optimization",
        "ai",
        "fleet",
        "routing",
        "api",
        "svg",
        "cloudoptimizationaifleetroutingapi"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Optimization Ai",
      "category": "Cloud Optimization Ai",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_optimization_ai/cloud_optimization_ai.svg",
      "sourcePath": "cloud_optimization_ai/cloud_optimization_ai.svg",
      "tokens": [
        "Cloud Optimization Ai",
        "cloud",
        "optimization",
        "ai",
        "svg",
        "cloudoptimizationai"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Router",
      "category": "Cloud Router",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_router/cloud_router.svg",
      "sourcePath": "cloud_router/cloud_router.svg",
      "tokens": [
        "Cloud Router",
        "cloud",
        "router",
        "svg",
        "cloudrouter"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Routes",
      "category": "Cloud Routes",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_routes/cloud_routes.svg",
      "sourcePath": "cloud_routes/cloud_routes.svg",
      "tokens": [
        "Cloud Routes",
        "cloud",
        "routes",
        "svg",
        "cloudroutes"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Run For Anthos",
      "category": "Cloud Run For Anthos",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_run_for_anthos/cloud_run_for_anthos.svg",
      "sourcePath": "cloud_run_for_anthos/cloud_run_for_anthos.svg",
      "tokens": [
        "Cloud Run For Anthos",
        "cloud",
        "run",
        "for",
        "anthos",
        "svg",
        "cloudrunforanthos"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Run",
      "category": "Cloud Run",
      "url": "/assets/network-icons/gcp/core-products-icons/unique-icons/Cloud-Run/SVG/CloudRun-512-color-rgb.svg",
      "sourcePath": "Unique Icons/Cloud Run/SVG/CloudRun-512-color-rgb.svg",
      "tokens": [
        "Cloud Run",
        "Unique",
        "Icons",
        "Cloud",
        "Run",
        "SVG",
        "CloudRun",
        "512",
        "color",
        "rgb",
        "svg",
        "cloudrun"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Run",
      "category": "Cloud Run",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_run/cloud_run.svg",
      "sourcePath": "cloud_run/cloud_run.svg",
      "tokens": [
        "Cloud Run",
        "cloud",
        "run",
        "svg",
        "cloudrun"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Scheduler",
      "category": "Cloud Scheduler",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_scheduler/cloud_scheduler.svg",
      "sourcePath": "cloud_scheduler/cloud_scheduler.svg",
      "tokens": [
        "Cloud Scheduler",
        "cloud",
        "scheduler",
        "svg",
        "cloudscheduler"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Security Scanner",
      "category": "Cloud Security Scanner",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_security_scanner/cloud_security_scanner.svg",
      "sourcePath": "cloud_security_scanner/cloud_security_scanner.svg",
      "tokens": [
        "Cloud Security Scanner",
        "cloud",
        "security",
        "scanner",
        "svg",
        "cloudsecurityscanner"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Shell",
      "category": "Cloud Shell",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_shell/cloud_shell.svg",
      "sourcePath": "cloud_shell/cloud_shell.svg",
      "tokens": [
        "Cloud Shell",
        "cloud",
        "shell",
        "svg",
        "cloudshell"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Spanner",
      "category": "Cloud Spanner",
      "url": "/assets/network-icons/gcp/core-products-icons/unique-icons/Cloud-Spanner/SVG/CloudSpanner-512-color.svg",
      "sourcePath": "Unique Icons/Cloud Spanner/SVG/CloudSpanner-512-color.svg",
      "tokens": [
        "Cloud Spanner",
        "Unique",
        "Icons",
        "Cloud",
        "Spanner",
        "SVG",
        "CloudSpanner",
        "512",
        "color",
        "svg",
        "cloudspanner"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Spanner",
      "category": "Cloud Spanner",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_spanner/cloud_spanner.svg",
      "sourcePath": "cloud_spanner/cloud_spanner.svg",
      "tokens": [
        "Cloud Spanner",
        "cloud",
        "spanner",
        "svg",
        "cloudspanner"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud SQL",
      "category": "Cloud SQL",
      "url": "/assets/network-icons/gcp/core-products-icons/unique-icons/Cloud-SQL/SVG/CloudSQL-512-color.svg",
      "sourcePath": "Unique Icons/Cloud SQL/SVG/CloudSQL-512-color.svg",
      "tokens": [
        "Cloud SQL",
        "Unique",
        "Icons",
        "Cloud",
        "SQL",
        "SVG",
        "CloudSQL",
        "512",
        "color",
        "svg",
        "cloudsql"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Sql",
      "category": "Cloud Sql",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_sql/cloud_sql.svg",
      "sourcePath": "cloud_sql/cloud_sql.svg",
      "tokens": [
        "Cloud Sql",
        "cloud",
        "sql",
        "svg",
        "cloudsql"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Storage",
      "category": "Cloud Storage",
      "url": "/assets/network-icons/gcp/core-products-icons/unique-icons/Cloud-Storage/SVG/Cloud_Storage-512-color.svg",
      "sourcePath": "Unique Icons/Cloud Storage/SVG/Cloud_Storage-512-color.svg",
      "tokens": [
        "Cloud Storage",
        "Unique",
        "Icons",
        "Cloud",
        "Storage",
        "SVG",
        "512",
        "color",
        "svg",
        "cloudstorage"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Storage",
      "category": "Cloud Storage",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_storage/cloud_storage.svg",
      "sourcePath": "cloud_storage/cloud_storage.svg",
      "tokens": [
        "Cloud Storage",
        "cloud",
        "storage",
        "svg",
        "cloudstorage"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Tasks",
      "category": "Cloud Tasks",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_tasks/cloud_tasks.svg",
      "sourcePath": "cloud_tasks/cloud_tasks.svg",
      "tokens": [
        "Cloud Tasks",
        "cloud",
        "tasks",
        "svg",
        "cloudtasks"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Test Lab",
      "category": "Cloud Test Lab",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_test_lab/cloud_test_lab.svg",
      "sourcePath": "cloud_test_lab/cloud_test_lab.svg",
      "tokens": [
        "Cloud Test Lab",
        "cloud",
        "test",
        "lab",
        "svg",
        "cloudtestlab"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Tpu",
      "category": "Cloud Tpu",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_tpu/cloud_tpu.svg",
      "sourcePath": "cloud_tpu/cloud_tpu.svg",
      "tokens": [
        "Cloud Tpu",
        "cloud",
        "tpu",
        "svg",
        "cloudtpu"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Translation Api",
      "category": "Cloud Translation Api",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_translation_api/cloud_translation_api.svg",
      "sourcePath": "cloud_translation_api/cloud_translation_api.svg",
      "tokens": [
        "Cloud Translation Api",
        "cloud",
        "translation",
        "api",
        "svg",
        "cloudtranslationapi"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Vision Api",
      "category": "Cloud Vision Api",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_vision_api/cloud_vision_api.svg",
      "sourcePath": "cloud_vision_api/cloud_vision_api.svg",
      "tokens": [
        "Cloud Vision Api",
        "cloud",
        "vision",
        "api",
        "svg",
        "cloudvisionapi"
      ]
    },
    {
      "provider": "gcp",
      "label": "Cloud Vpn",
      "category": "Cloud Vpn",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/cloud_vpn/cloud_vpn.svg",
      "sourcePath": "cloud_vpn/cloud_vpn.svg",
      "tokens": [
        "Cloud Vpn",
        "cloud",
        "vpn",
        "svg",
        "cloudvpn"
      ]
    },
    {
      "provider": "gcp",
      "label": "Collaboration",
      "category": "Collaboration",
      "url": "/assets/network-icons/gcp/category-icons/Category-Icons/Collaboration/SVG/Collaboration-512-color.svg",
      "sourcePath": "Category Icons/Collaboration/SVG/Collaboration-512-color.svg",
      "tokens": [
        "Collaboration",
        "Category",
        "Icons",
        "SVG",
        "512",
        "color",
        "svg",
        "collaboration"
      ]
    },
    {
      "provider": "gcp",
      "label": "Compute Engine",
      "category": "Compute Engine",
      "url": "/assets/network-icons/gcp/core-products-icons/unique-icons/Compute-Engine/SVG/ComputeEngine-512-color-rgb.svg",
      "sourcePath": "Unique Icons/Compute Engine/SVG/ComputeEngine-512-color-rgb.svg",
      "tokens": [
        "Compute Engine",
        "Unique",
        "Icons",
        "Compute",
        "Engine",
        "SVG",
        "ComputeEngine",
        "512",
        "color",
        "rgb",
        "svg",
        "computeengine"
      ]
    },
    {
      "provider": "gcp",
      "label": "Compute Engine",
      "category": "Compute Engine",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/compute_engine/compute_engine.svg",
      "sourcePath": "compute_engine/compute_engine.svg",
      "tokens": [
        "Compute Engine",
        "compute",
        "engine",
        "svg",
        "computeengine"
      ]
    },
    {
      "provider": "gcp",
      "label": "Compute",
      "category": "Compute",
      "url": "/assets/network-icons/gcp/category-icons/Category-Icons/Compute/SVG/Compute-512-color.svg",
      "sourcePath": "Category Icons/Compute/SVG/Compute-512-color.svg",
      "tokens": [
        "Compute",
        "Category",
        "Icons",
        "SVG",
        "512",
        "color",
        "svg",
        "compute"
      ]
    },
    {
      "provider": "gcp",
      "label": "Configuration Management",
      "category": "Configuration Management",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/configuration_management/configuration_management.svg",
      "sourcePath": "configuration_management/configuration_management.svg",
      "tokens": [
        "Configuration Management",
        "configuration",
        "management",
        "svg",
        "configurationmanagement"
      ]
    },
    {
      "provider": "gcp",
      "label": "Connectivity Test",
      "category": "Connectivity Test",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/connectivity_test/connectivity_test.svg",
      "sourcePath": "connectivity_test/connectivity_test.svg",
      "tokens": [
        "Connectivity Test",
        "connectivity",
        "test",
        "svg",
        "connectivitytest"
      ]
    },
    {
      "provider": "gcp",
      "label": "Connectors",
      "category": "Connectors",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/connectors/connectors.svg",
      "sourcePath": "connectors/connectors.svg",
      "tokens": [
        "Connectors",
        "connectors",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Contact Center Ai",
      "category": "Contact Center Ai",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/contact_center_ai/contact_center_ai.svg",
      "sourcePath": "contact_center_ai/contact_center_ai.svg",
      "tokens": [
        "Contact Center Ai",
        "contact",
        "center",
        "ai",
        "svg",
        "contactcenterai"
      ]
    },
    {
      "provider": "gcp",
      "label": "Container Optimized Os",
      "category": "Container Optimized Os",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/container_optimized_os/container_optimized_os.svg",
      "sourcePath": "container_optimized_os/container_optimized_os.svg",
      "tokens": [
        "Container Optimized Os",
        "container",
        "optimized",
        "os",
        "svg",
        "containeroptimizedos"
      ]
    },
    {
      "provider": "gcp",
      "label": "Container Registry",
      "category": "Container Registry",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/container_registry/container_registry.svg",
      "sourcePath": "container_registry/container_registry.svg",
      "tokens": [
        "Container Registry",
        "container",
        "registry",
        "svg",
        "containerregistry"
      ]
    },
    {
      "provider": "gcp",
      "label": "Containers",
      "category": "Containers",
      "url": "/assets/network-icons/gcp/category-icons/Category-Icons/Containers/SVG/Containers-512-color.svg",
      "sourcePath": "Category Icons/Containers/SVG/Containers-512-color.svg",
      "tokens": [
        "Containers",
        "Category",
        "Icons",
        "SVG",
        "512",
        "color",
        "svg",
        "containers"
      ]
    },
    {
      "provider": "gcp",
      "label": "Data Analytics",
      "category": "Data Analytics",
      "url": "/assets/network-icons/gcp/category-icons/Category-Icons/Data-Analytics/SVG/DataAnalytics-512-color.svg",
      "sourcePath": "Category Icons/Data Analytics/SVG/DataAnalytics-512-color.svg",
      "tokens": [
        "Data Analytics",
        "Category",
        "Icons",
        "Data",
        "Analytics",
        "SVG",
        "DataAnalytics",
        "512",
        "color",
        "svg",
        "dataanalytics"
      ]
    },
    {
      "provider": "gcp",
      "label": "Data Catalog",
      "category": "Data Catalog",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/data_catalog/data_catalog.svg",
      "sourcePath": "data_catalog/data_catalog.svg",
      "tokens": [
        "Data Catalog",
        "data",
        "catalog",
        "svg",
        "datacatalog"
      ]
    },
    {
      "provider": "gcp",
      "label": "Data Labeling",
      "category": "Data Labeling",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/data_labeling/data_labeling.svg",
      "sourcePath": "data_labeling/data_labeling.svg",
      "tokens": [
        "Data Labeling",
        "data",
        "labeling",
        "svg",
        "datalabeling"
      ]
    },
    {
      "provider": "gcp",
      "label": "Data Layers",
      "category": "Data Layers",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/data_layers/data_layers.svg",
      "sourcePath": "data_layers/data_layers.svg",
      "tokens": [
        "Data Layers",
        "data",
        "layers",
        "svg",
        "datalayers"
      ]
    },
    {
      "provider": "gcp",
      "label": "Data Loss Prevention Api",
      "category": "Data Loss Prevention Api",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/data_loss_prevention_api/data_loss_prevention_api.svg",
      "sourcePath": "data_loss_prevention_api/data_loss_prevention_api.svg",
      "tokens": [
        "Data Loss Prevention Api",
        "data",
        "loss",
        "prevention",
        "api",
        "svg",
        "datalosspreventionapi"
      ]
    },
    {
      "provider": "gcp",
      "label": "Data Qna",
      "category": "Data Qna",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/data_qna/data_qna.svg",
      "sourcePath": "data_qna/data_qna.svg",
      "tokens": [
        "Data Qna",
        "data",
        "qna",
        "svg",
        "dataqna"
      ]
    },
    {
      "provider": "gcp",
      "label": "Data Studio",
      "category": "Data Studio",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/data_studio/data_studio.svg",
      "sourcePath": "data_studio/data_studio.svg",
      "tokens": [
        "Data Studio",
        "data",
        "studio",
        "svg",
        "datastudio"
      ]
    },
    {
      "provider": "gcp",
      "label": "Data Transfer",
      "category": "Data Transfer",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/data_transfer/data_transfer.svg",
      "sourcePath": "data_transfer/data_transfer.svg",
      "tokens": [
        "Data Transfer",
        "data",
        "transfer",
        "svg",
        "datatransfer"
      ]
    },
    {
      "provider": "gcp",
      "label": "Database Migration Service",
      "category": "Database Migration Service",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/database_migration_service/database_migration_service.svg",
      "sourcePath": "database_migration_service/database_migration_service.svg",
      "tokens": [
        "Database Migration Service",
        "database",
        "migration",
        "service",
        "svg",
        "databasemigrationservice"
      ]
    },
    {
      "provider": "gcp",
      "label": "Databases",
      "category": "Databases",
      "url": "/assets/network-icons/gcp/category-icons/Category-Icons/Databases/SVG/Databases-512-color.svg",
      "sourcePath": "Category Icons/Databases/SVG/Databases-512-color.svg",
      "tokens": [
        "Databases",
        "Category",
        "Icons",
        "SVG",
        "512",
        "color",
        "svg",
        "databases"
      ]
    },
    {
      "provider": "gcp",
      "label": "Dataflow",
      "category": "Dataflow",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/dataflow/dataflow.svg",
      "sourcePath": "dataflow/dataflow.svg",
      "tokens": [
        "Dataflow",
        "dataflow",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Datalab",
      "category": "Datalab",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/datalab/datalab.svg",
      "sourcePath": "datalab/datalab.svg",
      "tokens": [
        "Datalab",
        "datalab",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Dataplex",
      "category": "Dataplex",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/dataplex/dataplex.svg",
      "sourcePath": "dataplex/dataplex.svg",
      "tokens": [
        "Dataplex",
        "dataplex",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Datapol",
      "category": "Datapol",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/datapol/datapol.svg",
      "sourcePath": "datapol/datapol.svg",
      "tokens": [
        "Datapol",
        "datapol",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Dataprep",
      "category": "Dataprep",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/dataprep/dataprep.svg",
      "sourcePath": "dataprep/dataprep.svg",
      "tokens": [
        "Dataprep",
        "dataprep",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Dataproc Metastore",
      "category": "Dataproc Metastore",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/dataproc_metastore/dataproc_metastore.svg",
      "sourcePath": "dataproc_metastore/dataproc_metastore.svg",
      "tokens": [
        "Dataproc Metastore",
        "dataproc",
        "metastore",
        "svg",
        "dataprocmetastore"
      ]
    },
    {
      "provider": "gcp",
      "label": "Dataproc",
      "category": "Dataproc",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/dataproc/dataproc.svg",
      "sourcePath": "dataproc/dataproc.svg",
      "tokens": [
        "Dataproc",
        "dataproc",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Datashare",
      "category": "Datashare",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/datashare/datashare.svg",
      "sourcePath": "datashare/datashare.svg",
      "tokens": [
        "Datashare",
        "datashare",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Datastore",
      "category": "Datastore",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/datastore/datastore.svg",
      "sourcePath": "datastore/datastore.svg",
      "tokens": [
        "Datastore",
        "datastore",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Datastream",
      "category": "Datastream",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/datastream/datastream.svg",
      "sourcePath": "datastream/datastream.svg",
      "tokens": [
        "Datastream",
        "datastream",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Debugger",
      "category": "Debugger",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/debugger/debugger.svg",
      "sourcePath": "debugger/debugger.svg",
      "tokens": [
        "Debugger",
        "debugger",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Dev Ops",
      "category": "Dev Ops",
      "url": "/assets/network-icons/gcp/category-icons/Category-Icons/DevOps/SVG/DevOps-512-color.svg",
      "sourcePath": "Category Icons/DevOps/SVG/DevOps-512-color.svg",
      "tokens": [
        "Dev Ops",
        "Category",
        "Icons",
        "DevOps",
        "SVG",
        "512",
        "color",
        "svg",
        "devops"
      ]
    },
    {
      "provider": "gcp",
      "label": "Developer Portal",
      "category": "Developer Portal",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/developer_portal/developer_portal.svg",
      "sourcePath": "developer_portal/developer_portal.svg",
      "tokens": [
        "Developer Portal",
        "developer",
        "portal",
        "svg",
        "developerportal"
      ]
    },
    {
      "provider": "gcp",
      "label": "Developer Tools",
      "category": "Developer Tools",
      "url": "/assets/network-icons/gcp/category-icons/Category-Icons/Developer-Tools/SVG/Developer_Tools-512-color.svg",
      "sourcePath": "Category Icons/Developer Tools/SVG/Developer_Tools-512-color.svg",
      "tokens": [
        "Developer Tools",
        "Category",
        "Icons",
        "Developer",
        "Tools",
        "SVG",
        "512",
        "color",
        "svg",
        "developertools"
      ]
    },
    {
      "provider": "gcp",
      "label": "Dialogflow Cx",
      "category": "Dialogflow Cx",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/dialogflow_cx/dialogflow_cx.svg",
      "sourcePath": "dialogflow_cx/dialogflow_cx.svg",
      "tokens": [
        "Dialogflow Cx",
        "dialogflow",
        "cx",
        "svg",
        "dialogflowcx"
      ]
    },
    {
      "provider": "gcp",
      "label": "Dialogflow Insights",
      "category": "Dialogflow Insights",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/dialogflow_insights/dialogflow_insights.svg",
      "sourcePath": "dialogflow_insights/dialogflow_insights.svg",
      "tokens": [
        "Dialogflow Insights",
        "dialogflow",
        "insights",
        "svg",
        "dialogflowinsights"
      ]
    },
    {
      "provider": "gcp",
      "label": "Dialogflow",
      "category": "Dialogflow",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/dialogflow/dialogflow.svg",
      "sourcePath": "dialogflow/dialogflow.svg",
      "tokens": [
        "Dialogflow",
        "dialogflow",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Distributed Cloud",
      "category": "Distributed Cloud",
      "url": "/assets/network-icons/gcp/core-products-icons/unique-icons/Distributed-Cloud/SVG/DistributedCloud-512-color.svg",
      "sourcePath": "Unique Icons/Distributed Cloud/SVG/DistributedCloud-512-color.svg",
      "tokens": [
        "Distributed Cloud",
        "Unique",
        "Icons",
        "Distributed",
        "Cloud",
        "SVG",
        "DistributedCloud",
        "512",
        "color",
        "svg",
        "distributedcloud"
      ]
    },
    {
      "provider": "gcp",
      "label": "Document Ai",
      "category": "Document Ai",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/document_ai/document_ai.svg",
      "sourcePath": "document_ai/document_ai.svg",
      "tokens": [
        "Document Ai",
        "document",
        "ai",
        "svg",
        "documentai"
      ]
    },
    {
      "provider": "gcp",
      "label": "Early Access Center",
      "category": "Early Access Center",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/early_access_center/early_access_center.svg",
      "sourcePath": "early_access_center/early_access_center.svg",
      "tokens": [
        "Early Access Center",
        "early",
        "access",
        "center",
        "svg",
        "earlyaccesscenter"
      ]
    },
    {
      "provider": "gcp",
      "label": "Error Reporting",
      "category": "Error Reporting",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/error_reporting/error_reporting.svg",
      "sourcePath": "error_reporting/error_reporting.svg",
      "tokens": [
        "Error Reporting",
        "error",
        "reporting",
        "svg",
        "errorreporting"
      ]
    },
    {
      "provider": "gcp",
      "label": "Eventarc",
      "category": "Eventarc",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/eventarc/eventarc.svg",
      "sourcePath": "eventarc/eventarc.svg",
      "tokens": [
        "Eventarc",
        "eventarc",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Filestore",
      "category": "Filestore",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/filestore/filestore.svg",
      "sourcePath": "filestore/filestore.svg",
      "tokens": [
        "Filestore",
        "filestore",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Financial Services Marketplace",
      "category": "Financial Services Marketplace",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/financial_services_marketplace/financial_services_marketplace.svg",
      "sourcePath": "financial_services_marketplace/financial_services_marketplace.svg",
      "tokens": [
        "Financial Services Marketplace",
        "financial",
        "services",
        "marketplace",
        "svg",
        "financialservicesmarketplace"
      ]
    },
    {
      "provider": "gcp",
      "label": "Firestore",
      "category": "Firestore",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/firestore/firestore.svg",
      "sourcePath": "firestore/firestore.svg",
      "tokens": [
        "Firestore",
        "firestore",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Fleet Engine",
      "category": "Fleet Engine",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/fleet_engine/fleet_engine.svg",
      "sourcePath": "fleet_engine/fleet_engine.svg",
      "tokens": [
        "Fleet Engine",
        "fleet",
        "engine",
        "svg",
        "fleetengine"
      ]
    },
    {
      "provider": "gcp",
      "label": "Free Trial",
      "category": "Free Trial",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/free_trial/free_trial.svg",
      "sourcePath": "free_trial/free_trial.svg",
      "tokens": [
        "Free Trial",
        "free",
        "trial",
        "svg",
        "freetrial"
      ]
    },
    {
      "provider": "gcp",
      "label": "Game Servers",
      "category": "Game Servers",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/game_servers/game_servers.svg",
      "sourcePath": "game_servers/game_servers.svg",
      "tokens": [
        "Game Servers",
        "game",
        "servers",
        "svg",
        "gameservers"
      ]
    },
    {
      "provider": "gcp",
      "label": "Gce Systems Management",
      "category": "Gce Systems Management",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/gce_systems_management/gce_systems_management.svg",
      "sourcePath": "gce_systems_management/gce_systems_management.svg",
      "tokens": [
        "Gce Systems Management",
        "gce",
        "systems",
        "management",
        "svg",
        "gcesystemsmanagement"
      ]
    },
    {
      "provider": "gcp",
      "label": "Genomics",
      "category": "Genomics",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/genomics/genomics.svg",
      "sourcePath": "genomics/genomics.svg",
      "tokens": [
        "Genomics",
        "genomics",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Gke On Prem",
      "category": "Gke On Prem",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/gke_on-prem/gke_on-prem.svg",
      "sourcePath": "gke_on-prem/gke_on-prem.svg",
      "tokens": [
        "Gke On Prem",
        "gke",
        "on",
        "prem",
        "svg",
        "gkeonprem"
      ]
    },
    {
      "provider": "gcp",
      "label": "GKE",
      "category": "GKE",
      "url": "/assets/network-icons/gcp/core-products-icons/unique-icons/GKE/SVG/GKE-512-color.svg",
      "sourcePath": "Unique Icons/GKE/SVG/GKE-512-color.svg",
      "tokens": [
        "GKE",
        "Unique",
        "Icons",
        "SVG",
        "512",
        "color",
        "svg",
        "gke"
      ]
    },
    {
      "provider": "gcp",
      "label": "Google Cloud Marketplace",
      "category": "Google Cloud Marketplace",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/google_cloud_marketplace/google_cloud_marketplace.svg",
      "sourcePath": "google_cloud_marketplace/google_cloud_marketplace.svg",
      "tokens": [
        "Google Cloud Marketplace",
        "google",
        "cloud",
        "marketplace",
        "svg",
        "googlecloudmarketplace"
      ]
    },
    {
      "provider": "gcp",
      "label": "Google Kubernetes Engine",
      "category": "Google Kubernetes Engine",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/google_kubernetes_engine/google_kubernetes_engine.svg",
      "sourcePath": "google_kubernetes_engine/google_kubernetes_engine.svg",
      "tokens": [
        "Google Kubernetes Engine",
        "google",
        "kubernetes",
        "engine",
        "svg",
        "googlekubernetesengine"
      ]
    },
    {
      "provider": "gcp",
      "label": "Google Maps Platform",
      "category": "Google Maps Platform",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/google_maps_platform/google_maps_platform.svg",
      "sourcePath": "google_maps_platform/google_maps_platform.svg",
      "tokens": [
        "Google Maps Platform",
        "google",
        "maps",
        "platform",
        "svg",
        "googlemapsplatform"
      ]
    },
    {
      "provider": "gcp",
      "label": "Healthcare Nlp Api",
      "category": "Healthcare Nlp Api",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/healthcare_nlp_api/healthcare_nlp_api.svg",
      "sourcePath": "healthcare_nlp_api/healthcare_nlp_api.svg",
      "tokens": [
        "Healthcare Nlp Api",
        "healthcare",
        "nlp",
        "api",
        "svg",
        "healthcarenlpapi"
      ]
    },
    {
      "provider": "gcp",
      "label": "Home",
      "category": "Home",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/home/home.svg",
      "sourcePath": "home/home.svg",
      "tokens": [
        "Home",
        "home",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Hybrid Multicloud",
      "category": "Hybrid & Multicloud",
      "url": "/assets/network-icons/gcp/category-icons/Category-Icons/Hybrid---Multicloud/SVG/HybridMulticloud-512-color.svg",
      "sourcePath": "Category Icons/Hybrid & Multicloud/SVG/HybridMulticloud-512-color.svg",
      "tokens": [
        "Hybrid Multicloud",
        "Hybrid & Multicloud",
        "Category",
        "Icons",
        "Hybrid",
        "&",
        "Multicloud",
        "SVG",
        "HybridMulticloud",
        "512",
        "color",
        "svg",
        "hybridmulticloud",
        "hybridandmulticloud"
      ]
    },
    {
      "provider": "gcp",
      "label": "Hyperdisk",
      "category": "Hyperdisk",
      "url": "/assets/network-icons/gcp/core-products-icons/unique-icons/Hyperdisk/SVG/Hyperdisk-512-color.svg",
      "sourcePath": "Unique Icons/Hyperdisk/SVG/Hyperdisk-512-color.svg",
      "tokens": [
        "Hyperdisk",
        "Unique",
        "Icons",
        "SVG",
        "512",
        "color",
        "svg",
        "hyperdisk"
      ]
    },
    {
      "provider": "gcp",
      "label": "Identity And Access Management",
      "category": "Identity And Access Management",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/identity_and_access_management/identity_and_access_management.svg",
      "sourcePath": "identity_and_access_management/identity_and_access_management.svg",
      "tokens": [
        "Identity And Access Management",
        "identity",
        "and",
        "access",
        "management",
        "svg",
        "identityandaccessmanagement"
      ]
    },
    {
      "provider": "gcp",
      "label": "Identity Aware Proxy",
      "category": "Identity Aware Proxy",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/identity-aware_proxy/identity-aware_proxy.svg",
      "sourcePath": "identity-aware_proxy/identity-aware_proxy.svg",
      "tokens": [
        "Identity Aware Proxy",
        "identity",
        "aware",
        "proxy",
        "svg",
        "identityawareproxy"
      ]
    },
    {
      "provider": "gcp",
      "label": "Identity Platform",
      "category": "Identity Platform",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/identity_platform/identity_platform.svg",
      "sourcePath": "identity_platform/identity_platform.svg",
      "tokens": [
        "Identity Platform",
        "identity",
        "platform",
        "svg",
        "identityplatform"
      ]
    },
    {
      "provider": "gcp",
      "label": "Integration Services",
      "category": "Integration Services",
      "url": "/assets/network-icons/gcp/category-icons/Category-Icons/Integration-Services/SVG/IntegrationServices-512-color.svg",
      "sourcePath": "Category Icons/Integration Services/SVG/IntegrationServices-512-color.svg",
      "tokens": [
        "Integration Services",
        "Category",
        "Icons",
        "Integration",
        "Services",
        "SVG",
        "IntegrationServices",
        "512",
        "color",
        "svg",
        "integrationservices"
      ]
    },
    {
      "provider": "gcp",
      "label": "Iot Core",
      "category": "Iot Core",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/iot_core/iot_core.svg",
      "sourcePath": "iot_core/iot_core.svg",
      "tokens": [
        "Iot Core",
        "iot",
        "core",
        "svg",
        "iotcore"
      ]
    },
    {
      "provider": "gcp",
      "label": "Iot Edge",
      "category": "Iot Edge",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/iot_edge/iot_edge.svg",
      "sourcePath": "iot_edge/iot_edge.svg",
      "tokens": [
        "Iot Edge",
        "iot",
        "edge",
        "svg",
        "iotedge"
      ]
    },
    {
      "provider": "gcp",
      "label": "Key Access Justifications",
      "category": "Key Access Justifications",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/key_access_justifications/key_access_justifications.svg",
      "sourcePath": "key_access_justifications/key_access_justifications.svg",
      "tokens": [
        "Key Access Justifications",
        "key",
        "access",
        "justifications",
        "svg",
        "keyaccessjustifications"
      ]
    },
    {
      "provider": "gcp",
      "label": "Key Management Service",
      "category": "Key Management Service",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/key_management_service/key_management_service.svg",
      "sourcePath": "key_management_service/key_management_service.svg",
      "tokens": [
        "Key Management Service",
        "key",
        "management",
        "service",
        "svg",
        "keymanagementservice"
      ]
    },
    {
      "provider": "gcp",
      "label": "Kuberun",
      "category": "Kuberun",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/kuberun/kuberun.svg",
      "sourcePath": "kuberun/kuberun.svg",
      "tokens": [
        "Kuberun",
        "kuberun",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Launcher",
      "category": "Launcher",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/launcher/launcher.svg",
      "sourcePath": "launcher/launcher.svg",
      "tokens": [
        "Launcher",
        "launcher",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Local Ssd",
      "category": "Local Ssd",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/local_ssd/local_ssd.svg",
      "sourcePath": "local_ssd/local_ssd.svg",
      "tokens": [
        "Local Ssd",
        "local",
        "ssd",
        "svg",
        "localssd"
      ]
    },
    {
      "provider": "gcp",
      "label": "Looker",
      "category": "Looker",
      "url": "/assets/network-icons/gcp/core-products-icons/unique-icons/Looker/SVG/Looker-512-color.svg",
      "sourcePath": "Unique Icons/Looker/SVG/Looker-512-color.svg",
      "tokens": [
        "Looker",
        "Unique",
        "Icons",
        "SVG",
        "512",
        "color",
        "svg",
        "looker"
      ]
    },
    {
      "provider": "gcp",
      "label": "Looker",
      "category": "Looker",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/looker/looker.svg",
      "sourcePath": "looker/looker.svg",
      "tokens": [
        "Looker",
        "looker",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Managed Service For Microsoft Active Directory",
      "category": "Managed Service For Microsoft Active Directory",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/managed_service_for_microsoft_active_directory/managed_service_for_microsoft_active_directory.svg",
      "sourcePath": "managed_service_for_microsoft_active_directory/managed_service_for_microsoft_active_directory.svg",
      "tokens": [
        "Managed Service For Microsoft Active Directory",
        "managed",
        "service",
        "for",
        "microsoft",
        "active",
        "directory",
        "svg",
        "managedserviceformicrosoftactivedirectory"
      ]
    },
    {
      "provider": "gcp",
      "label": "Management Tools",
      "category": "Management Tools",
      "url": "/assets/network-icons/gcp/category-icons/Category-Icons/Management-Tools/SVG/ManagementTools-512-color.svg",
      "sourcePath": "Category Icons/Management Tools/SVG/ManagementTools-512-color.svg",
      "tokens": [
        "Management Tools",
        "Category",
        "Icons",
        "Management",
        "Tools",
        "SVG",
        "ManagementTools",
        "512",
        "color",
        "svg",
        "managementtools"
      ]
    },
    {
      "provider": "gcp",
      "label": "Mandiant",
      "category": "Mandiant",
      "url": "/assets/network-icons/gcp/core-products-icons/unique-icons/Mandiant/SVG/Mandiant-512-color.svg",
      "sourcePath": "Unique Icons/Mandiant/SVG/Mandiant-512-color.svg",
      "tokens": [
        "Mandiant",
        "Unique",
        "Icons",
        "SVG",
        "512",
        "color",
        "svg",
        "mandiant"
      ]
    },
    {
      "provider": "gcp",
      "label": "Maps Geospatial",
      "category": "Maps & Geospatial",
      "url": "/assets/network-icons/gcp/category-icons/Category-Icons/Maps---Geospatial/SVG/MapsGeospatial-512-color.svg",
      "sourcePath": "Category Icons/Maps & Geospatial/SVG/MapsGeospatial-512-color.svg",
      "tokens": [
        "Maps Geospatial",
        "Maps & Geospatial",
        "Category",
        "Icons",
        "Maps",
        "&",
        "Geospatial",
        "SVG",
        "MapsGeospatial",
        "512",
        "color",
        "svg",
        "mapsgeospatial",
        "mapsandgeospatial"
      ]
    },
    {
      "provider": "gcp",
      "label": "Marketplace",
      "category": "Marketplace",
      "url": "/assets/network-icons/gcp/category-icons/Category-Icons/Marketplace/SVG/Marketplace-512-color.svg",
      "sourcePath": "Category Icons/Marketplace/SVG/Marketplace-512-color.svg",
      "tokens": [
        "Marketplace",
        "Category",
        "Icons",
        "SVG",
        "512",
        "color",
        "svg",
        "marketplace"
      ]
    },
    {
      "provider": "gcp",
      "label": "Media Services",
      "category": "Media Services",
      "url": "/assets/network-icons/gcp/category-icons/Category-Icons/Media-Services/SVG/MediaServices-512-color.svg",
      "sourcePath": "Category Icons/Media Services/SVG/MediaServices-512-color.svg",
      "tokens": [
        "Media Services",
        "Category",
        "Icons",
        "Media",
        "Services",
        "SVG",
        "MediaServices",
        "512",
        "color",
        "svg",
        "mediaservices"
      ]
    },
    {
      "provider": "gcp",
      "label": "Media Translation Api",
      "category": "Media Translation Api",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/media_translation_api/media_translation_api.svg",
      "sourcePath": "media_translation_api/media_translation_api.svg",
      "tokens": [
        "Media Translation Api",
        "media",
        "translation",
        "api",
        "svg",
        "mediatranslationapi"
      ]
    },
    {
      "provider": "gcp",
      "label": "Memorystore",
      "category": "Memorystore",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/memorystore/memorystore.svg",
      "sourcePath": "memorystore/memorystore.svg",
      "tokens": [
        "Memorystore",
        "memorystore",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Migrate For Anthos",
      "category": "Migrate For Anthos",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/migrate_for_anthos/migrate_for_anthos.svg",
      "sourcePath": "migrate_for_anthos/migrate_for_anthos.svg",
      "tokens": [
        "Migrate For Anthos",
        "migrate",
        "for",
        "anthos",
        "svg",
        "migrateforanthos"
      ]
    },
    {
      "provider": "gcp",
      "label": "Migrate For Compute Engine",
      "category": "Migrate For Compute Engine",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/migrate_for_compute_engine/migrate_for_compute_engine.svg",
      "sourcePath": "migrate_for_compute_engine/migrate_for_compute_engine.svg",
      "tokens": [
        "Migrate For Compute Engine",
        "migrate",
        "for",
        "compute",
        "engine",
        "svg",
        "migrateforcomputeengine"
      ]
    },
    {
      "provider": "gcp",
      "label": "Migration",
      "category": "Migration",
      "url": "/assets/network-icons/gcp/category-icons/Category-Icons/Migration/SVG/Migration-512-color.svg",
      "sourcePath": "Category Icons/Migration/SVG/Migration-512-color.svg",
      "tokens": [
        "Migration",
        "Category",
        "Icons",
        "SVG",
        "512",
        "color",
        "svg",
        "migration"
      ]
    },
    {
      "provider": "gcp",
      "label": "Mixed Reality",
      "category": "Mixed Reality",
      "url": "/assets/network-icons/gcp/category-icons/Category-Icons/Mixed-Reality/SVG/MixedReality-512-color.svg",
      "sourcePath": "Category Icons/Mixed Reality/SVG/MixedReality-512-color.svg",
      "tokens": [
        "Mixed Reality",
        "Category",
        "Icons",
        "Mixed",
        "Reality",
        "SVG",
        "MixedReality",
        "512",
        "color",
        "svg",
        "mixedreality"
      ]
    },
    {
      "provider": "gcp",
      "label": "My Cloud",
      "category": "My Cloud",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/my_cloud/my_cloud.svg",
      "sourcePath": "my_cloud/my_cloud.svg",
      "tokens": [
        "My Cloud",
        "my",
        "cloud",
        "svg",
        "mycloud"
      ]
    },
    {
      "provider": "gcp",
      "label": "Network Connectivity Center",
      "category": "Network Connectivity Center",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/network_connectivity_center/network_connectivity_center.svg",
      "sourcePath": "network_connectivity_center/network_connectivity_center.svg",
      "tokens": [
        "Network Connectivity Center",
        "network",
        "connectivity",
        "center",
        "svg",
        "networkconnectivitycenter"
      ]
    },
    {
      "provider": "gcp",
      "label": "Network Intelligence Center",
      "category": "Network Intelligence Center",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/network_intelligence_center/network_intelligence_center.svg",
      "sourcePath": "network_intelligence_center/network_intelligence_center.svg",
      "tokens": [
        "Network Intelligence Center",
        "network",
        "intelligence",
        "center",
        "svg",
        "networkintelligencecenter"
      ]
    },
    {
      "provider": "gcp",
      "label": "Network Security",
      "category": "Network Security",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/network_security/network_security.svg",
      "sourcePath": "network_security/network_security.svg",
      "tokens": [
        "Network Security",
        "network",
        "security",
        "svg",
        "networksecurity"
      ]
    },
    {
      "provider": "gcp",
      "label": "Network Tiers",
      "category": "Network Tiers",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/network_tiers/network_tiers.svg",
      "sourcePath": "network_tiers/network_tiers.svg",
      "tokens": [
        "Network Tiers",
        "network",
        "tiers",
        "svg",
        "networktiers"
      ]
    },
    {
      "provider": "gcp",
      "label": "Network Topology",
      "category": "Network Topology",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/network_topology/network_topology.svg",
      "sourcePath": "network_topology/network_topology.svg",
      "tokens": [
        "Network Topology",
        "network",
        "topology",
        "svg",
        "networktopology"
      ]
    },
    {
      "provider": "gcp",
      "label": "Networking",
      "category": "Networking",
      "url": "/assets/network-icons/gcp/category-icons/Category-Icons/Networking/SVG/Networking-512-color-rgb.svg",
      "sourcePath": "Category Icons/Networking/SVG/Networking-512-color-rgb.svg",
      "tokens": [
        "Networking",
        "Category",
        "Icons",
        "SVG",
        "512",
        "color",
        "rgb",
        "svg",
        "networking"
      ]
    },
    {
      "provider": "gcp",
      "label": "Observability",
      "category": "Observability",
      "url": "/assets/network-icons/gcp/category-icons/Category-Icons/Observability/SVG/Observability-512-color.svg",
      "sourcePath": "Category Icons/Observability/SVG/Observability-512-color.svg",
      "tokens": [
        "Observability",
        "Category",
        "Icons",
        "SVG",
        "512",
        "color",
        "svg",
        "observability"
      ]
    },
    {
      "provider": "gcp",
      "label": "Onboarding",
      "category": "Onboarding",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/onboarding/onboarding.svg",
      "sourcePath": "onboarding/onboarding.svg",
      "tokens": [
        "Onboarding",
        "onboarding",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Operations",
      "category": "Operations",
      "url": "/assets/network-icons/gcp/category-icons/Category-Icons/Operations/SVG/Operations-512-color.svg",
      "sourcePath": "Category Icons/Operations/SVG/Operations-512-color.svg",
      "tokens": [
        "Operations",
        "Category",
        "Icons",
        "SVG",
        "512",
        "color",
        "svg",
        "operations"
      ]
    },
    {
      "provider": "gcp",
      "label": "Os Configuration Management",
      "category": "Os Configuration Management",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/os_configuration_management/os_configuration_management.svg",
      "sourcePath": "os_configuration_management/os_configuration_management.svg",
      "tokens": [
        "Os Configuration Management",
        "os",
        "configuration",
        "management",
        "svg",
        "osconfigurationmanagement"
      ]
    },
    {
      "provider": "gcp",
      "label": "Os Inventory Management",
      "category": "Os Inventory Management",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/os_inventory_management/os_inventory_management.svg",
      "sourcePath": "os_inventory_management/os_inventory_management.svg",
      "tokens": [
        "Os Inventory Management",
        "os",
        "inventory",
        "management",
        "svg",
        "osinventorymanagement"
      ]
    },
    {
      "provider": "gcp",
      "label": "Os Patch Management",
      "category": "Os Patch Management",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/os_patch_management/os_patch_management.svg",
      "sourcePath": "os_patch_management/os_patch_management.svg",
      "tokens": [
        "Os Patch Management",
        "os",
        "patch",
        "management",
        "svg",
        "ospatchmanagement"
      ]
    },
    {
      "provider": "gcp",
      "label": "Partner Interconnect",
      "category": "Partner Interconnect",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/partner_interconnect/partner_interconnect.svg",
      "sourcePath": "partner_interconnect/partner_interconnect.svg",
      "tokens": [
        "Partner Interconnect",
        "partner",
        "interconnect",
        "svg",
        "partnerinterconnect"
      ]
    },
    {
      "provider": "gcp",
      "label": "Partner Portal",
      "category": "Partner Portal",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/partner_portal/partner_portal.svg",
      "sourcePath": "partner_portal/partner_portal.svg",
      "tokens": [
        "Partner Portal",
        "partner",
        "portal",
        "svg",
        "partnerportal"
      ]
    },
    {
      "provider": "gcp",
      "label": "Performance Dashboard",
      "category": "Performance Dashboard",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/performance_dashboard/performance_dashboard.svg",
      "sourcePath": "performance_dashboard/performance_dashboard.svg",
      "tokens": [
        "Performance Dashboard",
        "performance",
        "dashboard",
        "svg",
        "performancedashboard"
      ]
    },
    {
      "provider": "gcp",
      "label": "Permissions",
      "category": "Permissions",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/permissions/permissions.svg",
      "sourcePath": "permissions/permissions.svg",
      "tokens": [
        "Permissions",
        "permissions",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Persistent Disk",
      "category": "Persistent Disk",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/persistent_disk/persistent_disk.svg",
      "sourcePath": "persistent_disk/persistent_disk.svg",
      "tokens": [
        "Persistent Disk",
        "persistent",
        "disk",
        "svg",
        "persistentdisk"
      ]
    },
    {
      "provider": "gcp",
      "label": "Phishing Protection",
      "category": "Phishing Protection",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/phishing_protection/phishing_protection.svg",
      "sourcePath": "phishing_protection/phishing_protection.svg",
      "tokens": [
        "Phishing Protection",
        "phishing",
        "protection",
        "svg",
        "phishingprotection"
      ]
    },
    {
      "provider": "gcp",
      "label": "Policy Analyzer",
      "category": "Policy Analyzer",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/policy_analyzer/policy_analyzer.svg",
      "sourcePath": "policy_analyzer/policy_analyzer.svg",
      "tokens": [
        "Policy Analyzer",
        "policy",
        "analyzer",
        "svg",
        "policyanalyzer"
      ]
    },
    {
      "provider": "gcp",
      "label": "Premium Network Tier",
      "category": "Premium Network Tier",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/premium_network_tier/premium_network_tier.svg",
      "sourcePath": "premium_network_tier/premium_network_tier.svg",
      "tokens": [
        "Premium Network Tier",
        "premium",
        "network",
        "tier",
        "svg",
        "premiumnetworktier"
      ]
    },
    {
      "provider": "gcp",
      "label": "Private Connectivity",
      "category": "Private Connectivity",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/private_connectivity/private_connectivity.svg",
      "sourcePath": "private_connectivity/private_connectivity.svg",
      "tokens": [
        "Private Connectivity",
        "private",
        "connectivity",
        "svg",
        "privateconnectivity"
      ]
    },
    {
      "provider": "gcp",
      "label": "Private Service Connect",
      "category": "Private Service Connect",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/private_service_connect/private_service_connect.svg",
      "sourcePath": "private_service_connect/private_service_connect.svg",
      "tokens": [
        "Private Service Connect",
        "private",
        "service",
        "connect",
        "svg",
        "privateserviceconnect"
      ]
    },
    {
      "provider": "gcp",
      "label": "Producer Portal",
      "category": "Producer Portal",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/producer_portal/producer_portal.svg",
      "sourcePath": "producer_portal/producer_portal.svg",
      "tokens": [
        "Producer Portal",
        "producer",
        "portal",
        "svg",
        "producerportal"
      ]
    },
    {
      "provider": "gcp",
      "label": "Profiler",
      "category": "Profiler",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/profiler/profiler.svg",
      "sourcePath": "profiler/profiler.svg",
      "tokens": [
        "Profiler",
        "profiler",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Project",
      "category": "Project",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/project/project.svg",
      "sourcePath": "project/project.svg",
      "tokens": [
        "Project",
        "project",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Pubsub",
      "category": "Pubsub",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/pubsub/pubsub.svg",
      "sourcePath": "pubsub/pubsub.svg",
      "tokens": [
        "Pubsub",
        "pubsub",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Quantum Engine",
      "category": "Quantum Engine",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/quantum_engine/quantum_engine.svg",
      "sourcePath": "quantum_engine/quantum_engine.svg",
      "tokens": [
        "Quantum Engine",
        "quantum",
        "engine",
        "svg",
        "quantumengine"
      ]
    },
    {
      "provider": "gcp",
      "label": "Quotas",
      "category": "Quotas",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/quotas/quotas.svg",
      "sourcePath": "quotas/quotas.svg",
      "tokens": [
        "Quotas",
        "quotas",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Real World Insights",
      "category": "Real World Insights",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/real-world_insights/real-world_insights.svg",
      "sourcePath": "real-world_insights/real-world_insights.svg",
      "tokens": [
        "Real World Insights",
        "real",
        "world",
        "insights",
        "svg",
        "realworldinsights"
      ]
    },
    {
      "provider": "gcp",
      "label": "Recommendations Ai",
      "category": "Recommendations Ai",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/recommendations_ai/recommendations_ai.svg",
      "sourcePath": "recommendations_ai/recommendations_ai.svg",
      "tokens": [
        "Recommendations Ai",
        "recommendations",
        "ai",
        "svg",
        "recommendationsai"
      ]
    },
    {
      "provider": "gcp",
      "label": "Release Notes",
      "category": "Release Notes",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/release_notes/release_notes.svg",
      "sourcePath": "release_notes/release_notes.svg",
      "tokens": [
        "Release Notes",
        "release",
        "notes",
        "svg",
        "releasenotes"
      ]
    },
    {
      "provider": "gcp",
      "label": "Retail Api",
      "category": "Retail Api",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/retail_api/retail_api.svg",
      "sourcePath": "retail_api/retail_api.svg",
      "tokens": [
        "Retail Api",
        "retail",
        "api",
        "svg",
        "retailapi"
      ]
    },
    {
      "provider": "gcp",
      "label": "Risk Manager",
      "category": "Risk Manager",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/risk_manager/risk_manager.svg",
      "sourcePath": "risk_manager/risk_manager.svg",
      "tokens": [
        "Risk Manager",
        "risk",
        "manager",
        "svg",
        "riskmanager"
      ]
    },
    {
      "provider": "gcp",
      "label": "Runtime Config",
      "category": "Runtime Config",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/runtime_config/runtime_config.svg",
      "sourcePath": "runtime_config/runtime_config.svg",
      "tokens": [
        "Runtime Config",
        "runtime",
        "config",
        "svg",
        "runtimeconfig"
      ]
    },
    {
      "provider": "gcp",
      "label": "Sec Ops",
      "category": "Security Operations",
      "url": "/assets/network-icons/gcp/core-products-icons/unique-icons/Security-Operations/SVG/SecOps-512-color-rgb.svg",
      "sourcePath": "Unique Icons/Security Operations/SVG/SecOps-512-color-rgb.svg",
      "tokens": [
        "Sec Ops",
        "Security Operations",
        "Unique",
        "Icons",
        "Security",
        "Operations",
        "SVG",
        "SecOps",
        "512",
        "color",
        "rgb",
        "svg",
        "secops",
        "securityoperations"
      ]
    },
    {
      "provider": "gcp",
      "label": "Secret Manager",
      "category": "Secret Manager",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/secret_manager/secret_manager.svg",
      "sourcePath": "secret_manager/secret_manager.svg",
      "tokens": [
        "Secret Manager",
        "secret",
        "manager",
        "svg",
        "secretmanager"
      ]
    },
    {
      "provider": "gcp",
      "label": "Security Command Center",
      "category": "Security Command Center",
      "url": "/assets/network-icons/gcp/core-products-icons/unique-icons/Security-Command-Center/SVG/SecurityCommandCenter-512-color.svg",
      "sourcePath": "Unique Icons/Security Command Center/SVG/SecurityCommandCenter-512-color.svg",
      "tokens": [
        "Security Command Center",
        "Unique",
        "Icons",
        "Security",
        "Command",
        "Center",
        "SVG",
        "SecurityCommandCenter",
        "512",
        "color",
        "svg",
        "securitycommandcenter"
      ]
    },
    {
      "provider": "gcp",
      "label": "Security Command Center",
      "category": "Security Command Center",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/security_command_center/security_command_center.svg",
      "sourcePath": "security_command_center/security_command_center.svg",
      "tokens": [
        "Security Command Center",
        "security",
        "command",
        "center",
        "svg",
        "securitycommandcenter"
      ]
    },
    {
      "provider": "gcp",
      "label": "Security Health Advisor",
      "category": "Security Health Advisor",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/security_health_advisor/security_health_advisor.svg",
      "sourcePath": "security_health_advisor/security_health_advisor.svg",
      "tokens": [
        "Security Health Advisor",
        "security",
        "health",
        "advisor",
        "svg",
        "securityhealthadvisor"
      ]
    },
    {
      "provider": "gcp",
      "label": "Security Identity",
      "category": "Security Identity",
      "url": "/assets/network-icons/gcp/category-icons/Category-Icons/Security-Identity/SVG/SecurityIdentity-512-color.svg",
      "sourcePath": "Category Icons/Security Identity/SVG/SecurityIdentity-512-color.svg",
      "tokens": [
        "Security Identity",
        "Category",
        "Icons",
        "Security",
        "Identity",
        "SVG",
        "SecurityIdentity",
        "512",
        "color",
        "svg",
        "securityidentity"
      ]
    },
    {
      "provider": "gcp",
      "label": "Security Key Enforcement",
      "category": "Security Key Enforcement",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/security_key_enforcement/security_key_enforcement.svg",
      "sourcePath": "security_key_enforcement/security_key_enforcement.svg",
      "tokens": [
        "Security Key Enforcement",
        "security",
        "key",
        "enforcement",
        "svg",
        "securitykeyenforcement"
      ]
    },
    {
      "provider": "gcp",
      "label": "Security",
      "category": "Security",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/security/security.svg",
      "sourcePath": "security/security.svg",
      "tokens": [
        "Security",
        "security",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Serverless Computing",
      "category": "Serverless Computing",
      "url": "/assets/network-icons/gcp/category-icons/Category-Icons/Serverless-Computing/SVG/ServerlessComputing-512-color.svg",
      "sourcePath": "Category Icons/Serverless Computing/SVG/ServerlessComputing-512-color.svg",
      "tokens": [
        "Serverless Computing",
        "Category",
        "Icons",
        "Serverless",
        "Computing",
        "SVG",
        "ServerlessComputing",
        "512",
        "color",
        "svg",
        "serverlesscomputing"
      ]
    },
    {
      "provider": "gcp",
      "label": "Service Discovery",
      "category": "Service Discovery",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/service_discovery/service_discovery.svg",
      "sourcePath": "service_discovery/service_discovery.svg",
      "tokens": [
        "Service Discovery",
        "service",
        "discovery",
        "svg",
        "servicediscovery"
      ]
    },
    {
      "provider": "gcp",
      "label": "Speech To Text",
      "category": "Speech To Text",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/speech-to-text/speech-to-text.svg",
      "sourcePath": "speech-to-text/speech-to-text.svg",
      "tokens": [
        "Speech To Text",
        "speech",
        "to",
        "text",
        "svg",
        "speechtotext"
      ]
    },
    {
      "provider": "gcp",
      "label": "Stackdriver",
      "category": "Stackdriver",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/stackdriver/stackdriver.svg",
      "sourcePath": "stackdriver/stackdriver.svg",
      "tokens": [
        "Stackdriver",
        "stackdriver",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Standard Network Tier",
      "category": "Standard Network Tier",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/standard_network_tier/standard_network_tier.svg",
      "sourcePath": "standard_network_tier/standard_network_tier.svg",
      "tokens": [
        "Standard Network Tier",
        "standard",
        "network",
        "tier",
        "svg",
        "standardnetworktier"
      ]
    },
    {
      "provider": "gcp",
      "label": "Storage",
      "category": "Storage",
      "url": "/assets/network-icons/gcp/category-icons/Category-Icons/Storage/SVG/Storage-512-color.svg",
      "sourcePath": "Category Icons/Storage/SVG/Storage-512-color.svg",
      "tokens": [
        "Storage",
        "Category",
        "Icons",
        "SVG",
        "512",
        "color",
        "svg",
        "storage"
      ]
    },
    {
      "provider": "gcp",
      "label": "Stream Suite",
      "category": "Stream Suite",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/stream_suite/stream_suite.svg",
      "sourcePath": "stream_suite/stream_suite.svg",
      "tokens": [
        "Stream Suite",
        "stream",
        "suite",
        "svg",
        "streamsuite"
      ]
    },
    {
      "provider": "gcp",
      "label": "Support",
      "category": "Support",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/support/support.svg",
      "sourcePath": "support/support.svg",
      "tokens": [
        "Support",
        "support",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Tensorflow Enterprise",
      "category": "Tensorflow Enterprise",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/tensorflow_enterprise/tensorflow_enterprise.svg",
      "sourcePath": "tensorflow_enterprise/tensorflow_enterprise.svg",
      "tokens": [
        "Tensorflow Enterprise",
        "tensorflow",
        "enterprise",
        "svg",
        "tensorflowenterprise"
      ]
    },
    {
      "provider": "gcp",
      "label": "Text To Speech",
      "category": "Text To Speech",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/text-to-speech/text-to-speech.svg",
      "sourcePath": "text-to-speech/text-to-speech.svg",
      "tokens": [
        "Text To Speech",
        "text",
        "to",
        "speech",
        "svg",
        "texttospeech"
      ]
    },
    {
      "provider": "gcp",
      "label": "Threat Intelligence",
      "category": "Threat Intelligence",
      "url": "/assets/network-icons/gcp/core-products-icons/unique-icons/Threat-Intelligence/SVG/ThreatIntelligence-512-color.svg",
      "sourcePath": "Unique Icons/Threat Intelligence/SVG/ThreatIntelligence-512-color.svg",
      "tokens": [
        "Threat Intelligence",
        "Unique",
        "Icons",
        "Threat",
        "Intelligence",
        "SVG",
        "ThreatIntelligence",
        "512",
        "color",
        "svg",
        "threatintelligence"
      ]
    },
    {
      "provider": "gcp",
      "label": "Tools For Powershell",
      "category": "Tools For Powershell",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/tools_for_powershell/tools_for_powershell.svg",
      "sourcePath": "tools_for_powershell/tools_for_powershell.svg",
      "tokens": [
        "Tools For Powershell",
        "tools",
        "for",
        "powershell",
        "svg",
        "toolsforpowershell"
      ]
    },
    {
      "provider": "gcp",
      "label": "Trace",
      "category": "Trace",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/trace/trace.svg",
      "sourcePath": "trace/trace.svg",
      "tokens": [
        "Trace",
        "trace",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Traffic Director",
      "category": "Traffic Director",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/traffic_director/traffic_director.svg",
      "sourcePath": "traffic_director/traffic_director.svg",
      "tokens": [
        "Traffic Director",
        "traffic",
        "director",
        "svg",
        "trafficdirector"
      ]
    },
    {
      "provider": "gcp",
      "label": "Transfer Appliance",
      "category": "Transfer Appliance",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/transfer_appliance/transfer_appliance.svg",
      "sourcePath": "transfer_appliance/transfer_appliance.svg",
      "tokens": [
        "Transfer Appliance",
        "transfer",
        "appliance",
        "svg",
        "transferappliance"
      ]
    },
    {
      "provider": "gcp",
      "label": "Transfer",
      "category": "Transfer",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/transfer/transfer.svg",
      "sourcePath": "transfer/transfer.svg",
      "tokens": [
        "Transfer",
        "transfer",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "User Preferences",
      "category": "User Preferences",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/user_preferences/user_preferences.svg",
      "sourcePath": "user_preferences/user_preferences.svg",
      "tokens": [
        "User Preferences",
        "user",
        "preferences",
        "svg",
        "userpreferences"
      ]
    },
    {
      "provider": "gcp",
      "label": "Vertex AI",
      "category": "Vertex AI",
      "url": "/assets/network-icons/gcp/core-products-icons/unique-icons/Vertex-AI/SVG/VertexAI-512-color.svg",
      "sourcePath": "Unique Icons/Vertex AI/SVG/VertexAI-512-color.svg",
      "tokens": [
        "Vertex AI",
        "Unique",
        "Icons",
        "Vertex",
        "AI",
        "SVG",
        "VertexAI",
        "512",
        "color",
        "svg",
        "vertexai"
      ]
    },
    {
      "provider": "gcp",
      "label": "Vertexai",
      "category": "Vertexai",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/vertexai/vertexai.svg",
      "sourcePath": "vertexai/vertexai.svg",
      "tokens": [
        "Vertexai",
        "vertexai",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Video Intelligence Api",
      "category": "Video Intelligence Api",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/video_intelligence_api/video_intelligence_api.svg",
      "sourcePath": "video_intelligence_api/video_intelligence_api.svg",
      "tokens": [
        "Video Intelligence Api",
        "video",
        "intelligence",
        "api",
        "svg",
        "videointelligenceapi"
      ]
    },
    {
      "provider": "gcp",
      "label": "Virtual Private Cloud",
      "category": "Virtual Private Cloud",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/virtual_private_cloud/virtual_private_cloud.svg",
      "sourcePath": "virtual_private_cloud/virtual_private_cloud.svg",
      "tokens": [
        "Virtual Private Cloud",
        "virtual",
        "private",
        "cloud",
        "svg",
        "virtualprivatecloud"
      ]
    },
    {
      "provider": "gcp",
      "label": "Visual Inspection",
      "category": "Visual Inspection",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/visual_inspection/visual_inspection.svg",
      "sourcePath": "visual_inspection/visual_inspection.svg",
      "tokens": [
        "Visual Inspection",
        "visual",
        "inspection",
        "svg",
        "visualinspection"
      ]
    },
    {
      "provider": "gcp",
      "label": "Vmware Engine",
      "category": "Vmware Engine",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/vmware_engine/vmware_engine.svg",
      "sourcePath": "vmware_engine/vmware_engine.svg",
      "tokens": [
        "Vmware Engine",
        "vmware",
        "engine",
        "svg",
        "vmwareengine"
      ]
    },
    {
      "provider": "gcp",
      "label": "Web Mobile",
      "category": "Web & Mobile",
      "url": "/assets/network-icons/gcp/category-icons/Category-Icons/Web---Mobile/SVG/WebMobile-512-color.svg",
      "sourcePath": "Category Icons/Web & Mobile/SVG/WebMobile-512-color.svg",
      "tokens": [
        "Web Mobile",
        "Web & Mobile",
        "Category",
        "Icons",
        "Web",
        "&",
        "Mobile",
        "SVG",
        "WebMobile",
        "512",
        "color",
        "svg",
        "webmobile",
        "webandmobile"
      ]
    },
    {
      "provider": "gcp",
      "label": "Web Risk",
      "category": "Web Risk",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/web_risk/web_risk.svg",
      "sourcePath": "web_risk/web_risk.svg",
      "tokens": [
        "Web Risk",
        "web",
        "risk",
        "svg",
        "webrisk"
      ]
    },
    {
      "provider": "gcp",
      "label": "Web Security Scanner",
      "category": "Web Security Scanner",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/web_security_scanner/web_security_scanner.svg",
      "sourcePath": "web_security_scanner/web_security_scanner.svg",
      "tokens": [
        "Web Security Scanner",
        "web",
        "security",
        "scanner",
        "svg",
        "websecurityscanner"
      ]
    },
    {
      "provider": "gcp",
      "label": "Web3",
      "category": "Web3",
      "url": "/assets/network-icons/gcp/category-icons/Category-Icons/Web3/SVG/Web3-512-color.svg",
      "sourcePath": "Category Icons/Web3/SVG/Web3-512-color.svg",
      "tokens": [
        "Web3",
        "Category",
        "Icons",
        "SVG",
        "512",
        "color",
        "svg",
        "web3"
      ]
    },
    {
      "provider": "gcp",
      "label": "Workflows",
      "category": "Workflows",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/workflows/workflows.svg",
      "sourcePath": "workflows/workflows.svg",
      "tokens": [
        "Workflows",
        "workflows",
        "svg"
      ]
    },
    {
      "provider": "gcp",
      "label": "Workload Identity Pool",
      "category": "Workload Identity Pool",
      "url": "/assets/network-icons/gcp/google-cloud-legacy-icons/workload_identity_pool/workload_identity_pool.svg",
      "sourcePath": "workload_identity_pool/workload_identity_pool.svg",
      "tokens": [
        "Workload Identity Pool",
        "workload",
        "identity",
        "pool",
        "svg",
        "workloadidentitypool"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Api",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/control_plane_components/labeled/api.svg",
      "sourcePath": "community-main/icons/svg/control_plane_components/labeled/api.svg",
      "tokens": [
        "Api",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "control",
        "plane",
        "components",
        "labeled",
        "api"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "C C M",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/control_plane_components/labeled/c-c-m.svg",
      "sourcePath": "community-main/icons/svg/control_plane_components/labeled/c-c-m.svg",
      "tokens": [
        "C C M",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "control",
        "plane",
        "components",
        "labeled",
        "c",
        "m",
        "ccm"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "C M",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/control_plane_components/labeled/c-m.svg",
      "sourcePath": "community-main/icons/svg/control_plane_components/labeled/c-m.svg",
      "tokens": [
        "C M",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "control",
        "plane",
        "components",
        "labeled",
        "c",
        "m",
        "cm"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "C Role",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/c-role.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/c-role.svg",
      "tokens": [
        "C Role",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "c",
        "role",
        "crole"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "C Role",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/c-role.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/c-role.svg",
      "tokens": [
        "C Role",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "c",
        "role",
        "crole"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Cm",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/cm.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/cm.svg",
      "tokens": [
        "Cm",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "cm"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Cm",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/cm.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/cm.svg",
      "tokens": [
        "Cm",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "cm"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Control Plane",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/infrastructure_components/labeled/control-plane.svg",
      "sourcePath": "community-main/icons/svg/infrastructure_components/labeled/control-plane.svg",
      "tokens": [
        "Control Plane",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "infrastructure",
        "components",
        "labeled",
        "control",
        "plane",
        "controlplane"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Control Plane",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/infrastructure_components/unlabeled/control-plane.svg",
      "sourcePath": "community-main/icons/svg/infrastructure_components/unlabeled/control-plane.svg",
      "tokens": [
        "Control Plane",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "infrastructure",
        "components",
        "unlabeled",
        "control",
        "plane",
        "controlplane"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Crb",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/crb.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/crb.svg",
      "tokens": [
        "Crb",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "crb"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Crb",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/crb.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/crb.svg",
      "tokens": [
        "Crb",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "crb"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Crd",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/crd.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/crd.svg",
      "tokens": [
        "Crd",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "crd"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Crd",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/crd.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/crd.svg",
      "tokens": [
        "Crd",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "crd"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Cronjob",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/cronjob.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/cronjob.svg",
      "tokens": [
        "Cronjob",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "cronjob"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Cronjob",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/cronjob.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/cronjob.svg",
      "tokens": [
        "Cronjob",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "cronjob"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Deploy",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/deploy.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/deploy.svg",
      "tokens": [
        "Deploy",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "deploy"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Deploy",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/deploy.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/deploy.svg",
      "tokens": [
        "Deploy",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "deploy"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Ds",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/ds.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/ds.svg",
      "tokens": [
        "Ds",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "ds"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Ds",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/ds.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/ds.svg",
      "tokens": [
        "Ds",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "ds"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Ep",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/ep.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/ep.svg",
      "tokens": [
        "Ep",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "ep"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Ep",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/ep.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/ep.svg",
      "tokens": [
        "Ep",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "ep"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Etcd",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/infrastructure_components/labeled/etcd.svg",
      "sourcePath": "community-main/icons/svg/infrastructure_components/labeled/etcd.svg",
      "tokens": [
        "Etcd",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "infrastructure",
        "components",
        "labeled",
        "etcd"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Etcd",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/infrastructure_components/unlabeled/etcd.svg",
      "sourcePath": "community-main/icons/svg/infrastructure_components/unlabeled/etcd.svg",
      "tokens": [
        "Etcd",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "infrastructure",
        "components",
        "unlabeled",
        "etcd"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Group",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/group.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/group.svg",
      "tokens": [
        "Group",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "group"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Group",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/group.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/group.svg",
      "tokens": [
        "Group",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "group"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Hpa",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/hpa.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/hpa.svg",
      "tokens": [
        "Hpa",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "hpa"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Hpa",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/hpa.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/hpa.svg",
      "tokens": [
        "Hpa",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "hpa"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Ing",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/ing.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/ing.svg",
      "tokens": [
        "Ing",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "ing"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Ing",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/ing.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/ing.svg",
      "tokens": [
        "Ing",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "ing"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Job",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/job.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/job.svg",
      "tokens": [
        "Job",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "job"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Job",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/job.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/job.svg",
      "tokens": [
        "Job",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "job"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "K Proxy",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/control_plane_components/labeled/k-proxy.svg",
      "sourcePath": "community-main/icons/svg/control_plane_components/labeled/k-proxy.svg",
      "tokens": [
        "K Proxy",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "control",
        "plane",
        "components",
        "labeled",
        "k",
        "proxy",
        "kproxy"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Kubelet",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/control_plane_components/labeled/kubelet.svg",
      "sourcePath": "community-main/icons/svg/control_plane_components/labeled/kubelet.svg",
      "tokens": [
        "Kubelet",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "control",
        "plane",
        "components",
        "labeled",
        "kubelet"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Limits",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/limits.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/limits.svg",
      "tokens": [
        "Limits",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "limits"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Limits",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/limits.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/limits.svg",
      "tokens": [
        "Limits",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "limits"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Netpol",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/netpol.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/netpol.svg",
      "tokens": [
        "Netpol",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "netpol"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Netpol",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/netpol.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/netpol.svg",
      "tokens": [
        "Netpol",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "netpol"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Node",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/infrastructure_components/labeled/node.svg",
      "sourcePath": "community-main/icons/svg/infrastructure_components/labeled/node.svg",
      "tokens": [
        "Node",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "infrastructure",
        "components",
        "labeled",
        "node"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Node",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/infrastructure_components/unlabeled/node.svg",
      "sourcePath": "community-main/icons/svg/infrastructure_components/unlabeled/node.svg",
      "tokens": [
        "Node",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "infrastructure",
        "components",
        "unlabeled",
        "node"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Ns",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/ns.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/ns.svg",
      "tokens": [
        "Ns",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "ns"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Ns",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/ns.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/ns.svg",
      "tokens": [
        "Ns",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "ns"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Pod",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/pod.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/pod.svg",
      "tokens": [
        "Pod",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "pod"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Pod",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/pod.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/pod.svg",
      "tokens": [
        "Pod",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "pod"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Psp",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/psp.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/psp.svg",
      "tokens": [
        "Psp",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "psp"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Psp",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/psp.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/psp.svg",
      "tokens": [
        "Psp",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "psp"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Pv",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/pv.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/pv.svg",
      "tokens": [
        "Pv",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "pv"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Pv",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/pv.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/pv.svg",
      "tokens": [
        "Pv",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "pv"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Pvc",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/pvc.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/pvc.svg",
      "tokens": [
        "Pvc",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "pvc"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Pvc",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/pvc.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/pvc.svg",
      "tokens": [
        "Pvc",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "pvc"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Quota",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/quota.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/quota.svg",
      "tokens": [
        "Quota",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "quota"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Quota",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/quota.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/quota.svg",
      "tokens": [
        "Quota",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "quota"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Rb",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/rb.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/rb.svg",
      "tokens": [
        "Rb",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "rb"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Rb",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/rb.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/rb.svg",
      "tokens": [
        "Rb",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "rb"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Role",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/role.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/role.svg",
      "tokens": [
        "Role",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "role"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Role",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/role.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/role.svg",
      "tokens": [
        "Role",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "role"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Rs",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/rs.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/rs.svg",
      "tokens": [
        "Rs",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "rs"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Rs",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/rs.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/rs.svg",
      "tokens": [
        "Rs",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "rs"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Sa",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/sa.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/sa.svg",
      "tokens": [
        "Sa",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "sa"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Sa",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/sa.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/sa.svg",
      "tokens": [
        "Sa",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "sa"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Sc",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/sc.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/sc.svg",
      "tokens": [
        "Sc",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "sc"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Sc",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/sc.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/sc.svg",
      "tokens": [
        "Sc",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "sc"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Sched",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/control_plane_components/labeled/sched.svg",
      "sourcePath": "community-main/icons/svg/control_plane_components/labeled/sched.svg",
      "tokens": [
        "Sched",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "control",
        "plane",
        "components",
        "labeled",
        "sched"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Secret",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/secret.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/secret.svg",
      "tokens": [
        "Secret",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "secret"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Secret",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/secret.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/secret.svg",
      "tokens": [
        "Secret",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "secret"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Sts",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/sts.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/sts.svg",
      "tokens": [
        "Sts",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "sts"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Sts",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/sts.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/sts.svg",
      "tokens": [
        "Sts",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "sts"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Svc",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/svc.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/svc.svg",
      "tokens": [
        "Svc",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "svc"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Svc",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/svc.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/svc.svg",
      "tokens": [
        "Svc",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "svc"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "User",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/user.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/user.svg",
      "tokens": [
        "User",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "user"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "User",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/user.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/user.svg",
      "tokens": [
        "User",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "user"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Vol",
      "category": "Labeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/labeled/vol.svg",
      "sourcePath": "community-main/icons/svg/resources/labeled/vol.svg",
      "tokens": [
        "Vol",
        "Labeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "labeled",
        "vol"
      ]
    },
    {
      "provider": "kubernetes",
      "label": "Vol",
      "category": "Unlabeled",
      "url": "/assets/network-icons/kubernetes/kubernetes-community-main/icons/svg/resources/unlabeled/vol.svg",
      "sourcePath": "community-main/icons/svg/resources/unlabeled/vol.svg",
      "tokens": [
        "Vol",
        "Unlabeled",
        "community",
        "main",
        "icons",
        "svg",
        "resources",
        "unlabeled",
        "vol"
      ]
    }
  ]
};

export const PROVIDER_ICON_CATALOG = PROVIDER_ICON_CATALOG_DATA as ProviderIconCatalog;
